/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}({

/***/ 3832903848408961:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateLodgingProductRatePlan = function (_React$Component) {
	    _inherits(UpdateLodgingProductRatePlan, _React$Component);
	
	    function UpdateLodgingProductRatePlan(props) {
	        _classCallCheck(this, UpdateLodgingProductRatePlan);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateLodgingProductRatePlan.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC694\uAE08\uC81C \uC5C5\uB370\uC774\uD2B8'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC219\uBC15 \uC0C1\uD488\uC758 \uC694\uAE08\uC81C \uC5C5\uB370\uC774\uD2B8'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'PUT'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/lodgings/',
	                                '{travelProductId}',
	                                '/rates/',
	                                '{rateId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings/1234567890/rates/11111111'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'rateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'rate id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'lodgingRateUpdateDto'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<LodgingRateUpdateDto>'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC790\uC0AC\uC0AC\uC774\uD2B8\uC758 \uC694\uAE08ID'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRoomIds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC790\uC0AC \uC0AC\uC774\uD2B8\uC758 \uAC1D\uC2E4 ID'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08\uCE74\uD14C\uACE0\uB9AC\uBA85 (\uAD00\uB9AC\uB97C \uC704\uD55C \uBA85\uCE6D\uC73C\uB85C \uCFE0\uD321 \uD310\uB9E4\uD398\uC774\uC9C0\uC5D0 \uB178\uCD9C\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219 \uAE30\uAC04 - \uC2DC\uC791 (format : yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219 \uAE30\uAC04 - \uC885\uB8CC (\uBBF8\uC124\uC815\uC2DC2099-12-31 23:59:59\uB85C \uC124\uC815\uB428. format : yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'mealPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC815\uCC45'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'breakfastIncluded'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uD3EC\uD568 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'numberOfGuests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC720\uD615'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'mealStyle'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC720\uD615 (\uC870\uC2DD\uD3EC\uD568 \uC5EC\uBD80\uAC00 True\uC77C \uACBD\uC6B0 \uD544\uC218 \uC785\uB825). Eg:\uC9C1\uC811\uC785\uB825,\uC77C\uC2DD,\uC591\uC2DD,\uBDD4\uD398\uC2DD,\uCC44\uC2DD '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'surchargeAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uCD94\uAC00 \uC694\uAE08 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uC870\uC2DD \uCD94\uAC00 \uC694\uAE08\uC774 True\uC77C \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 12\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC694\uAE08 \uC785\uB825 (\'\uD604\uC7A5\uACB0\uC81C\' \uAE30\uC900\uC73C\uB85C \uC694\uAE08\uC744 \uC124\uC815\uD574\uC8FC\uC138\uC694.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uADDC\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uADDC\uC815 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'refundable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88 \uBD88\uAC00 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : True)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'refundRates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC790\uBCC4 \uCDE8\uC18C \uD658\uBD88 \uADDC\uC815 (\uCDE8\uC18C \uBD88\uAC00 \uC5EC\uBD80\uAC00 True \uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825 / False \uC778 \uACBD\uC6B0 \uC785\uB825 \uBD88\uD544\uC694)',
	                                _react2.default.createElement('br', null),
	                                '\uC804\uC561 \uD658\uBD88\uC758 \uACBD\uC6B0 \uADDC\uC815\uC5D0 \uB9DE\uB294 \uC219\uBC15\uC77C\uC744 \uC120\uD0DD\uD558\uACE0, \uD658\uBD88\uC728\uC740 100%\uB85C \uC124\uC815\uD574\uC8FC\uC138\uC694.\u200B',
	                                _react2.default.createElement('br', null),
	                                '\uC608: \uC219\uBC15\uC77C= 7days, \uD658\uBD88\uC728=100%\uB85C \uC124\uC815\uD558\uB294 \uACBD\uC6B0 \uACE0\uAC1D\uC774 \uBCF4\uB294 \uD658\uBD88 \uADDC\uC815\uC740 \uCDE8\uC18C \uC885\uB958\uC5D0 \uB530\uB77C \uC790\uB3D9 \uCDE8\uC18C\uC778 \uACBD\uC6B0 "7\uC77C 23:59 \uC804 \uCDE8\uC18C \uC2DC \uC804\uC561 \uD658\uBD88", \uC2B9\uC778 \uCDE8\uC18C\uC778 \uACBD\uC6B0 "7\uC77C 17:00 \uC804 \uCDE8\uC18C \uC2DC \uC804\uC561 \uD658\uBD88"\uC73C\uB85C \uBCF4\uC785\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'days'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC77C (\uC608: \uC219\uBC15\uC77C 5 ',
	                                '{days}',
	                                '\uC77C\uC804\uBD80\uD130 70% ',
	                                '{refundRate}',
	                                ' \uD658\uBD88)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'refundRate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC728 (\uC608: \uC219\uBC15\uC77C 5 ',
	                                '{days}',
	                                '\uC77C\uC804\uBD80\uD130 70% ',
	                                '{refundRate}',
	                                ' \uD658\uBD88)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'extraGuestPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uBE44\uC6A9 (\uC785\uB825\uD55C \uC778\uC6D0\uCD94\uAC00\uC694\uAE08\uC740 \uAC01 \uAC1D\uC2E4\uC758 \uAE30\uC900\uC778\uC6D0 \uCD08\uACFC\uC2DC \uC790\uB3D9\uC73C\uB85C \uC801\uC6A9\uB418\uC5B4 \uC628\uB77C\uC778\uC73C\uB85C \uACB0\uC81C\uB429\uB2C8\uB2E4.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'surchargeAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 17\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5 / (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825))'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uC694\uAE08 \uC785\uB825 (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'extraBedPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uC124\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraBedAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uAC00\uB2A5 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False) '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'surchargeNeeded'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraBeds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uC885\uB958'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'bedType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BABY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BABY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 17\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5 / (\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825))'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'checkInOutPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778/\uCCB4\uD06C\uC544\uC6C3 \uC2DC\uAC04 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'checkInStartTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778 \uC2DC\uAC04 (HH:mm)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'checkOutEndTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC544\uC6C3 \uC2DC\uAC04 (HH:mm)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'instruction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Instruction'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'freeServicePolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778/\uCCB4\uD06C\uC544\uC6C3 \uC548\uB0B4 \uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBB34\uB8CC \uC11C\uBE44\uC2A4 \uC81C\uACF5 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'freeServices'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBB34\uB8CC \uC11C\uBE44\uC2A4 \uC81C\uACF5 \uC720\uD615 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'freeServiceType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_DRINK'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBB34\uB8CC \uC74C\uB8CC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_GIFT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBB34\uB8CC \uC120\uBB3C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_ROOM_UPGRADE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4 \uBB34\uB8CC \uC5C5\uADF8\uB808\uC774\uB4DC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_VIEW_UPGRADE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4 \uBDF0 \uBB34\uB8CC \uC5C5\uADF8\uB808\uC774\uB4DC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBB34\uB8CC \uC11C\uBE44\uC2A4\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'extraPackagePolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC124\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraPackages'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC720\uD615 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC11C\uBE44\uC2A4\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'extraPackageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ENTRANCE_TICKET'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC785\uC7A5\uAD8C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#createTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'createTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n         "saleStartedAt":"2020-05-04 11:00:00",\n         "sellerRoomIds":["room_1","room_2","room3"],\n         "name":"rate_3",\n\n          "cancelPolicy": {\n            \n            "refundRates": [\n              {\n                "days": 5,\n                "refundRate": 90\n              }\n            ]\n          },\n          "checkInOutPolicy": {\n            "checkInStartTime": "16:00",\n            "checkOutEndTime": "13:00"\n          },\n          \n         \n        \n          "freeServicePolicy": {\n          \n          },\n          "mealPolicy": {\n            \n            "numberOfGuests": 2\n            \n          }\n        }\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Rate update request successfully received",\n    "data": 576983927370022914\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforCreateProduct' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforCreateProduct', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement('div', { className: 'panel-body' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateLodgingProductRatePlan;
	}(_react2.default.Component);
	
	exports.default = UpdateLodgingProductRatePlan;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateLodgingProductRatePlan.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1482121859620419);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	module.exports = $;

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./api/XYZ.json": 3744858885512850,
		"./api/index.json": 131268979554393,
		"./error404.html": 7217189229661154,
		"./error500.html": 3706460768780088,
		"./guides/HMAC_Signature_C.html": 2404868040314224,
		"./guides/HMAC_Signature_PHP.html": 2135400406923711,
		"./guides/HMAC_Signature_Python.html": 6526674205931212,
		"./guides/HMAC_Signature_java.html": 389870846230685,
		"./join.html": 108216004907396
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 3;


/***/ }),

/***/ 108216004907396:
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=\"col-sm-3 col-md-2 sidebar\"> <ul class=\"nav nav-sidebar\"> <li class=active><a href=#>Overview <span class=sr-only>(current)</span></a></li> <li><a href=#>Reports</a></li> <li><a href=#>Analytics</a></li> <li><a href=#>Export</a></li> </ul> <ul class=\"nav nav-sidebar\"> <li><a href=\"\">Nav item</a></li> <li><a href=\"\">Nav item again</a></li> <li><a href=\"\">One more nav</a></li> <li><a href=\"\">Another nav item</a></li> <li><a href=\"\">More navigation</a></li> </ul> <ul class=\"nav nav-sidebar\"> <li><a href=\"\">Nav item again</a></li> <li><a href=\"\">One more nav</a></li> <li><a href=\"\">Another nav item</a></li> </ul> </div> <div class=\"col-sm-9 col-md-10 main\"> <div class=page-header> <h1>MEMBER JOIN</h1> </div> <form class=form-horizontal> <div class=form-group> <label for=inputEmail3 class=\"col-sm-2 control-label\">연동업체명</label> <div class=col-sm-10> <input type=text class=\"form-control w80\" placeholder=\"Text input\"> </div> </div> <div class=form-group> <label for=inputEmail3 class=\"col-sm-2 control-label\">회신받을 email</label> <div class=col-sm-10> <input type=email class=\"form-control button\" id=inputEmail3 placeholder=Email> <button type=submit class=\"btn btn-default btn-ty01\">Confirm identity</button> </div> </div> <div class=form-group> <label for=inputEmail3 class=\"col-sm-2 control-label\">연동 vendorId list</label> <div class=col-sm-10> <input type=text class=\"form-control w80\" placeholder=\"Text input\"> </div> </div> <div class=form-group> <label for=inputEmail3 class=\"col-sm-2 control-label\">기타 메세지</label> <div class=col-sm-10> <input type=text class=\"form-control w80\" placeholder=\"Text input\"> </div> </div> <div class=form-group> <div class=\"col-sm-offset-2 col-sm-10\"> <div class=checkbox> <label> <input type=checkbox> Remember me </label> </div> </div> </div> <div class=form-group> <div class=\"col-sm-offset-2 col-sm-10\"> <button type=button class=\"btn btn-primary btn-lg\">Sign in</button> </div> </div> </form> </div> </div>";

/***/ }),

/***/ 131268979554393:
/***/ (function(module, exports) {

	module.exports = {
		"apiData": {
			"title": "title 입니다.",
			"content": "content 입니다.",
			"apiTestCode": ""
		}
	};

/***/ }),

/***/ 150382457790077:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TourAPIContent = function (_React$Component) {
	  _inherits(TourAPIContent, _React$Component);
	
	  function TourAPIContent(props) {
	    _classCallCheck(this, TourAPIContent);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  TourAPIContent.prototype.render = function render() {
	    var col_number_8 = 8;
	    var total_levels = 6;
	    var level1 = 5;
	    var level2 = 4;
	    var level2_prefix = level1 - level2;
	    var level3 = 3;
	    var level3_prefix = level1 - level3;
	    var level4 = 2;
	    var level4_prefix = level1 - level4;
	    var level5 = 1;
	    var level5_prefix = level1 - level5;
	    return _react2.default.createElement(
	      'div',
	      { className: 'col-sm-12' },
	      _react2.default.createElement(
	        'div',
	        { className: 'page-header', id: 'guides-section-05' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'blog-title' },
	          'Tour Open API'
	        )
	      ),
	      this.props.newDiv
	    );
	  };
	
	  return TourAPIContent;
	}(_react2.default.Component);
	
	exports.default = TourAPIContent;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "TourAPIContent.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 152998592313383:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketUsageProcessing = function (_React$Component) {
	    _inherits(TicketUsageProcessing, _React$Component);
	
	    function TicketUsageProcessing(props) {
	        _classCallCheck(this, TicketUsageProcessing);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    TicketUsageProcessing.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uD2F0\uCF13 \uC0AC\uC6A9 \uCC98\uB9AC API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: 's-post' },
	                    '\uBBF8\uC0AC\uC6A9 \uC0C1\uD0DC\uC758 \uD2F0\uCF13\uC744 \uC0AC\uC6A9\uB41C \uC0C1\uD0DC\uB85C \uCC98\uB9AC \uD569\uB2C8\uB2E4. \uC774 API\uB97C \uC774\uC6A9\uD574 \uD558\uB098\uC758 \uD2F0\uCF13\uC744 \uC0AC\uC6A9\uCC98\uB9AC \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                '\uD30C\uB77C\uBBF8\uD130 \uAC12\uC73C\uB85C \uC5EC\uB7EC \uC5EC\uB7EC\uAC1C\uC758 \uC5EC\uD589\uC0C1\uD488\uC744 \uAC00\uC838\uC624\uB294 AP',
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/',
	                                '{ticketNumber}',
	                                '/redeem'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/7000000000151/redeem'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638 (default = null)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638 (default = null)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'quantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uD560 \uC218\uB7C9 (default = 1)'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "code": "0000",\n            "message" : "success"\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0000'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'success'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9 \uCC98\uB9AC \uC131\uACF5'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0001'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon that was used'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8 \uC0AC\uC6A9\uCC98\uB9AC\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0002'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon that has been canceled'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0003'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'system error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB0B4\uBD80 \uC11C\uBC84 \uC5D0\uB7EC'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '500'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0004'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'invalid parameter'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCFE0\uD3F0\uBC88\uD638\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC744\uB54C(\uCFE0\uD3F0\uC774 \uC874\uC7AC\uD558\uC9C0 \uC54A\uC744\uB54C)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0005'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon useAmount invalid'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCC98\uB9AC\uC218\uB7C9\uC73C\uB85C \uCC98\uB9AC\uAC00 \uBD88\uAC00\uB2A5\uD560\uB54C(ex. 1\uD68C \uB0A8\uC558\uB294\uB370 2\uD68C \uC0AC\uC6A9\uCC98\uB9AC\uD558\uB824\uACE0 \uD560\uB54C)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0006'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'has no parameter'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD544\uC218 \uC785\uB825\uAC12\uC744 \uC785\uB825\uD558\uC9C0 \uC54A\uC558\uC744\uB54C'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0007'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'un used coupon'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD55C\uBC88\uB3C4 \uC0AC\uC6A9\uCC98\uB9AC \uB418\uC9C0 \uC54A\uC740 \uCFE0\uD3F0\uC744 \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0008'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon canceling'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC811\uC218\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0009'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon is already in progress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3D9\uC77C \uBC88\uD638\uC758 \uCFE0\uD3F0\uC774 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC911\uC77C\uB54C \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0010'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'couponNumber is duplicated'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCFE0\uD3F0\uBC88\uD638\uC758 \uCFE0\uD3F0\uC774 2\uAC1C \uC774\uC0C1 \uC874\uC7AC\uD560\uB54C'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '500'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0011'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'unauthorized vendor id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBBF8\uC778\uC99D vendorId\uB85C \uCFE0\uD3F0 \uCC98\uB9AC\uC2DC\uB3C4, \uBBF8\uC778\uC99D\uC740 acl\uC5D0 \uB4F1\uB85D\uB418\uC9C0 \uC54A\uC740 vendorId\uC778 \uACBD\uC6B0,',
	                                _react2.default.createElement('br', null),
	                                ' \uCC98\uB9AC\uD558\uB824\uB294 \uCFE0\uD3F0\uC758 vendorId\uC640 \uB2E4\uB97C \uACBD\uC6B0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return TicketUsageProcessing;
	}(_react2.default.Component);
	
	exports.default = TicketUsageProcessing;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "TicketUsageProcessing.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 219729406595023:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(7932631929871328);
	
	__webpack_require__(2692642590089237);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _LodgingAPIContent = __webpack_require__(1899016425442059);
	
	var _LodgingAPIContent2 = _interopRequireDefault(_LodgingAPIContent);
	
	var _CreateLodgingProducts = __webpack_require__(7855088649851362);
	
	var _CreateLodgingProducts2 = _interopRequireDefault(_CreateLodgingProducts);
	
	var _CreateLodgingProductRooms = __webpack_require__(3161203245340427);
	
	var _CreateLodgingProductRooms2 = _interopRequireDefault(_CreateLodgingProductRooms);
	
	var _CreateLodgingProductRatePlans = __webpack_require__(7549376536968869);
	
	var _CreateLodgingProductRatePlans2 = _interopRequireDefault(_CreateLodgingProductRatePlans);
	
	var _DeleteLodgingProduct = __webpack_require__(1724267608630013);
	
	var _DeleteLodgingProduct2 = _interopRequireDefault(_DeleteLodgingProduct);
	
	var _DeleteLodgingRatePlan = __webpack_require__(2273315117932759);
	
	var _DeleteLodgingRatePlan2 = _interopRequireDefault(_DeleteLodgingRatePlan);
	
	var _GetLodgingProductInfo = __webpack_require__(3391341478554248);
	
	var _GetLodgingProductInfo2 = _interopRequireDefault(_GetLodgingProductInfo);
	
	var _UpdateLodgingProducts = __webpack_require__(2870738329518842);
	
	var _UpdateLodgingProducts2 = _interopRequireDefault(_UpdateLodgingProducts);
	
	var _UpdateLodgingProductRatePlan = __webpack_require__(3832903848408961);
	
	var _UpdateLodgingProductRatePlan2 = _interopRequireDefault(_UpdateLodgingProductRatePlan);
	
	var _UpdateLodingProductRoom = __webpack_require__(3555176258568410);
	
	var _UpdateLodingProductRoom2 = _interopRequireDefault(_UpdateLodingProductRoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GuideSideBar = function (_React$Component) {
	    _inherits(GuideSideBar, _React$Component);
	
	    function GuideSideBar(props) {
	        _classCallCheck(this, GuideSideBar);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            elementNameValue: ""
	        };
	        return _this;
	    }
	
	    GuideSideBar.prototype.componentDidMount = function componentDidMount() {
	        (0, _jquery2.default)('.sub-menu ul').hide();
	        (0, _jquery2.default)("a").click(function () {
	            (0, _jquery2.default)("a").removeClass('active');
	            (0, _jquery2.default)(this).addClass('active');
	            (0, _jquery2.default)(this).parent(".sub-menu").children("ul").slideToggle("100");
	            (0, _jquery2.default)(this).find(".right").toggleClass("fa-caret-up fa-caret-down");
	        });
	    };
	
	    GuideSideBar.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { id: 'guideSideBar' },
	            _react2.default.createElement(
	                'nav',
	                { className: 'animated bounceInDown', onMouseDown: this.props.getElementNameValue },
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { name: 'guides-section-01' },
	                            'Intro'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { name: 'guides-section-02' },
	                            'HMAC Signature \uC0DD\uC131'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { name: 'guides-section-03' },
	                            'API key \uBC1C\uAE09\uBC1B\uAE30'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'sub-menu' },
	                        _react2.default.createElement(
	                            'a',
	                            { name: 'guides-section-04' },
	                            '\uD2F0\uCF13 \uC0C1\uD488 API',
	                            _react2.default.createElement('div', { className: 'fa fa-caret-down right' })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'sub-menu' },
	                                _react2.default.createElement(
	                                    'a',
	                                    null,
	                                    '\uC0C1\uD488 API',
	                                    _react2.default.createElement('div', { className: 'fa fa-caret-down right' })
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: "create-ticket-product" },
	                                            '\uC0C1\uD488 \uB4F1\uB85D'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: "create-ticket-product-item" },
	                                            '\uC635\uC158 \uB4F1\uB85D'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: "delete-ticket-product" },
	                                            '\uC0C1\uD488 \uC0AD\uC81C'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: "delete-ticket-product-item" },
	                                            '\uC635\uC158 \uC0AD\uC81C'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: "update-ticket-product" },
	                                            '\uC0C1\uD488 \uC218\uC815'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: "update-ticket-product-item" },
	                                            '\uC635\uC158 \uC218\uC815'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: "start-to-sell-ticket-product" },
	                                            '\uC0C1\uD488 \uD310\uB9E4 \uC2DC\uC791'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: "stop-to-sell-ticket-product" },
	                                            '\uC0C1\uD488 \uD310\uB9E4 \uC911\uC9C0'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: "view-single-ticket-product" },
	                                            '\uB2E8\uC77C \uC870\uD68C'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: "view-ticket-product-by-page" },
	                                            '\uBAA9\uB85D \uC870\uD68C'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: 'update-ticket-inventory-by-date' },
	                                            '\uC694\uAE08/\uC218\uB7C9 '
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: 'view-ticket-item-inventories' },
	                                            '\uC7AC\uACE0 \uC870\uD68C'
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: "sub-menu" },
	                                _react2.default.createElement(
	                                    'a',
	                                    null,
	                                    '\uC608\uC57D/\uCDE8\uC18C API',
	                                    _react2.default.createElement('div', { className: 'fa fa-caret-down right' })
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: 'sub-menu' },
	                                        _react2.default.createElement(
	                                            'a',
	                                            null,
	                                            '\uBC84\uC804 1',
	                                            _react2.default.createElement('div', { className: 'fa fa-caret-down right' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            null,
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { name: "ticket-usage-processing" },
	                                                    '\uD2F0\uCF13 \uC0AC\uC6A9 \uCC98\uB9AC'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { name: "mutiple-ticket-usage-processing" },
	                                                    '\uB2E4\uC218 \uD2F0\uCF13 \uC0AC\uC6A9 \uCC98\uB9AC'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { name: "ticket-free-processing" },
	                                                    '\uD2F0\uCF13 \uBBF8\uC0AC\uC6A9 \uCC98\uB9AC'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { name: "mutiple-ticket-unused-processing" },
	                                                    '\uB2E4\uC218 \uD2F0\uCF13 \uBBF8\uC0AC\uC6A9 \uCC98\uB9AC'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { name: "ticket-buyer-info-lookup" },
	                                                    '\uD2F0\uCF13 \uAD6C\uB9E4\uC790 \uC815\uBCF4 \uC870\uD68C'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { name: "view-ticket-details" },
	                                                    '\uD2F0\uCF13 \uC0C1\uC138 \uC815\uBCF4 \uC870\uD68C'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { name: "view-mutiple-ticket-details" },
	                                                    '\uB2E4\uC218 \uD2F0\uCF13 \uC0C1\uC138 \uC815\uBCF4 \uC870\uD68C'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: 'sub-menu' },
	                                        _react2.default.createElement(
	                                            'a',
	                                            null,
	                                            '\uBC84\uC804 2',
	                                            _react2.default.createElement('div', { className: 'fa fa-caret-down right' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            null,
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { name: "view-ticket-buyer-info-V2API" },
	                                                    '\uD2F0\uCF13 \uAD6C\uB9E4\uC790 \uC815\uBCF4 \uC870\uD68C'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { name: "travel-ticket-buyer-info-V1API" },
	                                                    '\uC5EC\uD589 \uC0C1\uD488\uBCC4 \uAD6C\uB9E4\uC790 \uC815\uBCF4 \uC870\uD68C'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { name: "view-canceled-ticket-info-V2" },
	                                                    '\uCDE8\uC18C \uC644\uB8CC \uD2F0\uCF13 \uC815\uBCF4 \uC870\uD68C'
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'sub-menu' },
	                        _react2.default.createElement(
	                            'a',
	                            { name: 'guides-section-05' },
	                            '\uD328\uD0A4\uC9C0/\uD56D\uACF5\uAD8C \uC0C1\uD488 API',
	                            _react2.default.createElement('div', { className: 'fa fa-caret-down right' })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'sub-menu' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'guides-section-05' },
	                                    '\uC0C1\uD488 API',
	                                    _react2.default.createElement('div', { className: 'fa fa-caret-down right' })
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: 'create-tour-product-V2API' },
	                                            '\uC0C1\uD488 \uB4F1\uB85D'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: 'update-tour-product-V2API' },
	                                            '\uC0C1\uD488 \uC218\uC815'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: 'delete-tour-product' },
	                                            '\uC0C1\uD488 \uC0AD\uC81C'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: 'delete-tour-product-item' },
	                                            '\uC635\uC158 \uC0AD\uC81C'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: 'view-tour-product-list' },
	                                            '\uBAA9\uB85D \uC870\uD68C'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: 'view-single-tour-product' },
	                                            '\uB2E8\uC77C \uC870\uD68C'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: 'update-tour-inventory-by-date-V2API' },
	                                            '\uC694\uAE08/\uC218\uB7C9'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { name: 'view-tour-inventories-V2API' },
	                                            '\uC7AC\uACE0 \uC870\uD68C'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'sub-menu' },
	                        _react2.default.createElement(
	                            'a',
	                            { name: 'guides-section-06' },
	                            '\uC608\uC57D/\uCDE8\uC18C API',
	                            _react2.default.createElement('div', { className: 'fa fa-caret-down right' })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'view-reservation-list' },
	                                    '\uC608\uC57D \uBAA9\uB85D \uC870\uD68C'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'view-single-order-reservation' },
	                                    '\uC608\uC57D \uB2E8\uC77C \uC870\uD68C'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'view-confirm-reservation' },
	                                    '\uC608\uC57D \uD655\uC815'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'view-reject-reservation' },
	                                    '\uC608\uC57D \uBD88\uAC00'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'view-approval-cancellation' },
	                                    '\uCDE8\uC18C \uC2B9\uC778'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'view-reservation-manage-history' },
	                                    '\uC8FC\uBB38 \uC0C1\uD0DC \uC774\uB825 \uC870\uD68C'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'sub-menu' },
	                        _react2.default.createElement(
	                            'a',
	                            { name: 'guides-section-08' },
	                            '\uC219\uBC15 API',
	                            _react2.default.createElement('div', { className: 'fa fa-caret-down right' })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'create-lodging-products' },
	                                    '\uC0C1\uD488 \uB4F1\uB85D'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'create-lodging-product-rooms' },
	                                    '\uB8F8 \uC0DD\uC131'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'create-lodging-product-rate-plans' },
	                                    '\uC219\uBC15 \uC694\uAE08\uC81C \uC0DD\uC131'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'delete-lodging-product' },
	                                    '\uC219\uBC15 \uC0C1\uD488 \uC0AD\uC81C'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'delete-lodging-rate-plan' },
	                                    '\uC694\uAE08\uC81C \uC0AD\uC81C'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'update-lodging-product-products' },
	                                    '\uC219\uBC15 \uC0C1\uD488 \uC5C5\uB370\uC774\uD2B8'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'update-lodging-product-room' },
	                                    '\uB8F8 \uC5C5\uB370\uC774\uD2B8'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'update-lodging-product-rate-plan' },
	                                    '\uC694\uAE08\uC81C \uC5C5\uB370\uC774\uD2B8'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'get-lodging-product-info' },
	                                    '\uC219\uBC15 \uC0C1\uD488 \uBCF4\uAE30'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { name: 'update-lodging-inventory' },
	                                    '\uC694\uAE08/\uC218\uB7C9'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return GuideSideBar;
	}(_react2.default.Component);
	
	exports.default = GuideSideBar;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "GuideSideBar.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 228970576441975:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(4813844983747096);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(642862956009192);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabList = function (_Component) {
	  _inherits(TabList, _Component);
	
	  function TabList() {
	    _classCallCheck(this, TabList);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TabList.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        attributes = _objectWithoutProperties(_props, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({}, attributes, { className: (0, _classnames2.default)(className), role: 'tablist' }),
	      children
	    );
	  };
	
	  return TabList;
	}(_react.Component);
	
	TabList.defaultProps = {
	  className: 'react-tabs__tab-list'
	};
	exports.default = TabList;
	TabList.propTypes =  false ? {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object])
	} : {};

/***/ }),

/***/ 233209352477664:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StopToSellTicketProduct = function (_React$Component) {
	    _inherits(StopToSellTicketProduct, _React$Component);
	
	    function StopToSellTicketProduct(props) {
	        _classCallCheck(this, StopToSellTicketProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    StopToSellTicketProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC0C1\uD488 \uD310\uB9E4 \uC911\uC9C0'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC758 \uD310\uB9E4\uC0C1\uD0DC\uB97C \uD310\uB9E4\uC911\uC9C0 \uB85C \uBCC0\uACBD\uD569\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets/',
	                                '{travelProductId}',
	                                '/stop'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890/stop'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": 1234567890\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return StopToSellTicketProduct;
	}(_react2.default.Component);
	
	exports.default = StopToSellTicketProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "StopToSellTicketProduct.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 321525095561427:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	__webpack_require__(7932631929871328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketAPIContent = function (_React$Component) {
	    _inherits(TicketAPIContent, _React$Component);
	
	    function TicketAPIContent(props) {
	        _classCallCheck(this, TicketAPIContent);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    TicketAPIContent.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'page-header', id: 'guides-section-04' },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'blog-title' },
	                    '\uD2F0\uCF13 \uC0C1\uD488 API'
	                )
	            ),
	            this.props.newDiv
	        );
	    };
	
	    return TicketAPIContent;
	}(_react2.default.Component);
	
	exports.default = TicketAPIContent;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "TicketAPIContent.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 389870846230685:
/***/ (function(module, exports) {

	module.exports = "<pre class=hljs><code id=preview><span class=hljs-keyword>package</span> com.coupang.travel.connect.api;\n<span class=hljs-keyword>import</span> com.coupang.openapi.sdk.Hmac;\n<span class=hljs-keyword>import</span> org.apache.http.HttpEntity;\n<span class=hljs-keyword>import</span> org.apache.http.client.methods.*;\n<span class=hljs-keyword>import</span> org.apache.http.client.utils.URIBuilder;\n<span class=hljs-keyword>import</span> org.apache.http.entity.StringEntity;\n<span class=hljs-keyword>import</span> org.apache.http.impl.client.CloseableHttpClient;\n<span class=hljs-keyword>import</span> org.apache.http.impl.client.HttpClients;\n<span class=hljs-keyword>import</span> org.apache.http.util.EntityUtils;\n\n<span class=hljs-keyword>import</span> java.io.IOException;\n\n<span class=hljs-keyword>public</span> <span class=hljs-class><span class=hljs-keyword>class</span> <span class=hljs-title>HmacReturnTest</span> </span>{\n    <span class=hljs-keyword>private</span> <span class=hljs-keyword>static</span> <span class=hljs-keyword>final</span> String HOST = <span class=hljs-string>\"api-gateway.coupang.com\"</span>;\n    <span class=hljs-keyword>private</span> <span class=hljs-keyword>static</span> <span class=hljs-keyword>final</span> <span class=hljs-keyword>int</span> PORT = <span class=hljs-number>443</span>;\n    <span class=hljs-keyword>private</span> <span class=hljs-keyword>static</span> <span class=hljs-keyword>final</span> String SCHEMA = <span class=hljs-string>\"https\"</span>;\n    <span class=hljs-comment>//replace with your own accessKey</span>\n    <span class=hljs-keyword>private</span> <span class=hljs-keyword>static</span> <span class=hljs-keyword>final</span> String ACCESS_KEY = <span class=hljs-string>\"*********************\"</span>;\n    <span class=hljs-comment>//replace with your own secretKey</span>\n    <span class=hljs-keyword>private</span> <span class=hljs-keyword>static</span> <span class=hljs-keyword>final</span> String SECRET_KEY = <span class=hljs-string>\"*********************\"</span>;\n\n    <span class=hljs-function><span class=hljs-keyword>public</span> <span class=hljs-keyword>void</span> <span class=hljs-title>testGetMethod</span><span class=hljs-params>()</span> </span>{\n        <span class=hljs-comment>//params</span>\n        String method = <span class=hljs-string>\"GET\"</span>;\n        String path = <span class=hljs-string>\"/v2/providers/travel_backbone_api/apis/ticket-api/v1/mock-up/purchasers\"</span>;\n\n        <span class=hljs-keyword>try</span> {\n            <span class=hljs-comment>//build uri</span>\n            URIBuilder uriBuilder = <span class=hljs-keyword>new</span> URIBuilder ( )\n                    .setPath ( path )\n                    .addParameter ( <span class=hljs-string>\"searchStartDateTime\"</span>, <span class=hljs-string>\"20130501000000\"</span> )\n                    .addParameter ( <span class=hljs-string>\"searchEndDateTime\"</span>, <span class=hljs-string>\"20130530000000\"</span> )\n                    .addParameter ( <span class=hljs-string>\"offset\"</span>, <span class=hljs-string>\"0\"</span> )\n                    .addParameter ( <span class=hljs-string>\"limit\"</span>, <span class=hljs-string>\"100\"</span> );\n\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>//authorize, demonstrate how to generate hmac signature here</span>\n            String authorization = Hmac.generate ( method, uriBuilder.build ( ).toString ( ), SECRET_KEY, ACCESS_KEY );\n            <span class=hljs-comment>//print out the hmac key</span>\n            System.out.println ( authorization );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            uriBuilder.setScheme ( SCHEMA ).setHost ( HOST ).setPort ( PORT );\n            HttpGet get = <span class=hljs-keyword>new</span> HttpGet ( uriBuilder.build ( ).toString ( ) );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>// set header, demonstarte how to use hmac signature here</span>\n            get.addHeader ( <span class=hljs-string>\"Authorization\"</span>, authorization );\n            get.addHeader ( <span class=hljs-string>\"content-type\"</span>, <span class=hljs-string>\"application/json\"</span> );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>// execute</span>\n            httpExecute ( get );\n        } <span class=hljs-keyword>catch</span> ( Exception e ) {\n            e.printStackTrace ( );\n        }\n    }\n\n    <span class=hljs-function><span class=hljs-keyword>public</span> <span class=hljs-keyword>void</span> <span class=hljs-title>testGetTourMethod</span><span class=hljs-params>()</span> </span>{\n        <span class=hljs-comment>//params</span>\n        String method = <span class=hljs-string>\"GET\"</span>;\n        String travelProductId = <span class=hljs-string>\"***********\"</span> ;\n        String vendorId = <span class=hljs-string>\"***********\"</span>;\n        String path = <span class=hljs-string>\"/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/\"</span>+travelProductId;\n\n        <span class=hljs-keyword>try</span> {\n            <span class=hljs-comment>//build uri</span>\n            URIBuilder uriBuilder = <span class=hljs-keyword>new</span> URIBuilder ( )\n                    .setPath ( path );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>//authorize, demonstrate how to generate hmac signature here</span>\n            String authorization = Hmac.generate ( method, uriBuilder.build ().toString (), SECRET_KEY, ACCESS_KEY );\n            <span class=hljs-comment>//print out the hmac key</span>\n            System.out.println ( authorization );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            uriBuilder.setScheme ( SCHEMA ).setHost ( HOST ).setPort ( PORT );\n            HttpGet get = <span class=hljs-keyword>new</span> HttpGet ( uriBuilder.build ().toString () );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>// set header, demonstarte how to use hmac signature here</span>\n            get.addHeader ( <span class=hljs-string>\"Authorization\"</span>, authorization );\n            get.addHeader ( <span class=hljs-string>\"content-type\"</span>, <span class=hljs-string>\"application/json\"</span> );\n            get.addHeader ( <span class=hljs-string>\"Request-Vendor-Id\"</span>, vendorId );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>//execute</span>\n            httpExecute(get);\n        } <span class=hljs-keyword>catch</span> ( Exception e ) {\n            e.printStackTrace ( );\n        }\n    }\n\n    <span class=hljs-function><span class=hljs-keyword>public</span> <span class=hljs-keyword>void</span> <span class=hljs-title>testPostMethod</span><span class=hljs-params>()</span> </span>{\n        <span class=hljs-comment>//params</span>\n        String method = <span class=hljs-string>\"POST\"</span>;\n        String travelProductId = <span class=hljs-string>\"********\"</span> ;\n        String vendorId = <span class=hljs-string>\"********\"</span>;\n        String path = <span class=hljs-string>\"/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/\"</span>+travelProductId+<span class=hljs-string>\"/items\"</span>;\n\n        <span class=hljs-keyword>try</span> {\n\n            <span class=hljs-comment>//build uri</span>\n            URIBuilder uriBuilder = <span class=hljs-keyword>new</span> URIBuilder ( )\n                    .setPath ( path );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>//authorize, demonstrate how to generate hmac signature here</span>\n            String authorization = Hmac.generate ( method, uriBuilder.build ().toString (), SECRET_KEY, ACCESS_KEY );\n            <span class=hljs-comment>//print out the hmac key</span>\n            System.out.println ( authorization );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            uriBuilder.setScheme ( SCHEMA ).setHost ( HOST ).setPort ( PORT );\n            HttpPost post = <span class=hljs-keyword>new</span> HttpPost ( uriBuilder.build ().toString () );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>// set header, demonstarte how to use hmac signature here</span>\n            post.addHeader ( <span class=hljs-string>\"Authorization\"</span>, authorization );\n            post.addHeader ( <span class=hljs-string>\"Content-Type\"</span>, <span class=hljs-string>\"application/json\"</span> );\n            post.addHeader ( <span class=hljs-string>\"Request-Vendor-Id\"</span>, vendorId );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>// set post body here</span>\n            String postBody = <span class=hljs-string>\"{\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"sellerTravelItemId\\\": \\\"seller-item-id-3\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"name\\\": \\\"[장사/장가계] 4박6일\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"description\\\": \\\"[장사/장가계] 4박6일 description\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"period\\\": \\\"4박6일\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"seq\\\": 2,\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"features\\\": [\\n\"</span> +\n                    <span class=hljs-string>\"  \\t{\\n\"</span> +\n                    <span class=hljs-string>\"  \\t\\t\\\"featureId\\\":\\\"DOMESTIC_DEPARTING_CITY\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\t\\t\\\"featureValues\\\":[\\\"SEOUL_INCLUDE_INCHOEN_AND_KIMPO\\\"]\\n\"</span> +\n                    <span class=hljs-string>\"  \\t}\\n\"</span> +\n                    <span class=hljs-string>\"  \\t],\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"taxType\\\": \\\"ZERO\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"onSale\\\": false,\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"rates\\\": [\\n\"</span> +\n                    <span class=hljs-string>\"    {\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"sellerRateId\\\": \\\"seller-rate-id-1\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"rateType\\\": \\\"ADULT\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"priceType\\\": \\\"COUPANG_PRICE\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"price\\\": 500000,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"representative\\\": true,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"saleStartedAt\\\": \\\"2019-11-01 01:00:00\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"saleEndedAt\\\": \\\"2019-11-21 01:00:00\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"maxPurchaseQtyPerPerson\\\": 10,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"maxPurchaseQtyPeriod\\\": 1,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"seq\\\": 0\\n\"</span> +\n                    <span class=hljs-string>\"    },\\n\"</span> +\n                    <span class=hljs-string>\"    {\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"sellerRateId\\\": \\\"seller-rate-id-1\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"rateType\\\": \\\"CHILD\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"priceType\\\": \\\"COUPANG_PRICE\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"price\\\": 400000,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"representative\\\": true,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"saleStartedAt\\\": \\\"2019-11-01 01:00:00\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"saleEndedAt\\\": \\\"2019-11-21 01:00:00\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"maxPurchaseQtyPerPerson\\\": 10,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"maxPurchaseQtyPeriod\\\": 1,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"seq\\\": 1\\n\"</span> +\n                    <span class=hljs-string>\"    }\\n\"</span> +\n                    <span class=hljs-string>\"  ]\\n\"</span> +\n                    <span class=hljs-string>\"}\"</span>;\n            StringEntity entity = <span class=hljs-keyword>new</span> StringEntity ( postBody);\n            post.setEntity ( entity );\n            <span class=hljs-comment>//execute</span>\n            httpExecute(post);\n        } <span class=hljs-keyword>catch</span> ( Exception e ) {\n            e.printStackTrace ( );\n        }\n    }\n\n    <span class=hljs-function><span class=hljs-keyword>public</span> <span class=hljs-keyword>void</span> <span class=hljs-title>testPutMethod</span><span class=hljs-params>()</span></span>{\n        <span class=hljs-comment>//params</span>\n        String method = <span class=hljs-string>\"PUT\"</span>;\n        String travelProductId = <span class=hljs-string>\"********\"</span> ;\n        String travelItemId = <span class=hljs-string>\"********\"</span>;\n        String vendorId = <span class=hljs-string>\"A00177491\"</span>;\n        String path = <span class=hljs-string>\"/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/\"</span>+travelProductId+<span class=hljs-string>\"/items/\"</span>+travelItemId;\n\n        <span class=hljs-keyword>try</span> {\n            <span class=hljs-comment>//build uri</span>\n            URIBuilder uriBuilder = <span class=hljs-keyword>new</span> URIBuilder ( )\n                    .setPath ( path );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>//authorize, demonstrate how to generate hmac signature here</span>\n            String authorization = Hmac.generate ( method, uriBuilder.build ().toString (), SECRET_KEY, ACCESS_KEY );\n            <span class=hljs-comment>//print out the hmac key</span>\n            System.out.println ( authorization );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            uriBuilder.setScheme ( SCHEMA ).setHost ( HOST ).setPort ( PORT );\n            HttpPut put = <span class=hljs-keyword>new</span> HttpPut ( uriBuilder.build ().toString () );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>// set header, demonstarte how to use hmac signature here</span>\n            put.addHeader ( <span class=hljs-string>\"Authorization\"</span>, authorization );\n            put.addHeader ( <span class=hljs-string>\"Content-Type\"</span>, <span class=hljs-string>\"application/json\"</span> );\n            put.addHeader ( <span class=hljs-string>\"Request-Vendor-Id\"</span>, vendorId );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>// set put request body here</span>\n            String putRequestBody = <span class=hljs-string>\"{\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"sellerTravelItemId\\\": \\\"seller-item-id-3\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"name\\\": \\\"[장사/장가계] 4박6일\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"description\\\": \\\"[장사/장가계] 4박6일 description\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"period\\\": \\\"4박6일\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"seq\\\": 2,\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"features\\\": [\\n\"</span> +\n                    <span class=hljs-string>\"  \\t{\\n\"</span> +\n                    <span class=hljs-string>\"  \\t\\t\\\"featureId\\\":\\\"DOMESTIC_DEPARTING_CITY\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\t\\t\\\"featureValues\\\":[\\\"SEOUL_INCLUDE_INCHOEN_AND_KIMPO\\\"]\\n\"</span> +\n                    <span class=hljs-string>\"  \\t}\\n\"</span> +\n                    <span class=hljs-string>\"  \\t],\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"taxType\\\": \\\"ZERO\\\",\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"onSale\\\": false,\\n\"</span> +\n                    <span class=hljs-string>\"  \\\"rates\\\": [\\n\"</span> +\n                    <span class=hljs-string>\"    {\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"sellerRateId\\\": \\\"seller-rate-id-1\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"rateType\\\": \\\"ADULT\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"priceType\\\": \\\"COUPANG_PRICE\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"price\\\": 500000000,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"representative\\\": true,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"saleStartedAt\\\": \\\"2019-11-01 01:00:00\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"saleEndedAt\\\": \\\"2019-11-21 01:00:00\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"maxPurchaseQtyPerPerson\\\": 10,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"maxPurchaseQtyPeriod\\\": 1,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"seq\\\": 0\\n\"</span> +\n                    <span class=hljs-string>\"    },\\n\"</span> +\n                    <span class=hljs-string>\"    {\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"sellerRateId\\\": \\\"seller-rate-id-1\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"rateType\\\": \\\"CHILD\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"priceType\\\": \\\"COUPANG_PRICE\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"price\\\": 400000000,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"representative\\\": true,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"saleStartedAt\\\": \\\"2019-11-01 01:00:00\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"saleEndedAt\\\": \\\"2019-11-21 01:00:00\\\",\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"maxPurchaseQtyPerPerson\\\": 10,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"maxPurchaseQtyPeriod\\\": 1,\\n\"</span> +\n                    <span class=hljs-string>\"      \\\"seq\\\": 1\\n\"</span> +\n                    <span class=hljs-string>\"    }\\n\"</span> +\n                    <span class=hljs-string>\"  ]\\n\"</span> +\n                    <span class=hljs-string>\"}\"</span>;\n            StringEntity entity = <span class=hljs-keyword>new</span> StringEntity ( putRequestBody);\n            put.setEntity ( entity );\n            <span class=hljs-comment>//execute</span>\n            httpExecute(put);\n        } <span class=hljs-keyword>catch</span> ( Exception e ) {\n            e.printStackTrace ( );\n        }\n    }\n\n    <span class=hljs-function><span class=hljs-keyword>public</span> <span class=hljs-keyword>void</span> <span class=hljs-title>testPatchMethod</span><span class=hljs-params>()</span> </span>{\n        <span class=hljs-comment>//params</span>\n        String method = <span class=hljs-string>\"PATCH\"</span>;\n        String travelProductId = <span class=hljs-string>\"********\"</span>;\n        String travelItemId = <span class=hljs-string>\"********\"</span>;\n        String vendorId = <span class=hljs-string>\"********\"</span>;\n        String path = <span class=hljs-string>\"/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/\"</span>+travelProductId+<span class=hljs-string>\"/items/\"</span>+travelItemId;\n\n        <span class=hljs-keyword>try</span> {\n            <span class=hljs-comment>//build uri</span>\n            URIBuilder uriBuilder = <span class=hljs-keyword>new</span> URIBuilder ( )\n                    .setPath ( path );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>//authorize, demonstrate how to generate hmac signature here</span>\n            String authorization = Hmac.generate ( method, uriBuilder.build ().toString (), SECRET_KEY, ACCESS_KEY );\n            <span class=hljs-comment>//print out the hmac key</span>\n            System.out.println ( authorization );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            uriBuilder.setScheme ( SCHEMA ).setHost ( HOST ).setPort ( PORT );\n            HttpPatch patch = <span class=hljs-keyword>new</span> HttpPatch ( uriBuilder.build ().toString () );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>// set header, demonstarte how to use hmac signature here</span>\n            patch.addHeader ( <span class=hljs-string>\"Authorization\"</span>, authorization );\n            patch.addHeader (<span class=hljs-string>\"Content-Type\"</span>,<span class=hljs-string>\"application/json\"</span>);\n            patch.addHeader ( <span class=hljs-string>\"Request-Vendor-Id\"</span>, vendorId );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>// set patch body here.</span>\n            String patchBody = <span class=hljs-string>\"[\\n\"</span> +\n                    <span class=hljs-string>\" {\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"calendarDate\\\": \\\"2019-11-01\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"rateType\\\": \\\"BASIC\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"salePrice\\\": 50000000000000,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"onSale\\\": true,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalSoldCount\\\": 0,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalStockCount\\\": 2\\n\"</span> +\n                    <span class=hljs-string>\" },\\n\"</span> +\n                    <span class=hljs-string>\"  {\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"calendarDate\\\": \\\"2019-11-02\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"rateType\\\": \\\"BASIC\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"salePrice\\\": 40000000000000,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"onSale\\\": true,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalSoldCount\\\": 0,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalStockCount\\\": 2\\n\"</span> +\n                    <span class=hljs-string>\" },\\n\"</span> +\n                    <span class=hljs-string>\"  {\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"calendarDate\\\": \\\"2019-12-08\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"rateType\\\": \\\"BASIC\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"salePrice\\\": 50000000000000,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"onSale\\\": true,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalSoldCount\\\": 0,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalStockCount\\\": 2\\n\"</span> +\n                    <span class=hljs-string>\" }, \\n\"</span> +\n                    <span class=hljs-string>\"   {\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"calendarDate\\\": \\\"2019-12-01\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"rateType\\\": \\\"BASIC\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"salePrice\\\": 40000000000000,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"onSale\\\": true,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalSoldCount\\\": 0,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalStockCount\\\": 2\\n\"</span> +\n                    <span class=hljs-string>\" },\\n\"</span> +\n                    <span class=hljs-string>\" {\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"calendarDate\\\": \\\"2019-12-01\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"rateType\\\": \\\"BASIC\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"salePrice\\\": 50000000000000,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"onSale\\\": true,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalSoldCount\\\": 0,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalStockCount\\\": 0\\n\"</span> +\n                    <span class=hljs-string>\" },\\n\"</span> +\n                    <span class=hljs-string>\"   {\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"calendarDate\\\": \\\"2019-12-02\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"rateType\\\": \\\"BASIC\\\",\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"salePrice\\\": 40000000000000,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"onSale\\\": true,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalSoldCount\\\": 0,\\n\"</span> +\n                    <span class=hljs-string>\"   \\\"totalStockCount\\\": 0\\n\"</span> +\n                    <span class=hljs-string>\" }\\n\"</span> +\n                    <span class=hljs-string>\"]\"</span>;\n            StringEntity entity = <span class=hljs-keyword>new</span> StringEntity ( patchBody,<span class=hljs-string>\"UTF-8\"</span> );\n            patch.setEntity ( entity );\n            <span class=hljs-comment>//execute</span>\n            httpExecute(patch);\n        } <span class=hljs-keyword>catch</span> ( Exception e ) {\n            e.printStackTrace ( );\n        }\n    }\n\n    <span class=hljs-function><span class=hljs-keyword>public</span> <span class=hljs-keyword>void</span> <span class=hljs-title>testDeleteMethod</span><span class=hljs-params>()</span> </span>{\n        <span class=hljs-comment>//params</span>\n        String method = <span class=hljs-string>\"DELETE\"</span>;\n        String travelProductId = <span class=hljs-string>\"***********\"</span>;\n        String vendorId = <span class=hljs-string>\"***********\"</span>;\n        String path = <span class=hljs-string>\"/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/\"</span>+travelProductId;\n\n        <span class=hljs-keyword>try</span> {\n            <span class=hljs-comment>//build uri</span>\n            URIBuilder uriBuilder = <span class=hljs-keyword>new</span> URIBuilder ( )\n                    .setPath ( path );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>//authorize, demonstrate how to generate hmac signature here</span>\n            String authorization = Hmac.generate ( method, uriBuilder.build ().toString (), SECRET_KEY, ACCESS_KEY );\n            <span class=hljs-comment>//print out the hmac key</span>\n            System.out.println ( authorization );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            uriBuilder.setScheme ( SCHEMA ).setHost ( HOST ).setPort ( PORT );\n            HttpDelete delete = <span class=hljs-keyword>new</span> HttpDelete ( uriBuilder.build ().toString () );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            <span class=hljs-comment>// set header, demonstarte how to use hmac signature here</span>\n            delete.addHeader ( <span class=hljs-string>\"Authorization\"</span>, authorization );\n            <span class=hljs-javadoc>/********************************************************/</span>\n            delete.addHeader ( <span class=hljs-string>\"content-type\"</span>, <span class=hljs-string>\"application/json\"</span> );\n            delete.addHeader ( <span class=hljs-string>\"Request-Vendor-Id\"</span>, vendorId );\n            <span class=hljs-comment>// execute</span>\n            httpExecute(delete);\n        } <span class=hljs-keyword>catch</span> ( Exception e ) {\n            e.printStackTrace ( );\n        }\n    }\n\n    <span class=hljs-function><span class=hljs-keyword>public</span> <span class=hljs-keyword>void</span> <span class=hljs-title>httpExecute</span><span class=hljs-params>(HttpUriRequest request)</span> </span>{\n\n        CloseableHttpClient client = <span class=hljs-keyword>null</span>;\n        <span class=hljs-keyword>try</span> {\n            <span class=hljs-comment>//create client</span>\n            client = HttpClients.createDefault ( );\n            CloseableHttpResponse response = <span class=hljs-keyword>null</span>;\n            <span class=hljs-keyword>try</span> {\n                <span class=hljs-comment>//execute get request</span>\n                response = client.execute ( request );\n                <span class=hljs-comment>//print result</span>\n                System.out.println ( <span class=hljs-string>\"status code:\"</span> + response.getStatusLine ( ).getStatusCode ( ) );\n                System.out.println ( <span class=hljs-string>\"status message:\"</span> + response.getStatusLine ( ).getReasonPhrase ( ) );\n                HttpEntity entity = response.getEntity ( );\n                System.out.println ( <span class=hljs-string>\"result:\"</span> + EntityUtils.toString ( entity ) );\n            } <span class=hljs-keyword>catch</span> ( Exception e ) {\n                e.printStackTrace ( );\n            } <span class=hljs-keyword>finally</span> {\n                <span class=hljs-keyword>if</span> (response != <span class=hljs-keyword>null</span>) {\n                    <span class=hljs-keyword>try</span> {\n                        response.close ( );\n                    } <span class=hljs-keyword>catch</span> ( IOException e ) {\n                        e.printStackTrace ( );\n                    }\n                }\n            }\n        } <span class=hljs-keyword>catch</span> ( Exception e ) {\n            e.printStackTrace ( );\n        } <span class=hljs-keyword>finally</span> {\n            <span class=hljs-keyword>if</span> (client != <span class=hljs-keyword>null</span>) {\n                <span class=hljs-keyword>try</span> {\n                    client.close ( );\n                } <span class=hljs-keyword>catch</span> ( IOException e ) {\n                    e.printStackTrace ( );\n                }\n            }\n        }\n    }\n\n    <span class=hljs-function><span class=hljs-keyword>public</span> <span class=hljs-keyword>static</span> <span class=hljs-keyword>void</span> <span class=hljs-title>main</span><span class=hljs-params>(String[] args)</span> </span>{\n        HmacReturnTest hmacTest = <span class=hljs-keyword>new</span> HmacReturnTest ( );\n        hmacTest.testGetMethod ();\n        hmacTest.testGetTourMethod ();\n        hmacTest.testPostMethod ();\n        hmacTest.testPutMethod ();\n        hmacTest.testPatchMethod ();\n        hmacTest.testDeleteMethod ();\n    }\n}\n</code></pre>";

/***/ }),

/***/ 469629816013851:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketBuyerInfoLookUp = function (_React$Component) {
	    _inherits(TicketBuyerInfoLookUp, _React$Component);
	
	    function TicketBuyerInfoLookUp(props) {
	        _classCallCheck(this, TicketBuyerInfoLookUp);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    TicketBuyerInfoLookUp.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uD2F0\uCF13 \uAD6C\uB9E4\uC790 \uC815\uBCF4 \uC870\uD68C API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uD2F0\uCF13 \uAD6C\uB9E4\uC790 \uC815\uBCF4\uB97C \uC870\uD68C\uD569\uB2C8\uB2E4. \uCD5C\uB300 1\uB144 \uC774\uB0B4\uC758 \uAD6C\uB9E4\uC790 \uC815\uBCF4\uB97C \uC77C\uC8FC\uC77C \uB2E8\uC704\uB85C \uC870\uD68C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v1/purchasers?searchStartDateTime=',
	                                '{searchStartDateTime}',
	                                '&searchEndDateTime=',
	                                '{searchEndDateTime}',
	                                '&dealId=',
	                                '{dealId}',
	                                '&offset=',
	                                '{offset}',
	                                '&limit=',
	                                '{limit}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/purchasers?searchStartDateTime=20170804000000&searchEndDateTime=20170804235959&dealId=3000000001&offset=0&limit=1000'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Query String Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'offset'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0 \uBC88\uD638 (\uCCAB\uBC88\uC9F8 \uD398\uC774\uC9C0 = 0)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'limit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD5C\uB300 \uC694\uCCAD \uAC2F\uC218 (\uCD5C\uB313\uAC12 = 1000)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'searchStartDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC \uAC80\uC0C9\uC2DC\uC791\uC77C (yyyyMMddHHmmss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'searchEndDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC \uAC80\uC0C9\uC885\uB8CC\uC77C (yyyyMMddHHmmss) - \uC2DC\uC791\uC77C\uB85C\uBD80\uD130 1\uC8FC\uC77C\uC774\uB0B4'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'userName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 \uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'phoneNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 \uD578\uB4DC\uD3F0 \uBC88\uD638 (010-xxxx-xxxx)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'email'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 email'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C \uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C \uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'purchaseDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uAC00\uACA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'status'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'CANCEL_COMPLETE(\uCDE8\uC18C\uC644\uB8CC), PURCHASE_COMPLETE(\uAD6C\uB9E4\uC644\uB8CC)'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "totalCount": 2,\n            "totalPageCount": 1,\n            "countPerPage": 1000,\n            "currentPage": 0,\n            "ticketPurchasers": [\n                {\n                    "ticketNumber": "9C320B-9000000000234",\n                    "userName": "\uAE40\uCFE0\uD321",\n                    "phoneNumber": null,\n                    "email": "coupang@coupang.com",\n                    "dealId": 6500124641,\n                    "dealName": "\uCFE0\uD321\uACFC \uD568\uAED8 \uBC14\uB85C\uC140\uB85C\uB098",\n                    "optionId": 53000424227,\n                    "optionName": "\uC989\uC2DC \uAC00\uAE30  ",\n                    "price": "1,000",\n                    "purchaseDateTime": "2017-07-05 05:17:13",\n                    "status": "PURCHASE_COMPLETE"\n                },\n                {\n                    "ticketNumber": "DCAA6C-9000000000235",\n                    "userName": "\uAE40\uCFE0\uD321",\n                    "phoneNumber": null,\n                    "email": "coupang@coupang.com",\n                    "dealId": 6500124641,\n                    "dealName": "\uCFE0\uD321\uACFC \uD568\uAED8 \uBC14\uB85C\uC140\uB85C\uB098",\n                    "optionId": 53000424227,\n                    "optionName": "\uC989\uC2DC \uAC00\uAE30  ",\n                    "price": "1,000",\n                    "purchaseDateTime": "2017-07-05 05:17:13",\n                    "status": "PURCHASE_COMPLETE"\n                }\n            ]\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'error'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'DATE_FORMATTER_ERROR_MESSAGE'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'yyyyMMddHHmmss \uD615\uD0DC\uB85C \uC694\uCCAD\uD574\uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'DATE_PERIOD_EXCEEDED'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD5C\uB300 31\uC77C\uAE4C\uC9C0 \uB370\uC774\uD130 \uC694\uCCAD \uAC00\uB2A5\uD569\uB2C8\uB2E4.'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ILLEGAL_VENDOR_IDS'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD574\uB2F9\uB418\uB294 accessId\uC5D0 \uB9F5\uD551\uB41C vendorId\uAC00 \uC874\uC7AC\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'INTERNAL_SERVER_ERROR'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Internal server error.'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LOWER_BOUND_ERROR'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC80\uC0C9\uC870\uAC74\uC744 \uC591\uC218\uAC12\uC73C\uB85C \uC694\uCCAD\uD574\uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'REQUEST_LIMIT_EXCEEDED'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD5C\uB300 1000\uAC1C\uAE4C\uC9C0 \uB370\uC774\uD130 \uC694\uCCAD \uAC00\uB2A5\uD569\uB2C8\uB2E4.'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'RESULT_NOT_FOUND'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD574\uB2F9\uB418\uB294 \uAC80\uC0C9\uC870\uAC74\uC5D0 \uB9DE\uB294 \uB370\uC774\uD130\uAC00 \uC874\uC7AC\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return TicketBuyerInfoLookUp;
	}(_react2.default.Component);
	
	exports.default = TicketBuyerInfoLookUp;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "TicketBuyerInfoLookup.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 475530201048940:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateLodgingInventory = function (_React$Component) {
	    _inherits(UpdateLodgingInventory, _React$Component);
	
	    function UpdateLodgingInventory(props) {
	        _classCallCheck(this, UpdateLodgingInventory);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateLodgingInventory.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC694\uAE08/\uC218\uB7C9'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC0C1\uD488 \uC635\uC158\uC758 \uC694\uAE08 \uBC0F \uC218\uB7C9\uC744 \uB4F1\uB85D/\uC5C5\uB370\uC774\uD2B8 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'PATCH'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/lodgings/',
	                                '{travelProductId}',
	                                '/rooms/',
	                                '{travelItemId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings/1234567890/rooms/11111111'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'inventoryDtos'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<LodgingInventoryRequestDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'rate id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'checkInDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778 \uB0A0\uC9DC(Format: yyyy-MM-dd).'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'stockCount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC7AC\uACE0 \uC218\uB7C9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'originalPrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6D0\uB798 \uAC00\uACA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'salePrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uAC00'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#patchInventoryDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'patchInventoryDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n  "lodgingInventoryDtos": [\n    {\n      "checkInDate": "2020-04-28",\n      "originalPrice": 100000,\n      "rateId": 572322710697279488,\n      "salePrice": 85000,\n      "stockCount": 20\n    },\n    {\n      "checkInDate": "2020-04-29",\n      "originalPrice": 100000,\n      "rateId": 572322710697279488,\n      "salePrice": 85000,\n      "stockCount": 20\n    },\n    {\n      "checkInDate": "2020-04-30",\n      "originalPrice": 100000,\n      "rateId": 572322710697279488,\n      "salePrice": 85000,\n      "stockCount": 20\n    },\n    {\n      "checkInDate": "2020-05-01",\n      "originalPrice": 100000,\n      "rateId": 572322710697279488,\n      "salePrice": 85000,\n      "stockCount": 20\n    },\n    {\n      "checkInDate": "2020-05-02",\n      "originalPrice": 100000,\n      "rateId": 572322710697279488,\n      "salePrice": 85000,\n      "stockCount": 20\n    },\n    {\n      "checkInDate": "2020-05-03",\n      "originalPrice": 100000,\n      "rateId": 572322710697279488,\n      "salePrice": 85000,\n      "stockCount": 20\n    },\n    {\n      "checkInDate": "2020-05-04",\n      "originalPrice": 100000,\n      "rateId": 572322710697279488,\n      "salePrice": 85000,\n      "stockCount": 20\n    }\n  ]\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'null'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Lodging inventory update request successfully received",\n    "data": null\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateLodgingInventory;
	}(_react2.default.Component);
	
	exports.default = UpdateLodgingInventory;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateLodgingInventory.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 540303210653771:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewSingleTicketProduct = function (_React$Component) {
	    _inherits(ViewSingleTicketProduct, _React$Component);
	
	    function ViewSingleTicketProduct(props) {
	        _classCallCheck(this, ViewSingleTicketProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewSingleTicketProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uB2E8\uC77C \uC870\uD68C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC0C1\uD488 ID(travelProductId)\uB85C \uB4F1\uB85D\uB41C \uC0C1\uD488\uC744 \uC870\uD68C\uD569\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets/',
	                                '{travelProductId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'TravelDto'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uB370\uC774\uD130 (\uC694\uCCAD \uAC12\uC744 \uCC38\uC870\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.)'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": {\n        "sellerProductId": "string",\n        "name": "Jenny_Test_5",\n        "adultOnly": true,\n        "subordinateIds": [\n            "string"\n        ],\n        "searchTags": [\n            "test1"\n        ],\n        "displayKeyword": "test1",\n        "images": [\n            {\n                "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_345855cf-a8a4-4dae-88aa-0797d665385d.jpg",\n                "sellerUrlMethod": "GET",\n                "representative": true,\n                "sellerImageCategory": "1234",\n                "imageGroup": "BASIC",\n                "description": "image 1 description",\n                "seq": 0\n            }\n        ],\n        "trafficInfo": "string",\n        "publicTransportInfo": "string",\n        "inventoryType":"PERIOD",\n        "nearbyLandmarks": null,\n        "locations": null,\n        "contents": [\n            {\n                "title": "product content title 2",\n                "type": "Product-Content",\n                "content": null,\n                "format": "IMAGE",\n                "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_345855cf-a8a4-4dae-88aa-0797d665385d.jpg",\n                "sellerUrlMethod": "GET",\n                "seq": 0\n            }\n        ],\n        "features": [\n            {\n                "featureId": "TYPE",\n                "featureValues": [\n                    "WIFI",\n                    "CAMERA"\n                ],\n                "description": ""\n            }\n        ],\n        "reservationNotifications": null,\n        "contacts": [\n            {\n                "contactType": "PHONE",\n                "contactUseType": "REPRESENTATIVE",\n                "contact": "010-0000-0000"\n            }\n        ],\n        "cancelPolicy": {\n            "notice": "string",\n            "cancelType": "AUTO",\n            "cancelPeriodType": "BEFORE_USE",\n            "cancelMarkType": "NOT_CANCELED",\n            "refundOnBusinessDay": true,\n            "refundUnusedTicket": true,\n            "refundRates": []\n        },\n        "introduction": "introduction test",\n        "notice": "string",\n        "benefits": [\n            "string"\n        ],\n        "hotelInfo": null,\n        "insuranceInfo": null,\n        "inclusionNotice": "string",\n        "exclusionNotice": "string",\n        "usageNotice": "test",\n        "reservationGuide": null,\n        "additionalInfoPrompt": "string",\n        "maxPurchaseQuantity": 0,\n        "csContactInfo": "string",\n        "taxType": "FREE",\n        "instantBooking": true,\n        "estimatedBookingDuration": 0,\n        "extension": null,\n        "travelProductId": 527852958679826432,\n        "productId": 10000000000680,\n        "vendorItemPackageId": 30000000000460,\n        "productDetailType": "READY_TO_TRIP",\n        "travelType": "OVERSEAS",\n        "displayCategoryCode": 108804,\n        "interlockingChannelType": null,\n        "vendorId": "A00100622",\n        "saleStatus": "ON_SALE",\n        "qcStatus": "COMPLETE_APPROVAL",\n        "displayChannels": null,\n        "userAgreements": null,\n        "reservationRequired": false,\n        "errors": null,\n        "travelItems": [\n            {\n                "sellerTravelItemId": "string",\n                "name": "test item 2",\n                "description": "string",\n                "seq": 0,\n                "features": [\n                    {\n                        "featureId": "OFFERING_SERVICE",\n                        "featureValues": [\n                            "NO_CHARGE_CALL",\n                            "UNLIMITED_USE"\n                        ],\n                        "description": ""\n                    }\n                ],\n                "taxType": "FREE",\n                "onSale": true,\n                "rates": [\n                    {\n                        "sellerRateId": "",\n                        "rateType": "BASIC",\n                        "priceType": "COUPANG_PRICE",\n                        "price": 0,\n                        "representative": true,\n                        "saleStartedAt": "2019-10-01 23:59:59",\n                        "saleEndedAt": "2019-12-31 23:59:59",\n                        "maxPurchaseQtyPerPerson": 0,\n                        "maxPurchaseQtyPeriod": 0,\n                        "seq": 0\n                    }\n                ],\n                "usePeriod": {\n                    "usePeriodName": "string",\n                    "useStartedAt": "2019-12-01 23:59:59",\n                    "useEndedAt": "2020-12-31 23:59:59"\n                },\n                "travelItemId": 527852958730158080,\n                "deleted": false\n            }\n        ],\n        "createdBy": "172.29.32.116",\n        "createdAt": "2019-12-27 23:19:15",\n        "modifiedBy": "SYSTEM",\n        "modifiedAt": "2019-12-27 23:19:21"\n    }\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewSingleTicketProduct;
	}(_react2.default.Component);
	
	exports.default = ViewSingleTicketProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewSingleTicketProduct.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 642862956009192:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes += ' ' + arg;
				} else if (Array.isArray(arg)) {
					classes += ' ' + classNames.apply(null, arg);
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes += ' ' + key;
						}
					}
				}
			}
	
			return classes.substr(1);
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 689334634470665:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewTicketItemInventories = function (_React$Component) {
	    _inherits(ViewTicketItemInventories, _React$Component);
	
	    function ViewTicketItemInventories(props) {
	        _classCallCheck(this, ViewTicketItemInventories);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewTicketItemInventories.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC7AC\uACE0 \uC870\uD68C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC758 \uC635\uC158 \uC815\uBCF4\uB97C \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4..'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets/',
	                                '{travelProductId}',
	                                '/items/',
	                                '{travelItemId}',
	                                '/inventories'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890/items/11111111/inventories'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '8', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '8', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '8', className: 'bold' },
	                                ' Query Parameters'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN_AND_CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778/\uC18C\uC778\uB3D9\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNIVERSITY_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACE0\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_AND_MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEENS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCCAD\uC18C\uB144'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PRESCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uCDE8\uD559\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC18C\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'INFANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'calendarDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uC815\uC77C\uC790(Format: yyyy-MM-dd)'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<InventoryDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                '\xA0calendarDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uC815\uC77C\uC790(Format: yyyy-MM-dd)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                '\xA0deadlineDay'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uD558\uB294 \uB0A0\uC9DC\uC804\uC5D0 \uBA87 \uC77C\uC5D0 \uD504\uB85C\uB355\uD2B8 \uD310\uB9E4\uB97C \uC911\uC9C0\uC2DC\uD0A4\uACA0\uC2B5\uB2C8\uAE4C? \uB514\uD3F4\uD2B8\uAC12:0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'deadlineHour'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uD558\uB294 \uB0A0\uC9DC \uB9C8\uC774\uB108\uC2A4 deadlineDay \uC804\uC5D0 \uBA87 \uC2DC\uAC04\uC5D0 \uD504\uB85C\uB355\uD2B8 \uD310\uB9E4\uB97C \uC911\uC9C0\uC2DC\uD0A4\uACA0\uC2B5\uB2C8\uAE4C? \uB370\uC774\uD130\uB294 1\uBD80\uD130 24\uAE4C\uC9C0\uC774\uBA70 \uB514\uD3F4\uD2B8\uAC12:24'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'onSale'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC911:true, \uD310\uB9E4\uC911\uC9C0:false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'salePrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'totalSoldCount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD1D\uD310\uB9E4\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'totalStockCount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD1D \uC7AC\uACE0 \uC218\uB7C9'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#toursResponseDto' },
	                            'Response Body Sample'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'toursResponseDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": [\n        {\n            "rateType": null,\n            "totalStockCount": 1,\n            "salePrice": 10000000,\n            "deadlineDay": 1,\n            "deadlineHour": 23,\n            "onSale": true,\n            "calendarDate": "2019-11-20",\n            "totalSoldCount": 0,\n            "usePeriod": null\n        }\n    ]\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewTicketItemInventories;
	}(_react2.default.Component);
	
	exports.default = ViewTicketItemInventories;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewTicketItemInventories.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 762558919458398:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.childrenPropType = childrenPropType;
	exports.onSelectPropType = onSelectPropType;
	exports.selectedIndexPropType = selectedIndexPropType;
	
	var _childrenDeepMap = __webpack_require__(5289629256324197);
	
	var _Tab = __webpack_require__(7925919092148657);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabList = __webpack_require__(228970576441975);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _TabPanel = __webpack_require__(7121215342470674);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function childrenPropType(props, propName, componentName) {
	  var error = void 0;
	  var tabsCount = 0;
	  var panelsCount = 0;
	  var tabListFound = false;
	  var listTabs = [];
	  var children = props[propName];
	
	  (0, _childrenDeepMap.deepForEach)(children, function (child) {
	    if (child.type === _TabList2.default) {
	      if (child.props && child.props.children && _typeof(child.props.children) === 'object') {
	        (0, _childrenDeepMap.deepForEach)(child.props.children, function (listChild) {
	          return listTabs.push(listChild);
	        });
	      }
	
	      if (tabListFound) {
	        error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
	      }
	      tabListFound = true;
	    }
	    if (child.type === _Tab2.default) {
	      if (!tabListFound || listTabs.indexOf(child) === -1) {
	        error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components have to be inside the 'TabList' component.");
	      }
	      tabsCount++;
	    } else if (child.type === _TabPanel2.default) {
	      panelsCount++;
	    }
	  });
	
	  if (!error && tabsCount !== panelsCount) {
	    error = new Error('There should be an equal number of \'Tab\' and \'TabPanel\' in `' + componentName + '`.' + ('Received ' + tabsCount + ' \'Tab\' and ' + panelsCount + ' \'TabPanel\'.'));
	  }
	
	  return error;
	}
	
	function onSelectPropType(props, propName, componentName, location, propFullName) {
	  var prop = props[propName];
	  var name = propFullName || propName;
	  var error = null;
	
	  if (prop && typeof prop !== 'function') {
	    error = new Error('Invalid ' + location + ' `' + name + '` of type `' + (typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) + '` supplied to `' + componentName + '`, expected `function`.');
	  } else if (props.selectedIndex != null && prop == null) {
	    error = new Error('The ' + location + ' `' + name + '` is marked as required in `' + componentName + '`, but its value is `undefined` or `null`.\n`onSelect` is required when `selectedIndex` is also set. Not doing so will make the tabs not do anything, as `selectedIndex` indicates that you want to handle the selected tab yourself.\nIf you only want to set the inital tab replace `selectedIndex` with `defaultIndex`.');
	  }
	
	  return error;
	}
	
	function selectedIndexPropType(props, propName, componentName, location, propFullName) {
	  var prop = props[propName];
	  var name = propFullName || propName;
	  var error = null;
	
	  if (prop != null && typeof prop !== 'number') {
	    error = new Error('Invalid ' + location + ' `' + name + '` of type `' + (typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) + '` supplied to `' + componentName + '`, expected `number`.');
	  } else if (props.defaultIndex != null && prop != null) {
	    return new Error('The ' + location + ' `' + name + '` cannot be used together with `defaultIndex` in `' + componentName + '`.\nEither remove `' + name + '` to let `' + componentName + '` handle the selected tab internally or remove `defaultIndex` to handle it yourself.');
	  }
	
	  return error;
	}

/***/ }),

/***/ 1449497434893056:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeleteTicketProductItem = function (_React$Component) {
	    _inherits(DeleteTicketProductItem, _React$Component);
	
	    function DeleteTicketProductItem(props) {
	        _classCallCheck(this, DeleteTicketProductItem);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    DeleteTicketProductItem.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC0C1\uD488 \uC635\uC158 \uC0AD\uC81C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC758 \uC635\uC158\uC744 \uC0AD\uC81C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'DELETE'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets/',
	                                '{travelProductId}',
	                                '/items/',
	                                '{travelItemId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890/items/12345678'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": 11111111\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return DeleteTicketProductItem;
	}(_react2.default.Component);
	
	exports.default = DeleteTicketProductItem;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "DeleteTicketProductItem.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 1479087788288239:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MutipleTicketUsageProcessing = function (_React$Component) {
	    _inherits(MutipleTicketUsageProcessing, _React$Component);
	
	    function MutipleTicketUsageProcessing(props) {
	        _classCallCheck(this, MutipleTicketUsageProcessing);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    MutipleTicketUsageProcessing.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uB2E4\uC218 \uD2F0\uCF13 \uC0AC\uC6A9 \uCC98\uB9AC API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uBBF8\uC0AC\uC6A9 \uC0C1\uD0DC\uC758 \uD2F0\uCF13\uC744 \uC0AC\uC6A9\uB41C \uC0C1\uD0DC\uB85C \uCC98\uB9AC \uD569\uB2C8\uB2E4. \uC774 API\uB97C \uC774\uC6A9\uD574 \uCD5C\uB300 5\uAC1C\uC758 \uD2F0\uCF13\uC744 \uC0AC\uC6A9\uCC98\uB9AC \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. '
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/multiple/redeem'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/multiple/redeem'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638 (default = null)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638 (default = null)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'quantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uD560 \uC218\uB7C9 (default = 1)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumbers'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638 \uB9AC\uC2A4\uD2B8'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "message" : "success",\n            "data" : {\n                        "8231E1-13000000000768" : {\n                            "code": "0000",\n                            "message" : "success"\n                        },\n                        "823ABC-13000000000769" : {\n                            "code": "0000",\n                            "message" : "success"\n                        }\n                    }\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0000'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'success'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9 \uCC98\uB9AC \uC131\uACF5'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0001'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon that was used'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8 \uC0AC\uC6A9\uCC98\uB9AC\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0002'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon that has been canceled'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0003'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'system error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB0B4\uBD80 \uC11C\uBC84 \uC5D0\uB7EC'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '500'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0004'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'invalid parameter'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCFE0\uD3F0\uBC88\uD638\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC744\uB54C(\uCFE0\uD3F0\uC774 \uC874\uC7AC\uD558\uC9C0 \uC54A\uC744\uB54C)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0005'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon useAmount invalid'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCC98\uB9AC\uC218\uB7C9\uC73C\uB85C \uCC98\uB9AC\uAC00 \uBD88\uAC00\uB2A5\uD560\uB54C(ex. 1\uD68C \uB0A8\uC558\uB294\uB370 2\uD68C \uC0AC\uC6A9\uCC98\uB9AC\uD558\uB824\uACE0 \uD560\uB54C)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0006'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'has no parameter'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD544\uC218 \uC785\uB825\uAC12\uC744 \uC785\uB825\uD558\uC9C0 \uC54A\uC558\uC744\uB54C'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0007'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'un used coupon'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD55C\uBC88\uB3C4 \uC0AC\uC6A9\uCC98\uB9AC \uB418\uC9C0 \uC54A\uC740 \uCFE0\uD3F0\uC744 \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0008'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon canceling'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC811\uC218\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0009'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon is already in progress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3D9\uC77C \uBC88\uD638\uC758 \uCFE0\uD3F0\uC774 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC911\uC77C\uB54C \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0010'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'couponNumber is duplicated'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCFE0\uD3F0\uBC88\uD638\uC758 \uCFE0\uD3F0\uC774 2\uAC1C \uC774\uC0C1 \uC874\uC7AC\uD560\uB54C'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '500'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0011'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'unauthorized vendor id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBBF8\uC778\uC99D vendorId\uB85C \uCFE0\uD3F0 \uCC98\uB9AC\uC2DC\uB3C4, \uBBF8\uC778\uC99D\uC740 acl\uC5D0 \uB4F1\uB85D\uB418\uC9C0 \uC54A\uC740 vendorId\uC778 \uACBD\uC6B0,',
	                                _react2.default.createElement('br', null),
	                                ' \uCC98\uB9AC\uD558\uB824\uB294 \uCFE0\uD3F0\uC758 vendorId\uC640 \uB2E4\uB97C \uACBD\uC6B0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return MutipleTicketUsageProcessing;
	}(_react2.default.Component);
	
	exports.default = MutipleTicketUsageProcessing;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "MutipleTicketUsageProcessing.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 1482121859620419:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _MenuLayout = __webpack_require__(8501594307383073);
	
	var _MenuLayout2 = _interopRequireDefault(_MenuLayout);
	
	var _GuideSideBar = __webpack_require__(219729406595023);
	
	var _GuideSideBar2 = _interopRequireDefault(_GuideSideBar);
	
	var _IntroContent = __webpack_require__(8386636578645942);
	
	var _IntroContent2 = _interopRequireDefault(_IntroContent);
	
	var _TicketAPIContent = __webpack_require__(321525095561427);
	
	var _TicketAPIContent2 = _interopRequireDefault(_TicketAPIContent);
	
	var _GetAPIKeyContent = __webpack_require__(7220459442453782);
	
	var _GetAPIKeyContent2 = _interopRequireDefault(_GetAPIKeyContent);
	
	var _FAQsContent = __webpack_require__(3027951262065701);
	
	var _FAQsContent2 = _interopRequireDefault(_FAQsContent);
	
	var _TourAPIContent = __webpack_require__(150382457790077);
	
	var _TourAPIContent2 = _interopRequireDefault(_TourAPIContent);
	
	var _HMacSignatureContent = __webpack_require__(3266623286041231);
	
	var _HMacSignatureContent2 = _interopRequireDefault(_HMacSignatureContent);
	
	var _Footer = __webpack_require__(2350188485298232);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _MainBanner = __webpack_require__(2886187413675904);
	
	var _MainBanner2 = _interopRequireDefault(_MainBanner);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	__webpack_require__(3703933408804179);
	
	__webpack_require__(6329104695656332);
	
	var _CreateTourProduct = __webpack_require__(5903247864544070);
	
	var _CreateTourProduct2 = _interopRequireDefault(_CreateTourProduct);
	
	var _CreateTourProductItems = __webpack_require__(8737297522905820);
	
	var _CreateTourProductItems2 = _interopRequireDefault(_CreateTourProductItems);
	
	var _DeleteTourProduct = __webpack_require__(5744599009178468);
	
	var _DeleteTourProduct2 = _interopRequireDefault(_DeleteTourProduct);
	
	var _DeleteTourProductItem = __webpack_require__(6195576110025848);
	
	var _DeleteTourProductItem2 = _interopRequireDefault(_DeleteTourProductItem);
	
	var _UpdateTourInventoryByDate = __webpack_require__(8600493323831505);
	
	var _UpdateTourInventoryByDate2 = _interopRequireDefault(_UpdateTourInventoryByDate);
	
	var _UpdateTourProduct = __webpack_require__(4150089103159804);
	
	var _UpdateTourProduct2 = _interopRequireDefault(_UpdateTourProduct);
	
	var _UpdateTourProductItem = __webpack_require__(1554313476952200);
	
	var _UpdateTourProductItem2 = _interopRequireDefault(_UpdateTourProductItem);
	
	var _ViewSingleTourProduct = __webpack_require__(2467110901838146);
	
	var _ViewSingleTourProduct2 = _interopRequireDefault(_ViewSingleTourProduct);
	
	var _ViewReservationList = __webpack_require__(5514153148102359);
	
	var _ViewReservationList2 = _interopRequireDefault(_ViewReservationList);
	
	var _ViewSingleOrderReservation = __webpack_require__(1945330911254992);
	
	var _ViewSingleOrderReservation2 = _interopRequireDefault(_ViewSingleOrderReservation);
	
	var _ViewConfirmReservation = __webpack_require__(6013708201064431);
	
	var _ViewConfirmReservation2 = _interopRequireDefault(_ViewConfirmReservation);
	
	var _ViewRejectReservation = __webpack_require__(4526404861839573);
	
	var _ViewRejectReservation2 = _interopRequireDefault(_ViewRejectReservation);
	
	var _ViewManagementHistory = __webpack_require__(1951455353603350);
	
	var _ViewManagementHistory2 = _interopRequireDefault(_ViewManagementHistory);
	
	var _ViewApprovalCancellation = __webpack_require__(6995356643797629);
	
	var _ViewApprovalCancellation2 = _interopRequireDefault(_ViewApprovalCancellation);
	
	var _ViewTourProductHistory = __webpack_require__(3095992240514420);
	
	var _ViewTourProductHistory2 = _interopRequireDefault(_ViewTourProductHistory);
	
	var _ViewTourProductList = __webpack_require__(7014169121198188);
	
	var _ViewTourProductList2 = _interopRequireDefault(_ViewTourProductList);
	
	var _TicketUsageProcessing = __webpack_require__(152998592313383);
	
	var _TicketUsageProcessing2 = _interopRequireDefault(_TicketUsageProcessing);
	
	var _MutipleTicketUsageProcessing = __webpack_require__(1479087788288239);
	
	var _MutipleTicketUsageProcessing2 = _interopRequireDefault(_MutipleTicketUsageProcessing);
	
	var _TicketFreeProcessing = __webpack_require__(4563773596670964);
	
	var _TicketFreeProcessing2 = _interopRequireDefault(_TicketFreeProcessing);
	
	var _MutipleTicketUnusedProcessing = __webpack_require__(4970350560183710);
	
	var _MutipleTicketUnusedProcessing2 = _interopRequireDefault(_MutipleTicketUnusedProcessing);
	
	var _TicketBuyerInfoLookup = __webpack_require__(469629816013851);
	
	var _TicketBuyerInfoLookup2 = _interopRequireDefault(_TicketBuyerInfoLookup);
	
	var _ViewTicketDetails = __webpack_require__(4387242569932491);
	
	var _ViewTicketDetails2 = _interopRequireDefault(_ViewTicketDetails);
	
	var _ViewMutipleTicketDetails = __webpack_require__(7076417321288329);
	
	var _ViewMutipleTicketDetails2 = _interopRequireDefault(_ViewMutipleTicketDetails);
	
	var _TicketRefundRequest = __webpack_require__(7340906541339508);
	
	var _TicketRefundRequest2 = _interopRequireDefault(_TicketRefundRequest);
	
	var _TicketRefundRequestList = __webpack_require__(8585802677143340);
	
	var _TicketRefundRequestList2 = _interopRequireDefault(_TicketRefundRequestList);
	
	var _ViewTicketBuyerInfoByV2API = __webpack_require__(6445149586794477);
	
	var _ViewTicketBuyerInfoByV2API2 = _interopRequireDefault(_ViewTicketBuyerInfoByV2API);
	
	var _TravelTicketBuyerInfoByV1API = __webpack_require__(4101044272864973);
	
	var _TravelTicketBuyerInfoByV1API2 = _interopRequireDefault(_TravelTicketBuyerInfoByV1API);
	
	var _ViewTicketBuyerInfoByOrderV = __webpack_require__(3209419146436878);
	
	var _ViewTicketBuyerInfoByOrderV2 = _interopRequireDefault(_ViewTicketBuyerInfoByOrderV);
	
	var _ViewCanceledTicketInfoV = __webpack_require__(4787353091300423);
	
	var _ViewCanceledTicketInfoV2 = _interopRequireDefault(_ViewCanceledTicketInfoV);
	
	var _CreateTicketProductItem = __webpack_require__(4108427237230249);
	
	var _CreateTicketProductItem2 = _interopRequireDefault(_CreateTicketProductItem);
	
	var _UpdateTicketProduct = __webpack_require__(2415487841710937);
	
	var _UpdateTicketProduct2 = _interopRequireDefault(_UpdateTicketProduct);
	
	var _UpdateTicketProductItem = __webpack_require__(8482719018238175);
	
	var _UpdateTicketProductItem2 = _interopRequireDefault(_UpdateTicketProductItem);
	
	var _StartToSellTicketProduct = __webpack_require__(3125539019903573);
	
	var _StartToSellTicketProduct2 = _interopRequireDefault(_StartToSellTicketProduct);
	
	var _StopToSellTicketProduct = __webpack_require__(233209352477664);
	
	var _StopToSellTicketProduct2 = _interopRequireDefault(_StopToSellTicketProduct);
	
	var _ViewSingleTicketProduct = __webpack_require__(540303210653771);
	
	var _ViewSingleTicketProduct2 = _interopRequireDefault(_ViewSingleTicketProduct);
	
	var _ViewTicketProductByPage = __webpack_require__(7950831717660649);
	
	var _ViewTicketProductByPage2 = _interopRequireDefault(_ViewTicketProductByPage);
	
	var _CreateTicketProduct = __webpack_require__(4681680635909653);
	
	var _CreateTicketProduct2 = _interopRequireDefault(_CreateTicketProduct);
	
	var _DeleteTicketProduct = __webpack_require__(7519069036365474);
	
	var _DeleteTicketProduct2 = _interopRequireDefault(_DeleteTicketProduct);
	
	var _DeleteTicketProductItem = __webpack_require__(1449497434893056);
	
	var _DeleteTicketProductItem2 = _interopRequireDefault(_DeleteTicketProductItem);
	
	var _ViewTourItemInventories = __webpack_require__(5368640261582402);
	
	var _ViewTourItemInventories2 = _interopRequireDefault(_ViewTourItemInventories);
	
	var _ViewTicketItemInventories = __webpack_require__(689334634470665);
	
	var _ViewTicketItemInventories2 = _interopRequireDefault(_ViewTicketItemInventories);
	
	var _UpdateTicketInventoryByDate = __webpack_require__(1549499131783229);
	
	var _UpdateTicketInventoryByDate2 = _interopRequireDefault(_UpdateTicketInventoryByDate);
	
	var _CreateTourProductV = __webpack_require__(8373411682089081);
	
	var _CreateTourProductV2 = _interopRequireDefault(_CreateTourProductV);
	
	var _UpdateTourProductV = __webpack_require__(3971358181474996);
	
	var _UpdateTourProductV2 = _interopRequireDefault(_UpdateTourProductV);
	
	var _UpdateTourInventoryByDateV = __webpack_require__(8914084046446817);
	
	var _UpdateTourInventoryByDateV2 = _interopRequireDefault(_UpdateTourInventoryByDateV);
	
	var _ViewTourItemInventoriesV = __webpack_require__(6542839653521249);
	
	var _ViewTourItemInventoriesV2 = _interopRequireDefault(_ViewTourItemInventoriesV);
	
	var _ReservationAndCancellationAPIContent = __webpack_require__(3003326045329452);
	
	var _ReservationAndCancellationAPIContent2 = _interopRequireDefault(_ReservationAndCancellationAPIContent);
	
	var _LodgingAPIContent = __webpack_require__(1899016425442059);
	
	var _LodgingAPIContent2 = _interopRequireDefault(_LodgingAPIContent);
	
	var _CreateLodgingProducts = __webpack_require__(7855088649851362);
	
	var _CreateLodgingProducts2 = _interopRequireDefault(_CreateLodgingProducts);
	
	var _CreateLodgingProductRooms = __webpack_require__(3161203245340427);
	
	var _CreateLodgingProductRooms2 = _interopRequireDefault(_CreateLodgingProductRooms);
	
	var _CreateLodgingProductRatePlans = __webpack_require__(7549376536968869);
	
	var _CreateLodgingProductRatePlans2 = _interopRequireDefault(_CreateLodgingProductRatePlans);
	
	var _DeleteLodgingProduct = __webpack_require__(1724267608630013);
	
	var _DeleteLodgingProduct2 = _interopRequireDefault(_DeleteLodgingProduct);
	
	var _DeleteLodgingRatePlan = __webpack_require__(2273315117932759);
	
	var _DeleteLodgingRatePlan2 = _interopRequireDefault(_DeleteLodgingRatePlan);
	
	var _GetLodgingProductInfo = __webpack_require__(3391341478554248);
	
	var _GetLodgingProductInfo2 = _interopRequireDefault(_GetLodgingProductInfo);
	
	var _UpdateLodgingProducts = __webpack_require__(2870738329518842);
	
	var _UpdateLodgingProducts2 = _interopRequireDefault(_UpdateLodgingProducts);
	
	var _UpdateLodgingProductRatePlan = __webpack_require__(3832903848408961);
	
	var _UpdateLodgingProductRatePlan2 = _interopRequireDefault(_UpdateLodgingProductRatePlan);
	
	var _UpdateLodingProductRoom = __webpack_require__(3555176258568410);
	
	var _UpdateLodingProductRoom2 = _interopRequireDefault(_UpdateLodingProductRoom);
	
	var _UpdateLodgingInventory = __webpack_require__(475530201048940);
	
	var _UpdateLodgingInventory2 = _interopRequireDefault(_UpdateLodgingInventory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GuideEntryContainer = function (_React$Component) {
	    _inherits(GuideEntryContainer, _React$Component);
	
	    function GuideEntryContainer(props) {
	        _classCallCheck(this, GuideEntryContainer);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        var active = _MenuLayout2.default.ACTIVE_DEFAULT;
	        _this.state = {
	            activeName: active.name,
	            contentPage: active.contentPage,
	            mainBannerText: "",
	            newDiv: _react2.default.createElement(_IntroContent2.default, null),
	            elementNameValue: "guides-section-01",
	            sidebar: {
	                $menu: [],
	                $pageHeader: []
	            },
	            divDic: {
	                "guides-section-01": _react2.default.createElement(_IntroContent2.default, null),
	                "guides-section-02": _react2.default.createElement(_HMacSignatureContent2.default, null),
	                "guides-section-03": _react2.default.createElement(_GetAPIKeyContent2.default, null),
	                "guides-section-07": _react2.default.createElement(_FAQsContent2.default, null),
	                // "guides-section-06": <ReservationAndCancellationAPIContent/>,
	
	                "ticket-usage-processing": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_TicketUsageProcessing2.default, null) }),
	                "mutiple-ticket-usage-processing": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_MutipleTicketUsageProcessing2.default, null) }),
	                "ticket-free-processing": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_TicketFreeProcessing2.default, null) }),
	                "mutiple-ticket-unused-processing": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_MutipleTicketUnusedProcessing2.default, null) }),
	                "ticket-buyer-info-lookup": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_TicketBuyerInfoLookup2.default, null) }),
	                "view-ticket-details": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_ViewTicketDetails2.default, null) }),
	                "view-mutiple-ticket-details": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_ViewMutipleTicketDetails2.default, null) }),
	                "ticket-refund-request": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_TicketRefundRequest2.default, null) }),
	                "ticket-refund-request-list": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_TicketRefundRequestList2.default, null) }),
	                "view-ticket-buyer-info-V2API": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_ViewTicketBuyerInfoByV2API2.default, null) }),
	                "travel-ticket-buyer-info-V1API": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_TravelTicketBuyerInfoByV1API2.default, null) }),
	                "view-ticket-buyer-info-by-order-V2": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_ViewTicketBuyerInfoByOrderV2.default, null) }),
	                "view-canceled-ticket-info-V2": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_ViewCanceledTicketInfoV2.default, null) }),
	                "create-tour-product": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_CreateTourProduct2.default, null) }),
	                "create-tour-product-items": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_CreateTourProductItems2.default, null) }),
	                "delete-tour-product": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_DeleteTourProduct2.default, null) }),
	                "delete-tour-product-item": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_DeleteTourProductItem2.default, null) }),
	                "update-tour-inventory-by-date": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateTourInventoryByDate2.default, null) }),
	                "view-tour-item-inventories": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_ViewTourItemInventories2.default, null) }),
	                "update-tour-product": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateTourProduct2.default, null) }),
	                "update-tour-product-item": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateTourProductItem2.default, null) }),
	
	                "view-tour-product-history": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_ViewTourProductHistory2.default, null) }),
	                "view-tour-product-list": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_ViewTourProductList2.default, null) }),
	                "create-ticket-product": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_CreateTicketProduct2.default, null) }),
	                "create-ticket-product-item": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_CreateTicketProductItem2.default, null) }),
	                "delete-ticket-product": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_DeleteTicketProduct2.default, null) }),
	                "delete-ticket-product-item": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_DeleteTicketProductItem2.default, null) }),
	                "update-ticket-product": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateTicketProduct2.default, null) }),
	                "update-ticket-product-item": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateTicketProductItem2.default, null) }),
	                "start-to-sell-ticket-product": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_StartToSellTicketProduct2.default, null) }),
	                "stop-to-sell-ticket-product": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_StopToSellTicketProduct2.default, null) }),
	                "view-single-ticket-product": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_ViewSingleTicketProduct2.default, null) }),
	                "view-ticket-product-by-page": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_ViewTicketProductByPage2.default, null) }),
	                "update-ticket-inventory-by-date": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateTicketInventoryByDate2.default, null) }),
	                "view-ticket-item-inventories": _react2.default.createElement(_TicketAPIContent2.default, { newDiv: _react2.default.createElement(_ViewTicketItemInventories2.default, null) }),
	                "create-tour-product-V2API": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_CreateTourProductV2.default, null) }),
	                "update-tour-product-V2API": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateTourProductV2.default, null) }),
	                "update-tour-inventory-by-date-V2API": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateTourInventoryByDateV2.default, null) }),
	                "view-tour-inventories-V2API": _react2.default.createElement(_TourAPIContent2.default, { newDiv: _react2.default.createElement(_ViewTourItemInventoriesV2.default, null) }),
	
	                "view-reservation-list": _react2.default.createElement(_ReservationAndCancellationAPIContent2.default, { newDiv: _react2.default.createElement(_ViewReservationList2.default, null) }),
	                "view-single-tour-product": _react2.default.createElement(_ReservationAndCancellationAPIContent2.default, { newDiv: _react2.default.createElement(_ViewSingleTourProduct2.default, null) }),
	                "view-single-order-reservation": _react2.default.createElement(_ReservationAndCancellationAPIContent2.default, { newDiv: _react2.default.createElement(_ViewSingleOrderReservation2.default, null) }),
	
	                "view-confirm-reservation": _react2.default.createElement(_ReservationAndCancellationAPIContent2.default, { newDiv: _react2.default.createElement(_ViewConfirmReservation2.default, null) }),
	                "view-reject-reservation": _react2.default.createElement(_ReservationAndCancellationAPIContent2.default, { newDiv: _react2.default.createElement(_ViewRejectReservation2.default, null) }),
	                "view-reservation-manage-history": _react2.default.createElement(_ReservationAndCancellationAPIContent2.default, { newDiv: _react2.default.createElement(_ViewManagementHistory2.default, null) }),
	                "view-approval-cancellation": _react2.default.createElement(_ReservationAndCancellationAPIContent2.default, { newDiv: _react2.default.createElement(_ViewApprovalCancellation2.default, null) }),
	
	                "create-lodging-products": _react2.default.createElement(_LodgingAPIContent2.default, { newDiv: _react2.default.createElement(_CreateLodgingProducts2.default, null) }),
	                "create-lodging-product-rooms": _react2.default.createElement(_LodgingAPIContent2.default, { newDiv: _react2.default.createElement(_CreateLodgingProductRooms2.default, null) }),
	                "create-lodging-product-rate-plans": _react2.default.createElement(_LodgingAPIContent2.default, { newDiv: _react2.default.createElement(_CreateLodgingProductRatePlans2.default, null) }),
	                "delete-lodging-product": _react2.default.createElement(_LodgingAPIContent2.default, { newDiv: _react2.default.createElement(_DeleteLodgingProduct2.default, null) }),
	                "delete-lodging-rate-plan": _react2.default.createElement(_LodgingAPIContent2.default, { newDiv: _react2.default.createElement(_DeleteLodgingRatePlan2.default, null) }),
	                "get-lodging-product-info": _react2.default.createElement(_LodgingAPIContent2.default, { newDiv: _react2.default.createElement(_GetLodgingProductInfo2.default, null) }),
	                "update-lodging-product-products": _react2.default.createElement(_LodgingAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateLodgingProducts2.default, null) }),
	                "update-lodging-product-rate-plan": _react2.default.createElement(_LodgingAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateLodgingProductRatePlan2.default, null) }),
	                "update-lodging-product-room": _react2.default.createElement(_LodgingAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateLodingProductRoom2.default, null) }),
	                "update-lodging-inventory": _react2.default.createElement(_LodgingAPIContent2.default, { newDiv: _react2.default.createElement(_UpdateLodgingInventory2.default, null) })
	
	            }
	        };
	        _this.standardTop = 492;
	        _this.divList = Object.keys(_this.state.divDic);
	        // this.handleHashChange();
	        return _this;
	    }
	
	    GuideEntryContainer.prototype.getActive = function getActive(hashValue) {
	        var activeKey = hashValue.indexOf("guides-") == 0 ? "guides" : hashValue;
	        return _MenuLayout2.default.ACTIVES[activeKey] || _MenuLayout2.default.ACTIVE_DEFAULT;
	    };
	
	    GuideEntryContainer.prototype.getMenuElement = function getMenuElement() {
	        if (!this.state.sidebar.$menu || this.state.sidebar.$menu.length <= 0) {
	            this.state.sidebar.$menu = (0, _jquery2.default)('.nav-sidebar li.m');
	        }
	        return this.state.sidebar.$menu;
	    };
	
	    GuideEntryContainer.prototype.getPageHeaderElement = function getPageHeaderElement() {
	        if (!this.state.sidebar.$pageHeader || this.state.sidebar.$pageHeader.length <= 0) {
	            this.state.sidebar.$pageHeader = (0, _jquery2.default)('.page-header');
	        }
	        return this.state.sidebar.$pageHeader;
	    };
	
	    GuideEntryContainer.prototype.getElementNameValue = function getElementNameValue(event) {
	        var _this2 = this;
	
	        console.log(event.target.name);
	        this.setState({ elementNameValue: event.target.name }, function () {
	            console.log(_this2.state.elementNameValue); //setState是异步操作，但是我们可以在它的回调函数里面进行操作
	            // console.log(this.state.oldDiv);
	            if (_this2.divList.includes(_this2.state.elementNameValue)) {
	                (0, _jquery2.default)("body,html").animate({ scrollTop: 442 }, 1000);
	            }
	        });
	    };
	
	    GuideEntryContainer.prototype.componentDidMount = function componentDidMount() {
	
	        var self = this;
	
	        (0, _jquery2.default)('.sidebar').addClass("f-nav").css("top", self.standardTop);
	
	        // menu class 추가
	        (0, _jquery2.default)(window).scroll(function () {
	            var $menu = self.getMenuElement(),
	                $contents = self.getPageHeaderElement();
	
	            //console.log("scroll");
	
	            var scltop = (0, _jquery2.default)(window).scrollTop();
	            var newScrollTop = self.standardTop - (0, _jquery2.default)(window).scrollTop();
	            (0, _jquery2.default)('.sidebar').addClass("f-nav").css("top", Math.max(newScrollTop, 70));
	            //     $.each($contents, function (idx, item) {
	            //         let $target = $contents.eq(idx),
	            //             i = $target.index(),
	            //             targetTop = $target.offset().top - $('.container-fluid').height() - 40;
	            //
	            //         if (targetTop <= scltop) {
	            //             $menu.removeClass('active');
	            //             $menu.eq(idx).addClass('active');
	            //         }
	            //         if (!(70 <= scltop)) {
	            //             $menu.removeClass('active');
	            //         }
	            //     })
	        });
	    };
	
	    GuideEntryContainer.prototype.handleChangeMainBannerText = function handleChangeMainBannerText(text) {
	        this.setState(function (old) {
	            old.mainBannerText = text;
	        });
	    };
	
	    // handleHashChange() {
	    //     let self = this;
	    //     $(window).on('hashchange', function () {
	    //         let hashValue = location.hash.slice(1) || "";
	    //
	    //         console.log(">>>>>>>>>>> hashValue", hashValue);
	    //
	    //         if (false == (hashValue.indexOf("guides") == 0)) {
	    //             self.setState(function (old) {
	    //                 old.sidebar = {};
	    //                 return old;
	    //             });
	    //         }
	    //
	    //         /***************************************************/
	    //
	    //         if (hashValue.indexOf("guides") == 0) {
	    //             let active = self.getActive("guides");
	    //             //console.log(">>>> active", active);
	    //             if (active && active.name) {
	    //                 self.handleMenuClick(active.name, active.contentPage.split(".")[1]);
	    //             }
	    //             return;
	    //         }
	    //
	    //         let active = self.getActive(hashValue);
	    //         if (active && active.name) {
	    //             self.handleMenuClick(active.name, active.contentPage.split(".")[1]);
	    //         }
	    //     });
	    // }
	
	    GuideEntryContainer.prototype.handleMenuClick = function handleMenuClick(activeName, type, func) {
	        type = type || "html";
	        this.setState(function (old) {
	            old.activeName = activeName;
	            old.contentPage = activeName + "." + type;
	            return old;
	        }, func || function () {});
	    };
	
	    GuideEntryContainer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState, nextContext) {
	        var keys = Object.keys(this.state.divDic);
	        return keys.includes(nextState.elementNameValue);
	    };
	
	    // shouldComponentUpdate(nextProps,nextState) {
	    //     let keys = Object.keys(this.state.divDic);
	    //
	    //     // !Object.keys(nextState.state.divDic).includes(nextState.elementNameValue);
	    // }
	
	    GuideEntryContainer.prototype.getRenderConponent = function getRenderConponent(elementNameValue) {
	        var renderDiv = null;
	        var divKeys = Object.keys(this.state.divDic);
	        if (divKeys.includes(this.state.elementNameValue)) {
	            return this.rederDiv = this.state.divDic[this.state.elementNameValue];
	            // this.oldDivChange(div);
	        }
	        return renderDiv;
	    };
	
	    GuideEntryContainer.prototype.renderHTML = function renderHTML(fileName) {
	        return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: GuideEntryContainer.pathToHTML(fileName, true) } });
	    };
	
	    GuideEntryContainer.prototype.renderContent = function renderContent() {
	        // const
	        return _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-3 col-md-2 sidebar f-nav', style: { top: 492 } },
	                _react2.default.createElement(_GuideSideBar2.default, { getElementNameValue: this.getElementNameValue.bind(this) })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-9 col-sm-offset-3 col-md-10 main', style: { top: -60 } },
	                this.getRenderConponent(this.state.elementNameValue)
	            )
	        );
	    };
	
	    GuideEntryContainer.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'red' },
	            _react2.default.createElement(_MenuLayout2.default, { activeName: this.state.activeName, onMenuClick: this.handleMenuClick.bind(this) }),
	            _react2.default.createElement(_MainBanner2.default, { onChange: this.handleChangeMainBannerText.bind(this), text: this.state.mainBannerText }),
	            _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                this.renderContent(),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(_Footer2.default, null)
	            )
	        );
	    };
	
	    return GuideEntryContainer;
	}(_react2.default.Component);
	
	GuideEntryContainer.pathToHTML = __webpack_require__(3);
	GuideEntryContainer.HTML_PREFIX = "./";
	exports.default = GuideEntryContainer;
	
	
	ReactDOM.render(_react2.default.createElement(GuideEntryContainer, null), document.getElementById('main-wrapper'));
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "GuideEntryContainer.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 1549499131783229:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateTicketInventoryByDate = function (_React$Component) {
	    _inherits(UpdateTicketInventoryByDate, _React$Component);
	
	    function UpdateTicketInventoryByDate(props) {
	        _classCallCheck(this, UpdateTicketInventoryByDate);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateTicketInventoryByDate.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC694\uAE08/\uC218\uB7C9'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC0C1\uD488 \uC635\uC158\uC758 \uC694\uAE08 \uBC0F \uC218\uB7C9\uC744 \uB4F1\uB85D/\uC5C5\uB370\uC774\uD2B8 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'PATCH'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets/',
	                                '{travelProductId}',
	                                '/items/',
	                                '{travelItemId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890/items/11111111'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'inventoryDtos'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<TravelItemInventoryDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN_AND_CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778/\uC18C\uC778\uB3D9\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNIVERSITY_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACE0\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_AND_MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEENS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCCAD\uC18C\uB144'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PRESCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uCDE8\uD559\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC18C\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'INFANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'calendarDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uC815\uC77C\uC790(Format: yyyy-MM-dd).\uC0C1\uD488 \uC778\uD15D\uD1A0\uB9AC \uD0C0\uC785\uC774 \u2018PERIOD\u2019 \uC77C \uACBD\uC6B0, calendarDate \uB294 \uC0AC\uC6A9\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'totalStockCount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD1D \uC7AC\uACE0 \uC218\uB7C9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'salePrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'onSale'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC0C1\uD0DC \uC124\uC815 / \uD310\uB9E4\uC911 : TRUE, \uD310\uB9E4\uC911\uC9C0 : FALSE (Default: FALSE)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'deadlineDay'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uD558\uB294 \uB0A0\uC9DC\uC804\uC5D0 \uBA87 \uC77C\uC5D0 \uD504\uB85C\uB355\uD2B8 \uD310\uB9E4\uB97C \uC911\uC9C0\uC2DC\uD0A4\uACA0\uC2B5\uB2C8\uAE4C? \uB514\uD3F4\uD2B8\uAC12:0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'deadlineHour'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                ' \uC0AC\uC6A9\uD558\uB294 \uB0A0\uC9DC \uB9C8\uC774\uB108\uC2A4 deadlineDay \uC804\uC5D0 \uBA87 \uC2DC\uAC04\uC5D0 \uD504\uB85C\uB355\uD2B8 \uD310\uB9E4\uB97C \uC911\uC9C0\uC2DC\uD0A4\uACA0\uC2B5\uB2C8\uAE4C? \uB370\uC774\uD130\uB294 1\uBD80\uD130 24\uAE4C\uC9C0\uC774\uBA70 \uB514\uD3F4\uD2B8\uAC12:24'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#patchInventoryDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'patchInventoryDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n[\n  {\n    "calendarDate": "2019-11-20",\n    "deadlineDay": 1,\n    "deadlineHour": 23,\n    "onSale": true,\n    "rateType": "BASIC",\n    "salePrice": 10000000,\n    "totalStockCount": 1\n  },\n    {\n    "calendarDate": "2019-11-21",\n    "deadlineDay": 1,\n    "deadlineHour": 23,\n    "onSale": true,\n    "rateType": "BASIC",\n    "salePrice": 10000000,\n    "totalStockCount": 1\n  },\n    {\n    "calendarDate": "2019-11-22",\n    "deadlineDay": 1,\n    "deadlineHour": 23,\n    "onSale": true,\n    "rateType": "BASIC",\n    "salePrice": 10000000,\n    "totalStockCount": 1\n  }\n]\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'null'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Partial Update Ticket Inventory Request accepted ",\n    "data": null\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateTicketInventoryByDate;
	}(_react2.default.Component);
	
	exports.default = UpdateTicketInventoryByDate;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateTicketInventoryByDate.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 1554313476952200:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateTourProductItem = function (_React$Component) {
	    _inherits(UpdateTourProductItem, _React$Component);
	
	    function UpdateTourProductItem(props) {
	        _classCallCheck(this, UpdateTourProductItem);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateTourProductItem.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { id: "update-tour-product-item" },
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC0C1\uD488 \uC635\uC158 \uC218\uC815 '
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC758 \uC635\uC158 \uC815\uBCF4\uB97C \uC218\uC815/\uC5C5\uB370\uC774\uD2B8 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'PUT'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tours/',
	                                '{travelProductId}',
	                                '/items/',
	                                '{travelItemId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/1234567890/items/11111111'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'sellerTravelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'onSale'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC911:true, \uD310\uB9E4\uC911\uC9C0:false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'period'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C\uC758 \uC5EC\uD589\uAE30\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'contents'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uCEE8\uD150\uCE20 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785\uC5D0 \uB300\uD55C \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825. \uC608:\uD328\uD0A4\uC9C0 \uD22C\uC5B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\' \uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \'\uC774\uBBF8\uC9C0\'\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\'\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url \uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'itineraries'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC77C\uC815 \uC81C\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815\uC5D0 \uAD00\uD55C \uACF5\uC9C0\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'courses'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC81C\uBAA9 \uC608) 1\uC77C\uCC28'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'summary'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC694\uC57D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'from'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD9C\uBC1C\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'to'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'details'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'HOTEL, FLIGHT, MEAL, SIGHTSEEING, SHOPPING, NOTICE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'mealName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2DD\uC0AC \uC81C\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'location'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC7A5\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightFrom'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uCD9C\uBC1C\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightTo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uBAA9\uC801\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightDepartureTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uCD9C\uBC1C\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightArrivalTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uB3C4\uCC29\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'duration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC18C\uC694\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'descriptions'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uB0B4\uC6A9 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uB0B4\uC6A9(\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT \uB514\uD3F4\uD2B8 \uAC12'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url \uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC11C\uBD80\uC77C\uC815 \uB0B4\uC6A9 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'feeIncluded'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08 \uD3EC\uD568\uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'optional'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815 \uC790\uC720\uC120\uD0DD \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'features'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Feature \uAD00\uB828 \uC138\uBD80 \uC0AC\uD56D\uC740 \uC5D1\uC140 \uD30C\uC77C \uCC38\uC870 \uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureValues'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<String>'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Feature \uAD00\uB828 \uC138\uBD80 \uC0AC\uD56D\uC740 \uC5D1\uC140 \uD30C\uC77C \uCC38\uC870 \uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'taxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'TaxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 taxType\uC774 \uC790\uB3D9\uC73C\uB85C \uBA74\uC138(FREE)\uB85C \uC124\uC815\uB418\uBA70, \uC774\uC678\uC758 taxType\uB97C \uC124\uC815 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACFC\uC138 (\uAE30\uBCF8\uAC12)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBA74\uC138'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ZERO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC138'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'rates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<TourRate>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC rate id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'TourRateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN_AND_CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778/\uC18C\uC778\uB3D9\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNIVERSITY_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACE0\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_AND_MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEENS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCCAD\uC18C\uB144'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PRESCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uCDE8\uD559\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC18C\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'INFANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'priceType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TOTAL_PRODUCT_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD1D \uC0C1\uD488 \uAC00\uACA9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC \uD648\uD398\uC774\uC9C0\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_MALL_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC\uBAB0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ONLINE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC628\uB77C\uC778 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TRAVEL_AGENCY_SPECIAL_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5EC\uD589\uC0AC \uD2B9\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESERVATION_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uB9E4\uCC98 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HOMEPAGE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD648\uD398\uC774\uC9C0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SITE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD604\uC7A5 \uD310\uB9E4\uAC00'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC6D0\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Default: TRUE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC2DC\uC791\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC885\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss). Default: 2099-12-31 23:59:59'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'maxPurchaseQtyPerPerson'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uB2F9 \uCD5C\uB300 \uAD6C\uB9E4 \uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'maxPurchaseQtyPeriod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4 \uC81C\uD55C \uAE30\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC21C\uC11C'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#putItemDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'putItemDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n            {\n                "sellerTravelItemId": "seller-item-id-2",\n                "name": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 4\uBC156\uC77C",\n                "description": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 4\uBC156\uC77C description",\n                "period": "4\uBC156\uC77C",\n                "seq": 1,\n                "features": [],\n                "taxType": "FREE",\n                "onSale": true,\n                "rates": [\n                    {\n                        "sellerRateId": "seller-rate-id-1",\n                        "rateType": "ADULT",\n                        "priceType": "COUPANG_PRICE",\n                        "price": 50000000,\n                        "representative": true,\n                        "saleStartedAt": "2019-11-01 01:00:00",\n                        "saleEndedAt": "2019-12-21 01:00:00",\n                        "maxPurchaseQtyPerPerson": 10,\n                        "maxPurchaseQtyPeriod": 1,\n                        "seq": 0\n                    },\n                    {\n                        "sellerRateId": "seller-rate-id-1",\n                        "rateType": "CHILD",\n                        "priceType": "COUPANG_PRICE",\n                        "price": 40000000,\n                        "representative": true,\n                        "saleStartedAt": "2019-11-01 01:00:00",\n                        "saleEndedAt": "2019-12-21 01:00:00",\n                        "maxPurchaseQtyPerPerson": 10,\n                        "maxPurchaseQtyPeriod": 1,\n                        "seq": 1\n                    }\n                ]\n            }\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "code": 200\n            "message" : "success"\n            "data" : 191043228223418368\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforUpdateItem' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforUpdateItem', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel-body' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC774\uB118 \uD0C0\uC785 ',
	                                            '${enumClazz.getSimpleName()}',
	                                            '\uC5D0 \uB300\uD55C \uBB34\uD6A8 \uBB38\uC790\uC5F4 \uAC12'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 seqs'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour item feature id'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour item feature value'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 \uC77C\uC790/\uC2DC\uAC04 \uD3EC\uB9F7, \uD3EC\uB9F7\uC774 ',
	                                            '{pattern}',
	                                            '\uC774\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uD310\uB9E4 \uC2DC\uC791\uC77C\uC740 \uD310\uB9E4 \uC885\uB8CC\uC77C\uBCF4\uB2E4 \uB2A6\uC9C0 \uC54A\uC544\uC57C\uD568'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateTourProductItem;
	}(_react2.default.Component);
	
	exports.default = UpdateTourProductItem;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateTourProductItem.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 1724267608630013:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeleteLodgingProduct = function (_React$Component) {
	    _inherits(DeleteLodgingProduct, _React$Component);
	
	    function DeleteLodgingProduct(props) {
	        _classCallCheck(this, DeleteLodgingProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    DeleteLodgingProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC219\uBC15 \uC0C1\uD488 API \uC0AD\uC81C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    ' \uC219\uBC15 \uC0C1\uD488 \uC0AD\uC81C'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'DELETE'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/lodgings/',
	                                '{travelProductId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings/1234567890'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Lodging product delete request successfully received",\n    "data": 572809504203210754\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return DeleteLodgingProduct;
	}(_react2.default.Component);
	
	exports.default = DeleteLodgingProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "DeleteLodgingProduct.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 1899016425442059:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LodgingAPIContent = function (_React$Component) {
	    _inherits(LodgingAPIContent, _React$Component);
	
	    function LodgingAPIContent(props) {
	        _classCallCheck(this, LodgingAPIContent);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    LodgingAPIContent.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'page-header', id: 'guides-section-08' },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'blog-title' },
	                    '\uC219\uBC15 API'
	                )
	            ),
	            this.props.newDiv
	        );
	    };
	
	    return LodgingAPIContent;
	}(_react2.default.Component);
	
	exports.default = LodgingAPIContent;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "LodgingAPIContent.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 1945330911254992:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewSingleOrderReservation = function (_React$Component) {
	    _inherits(ViewSingleOrderReservation, _React$Component);
	
	    function ViewSingleOrderReservation(props) {
	        _classCallCheck(this, ViewSingleOrderReservation);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewSingleOrderReservation.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { id: "view-single-order-reservation" },
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC608\uC57D \uB2E8\uC77C \uC870\uD68C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC8FC\uBB38 ID(orderID)\uB85C \uD310\uB9E4\uB41C \uC0C1\uD488\uC758 \uC608\uC57D\uC744 \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/reservations/',
	                                '{orderId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/reservations/1234567890'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'orderId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBB38 \uC544\uC774\uB514'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'responseDto'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Travel Item Id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Travel Rate Id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productDetailType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488 \uC0C1\uC138 \uD0C0\uC785'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'checkInDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'CheckIn Date'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'checkOutDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'CheckOut Date'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'penaltyPrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Penalty Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'arrivalTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uCC29\uC608\uC815\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'roomRequest'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4\uC694\uCCAD\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'additionalInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5C5\uCCB4 \uCEE4\uC2A4\uD140 \uD544\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorItemPackageName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC0C1\uD488\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorItemPackageId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uD15C \uD328\uD0A4\uC9C0 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorItemName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC0C1\uD488 \uC544\uC774\uD15C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uD15C \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Vendor Id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'userPhoneNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC800 \uC804\uD654 \uBC88\uD638r'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'userName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC800 \uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'userEmail'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC800 \uC774\uBA54\uC77C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'totalQuantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketStatusType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Enum'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD2F0\uCF13 \uC0C1\uD0DC'
	                                            ),
	                                            _react2.default.createElement('td', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CONFIRM_PENDING'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D\uB300\uAE30'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CONFIRMED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D\uD655\uC815'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CANCEL_RECEIPT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uC811\uC218'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CANCEL_PROCEEDING'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uC911'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CANCEL_COMPLETE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uC644\uB8CC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'USED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC1C\uD589\uC644\uB8CC'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13 \uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'salePrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uAC00\uACA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'reservedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D \uC77C\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'reservationModifiedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Reservation Update Time'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'reservationId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Reservation Id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88 \uC77C\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateCategoryId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'RateCategory Id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'purcahsedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4 \uC77C\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Product Type'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD504\uB85C\uB355\uD2B8 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'orderId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBB38 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'dailyInventoryPrices'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraPrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Extra Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraDepositPrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Extra Deposit Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'discountedSalePrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Discounted Sale Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'depositPrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Deposit Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'couponSrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Coupon Serial Number'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#responseDto' },
	                            'Response Body Sample'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'responseDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": {\n        "success": true,\n        "results": [\n            {\n                "travelProductId": "3556206588123456789",\n                "travelItemId": "355624954123456789",\n                "travelRateId": "355626726123456789",\n                "productDetailType": "HOTEL",\n                "penaltyPrice": null,\n                "arrivalTime": "",\n                "roomRequest": "",\n                "additionalInfo": null,\n                "vendorItemPackageName": "\uC8FC\uBB38\uC9C4 \uC704\uB108\uC2A4\uD638\uD154",\n                "vendorItemPackageId": 30000000539581,\n                "vendorItemName": "\uC2A4\uD0E0\uB2E4\uB4DC\uC628\uB3CC(\uC2DC\uD2F0\uBDF0) [\uB8F8\uC628\uB2C86-11\uC6D4\uD2B9\uAC00]\uC2A4\uD0E0\uB2E4\uB4DC\uC628\uB3CC(\uC2DC\uD2F0\uBDF0)",\n                "vendorItemId": 70000005963974,\n                "vendorId": "A00160447",\n                "userPhoneNumber": "010-1234-5678",\n                "userName": "abc",\n                "userEmail": "test@naver.com",\n                "totalQuantity": 1,\n                "ticketStatusType": "USED",\n                "ticketNumber": "6E0312-123456789",\n                "salePrice": 68966.0,\n                "reservedAt": "2021-02-21 00:00:00",\n                "reservationModifiedAt": "2021-02-19 12:42:59",\n                "reservationId": 12345678,\n                "refundedAt": null,\n                "rateCategoryId": 1234567,\n                "purchasedAt": "2021-02-19 12:42:56",\n                "productType": "ACCOMMODATION",\n                "productId": 10000000570160,\n                "orderId": 412345678890,\n                "dailyInventoryPrices": [\n                    {\n                        "price": 68966.0,\n                        "extraPrice": 0,\n                        "extraDepositPrice": 0,\n                        "discountedSalePrice": 68966.0,\n                        "depositPrice": 61380,\n                        "date": "2021-02-21"\n                    }\n                ],\n                "couponSrl": 4123456789,\n                "checkOutDate": "2021-02-22",\n                "checkInDate": "2021-02-21"\n            }\n        ],\n        "failMessage": null\n    }\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewSingleOrderReservation;
	}(_react2.default.Component);
	
	exports.default = ViewSingleOrderReservation;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewSingleOrderReservation.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 1951455353603350:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewConfirmReservation = function (_React$Component) {
		_inherits(ViewConfirmReservation, _React$Component);
	
		function ViewConfirmReservation(props) {
			_classCallCheck(this, ViewConfirmReservation);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		ViewConfirmReservation.prototype.render = function render() {
			var col_number_8 = 8;
			var total_levels = 6;
			var level1 = 5;
			var level2 = 4;
			var level2_prefix = level1 - level2;
			var level3 = 3;
			var level3_prefix = level1 - level3;
			var level4 = 2;
			var level4_prefix = level1 - level4;
			var level5 = 1;
			var level5_prefix = level1 - level5;
			return _react2.default.createElement(
				'div',
				{ id: "view-confirm-reject-reservation" },
				_react2.default.createElement(
					'h3',
					{ className: "mb0 mt40" },
					'\uC8FC\uBB38 \uC0C1\uD0DC \uC774\uB825 \uC870\uD68C'
				),
				_react2.default.createElement(
					'div',
					{ className: 'blog-post-meta' },
					_react2.default.createElement(
						'span',
						{ className: 's-post' },
						'\uD2F0\uCF13ID(ticketNumber)\uB97C \uD1B5\uD574 \uC8FC\uBB38 \uC0C1\uD0DC \uC774\uB825\uC744 \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
					),
					_react2.default.createElement(
						'h3',
						{ className: 'request-method' },
						_react2.default.createElement(
							'span',
							{ className: 'label label-success' },
							'POST'
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'Path'
								),
								_react2.default.createElement(
									'td',
									null,
									'Example Endpoint'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'/v1/marketplace/reservation/search/confirmation/history'
								),
								_react2.default.createElement(
									'td',
									null,
									'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/reservation/search/confirmation/history'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'h4',
						null,
						'Request Parameters'
					),
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: '4', className: 'bold' },
									'Request Header'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Required'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'Request-Vendor-Id'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: '4', className: 'bold' },
									'Query Parameter'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Required'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'ticketNumber'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uD2F0\uCF13 \uBC88\uD638'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'h4',
						null,
						'Response Specifications'
					),
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: level1 },
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'code'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uCF54\uB4DC'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'message'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uBA54\uC138\uC9C0'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'data'
								),
								_react2.default.createElement(
									'td',
									null,
									'responseDto'
								),
								_react2.default.createElement('td', null)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'key'
								),
								_react2.default.createElement(
									'td',
									null,
									'Long'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uB0B4\uBD80 \uAD00\uB9AC \uC544\uC774\uB514'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'value'
								),
								_react2.default.createElement(
									'td',
									null,
									'Array'
								),
								_react2.default.createElement(
									'td',
									null,
									_react2.default.createElement(
										'table',
										{ className: 'table table-striped' },
										_react2.default.createElement(
											'tbody',
											null,
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ colSpan: level4 },
													'\uC774\uB825 \uB9AC\uC2A4\uD2B8'
												),
												_react2.default.createElement('td', null),
												_react2.default.createElement('td', null)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'th',
													{ colSpan: level4 },
													'Name'
												),
												_react2.default.createElement(
													'th',
													null,
													'Type'
												),
												_react2.default.createElement(
													'th',
													null,
													'Description'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ colSpan: level4 },
													'ticketStatusHistoryId'
												),
												_react2.default.createElement(
													'td',
													null,
													'Long'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC774\uB825 \uC544\uC774\uB514'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ colSpan: level4 },
													'couponSrl'
												),
												_react2.default.createElement(
													'td',
													null,
													'Long'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uB0B4\uBD80 \uAD00\uB9AC \uC544\uC774\uB514'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ colSpan: level4 },
													'ticketNumber'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uD2F0\uCF13 \uBC88\uD638'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ colSpan: level4 },
													'modifiedByRole'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uBCC0\uACBD\uC790 \uC5ED\uD560'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ colSpan: level4 },
													'modifiedBy'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uBCC0\uACBD\uC790'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ colSpan: level4 },
													'fromStatusDesc'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC774\uC804 \uC0C1\uD0DC \uC124\uBA85'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ colSpan: level4 },
													'fromStatus'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC774\uC804 \uC0C1\uD0DC \uCF54\uB4DC'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ colSpan: level4 },
													'toStatusDesc'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uD604\uC7AC \uC0C1\uD0DC \uC124\uBA85'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ colSpan: level4 },
													'toStatus'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uD604\uC7AC \uC0C1\uD0DC \uCF54\uB4DC'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													{ colSpan: level4 },
													'createdAt'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC774\uB825 \uC0DD\uC131\uC77C'
												)
											)
										)
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'div',
						{ className: 'panel panel-default' },
						_react2.default.createElement(
							'div',
							{ className: 'panel-heading' },
							_react2.default.createElement(
								'h3',
								{ className: 'panel-title' },
								'\uC751\uB2F5\uAC12 \uC608\uC2DC'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'panel-body' },
							_react2.default.createElement(
								'pre',
								{ className: 'ty01' },
								'\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": {\n        "5000000000618": [\n            {\n                "ticketStatusHistoryId": 47908,\n                "couponSrl": 5000000000618,\n                "ticketNumber": "38F656-5000000000618",\n                "modifiedByRole": "",\n                "modifiedBy": "system",\n                "fromStatusDesc": "\uC608\uC57D\uD655\uC815",\n                "fromStatus": "CONFIRMED",\n                "toStatusDesc": "\uC0AC\uC6A9\uC644\uB8CC",\n                "toStatus": "USED",\n                "createdAt": "2020-02-25 16:03:13"\n            },\n            {\n                "ticketStatusHistoryId": 47907,\n                "couponSrl": 5000000000618,\n                "ticketNumber": "38F656-5000000000618",\n                "modifiedByRole": "",\n                "modifiedBy": "ikinye:external-test",\n                "fromStatusDesc": "\uC608\uC57D\uB300\uAE30",\n                "fromStatus": "CONFIRM_PENDING",\n                "toStatusDesc": "\uC608\uC57D\uD655\uC815",\n                "toStatus": "CONFIRMED",\n                "createdAt": "2020-02-25 16:03:13"\n            }\n        ]\n    }\n}\n                        '
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'HTTP CODE'
								),
								_react2.default.createElement(
									'th',
									null,
									'message'
								),
								_react2.default.createElement(
									'th',
									null,
									'\uC124\uBA85'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'400'
								),
								_react2.default.createElement(
									'td',
									null,
									'Bad request'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'401'
								),
								_react2.default.createElement(
									'td',
									null,
									'Unauthorized Error'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'403'
								),
								_react2.default.createElement(
									'td',
									null,
									'Forbidden Error'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'410'
								),
								_react2.default.createElement(
									'td',
									null,
									'The resource has been permanently deleted'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'412'
								),
								_react2.default.createElement(
									'td',
									null,
									'Precondition failed'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'429'
								),
								_react2.default.createElement(
									'td',
									null,
									'Too many requests'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'504'
								),
								_react2.default.createElement(
									'td',
									null,
									'API Gateway response timeout'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'521'
								),
								_react2.default.createElement(
									'td',
									null,
									'API provider server has error'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'524'
								),
								_react2.default.createElement(
									'td',
									null,
									'API provider to API gateway connection response timeout'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							)
						)
					)
				)
			);
		};
	
		return ViewConfirmReservation;
	}(_react2.default.Component);
	
	exports.default = ViewConfirmReservation;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewManagementHistory.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 1965880802553340:
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 2135400406923711:
/***/ (function(module, exports) {

	module.exports = "<pre class=\"php hljs\">\n    <code class=php>\n\n    <span class=hljs-meta>&lt;?php</span>\n    date_default_timezone_set(<span class=hljs-string>\"GMT+0\"</span>);\n\n    $datetime = date(<span class=hljs-string>\"ymd\"</span>).<span class=hljs-string>'T'</span>.date(<span class=hljs-string>\"His\"</span>).<span class=hljs-string>'Z'</span>;\n    $method = <span class=hljs-string>\"GET\"</span>;\n    $path = <span class=hljs-string>\"/v2/providers/travel_backbone_api/apis/ticket-api/v1/mock-up/purchasers\"</span>;\n    $query = <span class=hljs-string>\"searchStartDateTime=20170906000000&searchEndDateTime=20170906235959&offset=0&limit=1000\"</span>;\n\n    $message = $datetime.$method.$path.$query;\n\n    <span class=hljs-comment>//replace with your own accessKey</span>\n    $accesskey = <span class=hljs-string>\"****\"</span>;\n    <span class=hljs-comment>//replace with your own secretKey</span>\n    $secretkey = <span class=hljs-string>\"****\"</span>;\n\n    $algorithm = <span class=hljs-string>\"HmacSHA256\"</span>;\n\n    $signature = hash_hmac(<span class=hljs-string>'sha256'</span>, $message, $secretkey);\n\n    $authorization  = <span class=hljs-string>\"CEA algorithm=HmacSHA256, access-key=\"</span>.$accesskey.<span class=hljs-string>\", signed-date=\"</span>.$datetime.<span class=hljs-string>\", signature=\"</span>.$signature;\n\n    <span class=hljs-comment>//replace prod url when you need</span>\n    $url = <span class=hljs-string>'https://api-gateway.coupang.com'</span>.$path.<span class=hljs-string>'?'</span>.$query;\n\n    $curl = curl_init();\n    curl_setopt($curl, CURLOPT_URL, $url);\n    curl_setopt($curl, CURLOPT_CUSTOMREQUEST, $method);\n    curl_setopt($curl, CURLOPT_HTTPHEADER, <span class=hljs-keyword>array</span>(<span class=hljs-string>\"Content-Type:  application/json;charset=UTF-8\"</span>, <span class=hljs-string>\"Authorization:\"</span>.$authorization));\n    curl_setopt($curl, CURLOPT_RETURNTRANSFER, <span class=hljs-number>1</span>);\n    $result = curl_exec($curl);\n    curl_close($curl);\n\n    <span class=hljs-keyword>echo</span>($result);\n\n    <span class=hljs-meta>?&gt;</span>\n\n    </code>\n</pre>";

/***/ }),

/***/ 2273315117932759:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeleteLodgingProduct = function (_React$Component) {
	    _inherits(DeleteLodgingProduct, _React$Component);
	
	    function DeleteLodgingProduct(props) {
	        _classCallCheck(this, DeleteLodgingProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    DeleteLodgingProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC694\uAE08\uC81C API \uC0AD\uC81C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC219\uBC15 \uC0C1\uD488 \uC694\uAE08\uC81C \uC0AD\uC81C'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'DELETE'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/lodgings/',
	                                '{travelProductId}',
	                                '/rates/',
	                                '{rateId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings/1234567890/rates/11111111'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'rateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'rate id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'rate id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Rate plan delete request successfully received",\n    "data": 572809504203210752\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return DeleteLodgingProduct;
	}(_react2.default.Component);
	
	exports.default = DeleteLodgingProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "DeleteLodgingRatePlan.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 2350188485298232:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	    _inherits(Footer, _React$Component);
	
	    function Footer(props) {
	        _classCallCheck(this, Footer);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    Footer.prototype.componentDidMount = function componentDidMount() {};
	
	    Footer.prototype.render = function render() {
	        return _react2.default.createElement(
	            'footer',
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'Copyright Coupang Corp.,Ltd. All rights reserved.'
	            )
	        );
	    };
	
	    return Footer;
	}(_react2.default.Component);
	
	Footer.propTypes = {
	    //    activeName : React.PropTypes.string.isRequired,
	    //    onMenuClick : React.PropTypes.func.isRequired,
	    //    activeName2 : React.PropTypes.string.isRequired
	};
	exports.default = Footer;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "Footer.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 2404868040314224:
/***/ (function(module, exports) {

	module.exports = "<pre class=\"cs hljs\">\n    <code class=cs>\n\n    <span class=hljs-keyword>using</span> System;\n    <span class=hljs-keyword>using</span> System.Web;\n    <span class=hljs-keyword>using</span> System.Collections.Generic;\n    <span class=hljs-keyword>using</span> System.Diagnostics;\n    <span class=hljs-keyword>using</span> System.IO;\n    <span class=hljs-keyword>using</span> System.Linq;\n    <span class=hljs-keyword>using</span> System.Net;\n    <span class=hljs-keyword>using</span> System.Security.Cryptography;\n    <span class=hljs-keyword>using</span> System.Text;\n    <span class=hljs-keyword>using</span> System.Threading.Tasks;\n\n    <span class=hljs-keyword>using</span> System.Web.Script.Serialization;\n\n    <span class=hljs-keyword>namespace</span> <span class=hljs-title>ns_sample_get</span>\n    {\n        <span class=hljs-keyword>class</span> <span class=hljs-title>sample_get</span>\n        {\n\n            <span class=hljs-keyword>private</span> <span class=hljs-keyword>static</span> <span class=hljs-keyword>string</span> url = <span class=hljs-string>\"https://api-gateway.coupang.com\"</span>;\n            <span class=hljs-keyword>private</span> <span class=hljs-keyword>static</span> <span class=hljs-keyword>string</span> schema = <span class=hljs-string>\"https\"</span>;\n            <span class=hljs-keyword>private</span> <span class=hljs-keyword>static</span> <span class=hljs-keyword>int</span> port = <span class=hljs-number>443</span>;\n\n            <span class=hljs-keyword>private</span> <span class=hljs-keyword>string</span> path=<span class=hljs-string>\"/v2/providers/travel_backbone_api/apis/ticket-api/v1/mock-up/purchasers\"</span>;\n            <span class=hljs-comment>//replace with your own accessKey</span>\n            <span class=hljs-keyword>private</span> <span class=hljs-keyword>static</span> <span class=hljs-keyword>string</span> accessKey = <span class=hljs-string>\"****\"</span>;\n            <span class=hljs-comment>//replace with your own secretKey</span>\n            <span class=hljs-keyword>private</span> <span class=hljs-keyword>static</span> <span class=hljs-keyword>string</span> secretKey = <span class=hljs-string>\"****\"</span>;\n\n            <span class=hljs-function><span class=hljs-keyword>public</span> <span class=hljs-keyword>void</span> <span class=hljs-title>test</span>(<span class=hljs-params></span>)</span>{\n\n                <span class=hljs-keyword>string</span> method=<span class=hljs-string>\"GET\"</span>;\n\n                <span class=hljs-keyword>var</span> uriBuilder = <span class=hljs-keyword>new</span> UriBuilder(url+path);\n                <span class=hljs-keyword>var</span> parameters = HttpUtility.ParseQueryString(<span class=hljs-keyword>string</span>.Empty);\n                    parameters[<span class=hljs-string>\"searchStartDateTime\"</span>] = <span class=hljs-string>\"20130501000000\"</span>;\n                    parameters[<span class=hljs-string>\"searchEndDateTime\"</span>] = <span class=hljs-string>\"20130530000000\"</span>;\n                    parameters[<span class=hljs-string>\"offset\"</span>] = <span class=hljs-string>\"0\"</span>;\n                    parameters[<span class=hljs-string>\"limit\"</span>] = <span class=hljs-string>\"100\"</span>;\n                uriBuilder.Query = parameters.ToString();\n\n                <span class=hljs-keyword>string</span> query=uriBuilder.Query.ToString().Remove(<span class=hljs-number>0</span>,<span class=hljs-number>1</span>);\n\n                uriBuilder.Scheme = schema;\n                uriBuilder.Port = port;\n                Uri finalUrl = uriBuilder.Uri;\n\n                <span class=hljs-keyword>try</span>{\n                    HttpWebRequest request = (HttpWebRequest)HttpWebRequest.Create(finalUrl.ToString());\n\n                    request.Timeout = <span class=hljs-number>10000</span>;\n                    request.Method = method;\n\n                    request.ContentType = <span class=hljs-string>\"application/json;charset=UTF-8\"</span>;\n                    request.Headers[<span class=hljs-string>\"Authorization\"</span>] = GetHmac(method,query);\n\n                    <span class=hljs-keyword>var</span> response = (HttpWebResponse)request.GetResponse();\n                    <span class=hljs-comment>// Display the status ...</span>\n                    <span class=hljs-keyword>if</span> (response.StatusCode == HttpStatusCode.OK){\n                        Console.WriteLine(<span class=hljs-string>\"\n    Response Status Code is OK and StatusDescription is: {0}</span>\",response.StatusDescription);\n\n                       <span class=hljs-keyword> va</span>r responseStream = response.GetResponseStream();\n\n                        Encoding encode = System.Text.Encoding.GetEncoding<span class=hljs-string>(\"utf-8</span>\");\n                       <span class=hljs-comment> // Pipes the stream to a higher level stream reader with the required encoding format.</span>\n                        StreamReader reader =<span class=hljs-keyword> ne</span>w StreamReader( responseStream, encode );\n\n                       <span class=hljs-keyword> strin</span>g responseString = reader.ReadToEnd();\n\n                        reader.Close();\n                        responseStream.Close();\n                        response.Close();\n\n                        Console.WriteLine(responseString);\n                       <span class=hljs-comment> //Console.WriteLine(String.Format(\"Response: {0}\", responseString))</span>;\n                    <span class=hljs-keyword>}els</span>e{\n                        Console.WriteLine<span class=hljs-string>(\"\n    Response Status Code is Not OK and StatusDescription is: {0</span>}\",response.StatusDescription);\n                    }\n                }\n              <span class=hljs-keyword>  cat</span>ch(WebException e)\n                {\n                        Console.WriteLin<span class=hljs-string>e(\"\n    WebException Raised. The following error occured : {</span>0}\",e.Status);\n                    }\n             <span class=hljs-keyword>   ca</span>tch(Exception e)\n                {\n                    Console.WriteLi<span class=hljs-string>ne(\"\n    The following Exception was raised : {</span>0}\",e.Message);\n                }\n\n            }\n\n         <span class=hljs-function><span class=hljs-keyword>   priv</span>a<span class=hljs-keyword>te str</span>i<span class=hljs-title>ng GetH</span>m<span class=hljs-params><span class=hljs-keyword>ac(str</span>ing meth<span class=hljs-keyword>od,str</span>ing qu</span>ery)\n         </span>   {\n             <span class=hljs-keyword>   str</span>ing algorithm<span class=hljs-string> = \"HmacSHA2</span>56\";\n             <span class=hljs-keyword>   str</span>ing datetime = DateTime.Now.ToUniversalTime().ToStri<span class=hljs-string>ng(\"yyMMddTHHmms</span>sZ\");\n             <span class=hljs-keyword>   str</span>ing message = GenerateFormattedMessage(datetime, method, query);\n             <span class=hljs-keyword>   str</span>ing signature = CreateTokenByHMACSHA256(message);\n\n             <span class=hljs-keyword>   ret</span>urn GenerateFormattedHeader(algorithm, datetime, signature);\n            }\n\n         <span class=hljs-function><span class=hljs-keyword>   priv</span>a<span class=hljs-keyword>te str</span>i<span class=hljs-title>ng GenerateFormattedMess</span>a<span class=hljs-params><span class=hljs-keyword>ge(str</span>ing datetim<span class=hljs-keyword>e, str</span>ing metho<span class=hljs-keyword>d, str</span>ing qu</span>ery)\n         </span>   {\n             <span class=hljs-keyword>   ret</span>urn String.Form<span class=hljs-string>at(\"{0}{1}{2}{</span>3}\", datetime, method, path, query);\n            }\n\n         <span class=hljs-function><span class=hljs-keyword>   priv</span>ate Stri<span class=hljs-title>ng GenerateFormattedHea</span>d<span class=hljs-params><span class=hljs-keyword>er(str</span>ing algorith<span class=hljs-keyword>m, str</span>ing datetim<span class=hljs-keyword>e, str</span>ing signat</span>ure)\n         </span>   {\n             <span class=hljs-keyword>   ret</span>urn String.Form<span class=hljs-string>at(\"CEA algorithm={0}, access-key={1}, signed-date={2}, signature={</span>3}\", algorithm, accessKey, datetime, signature);\n            }\n\n         <span class=hljs-function><span class=hljs-keyword>   priv</span>ate Stri<span class=hljs-title>ng CreateTokenByHMACSHA</span>2<span class=hljs-params><span class=hljs-keyword>56(str</span>ing mess</span>age)\n         </span>   {\n                secretKey = secretKey <span class=hljs-string>??</span> \"\";\n             <span class=hljs-keyword>   </span>var encoding<span class=hljs-keyword> = </span>new System.Text.ASCIIEncoding();\n             <span class=hljs-keyword>   b</span>yte[] keyByte = encoding.GetBytes(secretKey);\n             <span class=hljs-keyword>   </span>var hmacsha256<span class=hljs-keyword> = </span>new HMACSHA256(keyByte);\n             <span class=hljs-keyword>   b</span>yte[] messageBytes = encoding.GetBytes(message);\n             <span class=hljs-keyword>   ret</span>urn ByteToString(hmacsha256.ComputeHash(messageBytes));\n            }\n\n         <span class=hljs-function><span class=hljs-keyword>   pub</span>l<span class=hljs-keyword>ic str</span>i<span class=hljs-title>ng ByteToStr</span>i<span class=hljs-params><span class=hljs-keyword>ng(b</span>yte[] b</span>uff)\n         </span>   {\n             <span class=hljs-keyword>   str</span>ing sbinary<span class=hljs-string> =</span> \"\";\n             <span class=hljs-keyword>   </span>fo<span class=hljs-keyword>r (</span>int i<span class=hljs-number> </span>= 0; i &lt; buff.Length; i++)\n                {\n                    sbinary += buff[i].ToStri<span class=hljs-string>ng(\"</span>x2\"<span class=hljs-comment>); // hex for</span>mat\n                }\n             <span class=hljs-keyword>   ret</span>urn sbinary;\n            }\n\n         <span class=hljs-function><span class=hljs-keyword>   sta</span>t<span class=hljs-keyword>ic v</span>o<span class=hljs-title>id M</span>a<span class=hljs-params><span class=hljs-keyword>in(str</span>ing[] a</span>rgs)\n         </span>   {\n                sample_get myob<span class=hljs-keyword>j= </span>new sample_get();\n                myobj.test();\n            }\n        }\n    }\n\n    </code>\n</pre>";

/***/ }),

/***/ 2415487841710937:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateTicketProduct = function (_React$Component) {
	    _inherits(UpdateTicketProduct, _React$Component);
	
	    function UpdateTicketProduct(props) {
	        _classCallCheck(this, UpdateTicketProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateTicketProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                ' \uC0C1\uD488 \uC218\uC815'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC758 \uC815\uBCF4\uB97C \uC218\uC815/\uC5C5\uB370\uC774\uD2B8 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\x0B'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'PUT'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets/',
	                                '{travelProductId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '8', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'adultOnly'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '19\uC138\uBBF8\uB9CC \uAD6C\uB9E4\uBD88\uAC00. Default:FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'reservationRequired'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC804 \uC608\uC57D\uC608\uC57D \uC5EC\uBD80,\uC778\uBCA4\uD1A0\uB9AC \uD0C0\uC785\uC774 Daily \uC77C \uACBD\uC6B0 \uC774 \uD544\uB4DC\uC758 \uAC12\uC740 false \uC785\uB2C8\uB2E4. Default:FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'subordinateIds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uAD00\uB9AC \uC11C\uBE0CID \uB9AC\uC2A4\uD2B8'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'searchTags'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC11C\uCE58\uD0DC\uADF8 \uB9AC\uC2A4\uD2B8'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'images'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\uAC00 \uC0C1\uD488 \uB300\uD45C\uD568, \uC0C1\uD488\uB2F9 \uB2E8\uC77C \uB300\uD45C\uC774\uBBF8\uC9C0 \uBCF4\uC720. Default: FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerImageCategory'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 \uCE74\uD14C\uACE0\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'imageGroup'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'VIEW'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FACILITY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD80\uB300\uC2DC\uC124'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESTAURANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DD\uB2F9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ROOM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        )
	                                    )
	                                ),
	                                '\uB514\uD3F4\uD2B8 \uAC12: BASIC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC21C\uC11C.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'trafficInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCC3E\uC544\uAC00\uB294 \uAE38 \uC124\uBA85\uD558\uB294 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'publicTransportInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uB300\uC911\uAD50\uD1B5 \uC815\uBCF4 \uC124\uBA85\uD558\uB294 \uC790\uC720 \uD14D\uC2A4\uD2B8 \uC785\uB825.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'nearbyLandmarks'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uAD00\uAD11\uC9C0 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C \uC704\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C \uACBD\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C\uAE4C\uC9C0\uC758 \uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'distanceUnit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Default:METER',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'KILOMETER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD0AC\uB85C\uBBF8\uD130'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'METER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uD130'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'direction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC11C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTH'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTH'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTHEAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTHWEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81\uC11C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTHEAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTHWEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8\uC11C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'transportations'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SUBWAY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC9C0\uD558\uCCA0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BUS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC84\uC2A4'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'operationPeriods'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'startTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'endTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'locations'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 locations\uAC00 \uD544\uC218 \uAC12\uC774 \uC544\uB2D8. Locations \uAC12\uC774 \uC785\uB825\uB41C \uACBD\uC6B0 \uAF2D \uC815\uD655\uD55C \uAC12\uC73C\uB85C \uC785\uB825\uD574\uC57C\uD568.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0 \uC704\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0 \uACBD\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'roadNameAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uB85C\uBA85\uC8FC\uC18C.\uB3C4\uB85C\uBA85 \uB610\uB294 \uC9C0\uBC88\uC8FC\uC18C \uC911 \uCD5C\uC18C\uD55C \uD55C\uAC00\uC9C0\uB294 \uC785\uB825\uD574\uC57C \uD568'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'landNumberAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uBC88\uC8FC\uC18C. \uB3C4\uB85C\uBA85 \uB610\uB294 \uC9C0\uBC88\uC8FC\uC18C \uC911 \uCD5C\uC18C\uD55C \uD55C\uAC00\uC9C0\uB294 \uC785\uB825\uD574\uC57C \uD568'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6D\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'province'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD589\uC815\uB2E8\uC704 \uC8FC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'city'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'district'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C, \uAD6C\uC5ED'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'town'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC74D \uBA74 \uB3D9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'zipCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B0\uD3B8\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'contents'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uCEE8\uD150\uCE20 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785\uC5D0 \uB300\uD55C \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825. \uC608:\uD328\uD0A4\uC9C0 \uD22C\uC5B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\' \uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \'\uC774\uBBF8\uC9C0\'\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\'\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url \uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'features'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureValues'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC18D\uC131 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'reservationGuide'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D\uAC00\uC774\uB4DC \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'reservationNotifications'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBA54\uC77C \uC8FC\uC18C, \uC804\uD654\uBC88\uD638 \uD639\uC740 \uD329\uC2A4 \uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactDescription'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'contacts'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WEBSITE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC6F9\uC0AC\uC774\uD2B8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactUseType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'REPRESENTATIVE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD45C\uC5F0\uB77D\uCC98*\uD544\uC218'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BOOKING_INQUIRY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D\uBB38\uC758 \uC5F0\uB77D\uCC98'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CANCEL_INQUIRY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uBB38\uC758 \uC5F0\uB77D\uCC98'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMERGENCY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE34\uAE09\uC5F0\uB77D\uB9DD'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contact'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608: \uC5F0\uB77D\uCC98 \uD0C0\uC785\uC774 \uD3F0\uC774\uBA74: 010-0000-0000'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'cancelPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uACF5\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AUTO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uB3D9\uCDE8\uC18C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778\uCDE8\uC18C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelMarkType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uB2F9 \uC5C6\uC74C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_CANCELED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNUSE_REFUND_ALL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uC0AC\uC6A9 100%\uD658\uBD88'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_REFUND_AFTER_RECEIPT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD2F0\uCF13 \uBC1C\uC1A1 \uD6C4 \uD658\uBD88 \uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_REFUND_AFTER_RESERVATION_CONFIRM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D \uD655\uC815 \uD6C4 \uD658\uBD88 \uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNUSE_REFUND_ALL_BEFORE_ONE_DAY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uC6A9\uC77C 1\uC77C\uC804\uAE4C\uC9C0 100%\uD658\uBD88'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DEPENDING_ON_VENDOR'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5C5\uCCB4 \uADDC\uC815\uC5D0 \uB530\uB984'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundOnBusinessDay'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC601\uC5C5\uC77C \uAE30\uC900 \uCDE8\uC18C \uC811\uC218 \uC5EC\uBD80 (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundUnusedTicket'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBBF8\uC0AC\uC6A9 \uD2F0\uCF13 100% \uD658\uBD88 \uC5EC\uBD80 (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundRates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9CC\uC57D cancelMarkType\uC774 \u2018\uC5C5\uCCB4\uADDC\uC815\uC5D0 \uB530\uB984\u2019\uC778 \uACBD\uC6B0, \uD658\uBD88\uC728 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'conditionDays'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uC77C x \uC77C \uC804 \uAE4C\uC9C0 \uD658\uBD88 \uAC00\uB2A5'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'conditionTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uC77C x \uC77C y \uC2DC \uC804 \uAE4C\uC9C0 \uD658\uBD88 \uAC00\uB2A5 format: HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'refundRate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC728 ex: rate 70% is 70'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'cancellable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC544\uC774\uD15C \uD310\uB9E4 \uC0C1\uD0DC (Default: TRUE)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'introduction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC0C1\uD488 \uC18C\uAC1C\uB9D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uC6A9\uC548\uB0B4 \uBC0F \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'benefits'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uBCC4\uD788 \uC81C\uACF5\uB418\uB294 \uD61C\uD0DD \uBC0F \uBCF4\uB108\uC2A4\u2018\uB780 \uAD6C\uB9E4 \uACE0\uAC1D\uC5D0\uAC8C \uD2B9\uBCC4\uD558\uAC8C \uC81C\uACF5\uB418\uB294 \uD61C\uD0DD\uC73C\uB85C \uC2E4\uC81C \uBCF8 \uC0C1\uD488\uC678\uC5D0 \uBB34\uB8CC \uD639\uC740 \uD560\uC778\uB418\uC5B4 \uC81C\uACF5\uB418\uB294 \uC120\uBB3C\uC774\uB098 \uC11C\uBE44\uC2A4\uB97C \uB9D0\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'insuranceInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCF4\uD5D8\uC815\uBCF4 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DDl'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'inclusionNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD3EC\uD568\uC0AC\uD56D \uAE30\uC7AC (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'exclusionNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBD88\uD3EC\uD568 \uC0AC\uD56D \uAE30\uC7AC (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'publication'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'useBarcode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCFE0\uD321 \uD2F0\uCF13\uBC88\uD638 \uBC14\uCF54\uB4DC \uBCC0\uD658 \uC5EC\uBD80 ((Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'isUseDirect'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC989\uC2DC\uC0AC\uC6A9 \uC5EC\uBD80, \uC219\uBC15\uC758 \uACBD\uC6B0 : true, \uAE30\uD0C0 \uD0C0\uC785\uC758 \uACBD\uC6B0 : false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'externalCouponUseType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC678\uBD80\uD2F0\uCF13\uBC88\uD638 \uC0AC\uC6A9\uC720\uD615'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'useExternalTicketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC678\uBD80\uD2F0\uCF13\uBC88\uD638 \uC0AC\uC6A9\uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketUsage'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uC81C\uACF5\uBC25\uBC95',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            ),
	                                            _react2.default.createElement('th', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PURCHASE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAD6C\uB9E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BARCODE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC14\uCF54\uB4DC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BARCODE_REAL_TIME'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC14\uCF54\uB4DC \uC2E4\uC2DC\uAC04'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'E_TICKET'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'E-\uD2F0\uCF13'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DELIVERY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC30\uC1A1'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ON_SITE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD604\uC7A5'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketSendCriteriaType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13 \uBC1C\uC1A1 \uAE30\uC900',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DAY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TIME'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DC\uAC04'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5C6\uC74C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketSendSpentTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13 \uBC1C\uC1A1 \uC18C\uC694 \uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketSendLimitTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13 \uB2F9\uC77C \uBC1C\uC1A1 \uAE30\uC900 \uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'usageNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC758\uC0AC\uD56D \uAE30\uC7AC (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'additionalInfoPrompt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488 \uC8FC\uBB38/\uC608\uC57D\uC5D0 \uD544\uC694\uD55C \uACE0\uAC1D\uC815\uBCF4\uB97C \uC218\uC9D1\uD560\uC218 \uC788\uC2B5\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'maxPurchaseQuantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC778\uB2F9 \uAD6C\uB9E4 \uCD5C\uB300 \uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'csContactInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D\uC548\uB0B4 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'taxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 taxType\uC774 \uC790\uB3D9\uC73C\uB85C \uBA74\uC138(FREE)\uB85C \uC124\uC815\uB418\uBA70, \uC774\uC678\uC758 taxType\uB97C \uC124\uC815 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACFC\uC138 (\uAE30\uBCF8\uAC12)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBA74\uC138'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ZERO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC138'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'instantBooking'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC989\uC2DC \uC608\uC57D (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'estimatedBookingDuration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D\uD655\uC815 \uC18C\uC694\uC2DC\uAC04, \uC989\uC2DC\uC608\uC57D\uC774 FALSE \uB77C\uBA74 \uD544\uC694.\uB370\uC774\uD130\uB294 0 \uBD80\uD130 72\uAE4C\uC9C0\uC774\uBA70'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'extension'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                "Map<String,String>"
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE30\uD0C0 \uC815\uBCF4\uC0AC\uD56D \uC790\uC720 \uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#updateTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'updateTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n  "additionalInfoPrompt": "string",\n  "adultOnly": true,\n  "benefits": [\n    "string"\n  ],\n  "cancelPolicy": {\n    "cancelMarkType": "NOT_REFUND_AFTER_RECEIPT",\n    "cancelType": "AUTO",\n    "notice": "string",\n    "refundOnBusinessDay": true,\n    "refundUnusedTicket": true\n  },\n  "contacts": [\n    {\n      "contact": "010-0000-0000",\n      "contactType": "PHONE",\n      "contactUseType": "REPRESENTATIVE"\n    }\n  ],\n  "contents": [\n    {\n                "title": "product content title 2",\n                "type": "Product-Content",\n                "content": null,\n                "format": "IMAGE",\n                "sellerUrl": "http://img.modetour.com/eagle/photoimg/39982/bfile/635116574873322964.jpg",\n                "sellerUrlMethod": "GET",\n                "seq": 0\n            }\n  ],\n  \n  "csContactInfo": "string",\n \n  "displayKeyword": "string",\n  "estimatedBookingDuration": 0,\n  "exclusionNotice": "string",\n  "extension": {},\n  "features": [\n  \t{\n  \t\t"description":"",\n  \t\t"featureId":"TYPE",\n  \t\t"featureValues":[\n  \t\t\t"WIFI","CAMERA"\n  \t\t\t]\n  \t}\n  ],\n  "images": [\n            {\n                "sellerUrl": "http://img.modetour.com/eagle/photoimg/39975/bfile/635993410305760918.JPG",\n                "sellerUrlMethod": "GET",\n                "representative": true,\n                "sellerImageCategory": "1234",\n                "imageGroup": "BASIC",\n                "description": "image 1 description",\n                 "seq": 0\n            }\n  ],\n  "inclusionNotice": "string",\n  "instantBooking": true,\n  "introduction": "string",\n  "inventoryType": "DAILY",\n  "maxPurchaseQuantity": 0,\n  "name": "Test Update Product 999999",\n  "notice": "string",\n  "publicTransportInfo": "string",\n  "publication": {\n    "externalCouponUseType": "string",\n    "isUseDirect": true,\n    "ticketSendCriteriaType": "string",\n    "ticketSendLimitTime": 0,\n    "ticketSendSpentTime": 0,\n    "ticketUsage": "string",\n    "useBarcode": true,\n    "useExternalTicketNumber": true\n  },\n  "searchTags": [\n    "string"\n  ],\n  "sellerProductId": "string",\n  "subordinateIds": [\n    "string"\n  ],\n  "taxType": "ZERO",\n  "themes": [\n    "string"\n  ],\n  "trafficInfo": "string",\n  "travelItems": [\n    {\n      "description": "string",\n        "features": [\n        \t{\n        \t\t"description":"",\n        \t\t"featureId":"OFFERING_SERVICE",\n        \t\t"featureValues":[\n        \t\t\t"NO_CHARGE_CALL","UNLIMITED_USE"\n        \t\t\t]\n        \t}\n      ],\n      "name": "test item 2",\n      "onSale": true,\n      "rates": [\n        {\n          "maxPurchaseQtyPerPerson": 0,\n          "maxPurchaseQtyPeriod": 0,\n          "price": 0,\n          "priceType": "COUPANG_PRICE",\n          "rateType": "BASIC",\n          "representative": true,\n          "saleEndedAt": "2019-12-31 23:59:59",\n          "saleStartedAt": "2019-10-01 00:00:00",\n          "sellerRateId": "",\n          "seq": 0\n        }\n      ],\n      "sellerTravelItemId": "string",\n      "seq": 0,\n      "taxType": "TAX",\n      "usePeriod": {\n        "useEndedAt": "2019-12-31 23:59:59",\n        "usePeriodName": "string",\n        "useStartedAt": "2019-12-01 23:59:59"\n      }\n    }\n  ],\n \n  "usageNotice": "test"\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n  "code": 0,\n  "data": 0,\n  "message": "string"\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesForUpdateProduct' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesForUpdateProduct', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel-body' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC774\uB118 \uD0C0\uC785 ',
	                                            '${enumClazz.getSimpleName()}',
	                                            '\uC5D0 \uB300\uD55C \uBB34\uD6A8 \uBB38\uC790\uC5F4 \uAC12'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'images\uAC00 \uBE44\uC5B4\uC788\uC744 \uC218 \uC5C6\uC74C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uB300\uD45C \uC774\uBBF8\uC9C0 \uB2E8 \uD55C\uC7A5\uB9CC \uD5C8\uC6A9 \uAC00\uB2A5'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uAD6D\uB0B4 \uC5EC\uD589\uC5D0 \uB300\uD55C locations\uAC00 \uBE44\uC5B4\uC788\uC73C\uBA74 \uC548\uB428 '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'landNumberAddress\uC911 \uD558\uB098\uC640 roadNameAddress\uB97C \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 seqs '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uAC00 \uC544\uB2CC \uACBD\uC6B0 content\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uC778 \uACBD\uC6B0 sellerUrl\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'instantBooking\uC774 false\uC778 \uACBD\uC6B0 estimatedBookingDuration\uC774 0\uBCF4\uB2E4 \uD06C\uACE0 72\uBCF4\uB2E4 \uC791\uAC70\uB098 \uAC19\uC544\uC57C\uB428'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC5F0\uB77D\uCC98\uC5D0 \uB300\uD45C \uC804\uD654 \uBC88\uD638\uAC00 \uD558\uB098 \uC788\uC5B4\uC57C\uD568 '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 travel feature id '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 travel feature value'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 \uC77C\uC790/\uC2DC\uAC04 \uD3EC\uB9F7, \uD3EC\uB9F7\uC774 ',
	                                            '{pattern}',
	                                            '\uC774\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uD310\uB9E4 \uC2DC\uC791\uC77C\uC740 \uD310\uB9E4 \uC885\uB8CC\uC77C\uBCF4\uB2E4 \uB2A6\uC9C0 \uC54A\uC544\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC0C1\uD488 inventoryType\uC774 PERIOD\uC778 \uACBD\uC6B0 usePeriod\uAC00 NULL\uC774\uBA74 \uC548\uB428'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'inventoryType\uC774 DAILY\uC778 \uACBD\uC6B0 usePeriod\uAC00 \uBD88\uD544\uC694\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'publication\uC740 null\uC774 \uC544\uB2C8\uC5B4\uC57C\uD568'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateTicketProduct;
	}(_react2.default.Component);
	
	exports.default = UpdateTicketProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateTicketProduct.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 2467110901838146:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewSingleTourProduct = function (_React$Component) {
	    _inherits(ViewSingleTourProduct, _React$Component);
	
	    function ViewSingleTourProduct(props) {
	        _classCallCheck(this, ViewSingleTourProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewSingleTourProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { id: 'view-single-tour-product' },
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uB2E8\uC77C \uC870\uD68C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    ' \uC0C1\uD488 ID(travelProductId)\uB85C \uB4F1\uB85D\uB41C \uC0C1\uD488\uC744 \uC870\uD68C\uD569\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tours/',
	                                '{travelProductId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/1234567890'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'TravelTourDto'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uB370\uC774\uD130 (\uC5EC\uD589\uC0C1\uD488 \uC0DD\uC131\uC2DC \uC694\uCCAD \uAC12\uC744 \uCC38\uC870\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.)'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#collapse' },
	                            'Response Data Sample'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'collapse', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": {\n        "sellerProductId": "seller-product-id",\n        "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 6/7\uC77C \uD328\uD0A4\uC9C0",\n        "adultOnly": false,\n        "subordinateIds": null,\n        "searchTags": [\n            "\uC911\uAD6D\uC7A5\uAC00\uACC4",\n            "\uC7A5\uAC00\uACC4\uC5EC\uD589"\n        ],\n        "displayKeyword": "\uC778\uCC9C\u51FA",\n        "images": [\n            {\n                "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n                "sellerUrlMethod": "GET",\n                "representative": true,\n                "sellerImageCategory": "1234",\n                "imageGroup": "BASIC",\n                "description": "image 1 description",\n                "seq": 0\n            },\n            {\n                "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n                "sellerUrlMethod": "GET",\n                "representative": false,\n                "sellerImageCategory": "1234",\n                "imageGroup": "BASIC",\n                "description": "image 2 description",\n                "seq": 1\n            },\n            {\n                "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",\n                "sellerUrlMethod": "GET",\n                "representative": false,\n                "sellerImageCategory": "1234",\n                "imageGroup": "BASIC",\n                "description": "image 3 description",\n                "seq": 2\n            },\n            {\n                "sellerUrl": "http://image15.coupangcdn.com/image/bannerunit/bannerunit_c5b412fb-44cd-4cfb-b632-bafd1270fef8.jpg",\n                "sellerUrlMethod": "GET",\n                "representative": false,\n                "sellerImageCategory": "1234",\n                "imageGroup": "BASIC",\n                "description": "image 4 description",\n                "seq": 3\n            }\n        ],\n        "trafficInfo": "\uC81C\uC8FC\uACF5\uD56D \uCC28\uB7C9 \uC57D 3km",\n        "publicTransportInfo": "\uC6A9\uB450\uC554 \uCC28\uB7C9 \uC57D 1km",\n        "nearbyLandmarks": [\n            {\n                "name": "nearby 1",\n                "latitude": 10.1,\n                "longitude": 20.2,\n                "distance": 300,\n                "distanceUnit": "METER",\n                "direction": null,\n                "transportations": []\n            },\n            {\n                "name": "nearby 1",\n                "latitude": 30.3,\n                "longitude": 40.4,\n                "distance": 2,\n                "distanceUnit": "KILOMETER",\n                "direction": null,\n                "transportations": []\n            }\n        ],\n        "locations": [\n            {\n                "latitude": 80.11,\n                "longitude": 20.12,\n                "roadNameAddress": "\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4 \uC81C\uC8FC\uC2DC \uC6A9\uD574\uB85C 21-6",\n                "landNumberAddress": "\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4 \uC81C\uC8FC\uC2DC \uC6A9\uB2F4\uC0BC\uB3D9 1016",\n                "nation": "\uB300\uD55C\uBBFC\uAD6D",\n                "province": null,\n                "city": "\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4",\n                "district": "\uC81C\uC8FC\uC2DC",\n                "town": "\uC6A9\uB2F4\uC0BC\uB3D9",\n                "zipCode": "63150"\n            }\n        ],\n        "contents": [\n            {\n                "title": "product content title 1",\n                "type": "Product-Content",\n                "content": "product content 1: text",\n                "format": "TEXT",\n                "sellerUrl": null,\n                "sellerUrlMethod": "GET",\n                "seq": 0\n            },\n            {\n                "title": "product content title 2",\n                "type": "Product-Content",\n                "content": null,\n                "format": "IMAGE",\n                "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n                "sellerUrlMethod": "GET",\n                "seq": 1\n            },\n            {\n                "title": "product content title 3",\n                "type": "Product-Content",\n                "content": null,\n                "format": "IMAGE",\n                "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n                "sellerUrlMethod": "GET",\n                "seq": 2\n            },\n            {\n                "title": "product content title 2",\n                "type": "Product-Content",\n                "content": null,\n                "format": "IMAGE",\n                "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",\n                "sellerUrlMethod": "GET",\n                "seq": 3\n            }\n        ],\n        "features": [\n            {\n                "featureId": "ADDITIONAL_EXPENSE",\n                "featureValues": [\n                    "ADDITIONAL_EXPENSE_EXCLUDE"\n                ],\n                "description": null\n            },\n            {\n                "featureId": "SHOPPING",\n                "featureValues": [\n                    "SHOPPING_INCLUDE"\n                ],\n                "description": null\n            },\n            {\n                "featureId": "FREE_SCHEDULE",\n                "featureValues": [\n                    "FREE_SCHEDULE_EXCLUDE"\n                ],\n                "description": null\n            }\n        ],\n        "themes": [\n            "SIGHT_SEEING",\n            "WATER_SPORTS"\n        ],\n        "reservationNotifications": [\n            {\n                "type": "PHONE",\n                "contactInfo": "010-1234-5678",\n                "contactDescription": "order notification phone number"\n            },\n            {\n                "type": "EMAIL",\n                "contactInfo": "coupang@coupang.com",\n                "contactDescription": "order notification email"\n            }\n        ],\n        "contacts": [\n            {\n                "contactType": "PHONE",\n                "contactUseType": "REPRESENTATIVE",\n                "contact": "02-1544-3663"\n            },\n            {\n                "contactType": "PHONE",\n                "contactUseType": "BOOKING_INQUIRY",\n                "contact": "02-1544-3663"\n            },\n            {\n                "contactType": "PHONE",\n                "contactUseType": "EMERGENCY",\n                "contact": "02-1544-3663"\n            },\n            {\n                "contactType": "PHONE",\n                "contactUseType": "CANCEL_INQUIRY",\n                "contact": "02-1544-3663"\n            }\n        ],\n        "itineraries": [\n            {\n                "name": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4 3\uBC155\uC77C]",\n                "notice": "\u203B\uBCF8 \uC0C1\uD488\uC740 \uBAA8\uB450\uD22C\uC5B4\uC758 \uB3D9\uC77C\uD56D\uACF5\uC758 \uB2E4\uB978\uC0C1\uD488\uACFC \uD604\uC9C0\uC5D0\uC11C \uC870\uC778(\uD569\uB958) \uB418\uC5B4 \uC9C4\uD589\uB420 \uC218 \uC788\uC73C\uBA70, \uCD9C\uBC1C 1\uC77C\uC804\uAE4C\uC9C0 \uC77C\uC815 \uD655\uC815\uC2DC \uD648\uD398\uC774\uC9C0 \uB4F1\uC744 \uD1B5\uD574 \uD655\uC778 \uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n\u203B\uBCF8 \uC0C1\uD488\uC740 \uC608\uC57D\uC2DC\uC810\uC5D0 \uB530\uB77C \uC0C1\uD488\uAC00\uAC00 \uC0C1\uC774\uD560 \uC218 \uC788\uC73C\uBA70 \uAE08\uC561 \uCC28\uC774\uC5D0 \uB300\uD574\uC11C\uB294 \uCD94\uD6C4 \uD658\uBD88 \uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\\n\u203B\uC77C\uC815\uC0C1\uC758 \uD45C\uAE30\uB41C \uD638\uD154\uC740 \uD604\uC9C0 \uC0AC\uC815\uC0C1 \uAC00\uB2A5\uD55C \uD638\uD154\uC774\uB098 \uB3D9\uAE09 \uD638\uD154\uB85C \uBCC0\uACBD\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\u203B\uC7A5\uAC00\uACC4 \uC77C\uC815 \uC911 \uC1FC\uD551\uC13C\uD130 \uC678 \uCC28\uB7C9\uB0B4 \uAE30\uB150\uD488 \uD310\uB9E4 \uBC0F \uB18D\uC218\uC0B0\uD488 \uD310\uB9E4\uB97C \uD558\uBA70, \uD544\uC694\uD55C \uACE0\uAC1D\uC5D0 \uD55C\uD558\uBA70 \uAD6C\uB9E4\uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n\u203B\uD604\uC9C0\uC0AC\uC815(\uAE30\uD6C4, \uB3C4\uB85C\uB4F1)\uC5D0 \uB530\uB77C \uC18C\uBE44\uC790\uC758 \uB3D9\uC758\uB97C \uC5BB\uC5B4 \uC5EC\uD589\uC77C\uC815 \uBCC0\uACBD\uC774 \uAC00\uB2A5\uD558\uBA70, \uAE30\uC0C1\uC545\uD654\uC5D0 \uB530\uB77C \uC77C\uBD80 \uAD00\uAD11\uC9C0\uAC00 \uC81C\uD55C\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n---111111",\n                "courses": [\n                    {\n                        "name": "1 \uC77C\uCC28 - 1",\n                        "summary": "2019\uB144 10\uC6D4 14\uC77C \uC6D4\uC694\uC77C - 1",\n                        "from": "\uC778\uCC9C (ICN)\uCD9C\uBC1C - 1",\n                        "to": "\uC911\uACBD (CKG)\uB3C4\uCC29 - 1",\n                        "details": [\n                            {\n                                "type": "NOTICE",\n                                "mealName": null,\n                                "location": null,\n                                "hotelName": null,\n                                "flightFrom": null,\n                                "flightTo": null,\n                                "flightDepartureTime": "19:00:00",\n                                "flightArrivalTime": "19:00:00",\n                                "duration": null,\n                                "distance": null,\n                                "descriptions": [\n                                    {\n                                        "title": "\uC911\uACBD \uB2E8\uCCB4\uBE44\uC790 \uC785\uAD6D\uC2DC \uC720\uC758 \uC0AC\uD56D - 1",\n                                        "type": null,\n                                        "content": "\uAC1C\uC694 : \u25CE \uC911\uAD6D \uBE44\uC790 \uC785\uAD6D \uC21C\uC11C \u25CE\\n1. \uC5EC\uAD8C\uACFC \uBE44\uC790 \uC6D0\uBCF8\uC744 \uD655\uC778 \uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n-\uC911\uAD6D \uBE44\uC790 \uC6D0\uBCF8\uC740 \uBD89\uC740\uC0C9 \uB3C4\uC7A5\uC774 \uCC0D\uD600 \uC788\uC2B5\uB2C8\uB2E4.\\n2. \uBE44\uC790 1\uBC88\uC5D0 \uC788\uB294 \uC190\uB2D8\uAED8\uC11C \uC5EC\uAD8C\uACFC \uBE44\uC790 \uC6D0\uBCF8, \uBCF5\uC0AC\uBCF8 1\uBD80\uB97C \uC785\uAD6D\uC2EC\uC0AC\uB300\uC5D0 \uC81C\uCD9C \uD569\uB2C8\uB2E4.\\n3. \uBE44\uC790\uC5D0 \uB098\uC640 \uC788\uB294 \uC21C\uC11C\uB300\uB85C \uC785\uAD6D\uC2EC\uC0AC\uB300\uB97C \uD1B5\uACFC\uD569\uB2C8\uB2E4.\\n4. \uBE44\uC790 \uB9C8\uC9C0\uB9C9\uC5D0 \uC788\uB294 \uC190\uB2D8\uAED8\uC11C\uB294 \uBE44\uC790 \uC6D0\uBCF8\uC744 \uBC1B\uC544 \uC624\uC154\uC57C \uD569\uB2C8\uB2E4.\\n(\uBE44\uC790 \uC6D0\uBCF8\uC740 \uCD9C\uAD6D \uC2DC \uC81C\uCD9C\uD569\uB2C8\uB2E4.)\\n---111111",\n                                        "format": "TEXT",\n                                        "sellerUrl": null,\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 0\n                                    }\n                                ],\n                                "seq": 0,\n                                "feeIncluded": true,\n                                "optional": false\n                            },\n                            {\n                                "type": "FLIGHT",\n                                "mealName": null,\n                                "location": null,\n                                "hotelName": null,\n                                "flightFrom": "\uC778\uCC9C (ICN)\uCD9C\uBC1C - 1",\n                                "flightTo": "\uC911\uACBD (CKG)\uB3C4\uCC29 - 1",\n                                "flightDepartureTime": "10-14 (\uC6D4) 15:10",\n                                "flightArrivalTime": "10-14 (\uC6D4) 17:40",\n                                "duration": null,\n                                "distance": null,\n                                "descriptions": [\n                                    {\n                                        "title": "Fight Title Required",\n                                        "type": null,\n                                        "content": "CA440\uD3B8-03\uC2DC\uAC04 30\uBD84 \uC18C\uC694",\n                                        "format": "TEXT",\n                                        "sellerUrl": null,\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 0\n                                    }\n                                ],\n                                "seq": 1,\n                                "feeIncluded": true,\n                                "optional": false\n                            },\n                            {\n                                "type": "MEAL",\n                                "mealName": "\uC11D\uC2DD",\n                                "location": null,\n                                "hotelName": null,\n                                "flightFrom": null,\n                                "flightTo": null,\n                                "flightDepartureTime": null,\n                                "flightArrivalTime": null,\n                                "duration": null,\n                                "distance": null,\n                                "descriptions": [\n                                    {\n                                        "title": "Meal Title Required",\n                                        "type": null,\n                                        "content": "\uD604\uC9C0\uC2DD",\n                                        "format": "TEXT",\n                                        "sellerUrl": null,\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 0\n                                    }\n                                ],\n                                "seq": 2,\n                                "feeIncluded": true,\n                                "optional": false\n                            },\n                            {\n                                "type": "HOTEL",\n                                "mealName": null,\n                                "location": null,\n                                "hotelName": null,\n                                "flightFrom": null,\n                                "flightTo": null,\n                                "flightDepartureTime": null,\n                                "flightArrivalTime": null,\n                                "duration": null,\n                                "distance": null,\n                                "descriptions": [\n                                    {\n                                        "title": "Hotel Title Required",\n                                        "type": null,\n                                        "content": "\uCD1D 2\uAC1C\uC758 \uC608\uC815 \uD638\uD154\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uD655\uC815 \uB418\uB294\uB300\uB85C(\uCD9C\uBC1C 1\uC77C\uC804\uAE4C\uC9C0) \uD648\uD398\uC774\uC9C0, \uC774\uBA54\uC77C \uB610\uB294 \uC54C\uB9BC\uD1A1 \uB4F1\uC744 \uD1B5\uD574 \uC548\uB0B4 \uB4DC\uB9AC\uACA0\uC2B5\uB2C8\uB2E4.",\n                                        "format": "TEXT",\n                                        "sellerUrl": null,\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 0\n                                    }\n                                ],\n                                "seq": 3,\n                                "feeIncluded": true,\n                                "optional": false\n                            }\n                        ]\n                    },\n                    {\n                        "name": "2 \uC77C\uCC28",\n                        "summary": "2019\uB144 10\uC6D4 15\uC77C \uD654\uC694\uC77C",\n                        "from": null,\n                        "to": null,\n                        "details": [\n                            {\n                                "type": "SIGHTSEEING",\n                                "mealName": null,\n                                "location": null,\n                                "hotelName": null,\n                                "flightFrom": null,\n                                "flightTo": null,\n                                "flightDepartureTime": null,\n                                "flightArrivalTime": null,\n                                "duration": null,\n                                "distance": null,\n                                "descriptions": [\n                                    {\n                                        "title": "\uBCF4\uBD09\uD638",\n                                        "type": null,\n                                        "content": "\uBCF4\uBD09\uD638\uC218\uB294 \uB310\uC744 \uC313\uC544 \uBB3C\uC744 \uB9C9\uC544\uC11C \uB9CC\uB4E0 \uC778\uACF5\uD638\uC218\uB85C \uC8FC\uB85C \uC218\uB825\uBC1C\uC804\uACFC \uC591\uC2DD\uC7A5\uC73C\uB85C \uC0AC\uC6A9 \uB418\uB358 \uC911 \uBCF4\uBD09\uD638\uC758 \uC544\uB984\uB2E4\uC6C0\uC5D0 \uAD00\uAD11\uC9C0\uB85C \uAC1C\uBC1C\uB418\uC5C8\uC2B5\uB2C8\uB2E4 \uD574\uBC1C 430m \uC704\uC5D0 \uC788\uB294 \uC0B0\uC815\uD638\uC218\uB85C \uD3C9\uADE0\uC218\uC2EC\uC740 72m\uC774\uBA70 \uAC00\uC7A5 \uB113\uC740 \uACF3\uC758 \uD3ED\uC740 150m\uC5D0 \uC774\uB978\uB2E4. \uC120\uB140\uBC14\uC704, \uB450\uAEBC\uBE44\uBC14\uC704, \uACF5\uC791\uC0C8\uBC14\uC704 \uB4F1\uACFC \uAC19\uC774 \uC0AC\uB78C \uD639\uC740 \uC9D0\uC2B9\uBAA8\uC591\uC73C\uB85C \uB418\uC5B4\uC788\uB294 \uBC14\uC704\uB4E4\uC774 \uBCF4\uBD09\uD638\uC758 \uC544\uB984\uB2E4\uC6C0\uC744 \uB354\uC6B1 \uC2E0\uBE44\uC2A4\uB7FD\uAC8C \uB9CC\uB4E4...",\n                                        "format": "TEXT",\n                                        "sellerUrl": null,\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 0\n                                    },\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": null,\n                                        "format": "IMAGE",\n                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 1\n                                    },\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": null,\n                                        "format": "IMAGE",\n                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 2\n                                    },\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": null,\n                                        "format": "IMAGE",\n                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 3\n                                    }\n                                ],\n                                "seq": 0,\n                                "feeIncluded": true,\n                                "optional": false\n                            },\n                            {\n                                "type": "SIGHTSEEING",\n                                "mealName": null,\n                                "location": null,\n                                "hotelName": null,\n                                "flightFrom": null,\n                                "flightTo": null,\n                                "flightDepartureTime": null,\n                                "flightArrivalTime": null,\n                                "duration": null,\n                                "distance": null,\n                                "descriptions": [\n                                    {\n                                        "title": "\uC120\uD0DD\uAD00\uAD11-\uD669\uB8E1\uB3D9\uAD74($30)",\n                                        "type": null,\n                                        "content": "\uAC1C\uC694 : \uAD70\uC9C0\uD3C9 \uB3D9\uCABD\uC73C\uB85C 8km \uB5A8\uC5B4\uC9C4 \uACF3\uC5D0 \uC704\uCE58\uD574 \uC788\uB2E4. \uC9C0\uAC01\uC6B4\uB3D9\uC73C\uB85C \uC778\uD574 \uC0DD\uC131\uB41C \uC11D\uD68C\uC554 \uC6A9\uC554\uB3D9\uAD74\uB85C \uC0C1\uD558 4\uCE35\uC73C\uB85C \uB418\uC5B4 \uC788\uACE0, \uC544\uB798 2\uCE35\uC5D0\uB294 4\uAC1C\uC758 \uC2DC\uB0B4\uAC00 \uD758\uB7EC\uB0B4\uB9AC\uB294 \uB3D9\uAD74\uC774\uB2E4. \uC218\uC9C1\uACE0\uB3C4\uB294 160m, \uB3D9\uAD74 \uAE38\uC774\uB294 15km\uC774\uBA70, \uC774\uBBF8 \uAC1C\uBC1C\uB418\uC5B4 \uC788\uB294 \uBA74\uC801\uC774 6\uB9CC\uD3C9\uC5D0 \uB2EC\uD55C\uB2E4. \uB610\uD55C \uB3D9\uAD74 \uC548\uC5D0\uB294 \uC218\uB9CE\uC740 \uAE30\uC774\uD55C \uC885\uC720\uC11D\uC774 \uCC9C\uD0DC\uB9CC\uC0C1\uC744 \uBCF4\uC5EC\uC8FC\uACE0 \uC788\uB2E4.",\n                                        "format": "TEXT",\n                                        "sellerUrl": null,\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 0\n                                    },\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": null,\n                                        "format": "IMAGE",\n                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 1\n                                    },\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": null,\n                                        "format": "IMAGE",\n                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 2\n                                    },\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": null,\n                                        "format": "IMAGE",\n                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 3\n                                    },\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": null,\n                                        "format": "IMAGE",\n                                        "sellerUrl": "http://image15.coupangcdn.com/image/bannerunit/bannerunit_c5b412fb-44cd-4cfb-b632-bafd1270fef8.jpg",\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 4\n                                    }\n                                ],\n                                "seq": 1,\n                                "feeIncluded": false,\n                                "optional": true\n                            },\n                            {\n                                "type": "SIGHTSEEING",\n                                "mealName": null,\n                                "location": null,\n                                "hotelName": null,\n                                "flightFrom": null,\n                                "flightTo": null,\n                                "flightDepartureTime": null,\n                                "flightArrivalTime": null,\n                                "duration": null,\n                                "distance": null,\n                                "descriptions": [\n                                    {\n                                        "title": "\uC120\uD0DD\uAD00\uAD11-\uC720\uB9AC\uB2E4\uB9AC+\uB300\uD611\uACE1($95)",\n                                        "type": null,\n                                        "content": "\uAC1C\uC694 : \uC720\uB9AC\uB2E4\uB9AC\uC640 \uB300\uD611\uACE1\uC744 \uD568\uAC8C \uBCFC \uC218 \uC788\uB294 \uC120\uD0DD\uAD00\uAD11",\n                                        "format": "TEXT",\n                                        "sellerUrl": null,\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 0\n                                    },\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": null,\n                                        "format": "IMAGE",\n                                        "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 1\n                                    },\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": null,\n                                        "format": "IMAGE",\n                                        "sellerUrl": "hhttp://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 2\n                                    },\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": null,\n                                        "format": "IMAGE",\n                                        "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 3\n                                    },\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": null,\n                                        "format": "IMAGE",\n                                        "sellerUrl": "http://image15.coupangcdn.com/image/bannerunit/bannerunit_c5b412fb-44cd-4cfb-b632-bafd1270fef8.jpg",\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 4\n                                    }\n                                ],\n                                "seq": 2,\n                                "feeIncluded": false,\n                                "optional": true\n                            },\n                            {\n                                "type": "HOTEL",\n                                "mealName": null,\n                                "location": null,\n                                "hotelName": null,\n                                "flightFrom": null,\n                                "flightTo": null,\n                                "flightDepartureTime": null,\n                                "flightArrivalTime": null,\n                                "duration": null,\n                                "distance": null,\n                                "descriptions": [\n                                    {\n                                        "title": "Test Title",\n                                        "type": null,\n                                        "content": "\uCD1D 2\uAC1C\uC758 \uC608\uC815 \uD638\uD154\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uD655\uC815 \uB418\uB294\uB300\uB85C(\uCD9C\uBC1C 1\uC77C\uC804\uAE4C\uC9C0) \uD648\uD398\uC774\uC9C0, \uC774\uBA54\uC77C \uB610\uB294 \uC54C\uB9BC\uD1A1 \uB4F1\uC744 \uD1B5\uD574 \uC548\uB0B4 \uB4DC\uB9AC\uACA0\uC2B5\uB2C8\uB2E4.",\n                                        "format": "TEXT",\n                                        "sellerUrl": null,\n                                        "sellerUrlMethod": "GET",\n                                        "seq": 0\n                                    }\n                                ],\n                                "seq": 3,\n                                "feeIncluded": true,\n                                "optional": false\n                            }\n                        ]\n                    }\n                ]\n            }\n        ],\n        "cancelPolicy": {\n            "notice": "\u2022 \uCDE8\uC18C\uB8CC\uB294 \uCFE0\uD321\uAC00(\uC989\uC2DC\uD560\uC778 \uC801\uC6A9 \uC804 \uC0C1\uD488\uAC00) \uAE30\uC900\uC73C\uB85C \uBD80\uACFC\uB429\uB2C8\uB2E4.(\uC5EC\uD589\uC0AC\uC758 \uADC0\uCC45 \uC0AC\uC720\uB85C \uC778\uD55C \uCDE8\uC18C\uC758 \uACBD\uC6B0\uC5D0\uB3C4 \uB3D9\uC77C\uD558\uAC8C \uC801\uC6A9\uB429\uB2C8\uB2E4.) \u2022 \uC989\uC2DC\uD560\uC778\uC740 \uC0C1\uD669\uC5D0 \uB530\uB77C \uC608\uACE0\uC5C6\uC774 \uD560\uC778\uAE08\uC561\uC758 \uC870\uC815 \uBC0F \uC870\uAE30\uC885\uB8CC \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \u2022 \uC989\uC2DC\uD560\uC778 \uC774\uBCA4\uD2B8\uAC00 \uC885\uB8CC\uB41C \uD6C4\uC5D0\uB294 \uAE30\uC801\uC6A9\uB41C \uC989\uC2DC\uD560\uC778 \uC0C1\uD488\uC744 \uCDE8\uC18C \uD6C4\uC5D0 \uC7AC\uAD6C\uB9E4\uD558\uB354\uB77C\uB3C4 \uD560\uC778 \uC801\uC6A9\uC774 \uC720\uC9C0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \u2022 \uBCF8 \uC0C1\uD488\uC740 \uC608\uC57D \uD6C4 \uCDE8\uC18C\uD560 \uACBD\uC6B0 \uC5EC\uD589\uC57D\uAD00 \uC81C5\uC870 (\uD2B9\uC57D)\uC5D0 \uB530\uB77C \uD45C\uC900\uC57D\uAD00\uACFC\uB294 \uBCC4\uB3C4\uC758 \uCDE8\uC18C\uC218\uC218\uB8CC\uAC00 \uC801\uC6A9\uB429\uB2C8\uB2E4. (\uC774 \uC0C1\uD488\uC740 \uD56D\uACF5(\uB610\uB294 \uC120\uBC15)\uC88C\uC11D \uB610\uB294 \uD638\uD154 \uAC1D\uC2E4\uC5D0 \uB300\uD55C \uBE44\uC6A9\uC744 \uC120\uB0A9\uD574 \uB193\uC740 \uC0C1\uD488\uC73C\uB85C\uC11C, \uCDE8\uC18C\uC2DC \uBCC4\uB3C4\uC758 \uCDE8\uC18C\uC218\uC218\uB8CC\uAC00 \uC801\uC6A9\uB428\uC744 \uC591\uD574 \uBC14\uB78D\uB2C8\uB2E4.) \u2022 \uD574\uD53C\uCF5C\uC744 \uD1B5\uD574 \uC608\uC57D \uD655\uC815 \uD6C4 \uC5EC\uD589\uC790\uC758 \uCDE8\uC18C\uC694\uCCAD \uC2DC \uC5C5\uCCB4\uAC00 \uC815\uD55C \uD2B9\uBCC4\uC57D\uAD00\uC5D0 \uC758\uAC70 \uCDE8\uC18C\uB8CC\uAC00 \uBD80\uACFC\uB429\uB2C8\uB2E4. (\uAD6D\uC678\uC5EC\uD589\uC57D\uAD00 \uC81C5\uC870 \uD2B9\uC57D) \u261E \uCDE8\uC18C\uC218\uC218\uB8CC \uD2B9\uBCC4 \uADDC\uC815 (\u203B \uC804\uC138\uAE30 \uC0C1\uD488 \uBC0F \uC911\uAD6D \uBBFC\uD56D\uAE30 \uC0C1\uD488 \uADDC\uC815\u203B) - \uD574\uD53C\uCF5C \uD655\uC815 \uD6C4 ~30\uC77C \uC774\uC804 \uCDE8\uC18C \uC704\uC57D\uAE08 20\uB9CC\uC6D0 - \uC5EC\uD589\uAC1C\uC2DC 20\uC77C \uC804\uAE4C\uC9C0(29 ~ 20) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 30% \uBC30\uC0C1 - \uC5EC\uD589\uAC1C\uC2DC 10\uC77C \uC804\uAE4C\uC9C0(19 ~ 10) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 55% \uBC30\uC0C1 - \uC5EC\uD589\uAC1C\uC2DC   8\uC77C \uC804\uAE4C\uC9C0( 9 ~   8) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 85% \uBC30\uC0C1 - \uC5EC\uD589\uAC1C\uC2DC   1\uC77C \uC804\uAE4C\uC9C0( 7 ~   1) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 90% \uBC30\uC0C1 - \uC5EC\uD589 \uB2F9\uC77C \uD1B5\uBCF4 \uC2DC : \uC5EC\uD589\uC694\uAE08\uC758 100% \uBC30\uC0C1",\n            "cancelType": "APPROVAL",\n            "cancelPeriodType": "BEFORE_USE",\n            "cancelMarkType": "DEPENDING_ON_VENDOR",\n            "refundOnBusinessDay": true,\n            "refundUnusedTicket": true,\n            "refundRates": [\n                {\n                    "conditionDays": 5,\n                    "conditionTime": "17:00",\n                    "refundRate": 100,\n                    "cancellable": false\n                },\n                {\n                    "conditionDays": 3,\n                    "conditionTime": "17:00",\n                    "refundRate": 70,\n                    "cancellable": false\n                },\n                {\n                    "conditionDays": 1,\n                    "conditionTime": "17:00",\n                    "refundRate": 50,\n                    "cancellable": false\n                }\n            ]\n        },\n        "introduction": "\uC7A5\uAC00\uACC4 \uD56D\uACF5\uC774\uB3D9&\uBC84\uC2A4\uC774\uB3D9 \uC120\uD0DD\uAC00\uB2A5",\n        "notice": "\uB0A0\uC9DC\uB2F9 \uC131\uC778\uAE30\uC900 10\uBA85 \uC774\uC0C1 \uBAA8\uAC1D \uC2DC \uCD9C\uBC1C\uD655\uC815 \uAC00\uB2A5",\n        "benefits": [\n            "Special Offer 1",\n            "Special Offer 2"\n        ],\n        "flightInfo": {\n            "title": "Flight Information",\n            "type": "Flight Info",\n            "content": "\uD56D\uACF5\uD3B8:\uC911\uAD6D\uAD6D\uC81C\uD56D\uACF5\\n\uBB34\uB8CC\uC704\uD0C1\uC218\uD558\uBB3C:1pc 23kg [\uB2E8, \uC0B0\uB3D9\uB178\uC120(\uCCAD\uB3C4, \uC81C\uB0A8, \uC704\uD574, \uC5F0\uD0DC)\uC740 2pc 23kg]\\n\uD5C8\uC6A9\uAE30\uB0B4\uC218\uD558\uBB3C:1pc 5kg\\n",\n            "format": "TEXT",\n            "sellerUrl": null,\n            "sellerUrlMethod": "GET",\n            "seq": 0\n        },\n        "visaInfo": {\n            "title": "\uBE44 \uC790",\n            "type": "VISA Info",\n            "content": null,\n            "format": "IMAGE",\n            "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n            "sellerUrlMethod": "GET",\n            "seq": 0\n        },\n        "meetingPlace": "\uC778\uCC9C\uAD6D\uC81C\uACF5\uD56D 1\uD130\uBBF8\uB110 3\uCE35 \uCD9C\uAD6D\uC7A5 14\uBC88 \uCD9C\uAD6C \uC55E(N\uCE74\uC6B4\uD130 \uC606 \uCC3D\uCE21) \uC5EC\uD589\uC0AC\uCE74\uC6B4\uD130 38~42\uBC88 \uD14C\uC774\uBE14",\n        "meetingTime": "2019-11-01 12:30:00",\n        "meetingNotice": {\n            "title": "Map - Meeting Point",\n            "type": "Meeting Notice",\n            "content": null,\n            "format": "IMAGE",\n            "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n            "sellerUrlMethod": "GET",\n            "seq": 0\n        },\n        "guideInfo": "\uC778\uC194\uC790\uB294 \uB3D9\uBC18\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",\n        "shoppingInfo": {\n            "details": [\n                {\n                    "shoppingCategory": "\uB77C\uD14D\uC2A4",\n                    "shoppingPlace": "\uBB34\uB989\uC6D0 \uCC9C\uC790\uAC70\uB9AC \uB300\uC9C0\uB77C\uD14D\uC2A4",\n                    "duration": "\uC57D 7-80\uBD84",\n                    "refundable": false\n                },\n                {\n                    "shoppingCategory": "\uC9C4\uC8FC",\n                    "shoppingPlace": "\uCC9C\uBB381\uD638 \uC591\uC0C1 \uBC15\uB78C\uC911\uC2EC",\n                    "duration": "\uC57D 60\uBD84",\n                    "refundable": false\n                },\n                {\n                    "shoppingCategory": "\uD788\uB178\uB07C",\n                    "shoppingPlace": "\uBB34\uB989\uC6D0 \uBCF4\uBD09\uC0B0\uC7A5 \uB0B4 \uD788\uB178\uB07C \uB9E4\uC7A5",\n                    "duration": "\uC57D 60\uBD84",\n                    "refundable": false\n                },\n                {\n                    "shoppingCategory": "\uAC8C\uB974\uB9C8\uB284",\n                    "shoppingPlace": "\uBB34\uB989\uC6D0\uAD6C \uBC31\uB85C\uB85C \uAC74\uC124\uC740\uD589 \uD6C4\uC6D0",\n                    "duration": "\uC57D 60\uBD84",\n                    "refundable": true\n                }\n            ],\n            "exchangeRefundNotice": {\n                "title": null,\n                "type": "Exchange Refund Notice",\n                "content": "? \uD658\uBD88\uC811\uC218\uAE30\uAC04 : \uC5EC\uD589\uC885\uB8CC \uD6C4 30\uC77C \uC774\uB0B4\\n? \uD658\uBD88\uAC00\uB2A5\uBB3C\uD488 : \uC9C0\uC815\uB41C \uC1FC\uD551\uC7A5\uC18C\uC5D0\uC11C \uAD6C\uB9E4\uD55C \uBB3C\uD488,\uAC1C\uC778 \uAD6C\uB9E4 \uBB3C\uD488 \uD639\uC740 \uB2E8\uC21C \uACE0\uAC1D \uBCC0\uC2EC\uC758 \uAD50\uD658/\uD658\uBD88 \uB300\uD589 \uBD88\uAC00\\n? \uD658\uBD88\uC694\uCCAD\uBC29\uBC95 : \uC5EC\uD589\uC0C1\uD488\uBA85,\uCD9C\uBC1C\uC77C,\uC778\uC194\uC790\uBA85,\uAC04\uB2E8\uD55C \uC0AC\uC720\uB97C \uB300\uB9AC\uC810 \uD639\uC740 \uC608\uC57D\uB2F4\uB2F9\uC790\uC5D0\uAC8C \uC720\uC120 \uBB38\uC758 \uD6C4 \uC870\uCE58\\n? \uD658\uBD88\uD544\uC694\uC11C\uB958 : \uBCF8\uC778 \uC5F0\uB77D\uCC98/\uD1B5\uC7A5\uBC88\uD638(\uC218\uCDE8\uC778 \uBCF8\uC778\uB9CC \uAC00\uB2A5),\uC6D0\uBCF8 \uC601\uC218\uC99D(\uC0AC\uBCF8 \uBCF4\uAD00 \uD544\uC218),\uD658\uBD88 \uD639\uC740 \uAD50\uD658 \uC694\uCCAD \uBB3C\uD488\\n? \uD658\uBD88\uBC30\uC1A1\uBE44\uBD80\uB2F4 : \uACE0\uAC1D\uBCF8\uC778\\n? \uD658\uBD88\uC18C\uC694\uAE30\uAC04 : \uC811\uC218\uC77C\uB85C\uBD80\uD130 \uCD5C\uC18C 15\uC77C ~ \uCD5C\uB300 60\uC77C\\n\u25CE\uD658\uBD88\uC2DC \uC8FC\uC758\uC0AC\uD56D\u25CE\\n-\uD658\uBD88\uC218\uC218\uB8CC: \uCE74\uB4DC\uACB0\uC81C\uC778 \uACBD\uC6B0 \uD658\uBD88\uC2DC \uCE74\uB4DC\uC218\uC218\uB8CC 5% \uBD80\uACFC (\uD658\uBD88\uC218\uC218\uB8CC\uB294 \uC0C1\uD488 \uBC0F \uC1FC\uD551\uC810 \uAE30\uC900\uC5D0 \uB530\uB77C \uC0C1\uC774\uD558\uBA70, \uC601\uC218\uC99D \uBBF8\uC9C0\uCC38\uC2DC \uD658\uBD88 \uBD88\uAC00)\\n-\uC720\uC758\uC0AC\uD56D\\n1)\uBCF4\uC11D\uB958\\n\uC131\uBD84\uD568\uB7C9\uC774 \uBBF8\uB2EC\uB418\uB294 \uC81C\uD488\uC774 \uB9CE\uC73C\uB2C8, \uACE0\uAC00\uC758 \uC0C1\uD488\uC740 \uAD6C\uC785\uC744 \uC790\uC81C\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n2)\uB77C\uD14D\uC2A4\\n\uD3EC\uC7A5\uC774 \uC81C\uAC70\uB418\uC9C0 \uC54A\uC740 \uC81C\uD488\uC77C\uACBD\uC6B0 100% \uD658\uBD88 \uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n30\uC77C \uC774\uB0B4\uC5D0 \uB2E8\uC21C\uBCC0\uC2EC\uC73C\uB85C \uC778\uD55C \uD658\uBD88\uC2DC \uAD6C\uB9E4\uAE08\uC561\uC758 30% \uD658\uBD88\uC218\uC218\uB8CC \uBC1C\uC0DD\\n90\uC77C \uC774\uB0B4\uC5D0 \uB2E8\uC21C\uBCC0\uC2EC\uC73C\uB85C \uC778\uD55C \uD658\uBD88\uC2DC \uAD6C\uB9E4\uAE08\uC561\uC758 50% \uD658\uBD88\uC218\uC218\uB8CC \uBC1C\uC0DD\\n\uD604\uC9C0\uC5D0\uC11C \uBC30\uC1A1\uBC1B\uB294 \uACBD\uC6B0 \uBCC4\uB3C4\uC758 \uBC30\uC1A1\uBE44\uAC00 \uBD80\uACFC\\n3)\uAC8C\uB974\uB9C8\uB284\\n\uD658\uBD88\uC2DC \uC54C\uB808\uB974\uAE30 \uBC1C\uC0DD\uC740 \uAD6C\uB9E4\uC77C\uB85C\uBD80\uD130 7\uC77C \uB0B4\uC5D0 \uD658\uBD88\uC2E0\uCCAD, \uADF8 \uC678\uC758 \uD658\uBD88\uC740 \uAD6C\uB9E4\uC77C\uB85C\uBD80\uD130 15\uC77C \uB0B4\uC5D0 \uD658\uBD88 \uC2E0\uCCAD\\n\uD658\uBD88\uC2DC 5% \uCE74\uB4DC\uC218\uC218\uB8CC + 10% \uC704\uC57D\uAE08 \uBC1C\uC0DD\\n\uB3C4\uAE08\uBCC0\uC0C9\uC740 A/S \uBD88\uAC00\\n4)\uB18D\uC218\uC0B0\uBB3C(\uAE68,\uC7A3 \uB4F1)\\n\uAD50\uD658 \uBC0F \uD658\uBD88 \uC808\uB300 \uBD88\uAC00\\n",\n                "format": "TEXT",\n                "sellerUrl": null,\n                "sellerUrlMethod": "GET",\n                "seq": 0\n            }\n        },\n        "tourGuides": [\n            {\n                "title": "\uC120\uD0DD\uAD00\uAD11 \uC548\uB0B4",\n                "type": "Tour Guide",\n                "content": "1. \uC120\uD0DD\uAD00\uAD11 \uBC0F \uC790\uC720\uC2DC\uAC04 \uC911 \uACE0\uAC1D\uB2D8\uC758 \uC548\uC804\uC744 \uC704\uD558\uC5EC \uAC00\uC774\uB4DC\uC758 \uC548\uB0B4\uC0AC\uD56D \uBC0F \uC548\uC804\uC218\uCE59\uC744 \uC900\uC218\uD558\uC5EC \uBAA8\uB4E0 \uC548\uC804\uC0AC\uACE0\uC5D0 \uC720\uC758\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n2. \uD604\uC9C0 \uC120\uD0DD\uAD00\uAD11\uC740 \uAC00\uC774\uB4DC\uC758 \uC8FC\uC758\uC0AC\uD56D\uC744 \uC219\uC9C0 \uD6C4 \uCC38\uC5EC \uC5EC\uBD80\uB97C \uACB0\uC815\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB77C\uBA70, \uCC38\uC5EC \uC804 \uBC18\uB4DC\uC2DC \uBC30\uD3EC\uB418\uB294 \uC548\uC804\uC218\uCE59 \uB3D9\uC758\uC11C\uB97C \uC219\uC9C0 \uBC0F \uB3D9\uC758 \uD6C4 \uCC38\uC5EC\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n3. \uC774\uC6A9\uC790 \uBCF8\uC778\uC758 \uACFC\uC2E4 \uBC0F \uAC74\uAC15\uC0C1\uD0DC\uB85C \uC778\uD558\uC5EC \uBC1C\uC0DD\uD55C \uC548\uC804\uC0AC\uACE0\uC5D0 \uB300\uD558\uC5EC \uB2F9\uC0AC\uB294 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\\n4. \uC120\uD0DD\uAD00\uAD11\uC740 \uACE0\uAC1D\uB2D8\uC774 \uC790\uC720\uB86D\uAC8C \uC9C0\uBD88\uC5EC\uBD80\uB97C \uACB0\uC815\uD560 \uC218 \uC788\uC73C\uBA70 \uC120\uD0DD\uAD00\uAD11\uC5D0 \uCC38\uC5EC\uD558\uC9C0 \uC54A\uC74C\uC73C\uB85C \uC778\uD55C \uCD94\uAC00\uC801\uC778 \uBE44\uC6A9 \uB610\uB294 \uC77C\uC815\uC0C1\uC758 \uBD88\uC774\uC775\uC740 \uC5C6\uC2B5\uB2C8\uB2E4.\\n",\n                "format": "TEXT",\n                "sellerUrl": null,\n                "sellerUrlMethod": "GET",\n                "seq": 0\n            },\n            {\n                "title": "Tour Guide",\n                "type": "Tour Guide",\n                "content": "\u25C7 \uBBF8\uD305\uC7A5\uC18C : \uC778\uCC9C\uAD6D\uC81C\uACF5\uD56D \uC81C1\uD130\uBBF8\uB110 3\uCE35 N\uCE74\uC6B4\uD130(14\uBC88 \uCD9C\uC785\uBB38) \uC55E <\uD22C\uC5B42000> \uD14C\uC774\uBE14 \uBBF8\uD305\\n\u25C7 \uC778\uCC9C\uACF5\uD56D : \uC778\uCC9C\uACF5\uD56D \uC5F0\uB77D\uCC98 010-2742-6200\\n\u25C7 \uCD5C\uC18C \uCD9C\uBC1C \uC778\uC6D0 : \uC131\uC77810\uBA85 \uC774\uC0C1 \uCD9C\uBC1C \uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n\u25C7 \uCD9C\uBC1C\uC778\uC6D0\uC774 \uBD80\uC871\uD560 \uACBD\uC6B0 \uD0C0\uC0AC\uC640 \uACF5\uB3D9 \uC9C4\uD589 \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\u25C7 \uC778\uC194\uC790\uB294 \uB3D9\uD589\uD558\uC9C0 \uC54A\uC73C\uBA70, \uD604\uC9C0 \uB3C4\uCC29 \uD6C4 \uAC00\uC774\uB4DC\uC640 \uBBF8\uD305 \uD569\uB2C8\uB2E4.\\n\u25C7 \uB3C5\uC2E4\uC0AC\uC6A9\uB8CC : 1\uBC15 40,000\uC6D0(\uC804 \uC77C\uC815 3\uBC15 120,000\uC6D0) \uC785\uB2C8\uB2E4.\\n- \uD638\uD154: 2\uC7781\uC2E4 \uAE30\uC900\uC774\uBA70, 3\uC778\uC2E4 \uC774\uC6A9\uC2DC \uAC04\uC774\uCE68\uB300\uAC00 \uC81C\uACF5 \uB429\uB2C8\uB2E4.\\n- \uC5EC\uD589 \uD558\uC2DC\uB294 \uC778\uC6D0\uC774 \uD640\uC218\uC778 \uACBD\uC6B0 \uBCC4\uB3C4\uC758 \uC694\uCCAD\uC774 \uC5C6\uC73C\uC2E4 \uACBD\uC6B0 3\uC7781\uC2E4\uB85C \uBC30\uC815 \uB429\uB2C8\uB2E4.\\n\u25C7 \uC790\uC720\uC77C\uC815 : \uD328\uD0A4\uC9C0\uC77C\uC815\uC758 \uD2B9\uC131\uC0C1 \uAC1C\uBCC4\uC77C\uC815 \uBD88\uAC00\uD569\uB2C8\uB2E4.\\n\u25C7 \uC77C\uC815 \uC9C4\uD589 \uC911 \uC1FC\uD551\uC810 \uBC29\uBB38\uC774 \uC788\uC2B5\uB2C8\uB2E4.(*\uC1FC\uD551\uC815\uBCF4 \uCC38\uC870)\\n\u25C7 \uC5EC\uD589\uC790 \uBCF4\uD5D8\uC740 \'DB \uC190\uD574\uBCF4\uD5D8\'\uC73C\uB85C \uC790\uB3D9 \uAC00\uC785 \uB429\uB2C8\uB2E4. (*\uC5EC\uD589\uC790\uBCF4\uD5D8 \uCC38\uC870)\\n\u25C7 \uBCF8 \uC5EC\uD589\uC0C1\uD488\uC740 \uACC4\uC57D\uAE08 \uC9C0\uBD88 \uC2DC\uC810\uBD80\uD130 \uACC4\uC57D\uC774 \uCCB4\uACB0\uB418\uBA70, \uACC4\uC57D \uD574\uC81C \uC694\uCCAD \uC2DC \uADC0\uCC45\uC0AC\uC720\uC5D0 \uB530\uB77C \uCDE8\uC18C\uC218\uC218\uB8CC\uAC00 \uBD80\uACFC\uB429\uB2C8\uB2E4. \uCDE8\uC18C\uC218\uC218\uB8CC \uBD80\uACFC\uAE30\uC900\uC740 [\uAD6D\uC678\uC5EC\uD589\uD45C\uC900\uC57D\uAD00/\uD2B9\uBCC4\uC57D\uAD00]\uC5D0 \uB530\uB985\uB2C8\uB2E4.\\n\u25C7 \uC0C1\uAE30 \uC77C\uC815\uC740 \uD56D\uACF5 \uBC0F \uD604\uC9C0\uC0AC\uC815\uC5D0 \uC758\uD558\uC5EC \uBCC0\uACBD\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\u25C7 \uC720\uB958\uD560\uC99D\uB8CC\uB294 \uC608\uC57D\uC2DC\uC810\uC774 \uC544\uB2CC \uBC1C\uAD8C\uC77C \uAE30\uC900\uC73C\uB85C \uC801\uC6A9\uB418\uBA70, \uAD6D\uC81C\uC720\uAC00\uC640 \uD56D\uACF5\uC0AC \uC601\uC5C5\uD658\uACBD\uC744 \uACE0\uB824\uD55C \uAC74\uC124\uAD50\uD1B5\uBD80\uC758 \uAD6D\uC81C\uC120 \uD56D\uACF5\uC694\uAE08\uACFC \uC720\uB958\uD560\uC99D\uB8CC \uD655\uB300\uBC29\uC548\uC5D0 \uB530\uB77C \uC608\uACE0\uC5C6\uC774 \uC778\uC0C1\uB418\uAC70\uB098 \uC778\uD558\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n",\n                "format": "TEXT",\n                "sellerUrl": null,\n                "sellerUrlMethod": "GET",\n                "seq": 1\n            }\n        ],\n        "safetyInstructions": [\n            {\n                "title": "\uC5EC\uD589\uAE08\uC9C0\uAD6D\uAC00 \uD604\uD669 \uBC0F \uBC95\uC801\uADFC\uAC70",\n                "type": "Safety Instruction",\n                "content": "\u25CF \uC5EC\uD589\uAE08\uC9C0\uAD6D\uAC00 \uC9C0\uC815 \uD604\uD669\\n\uC678\uAD50\uBD80\uB294 \uC6B0\uB9AC \uAD6D\uBBFC\uC758 \uC0DD\uBA85\xB7\uC548\uC804\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD558\uC5EC \uC5EC\uAD8C\uBC95 \uC81C 17\uC870\uC5D0 \uB530\uB77C \uC544\uB798\uC758 \uAD6D\uAC00\uB4E4\uC740 \uC9C0\uC815\uB41C \uAE30\uAC04 \uB3D9\uC548 \uC5EC\uD589\uAE08\uC9C0\uAD6D\uC73C\uB85C \uC9C0\uC815\uD558\uC5EC \uC6B0\uB9AC \uAD6D\uBBFC\uB4E4\uC758 \uBC29\uBB38 \uBC0F \uCCB4\uB958\uB97C \uAE08\uC9C0\uD569\uB2C8\uB2E4.\\n- \uC774\uB77C\uD06C(2007\uB144 8\uC6D4 7\uC77C ~ 2017\uB144 1\uC6D431\uC77C\uAE4C\uC9C0)\\n- \uC18C\uB9D0\uB9AC\uC544\xB7\uC544\uD504\uAC00\uB2C8\uC2A4\uD0C4(2007\uB144 8\uC6D4 7\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uC608\uBA58(2011\uB144 6\uC6D4 28\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uC2DC\uB9AC\uC544(2011\uB144 8\uC6D4 20\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uB9AC\uBE44\uC544(2014\uB144 8\uC6D4 4\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uD544\uB9AC\uD540 \uC77C\uBD80\uC9C0\uC5ED(\uC7A0\uBCF4\uC559\uAC00, \uC220\uB8E8 \uAD70\uB3C4, \uBC14\uC2E4\uB780, \uD0C0\uC704\uD0C0\uC704 \uAD70\uB3C4) (2015\uB144 12\uC6D4 1\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n\u25CF \uBC95\uC801\uADFC\uAC70\\n- \uC5EC\uAD8C\uBC95 17\uC870(\uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uC81C\uD55C \uB4F1)\\n\uC678\uAD50\uBD80\uC7A5\uAD00\uC740 \uCC9C\uC7AC\uC9C0\uBCC0\xB7\uC804\uC7C1\xB7\uB0B4\uB780\xB7\uD3ED\uB3D9\xB7\uD14C\uB7EC \uB4F1 \uB300\uD1B5\uB839\uB839\uC73C\uB85C \uC815\uD558\uB294 \uAD6D\uC678 \uC704\uB09C\uC0C1\uD669(\u5371\u96E3\u72C0\u6CC1)\uC73C\uB85C \uC778\uD558\uC5EC \uAD6D\uBBFC\uC758 \uC0DD\uBA85\xB7\uC2E0\uCCB4\uB098 \uC7AC\uC0B0\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD558\uC5EC \uAD6D\uBBFC\uC774 \uD2B9\uC815 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC744 \uBC29\uBB38\uD558\uAC70\uB098 \uCCB4\uB958\uD558\uB294 \uAC83\uC744 \uC911\uC9C0\uC2DC\uD0A4\uB294 \uAC83\uC774 \uD544\uC694\uD558\uB2E4\uACE0 \uC778\uC815\uD558\uB294 \uB54C\uC5D0\uB294 \uAE30\uAC04\uC744 \uC815\uD558\uC5EC \uD574\uB2F9 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC5D0\uC11C\uC758 \uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uC744 \uC81C\uD55C\uD558\uAC70\uB098 \uBC29\uBB38\xB7\uCCB4\uB958\uB97C \uAE08\uC9C0 (\uC774\uD558 \\"\uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uC81C\uD55C \uB4F1\\"\uC774\uB77C \uD55C\uB2E4)\uD560\uC218 \uC788\uB2E4. \uB2E4\uB9CC, \uC601\uC8FC(\u6C38\u4F4F), \uCDE8\uC7AC\xB7\uBCF4\uB3C4, \uAE34\uAE09\uD55C \uC778\uB3C4\uC801 \uC0AC\uC720, \uACF5\uBB34 \uB4F1 \uB300\uD1B5\uB839\uB839\uC73C\uB85C \uC815\uD558\uB294 \uBAA9\uC801\uC758 \uC5EC\uD589\uC73C\uB85C\uC11C \uC678\uAD50\uBD80\uC7A5\uAD00\uC774 \uD544\uC694\uD558\uB2E4\uACE0 \uC778\uC815\uD558\uBA74 \uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uACFC \uBC29\uBB38\xB7\uCCB4\uB958\uB97C \uD5C8\uAC00\uD560 \uC218 \uC788\uB2E4.\\n- \uC5EC\uAD8C\uBC95 \uC81C26\uC870 \uC81C17\uC870\uC81C1\uD56D \uBCF8\uBB38 \uBC0F \uC81C2\uD56D\uC5D0 \uB530\uB77C \uBC29\uBB38 \uBC0F \uCCB4\uB958\uAC00 \uAE08\uC9C0\uB41C \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC73C\uB85C \uACE0\uC2DC\uB41C \uC0AC\uC815\uC744 \uC54C\uBA74\uC11C\uB3C4 \uAC19\uC740 \uC870 \uC81C1\uD56D \uB2E8\uC11C\uC5D0 \uB530\uB978 \uD5C8\uAC00(\uC81C14\uC870\uC81C3\uD56D\uC5D0 \uB530\uB77C \uC900\uC6A9\uB418\uB294 \uACBD\uC6B0\uB97C \uD3EC\uD568\uD55C\uB2E4)\uB97C \uBC1B\uC9C0 \uC544\uB2C8\uD558\uACE0 \uD574\uB2F9 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC5D0\uC11C \uC5EC\uAD8C \uB4F1\uC744 \uC0AC\uC6A9\uD558\uAC70\uB098 \uD574\uB2F9 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC744 \uBC29\uBB38\uD558\uAC70\uB098 \uCCB4\uB958\uD55C \uC0AC\uB78C\uC740 1\uB144 \uC774\uD558\uC758 \uC9D5\uC5ED \uB610\uB294 1000\uB9CC\uC6D0 \uC774\uD558\uC758 \uBC8C\uAE08\uC5D0 \uCC98\uD55C\uB2E4.\\n",\n                "format": "TEXT",\n                "sellerUrl": null,\n                "sellerUrlMethod": "GET",\n                "seq": 0\n            },\n            {\n                "title": "\uC5EC\uD589\uC9C0(\uAD6D\uAC00/\uC9C0\uC5ED) \uC5EC\uD589\uACBD\uBCF4 \uBC1C\uB839\uD604\uD669",\n                "type": "Safety Instruction",\n                "content": "\u25CF \uC911\uAD6D\\n- \uC5EC\uD589\uC720\uC758(\uC77C\uBD80) : \uC911\uAD6D\u318D\uBD81\uD55C \uAD6D\uACBD\uC9C0\uC5ED : \uB2E8\uB465\uC2DC, \uAD00\uC804\uB9CC\uC871\uC790\uCE58\uD604, \uC9D1\uC548\uC2DC, \uBC31\uC0B0\uC2DC, \uC784\uAC15\uC2DC, \uC7A5\uBC31\uC870\uC120\uC871\uC790\uCE58\uD604, \uC548\uB3C4\uD604, \uD654\uB8E1\uC2DC, \uC6A9\uC815\uC2DC, \uB3C4\uBB38\uC2DC, \uD6C8\uCD98\uC2DC\\n- \uC5EC\uD589\uC790\uC81C(\uC77C\uBD80) : \uD2F0\uBCB3, \uC2E0\uC7A5\uC704\uAD6C\uB974\uC790\uCE58\uAD6C\\n\uC678\uAD50\uBD80\uB294 \uC6B0\uB9AC \uAD6D\uBBFC\uC758 \uC0DD\uBA85\xB7\uC548\uC804\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD558\uC5EC \uC5EC\uAD8C\uBC95 \uC81C 17\uC870\uC5D0 \uB530\uB77C \uC544\uB798\uC758 \uAD6D\uAC00\uB4E4\uC740 \uC9C0\uC815\uB41C \uAE30\uAC04 \uB3D9\uC548 \uC5EC\uD589\uAE08\uC9C0\uAD6D\uC73C\uB85C \uC9C0\uC815\uD558\uC5EC \uC6B0\uB9AC \uAD6D\uBBFC\uB4E4\uC758 \uBC29\uBB38 \uBC0F \uCCB4\uB958\uB97C \uAE08\uC9C0\uD569\uB2C8\uB2E4.\\n\u203B \uC5EC\uD589\uACBD\uBCF4\uB2E8\uACC4\uB294 \uC5EC\uD589\uC720\uC758/\uC790\uC81C/\uC81C\uD55C/\uAE08\uC9C0 4\uB2E8\uACC4\uB85C \uAD6C\uBD84\uB418\uBA70, \uC678\uAD50\uBD80 \'\uD574\uC678\uC548\uC804\uC5EC\uD589\' \uC0AC\uC774\uD2B8(www.0404.go.kr)\uC5D0\uC11C \uC0C1\uC138\uC815\uBCF4\uB97C \uD655\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\uB610\uD55C \uCD9C\uAD6D \uC804 \uB3D9\uC0AC\uC774\uD2B8\uC758 \uD574\uC678\uC5EC\uD589 \uB4F1\uB85D\uC81C \\"\uB3D9\uD589\\"\uC5D0 \uAC00\uC785\uD558\uC2DC\uBA74 \uC548\uC804\uC815\uBCF4\uB97C \uC218\uC2DC\uB85C \uC81C\uACF5 \uBC1B\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n",\n                "format": "TEXT",\n                "sellerUrl": null,\n                "sellerUrlMethod": "GET",\n                "seq": 1\n            }\n        ],\n        "hotelInfo": {\n            "title": "Hotel Information",\n            "type": "Hotel Information",\n            "content": "\u2022 \uD638\uD154\uBA85 :\\n\u2022 \uB4F1\uAE09 : \\n\u2022 \uB8F8\uD0C0\uC785 : \\n\u2022 1\uC778 \uC2F1\uAE00 \uB8F8 \uC0AC\uC6A9\uC2DC :\\n- \uD638\uD154\uC740 \uBD80\uB4DD\uC774\uD55C \uACBD\uC6B0 \uB3D9\uAE09\uC758 \uB2E4\uB978 \uD638\uD154\uB85C \uBCC0\uB3D9 \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n",\n            "format": "TEXT",\n            "sellerUrl": null,\n            "sellerUrlMethod": "GET",\n            "seq": 0\n        },\n        "insuranceInfo": null,\n        "inclusionNotice": "\uC655\uBCF5 \uD56D\uACF5\uAD8C \uD3EC\uD568 -\\n\uC720\uB958\uD560\uC99D\uB8CC \uBC0F \uAC01\uC885 TAX(\uC655\uBCF5\uACF5\uD56D\uC138, \uC804\uC7C1\uBCF4\uD5D8\uB8CC, \uAD00\uAD11\uC9C4\uD765\uAC1C\uBC1C\uAE30\uAE08 \uB4F1) \uD3EC\uD568:   XXX\uD56D\uACF5 00,\\n000 \uC6D0(\uC131\uC778 / \uC18C\uC544 \uB3D9\uC77C) -\\n\uC720\uB958\uD560\uC99D\uB8CC\uB294 \uAD6D\uC81C \uC720\uAC00 \uBC0F IATA\uAD6D\uC81C\uD56D\uACF5\uC218\uC1A1\uD611\uD68C\uC758 \uACF5\uC2DC \uD658\uC728\uC5D0 \uB530\uB77C \uBCC0\uB3D9 \uB420 \uC218 \uC788\uC74C. \uBCC0\uB3D9\uC5D0 \uB530\uB77C \uCD94\uAC00\uC694\uAE08\uC774 \uBC1C\uC0DD\uB420 \uC218 \uC788\uC73C\uBA70,\\n\uCD94\uAC00\uC694\uAE08 \uBC1C\uC0DD\uC758 \uACBD\uC6B0 \uD574\uD53C\uCF5C\uC2DC \uC548\uB0B4\uB4DC\uB9BD\uB2C8\uB2E4.\u2022\uC804 \uC77C\uC815 \uC219\uBC15 \uBE44\uC6A9(\uC131\uC778 2 \uC778 1 \uC2E4 \uAE30\uC900)\u2022 \uC77C\uC815\uD45C\uC0C1 \uAE30\uC81C\uB41C \uAD00\uAD11\uC9C0 \uC785\uC7A5\uB8CC \uBC0F \uC2DD\uC0AC\u2022 \uC77C\uC815 \uC911 \uC804\uC6A9\uCC28\uB7C9 \uBC0F \uAE30\uC0AC\u2022 \uC5EC\uD589\uC790 \uBCF4\uD5D8\u2022 \uAC01\uC885 \uD2B9\uC804 \uC81C\uACF5(\uCEE8\uD150\uCE20 \uC0C1\uC138\uD398\uC774\uC9C0 \uCC38\uC870)\\n---111111",\n        "exclusionNotice": "1 \uC778\uB2F9 \uC804\uC77C\uC815 $00 (0 \uBC150\uC77C) \uC758 \uAC00\uC774\uB4DC / \uAE30\uC0AC \uACBD\uBE44 \uD604\uC9C0 \uC9C0\uBD88(\uC131\uC778 / \uC544\uB3D9 \uB3D9\uC77C)\u2022 \uC120\uD0DD \uAD00\uAD11 \uACBD\uBE44 \uBC0F \uAE30\uD0C0 \uAC1C\uC778\uACBD\uBE44 -\\n\uC120\uD0DD \uAD00\uAD11\uC740 \uC790\uC720\uC758\uC0AC\uB85C \uBBF8 \uC120\uD0DD\uC5D0 \uB530\uB978 \uBD88\uC774\uC775 \uBC0F \uCD94\uAC00\uAE08\uC740 \uC5C6\uC2B5\uB2C8\uB2E4.\\n---111111",\n        "usageNotice": "\uC544\uB3D9(24 \uAC1C\uC6D4\uC774\uC0C1~\uB9CC12\uC138\uBBF8\uB9CC) \uC694\uAE08: \uC131\uC778\uACFC \uB3D9\uC77C -\\n\uD56D\uACF5 \uC88C\uC11D \uC788\uC74C,\\n\uC131\uC778\uACFC \uD55C\uBC29 \uC0AC\uC6A9\u2022 \uC720\uC544(24 \uAC1C\uC6D4\uBBF8\uB9CC) \uC694\uAE08: 000,\\n000 \uC6D0 / \uC778 -\\n\uBCC4\uB3C4\uC758 \uD56D\uACF5\uC88C\uC11D \uC5C6\uC74C,\\n\uB178\uBCA0\uB4DC \uC870\uAC74(\uC5EC\uD589\uC0AC\uC5D0 \uC9C1\uC811 \uACB0\uC81C) \u2022 \uC5EC\uAD8C \uC720\uD6A8\uAE30\uAC04\uC740 6 \uAC1C\uC6D4 \uC774\uC0C1 \uB0A8\uC544 \uC788\uC5B4\uC57C \uD569\uB2C8\uB2E4.\u2022\uB2E8\uC218\uC5EC\uAD8C\uC758 \uACBD\uC6B0 \uBCC4\uB3C4 \uBB38\uC758 \uBD80\uD0C1 \uB4DC\uB9BD\uB2C8\uB2E4.\u2022\uD574\uD53C\uCF5C\uC2DC \uC5EC\uD589\uC0AC\uC5D0 \uC815\uD655\uD55C \uC5EC\uAD8C\uC0C1\uC758 \uC601\uBB38\uC774\uB984\uC744 \uC54C\uB824\uC8FC\uC154\uC57C \uD569\uB2C8\uB2E4.\u2022\uBCF8 \uC0C1\uD488\uC740 \uC1FC\uD551\uC13C\uD130 0 \uD68C(XX, XX, XX \uC911 0 \uD68C) \uBC29\uBB38 \uC608\uC815\\n---111111",\n        "reservationGuide": {\n            "title": null,\n            "type": "Reservation Guide",\n            "content": "\u2022 \uCD9C\uBC1C\uC870\uAC74\\n-  \uB0A0\uC9DC\uB2F9 \uC131\uC778\uAE30\uC900 0\uBA85 \uC774\uC0C1 \uBAA8\uAC1D \uC2DC \uCD9C\uBC1C\uD655\uC815 \uAC00\uB2A5\\n- \uCFE0\uD321\uACFC \uC5C5\uCCB4\uC758 \uBAA8\uAC1D\uC778\uC6D0\uC744 \uD569\uC0B0\uD55C \uCD5C\uC18C\uC778\uC6D0\\n- \uCD5C\uC18C\uC778\uC6D0 \uBBF8\uB2EC \uC2DC \uCD9C\uBC1C 7\uC77C\uC804\uAE4C\uC9C0 \uC5EC\uD589 \uCDE8\uC18C \uD1B5\uC9C0\\n\u2022 \uC5EC\uD589\uC9C0 \uC548\uC804\uC815\uBCF4: \uAD6D\uAC00\uBCC4 \uC5EC\uD589\uACBD\uBCF4 \uB2E8\uACC4 \uBCF4\uAE30 (http://www.0404.go.kr/dev/main.mofa)",\n            "format": "TEXT",\n            "sellerUrl": null,\n            "sellerUrlMethod": "GET",\n            "seq": 0\n        },\n        "additionalInfoPrompt": "please leave your phone number,dob,name and gender",\n        "maxPurchaseQuantity": 1000,\n        "csContactInfo": "\uD3C9\uC77C 09: 00~18: 00(\uB2E8, \uD1A0 / \uC77C, \uACF5\uD734\uC77C\uC740 \uD734\uBB34)",\n        "taxType": "FREE",\n        "instantBooking": false,\n        "estimatedBookingDuration": 1,\n        "extension": null,\n        "travelProductId": 205649217090228224,\n        "productId": 347225867,\n        "vendorItemPackageId": 100000048987,\n        "productDetailType": "PACKAGE_TOUR",\n        "travelType": "OVERSEAS",\n        "displayCategoryCode": 108682,\n        "vendorId": "A00177491",\n        "saleStatus": "ON_SALE",\n        "qcStatus": "COMPLETE_APPROVAL",\n        "displayChannels": null,\n        "userAgreements": null,\n        "reservationRequired": false,\n        "errors": [\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": null,\n                "type": "IMAGE_PROCESS",\n                "level": "MINOR"\n            },\n            {\n                "info": "Duplicate key {\\"interlockingVendorItemId\\": \\"0\\", \\"interlockingRateCategoryId\\": \\"205649217534828544\\", \\"interlockingTravelItemId\\": \\"205660229461880832\\"}",\n                "type": "CATALOG_INTEGRATION",\n                "level": "MINOR"\n            }\n        ],\n        "travelItems": [\n            {\n                "sellerTravelItemId": "seller-item-id-1",\n                "name": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 3\uBC155\uC77C",\n                "description": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 3\uBC155\uC77C description",\n                "period": "3\uBC155\uC77C",\n                "seq": 0,\n                "features": [\n                    {\n                        "featureId": "AIRLINE_SHIP_TYPE",\n                        "featureValues": [\n                            "FOREIGN_AIRLINE"\n                        ],\n                        "description": null\n                    },\n                    {\n                        "featureId": "TRAVEL_PERIOD",\n                        "featureValues": [\n                            "FIVE_DAYS"\n                        ],\n                        "description": null\n                    },\n                    {\n                        "featureId": "DOMESTIC_DEPARTING_CITY",\n                        "featureValues": [\n                            "SEOUL_INCLUDE_INCHOEN_AND_KIMPO"\n                        ],\n                        "description": null\n                    },\n                    {\n                        "featureId": "CONFIRMED_DEPART",\n                        "featureValues": [\n                            "DEPARTURE_UNDECIDED"\n                        ],\n                        "description": null\n                    },\n                    {\n                        "featureId": "HOTEL_GRADE",\n                        "featureValues": [\n                            "FIVE_STAR"\n                        ],\n                        "description": null\n                    },\n                    {\n                        "featureId": "FUEL_SURCHARGE_TAX",\n                        "featureValues": [\n                            "FUEL_SURCHARGE_INCLUDED"\n                        ],\n                        "description": null\n                    },\n                    {\n                        "featureId": "DEPARTURE_OVERSEA_TIME",\n                        "featureValues": [\n                            "EVENING"\n                        ],\n                        "description": null\n                    }\n                ],\n                "taxType": "FREE",\n                "onSale": false,\n                "rates": [\n                    {\n                        "sellerRateId": "seller-rate-id-1",\n                        "rateType": "BASIC",\n                        "priceType": "COUPANG_PRICE",\n                        "price": 500000,\n                        "representative": true,\n                        "saleStartedAt": "2019-11-01 01:00:00",\n                        "saleEndedAt": "2019-11-21 01:00:00",\n                        "maxPurchaseQtyPerPerson": 10,\n                        "maxPurchaseQtyPeriod": 1,\n                        "seq": 0\n                    }\n                ],\n                "travelItemId": 205649217492889600,\n                "deleted": false\n            },\n            {\n                "sellerTravelItemId": "seller-item-id-2",\n                "name": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 4\uBC156\uC77C",\n                "description": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 4\uBC156\uC77C description",\n                "period": "4\uBC156\uC77C",\n                "seq": 1,\n                "features": [],\n                "taxType": "FREE",\n                "onSale": true,\n                "rates": [\n                    {\n                        "sellerRateId": "seller-rate-id-1",\n                        "rateType": "ADULT",\n                        "priceType": "COUPANG_PRICE",\n                        "price": 5000000,\n                        "representative": true,\n                        "saleStartedAt": "2019-11-01 01:00:00",\n                        "saleEndedAt": "2019-12-21 01:00:00",\n                        "maxPurchaseQtyPerPerson": 10,\n                        "maxPurchaseQtyPeriod": 1,\n                        "seq": 0\n                    },\n                    {\n                        "sellerRateId": "seller-rate-id-1",\n                        "rateType": "CHILD",\n                        "priceType": "COUPANG_PRICE",\n                        "price": 4000000,\n                        "representative": true,\n                        "saleStartedAt": "2019-11-01 01:00:00",\n                        "saleEndedAt": "2019-12-21 01:00:00",\n                        "maxPurchaseQtyPerPerson": 10,\n                        "maxPurchaseQtyPeriod": 1,\n                        "seq": 1\n                    }\n                ],\n                "travelItemId": 205649217522237440,\n                "deleted": false\n            },\n            {\n                "sellerTravelItemId": "seller-item-id-5",\n                "name": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 4\uBC156\uC77C",\n                "description": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 4\uBC156\uC77C description",\n                "period": "4\uBC156\uC77C",\n                "seq": 1,\n                "features": [],\n                "taxType": "FREE",\n                "onSale": true,\n                "rates": [\n                    {\n                        "sellerRateId": "seller-rate-id-1",\n                        "rateType": "ADULT",\n                        "priceType": "COUPANG_PRICE",\n                        "price": 5000000,\n                        "representative": true,\n                        "saleStartedAt": "2019-11-01 01:00:00",\n                        "saleEndedAt": "2019-12-21 01:00:00",\n                        "maxPurchaseQtyPerPerson": 10,\n                        "maxPurchaseQtyPeriod": 1,\n                        "seq": 0\n                    },\n                    {\n                        "sellerRateId": "seller-rate-id-1",\n                        "rateType": "CHILD",\n                        "priceType": "COUPANG_PRICE",\n                        "price": 4000000,\n                        "representative": true,\n                        "saleStartedAt": "2019-11-01 01:00:00",\n                        "saleEndedAt": "2019-12-21 01:00:00",\n                        "maxPurchaseQtyPerPerson": 10,\n                        "maxPurchaseQtyPeriod": 1,\n                        "seq": 1\n                    }\n                ],\n                "travelItemId": 205660229461880832,\n                "deleted": false\n            }\n        ],\n        "createdBy": "1.24.57.16",\n        "createdAt": "2019-12-04 18:48:27",\n        "modifiedBy": "SYSTEM",\n        "modifiedAt": "2019-12-04 19:32:15"\n    }\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewSingleTourProduct;
	}(_react2.default.Component);
	
	exports.default = ViewSingleTourProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewSingleTourProduct.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 2665048300771620:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4813844983747096);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes3 = __webpack_require__(762558919458398);
	
	var _UncontrolledTabs = __webpack_require__(6481278976589768);
	
	var _UncontrolledTabs2 = _interopRequireDefault(_UncontrolledTabs);
	
	var _count = __webpack_require__(8476312172317632);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tabs = function (_Component) {
	  _inherits(Tabs, _Component);
	
	  function Tabs(props) {
	    _classCallCheck(this, Tabs);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleSelected = function (index, last, event) {
	      // Call change event handler
	      if (typeof _this.props.onSelect === 'function') {
	        // Check if the change event handler cancels the tab change
	        if (_this.props.onSelect(index, last, event) === false) return;
	      }
	
	      var state = {
	        // Set focus if the change was triggered from the keyboard
	        focus: event.type === 'keydown'
	      };
	
	      if (Tabs.inUncontrolledMode(_this.props)) {
	        // Update selected index
	        state.selectedIndex = index;
	      }
	
	      _this.setState(state);
	    };
	
	    _this.state = Tabs.copyPropsToState(_this.props, {}, _this.props.defaultFocus);
	    return _this;
	  }
	
	  Tabs.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
	    if (false) {
	      throw new Error('Switching between controlled mode (by using `selectedIndex`) and uncontrolled mode is not supported in `Tabs`.\nFor more information about controlled and uncontrolled mode of react-tabs see the README.');
	    }
	    // Use a transactional update to prevent race conditions
	    // when reading the state in copyPropsToState
	    // See https://github.com/reactjs/react-tabs/issues/51
	    this.setState(function (state) {
	      return Tabs.copyPropsToState(newProps, state);
	    });
	  };
	
	  Tabs.inUncontrolledMode = function inUncontrolledMode(props) {
	    return props.selectedIndex === null;
	  };
	
	  // preserve the existing selectedIndex from state.
	  // If the state has not selectedIndex, default to the defaultIndex or 0
	  Tabs.copyPropsToState = function copyPropsToState(props, state) {
	    var focus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var newState = {
	      focus: focus
	    };
	
	    if (Tabs.inUncontrolledMode(props)) {
	      var maxTabIndex = (0, _count.getTabsCount)(props.children) - 1;
	      var selectedIndex = null;
	
	      if (state.selectedIndex != null) {
	        selectedIndex = Math.min(state.selectedIndex, maxTabIndex);
	      } else {
	        selectedIndex = props.defaultIndex || 0;
	      }
	      newState.selectedIndex = selectedIndex;
	    }
	
	    return newState;
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        defaultIndex = _props.defaultIndex,
	        defaultFocus = _props.defaultFocus,
	        props = _objectWithoutProperties(_props, ['children', 'defaultIndex', 'defaultFocus']);
	
	    props.focus = this.state.focus;
	    props.onSelect = this.handleSelected;
	
	    if (this.state.selectedIndex != null) {
	      props.selectedIndex = this.state.selectedIndex;
	    }
	
	    return _react2.default.createElement(
	      _UncontrolledTabs2.default,
	      props,
	      children
	    );
	  };
	
	  return Tabs;
	}(_react.Component);
	
	Tabs.defaultProps = {
	  defaultFocus: false,
	  forceRenderTabPanel: false,
	  selectedIndex: null,
	  defaultIndex: null
	};
	exports.default = Tabs;
	Tabs.propTypes =  false ? {
	  children: _propTypes3.childrenPropType,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
	  defaultFocus: _propTypes2.default.bool,
	  defaultIndex: _propTypes2.default.number,
	  disabledTabClassName: _propTypes2.default.string,
	  forceRenderTabPanel: _propTypes2.default.bool,
	  onSelect: _propTypes3.onSelectPropType,
	  selectedIndex: _propTypes3.selectedIndexPropType,
	  selectedTabClassName: _propTypes2.default.string,
	  selectedTabPanelClassName: _propTypes2.default.string
	} : {};

/***/ }),

/***/ 2692642590089237:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2715183967877881:
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),

/***/ 2870738329518842:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateLodgingProducts = function (_React$Component) {
	    _inherits(UpdateLodgingProducts, _React$Component);
	
	    function UpdateLodgingProducts(props) {
	        _classCallCheck(this, UpdateLodgingProducts);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateLodgingProducts.prototype.render = function render() {
	        var col_number_9 = 9;
	        var total_levels = 6;
	        var level1 = 6;
	        var level2 = 5;
	        var level2_prefix = level1 - level2;
	        var level3 = 4;
	        var level3_prefix = level1 - level3;
	        var level4 = 3;
	        var level4_prefix = level1 - level4;
	        var level5 = 2;
	        var level6 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC219\uBC15 \uC0C1\uD488 \uC5C5\uB370\uC774\uD2B8'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uD55C\uAC1C \uC774\uC0C1\uC758 \uC219\uBC15 \uC0C1\uD488 \uC5C5\uB370\uC774\uD2B8'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'PUT'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/lodgings'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_9, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_9, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'lodgingUpdateDtos'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<LodgingUpdateDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC790\uC0AC\uC0AC\uC774\uD2B8\uC758 \uC0C1\uD488ID'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15 \uC2DC\uC124 \uAD6D\uAC00 (\uAE30\uBCF8\uAC12 : \uD55C\uAD6D)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uC774\uB984 (\uCD5C\uB300 50\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'localName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Local Name'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'introduction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uC18C\uAC1C (\uCD5C\uB300 2000\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uACF5\uC9C0\uC0AC\uD56D (\uCD5C\uB300 2000\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5) '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'benefits'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uD2B9\uBCC4\uD61C\uD0DD (\uCD5C\uB300 3\uAC1C / \uCD5C\uB300 30\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5) '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'regionKeyword'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uC5ED\uD0A4\uC6CC\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'searchTags'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC80\uC0C9\uD0DC\uADF8 (\uCD5C\uB300 100\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'images'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Method. Default: GET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'representative '
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\uAC00 \uC0C1\uD488 \uB300\uD45C\uD568, \uC0C1\uD488\uB2F9 \uB2E8\uC77C \uB300\uD45C\uC774\uBBF8\uC9C0 \uBCF4\uC720. Default: FALSE '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'imageGroup'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85. Default:BASIC',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'VIEW'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FACILITY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD80\uB300\uC2DC\uC124'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESTAURANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DD\uB2F9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ROOM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uC815\uCC45',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AUTO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uB3D9\uCDE8\uC18C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778\uCDE8\uC18C'
	                                            )
	                                        )
	                                    )
	                                ),
	                                'CancelType(\uCDE8\uC18C\uC885\uB958) \uBCC4 \uCDE8\uC18C\uB9C8\uAC10\uC2DC\uAC04 (\uC219\uBC15\uC0C1\uD488)',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AUTO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uB3D9\uCDE8\uC18C: \uBE44\uC601\uC5C5\uC77C(\uACE0\uAC1D\uCDE8\uC18C\uC811\uC218)\uAE30\uC900 23:59\u200B'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778\uCDE8\uC18C: \uC601\uC5C5\uC77C \uAE30\uC900 17:00'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelPolicyNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'instantBooking'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2E4\uC2DC\uAC04 \uC608\uC57D \uAC00\uB2A5 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : True)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'additionalInfoPrompt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBB38 \uCD94\uAC00\uC815\uBCF4  (\uCFE0\uD321\uC5D0\uC11C \uC8FC\uBB38\uC2DC \uACE0\uAC1D\uC5D0\uAC8C \uCD94\uAC00\uC694\uCCAD\uC0AC\uD56D\uC744 \uB0A8\uAE30\uB3C4\uB85D \uC694\uCCAD\uD574\uC57C\uD558\uB294\uACBD\uC6B0, \uC8FC\uBB38 \uCD94\uAC00 \uC815\uBCF4\uB97C \uB0A8\uACA8\uC8FC\uC138\uC694. (\uC608 : \uBC29\uBB38\uBC29\uBC95\uACFC \uC2DC\uAC04\uC744 \uB0A8\uACA8\uC8FC\uC138\uC694 \uB4F1))'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'usageGuide'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'usage guide'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'usageNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uC6A9\uC548\uB0B4 \uBC0F \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'address'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15 \uC2DC\uC124 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uB3C4, \uB370\uC774\uD130 \uBC94\uC704(-90, 90)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uACBD\uB3C4, \uB370\uC774\uD130 \uBC94\uC704(-180,180)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'roadNameAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uB85C\uBA85 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'landNumberAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uBC88 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6D\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'province'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'city'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'district'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'town'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'zipCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B0\uD3B8\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'localAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD604\uC9C0 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uB3C4 , \uB370\uC774\uD130 \uBC94\uC704(-90, 90)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uACBD\uB3C4, \uB370\uC774\uD130 \uBC94\uC704(-180,180)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'roadNameAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uB85C\uBA85 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'landNumberAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uBC88 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6D\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'province'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'city'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'district'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'town'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'zipCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B0\uD3B8\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'reservationNotifications'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D/\uCDE8\uC18C \uC54C\uB9BC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'contactInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'contactDescription'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'homepage'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD648\uD398\uC774\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'representativePhone'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uB300\uD45C \uC804\uD654'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'bookingInquiryPhone'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D \uBB38\uC758 \uC804\uD654. \uC81C\uACF5\uB418\uC9C0 \uC54A\uC73C\uBA74 \uD574\uB2F9 \uB370\uC774\uD130\uAC00 representativePhone\uACFC \uB3D9\uC77C\uD568'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelInquiryPhone'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uBB38\uC758 \uC804\uD654.\uC81C\uACF5\uB418\uC9C0 \uC54A\uC73C\uBA74 \uD574\uB2F9 \uB370\uC774\uD130\uAC00 representativePhone\uACFC \uB3D9\uC77C\uD568'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'emergencyPhone'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD734\uB300\uD3F0 \uAE34\uAE09 \uC5F0\uB77D\uCC98'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'trafficInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE38\uC548\uB0B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'publicTransportInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C \uC548\uB0B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'nearbyLandmarks'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uAD00\uAD11\uC9C0 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'distanceUnit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'KILOMETER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD0AC\uB85C\uBBF8\uD130'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'METER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uD130'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'amenities'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uACF5\uD1B5 \uAD6C\uBE44 \uD488\uBAA9. \uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'themes'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD14C\uB9C8\uC815\uBCF4. \uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#createTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'createTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n  "lodgingUpdateDtos": [\n    {\n      "travelProductId": 579968859277099012,\n      "additionalInfoPrompt": "changed: additional info prompt",\n      "address": {\n        "city": "shanghai-2",\n        "district": "district",\n        "landNumberAddress": null,\n        "latitude": 32.260077,\n        "longitude": 122.448697,\n        "nation": "CN",\n        "province": "shanghai-2",\n        "roadNameAddress": "Shanghai \uC0C1\uD558\uC774 shanghaihutail617-2",\n        "town": null,\n        "zipCode": "200000-2"\n      },\n      "amenities": [\n        "ACCOMMODATION_LEISURE_43",\n        "ACCOMMODATION_LEISURE_57",\n        "ACCOMMODATION_COMFORT_37"\n      ],\n      "benefits": [\n        "benefit 3",\n        "benefit 4"\n      ],\n      "bookingInquiryPhone": "010-2345-6789",\n      "cancelInquiryPhone": "010-2345-6789",\n      "cancelPolicyNotice": "cancel policy notice-2",\n      "cancelType": "AUTO",\n      "emergencyPhone": "010-2345-6789",\n      "homepage": "www.example.com",\n      "images": [\n        {\n          "description": null,\n          "imageGroup": "VIEW",\n          "representative": true,\n          "sellerImageCategory": null,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 0\n        },\n        {\n          "description": null,\n          "imageGroup": "ROOM",\n          "representative": false,\n          "sellerImageCategory": null,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/db272720_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 1\n        },\n        {\n          "description": null,\n          "imageGroup": "VIEW",\n          "representative": false,\n          "sellerImageCategory": null,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 2\n        },\n        {\n          "description": null,\n          "imageGroup": "VIEW",\n          "representative": false,\n          "sellerImageCategory": null,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 3\n        },\n        {\n          "description": null,\n          "imageGroup": "ROOM",\n          "representative": false,\n          "sellerImageCategory": null,\n          "sellerUrl": "https://i.travelapi.com/hotels/15000000/14740000/14736800/14736767/3394096f_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 4\n        }\n      ],\n      "instantBooking": true,\n      "introduction": "product introduction - 2",\n      "localAddress": null,\n      "localName": "\u5047\u65E5\u9152\u5E97_11",\n      "name": "\uD558\uC774 \uC778_update_1",\n      "nation": "CN",\n      "nearbyLandmarks": [\n        {\n          "distance": 1,\n          "distanceUnit": "KILOMETER",\n          "latitude": 31,\n          "longitude": 121,\n          "name": "nearbyLandmark 1"\n        },\n        {\n          "distance": 500,\n          "distanceUnit": "METER",\n          "latitude": 31.1,\n          "longitude": 121.1,\n          "name": "nearbyLandmark 1"\n        }\n      ],\n      "notice": "product notice - 2",\n      "publicTransportInfo": "public transport infomation - 2",\n      "refundByBusinessDay": true,\n      "regionKeyword": "Shanghai",\n      "representativePhone": "010-2345-6789",\n      "reservationNotifications": [\n        {\n          "contactDescription": "reservation notification 1 - 2",\n          "contactInfo": "010-2345-7777",\n          "type": "PHONE"\n        }\n      ],\n      "searchTags": [\n        "shanghai",\n        "disney"\n      ],\n      "sellerProductId": "seller product 1",\n      "themes": [\n        "ACCOMMODATION_THEME_65"\n      ],\n      "trafficInfo": "traffic info - 2",\n      "usageGuide": "usage guide - 2",\n      "usageNotice": "usage notice - 2"\n    },\n    {\n      "travelProductId": 577175634321604613,\n      "additionalInfoPrompt": "changed: additional info prompt",\n      "address": {\n        "city": "shanghai-3",\n        "district": "Pudong New distict",\n        "landNumberAddress": null,\n        "latitude": 32.260077,\n        "longitude": 122.448697,\n        "nation": "CN",\n        "province": "shanghai-2",\n        "roadNameAddress": "Shanghai \uC0C1\uD558\uC774 shanghaihutail617-2",\n        "town": null,\n        "zipCode": "200000-2"\n      },\n      "amenities": [\n        "ACCOMMODATION_LEISURE_43",\n        "ACCOMMODATION_LEISURE_57",\n        "ACCOMMODATION_COMFORT_37"\n      ],\n      "benefits": [\n        "benefit 3",\n        "benefit 4"\n      ],\n      "bookingInquiryPhone": "010-2345-6789",\n      "cancelInquiryPhone": "010-2345-6789",\n      "cancelPolicyNotice": "cancel policy notice-2",\n      "cancelType": "AUTO",\n      "emergencyPhone": "010-2345-7777",\n      "homepage": "www.example.com",\n      "images": [\n        {\n          "description": null,\n          "imageGroup": "VIEW",\n          "representative": true,\n          "sellerImageCategory": null,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 0\n        },\n        {\n          "description": null,\n          "imageGroup": "ROOM",\n          "representative": false,\n          "sellerImageCategory": null,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/db272720_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 1\n        },\n        {\n          "description": null,\n          "imageGroup": "VIEW",\n          "representative": false,\n          "sellerImageCategory": null,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 2\n        },\n        {\n          "description": null,\n          "imageGroup": "VIEW",\n          "representative": false,\n          "sellerImageCategory": null,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 3\n        },\n        {\n          "description": null,\n          "imageGroup": "ROOM",\n          "representative": false,\n          "sellerImageCategory": null,\n          "sellerUrl": "https://i.travelapi.com/hotels/15000000/14740000/14736800/14736767/3394096f_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 4\n        }\n      ],\n      "instantBooking": true,\n      "introduction": "product introduction - 2",\n      "localAddress": null,\n      "localName": "\u5047\u65E5\u9152\u5E97_2",\n      "name": "\uD558\uC774 \uC778_update_3",\n      "nation": "CN",\n      "nearbyLandmarks": [\n        {\n          "distance": 1,\n          "distanceUnit": "KILOMETER",\n          "latitude": 31,\n          "longitude": 121,\n          "name": "nearbyLandmark 1"\n        },\n        {\n          "distance": 500,\n          "distanceUnit": "METER",\n          "latitude": 31.1,\n          "longitude": 121.1,\n          "name": "nearbyLandmark 1"\n        }\n      ],\n      "notice": "product notice - 2",\n      "publicTransportInfo": "public transport infomation - 2",\n      "refundByBusinessDay": true,\n      "regionKeyword": "Shanghai",\n      "representativePhone": "010-2345-6789",\n      "reservationNotifications": [\n        {\n          "contactDescription": "reservation notification 1 - 2",\n          "contactInfo": "010-2345-6789",\n          "type": "PHONE"\n        }\n      ],\n      "searchTags": [\n        "shanghai",\n        "disney"\n      ],\n      "sellerProductId": "seller product 1",\n      "themes": [\n        "ACCOMMODATION_THEME_65"\n      ],\n      "trafficInfo": "traffic info - 2",\n      "usageGuide": "usage guide - 2",\n      "usageNotice": "usage notice - 2"\n    }\n  ]\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'LodgingResultResponseDto'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<SuccessOrFail>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                '(success)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LodgingResponseDto'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'rooms'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<LodgingRoomResponseDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'sellerRoomId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uB8F8 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uB8F8\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'rates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<LodgingRateResponseDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'rateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'rate id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6F9\uC0AC\uC774\uD2B8\uC758 \uC694\uAE08 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uC694\uAE08\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                '(fail)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LodgingErrorResponseDto'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uD504\uB85C\uB355\uD2B8 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uD504\uB85C\uB355\uD2B8\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'reason'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC624\uB958 \uC0AC\uC720'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Lodging product update request successfully received",\n    "data": {\n        "success": [\n            {\n                "travelProductId": 579968859277099012,\n                "sellerProductId": "seller product 1",\n                "name": "\uD558\uC774 \uC778_update_1",\n                "rooms": null,\n                "rates": null\n            },\n            {\n                "travelProductId": 577175634321604613,\n                "sellerProductId": "seller product 1",\n                "name": "\uD558\uC774 \uC778_update_3",\n                "rooms": null,\n                "rates": null\n            }\n        ],\n        "fail": []\n    }\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforCreateProduct' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforCreateProduct', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement('div', { className: 'panel-body' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateLodgingProducts;
	}(_react2.default.Component);
	
	exports.default = UpdateLodgingProducts;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateLodgingProducts.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 2886187413675904:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainBanner = function (_React$Component) {
	    _inherits(MainBanner, _React$Component);
	
	    function MainBanner(props) {
	        _classCallCheck(this, MainBanner);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    MainBanner.prototype.componentDidMount = function componentDidMount() {
	        this.initTextSpeed();
	    };
	
	    MainBanner.prototype.render = function render() {
	        return _react2.default.createElement(
	            "div",
	            { className: "main-banner" },
	            _react2.default.createElement(
	                "div",
	                { className: "_1v5a" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "_1v5c _52jv" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "_1v5d" },
	                        "\uC0AC\uC6A9\uC790\uB4E4\uACFC \uC0C8\uB86D\uAC8C \uB9CC\uB098\uBCF4\uC138\uC694"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { id: "u_0_0" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "_1sfp" },
	                            "\uC571 \uAC1C\uBC1C, \uC0AC\uC5C5 \uD655\uC7A5, \uC218\uC775 \uCC3D\uCD9C\uC5D0 \uB3C4\uC6C0\uC744 \uC8FC\uB294 ",
	                            _react2.default.createElement(
	                                "span",
	                                { id: "texts" },
	                                this.props.text || "",
	                                " "
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement("img", { className: "_1v5b img", src: "https://img1a.coupangcdn.com/image/static/travel/api/banner_5_1920.jpg", height: "400", alt: "" })
	            )
	        );
	    };
	
	    MainBanner.prototype.initTextSpeed = function initTextSpeed() {
	        var _this2 = this;
	
	        var text = "Ticket OpenAPI";
	        var cnt = 0;
	        var speed = 400; //글자가 찍히는 속도
	        var timer1 = null;
	
	        window.gogogo = function () {
	            _this2.props.onChange(text.substring(0, cnt) + "_");
	            cnt++;
	            timer1 = setTimeout('gogogo()', speed);
	
	            if (text.length < cnt) {
	                cnt = 0;
	            }
	        };
	        gogogo();
	    };
	
	    return MainBanner;
	}(_react2.default.Component);
	
	MainBanner.propTypes = {
	    text: _react2.default.PropTypes.string.isRequired,
	    onChange: _react2.default.PropTypes.func.isRequired
	};
	exports.default = MainBanner;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "MainBanner.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 3003326045329452:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReservationAndCancellationAPIContent = function (_React$Component) {
	    _inherits(ReservationAndCancellationAPIContent, _React$Component);
	
	    function ReservationAndCancellationAPIContent(props) {
	        _classCallCheck(this, ReservationAndCancellationAPIContent);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ReservationAndCancellationAPIContent.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'page-header', id: 'guides-section-07' },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'blog-title' },
	                    '\uC608\uC57D/\uCDE8\uC18C API'
	                )
	            ),
	            this.props.newDiv
	        );
	    };
	
	    return ReservationAndCancellationAPIContent;
	}(_react2.default.Component);
	
	exports.default = ReservationAndCancellationAPIContent;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ReservationAndCancellationAPIContent.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 3027951262065701:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(7932631929871328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FAQsContent = function (_React$Component) {
	    _inherits(FAQsContent, _React$Component);
	
	    function FAQsContent(props) {
	        _classCallCheck(this, FAQsContent);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    FAQsContent.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'section-06 page-header', id: 'guides-section-06' },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'blog-title' },
	                    'FAQs'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://developers.coupang.com/hc/ko/sections/360004301613-API-%EC%9D%B8%EC%A6%9D-Key', className: 'mt40', target: '_blank' },
	                        'API \uC778\uC99D / Key'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://developers.coupang.com/hc/ko/sections/360004259994-%EA%B8%B0%ED%83%80%EB%AC%B8%EC%9D%98', className: 'mt40', target: '_blank' },
	                        '\uAE30\uD0C0\uBB38\uC758'
	                    )
	                )
	            )
	        );
	    };
	
	    return FAQsContent;
	}(_react2.default.Component);
	
	exports.default = FAQsContent;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "FAQsContent.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 3095992240514420:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewTourProductHistory = function (_React$Component) {
	    _inherits(ViewTourProductHistory, _React$Component);
	
	    function ViewTourProductHistory(props) {
	        _classCallCheck(this, ViewTourProductHistory);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewTourProductHistory.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { id: "view-tour-product-history" },
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC5EC\uD589\uC0C1\uD488\uC758 \uD788\uC2A4\uD1A0\uB9AC \uAC00\uC838\uC624\uAE30'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: 's-post' },
	                    '\uC5EC\uD589\uC0C1\uD488 id \uB85C \uD574\uB2F9 \uC0C1\uD488\uC758 \uC774\uB825\uC744 \uAC00\uC838\uC635\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/history/tours/',
	                                '{travelProductId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/history/tours/1234567890'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                ' Path Segment Parameters'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 ID'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'pageSize'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0 \uC0AC\uC774\uC988'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'nextPageToken'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB2E4\uC74C \uD398\uC774\uC9C0 \uD1A0\uD070, Default:50'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<ChangeHistoryDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'targetId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD504\uB85C\uB355\uD2B8 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uD615'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'operation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCC98\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'changedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC218\uC815 \uC77C\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'changedBy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC218\uC815\uC790'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#historyResponse' },
	                            'Response Body Sample'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'historyResponse', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n    "code": 200,\n    "message": "OK",\n    "nextPageToken": "1573553941810",\n    "size": 20,\n    "data": [\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:41:17",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:41:11",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:41:08",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:41:06",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:41:05",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:41:03",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:41:01",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:40:59",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:40:58",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:21:07",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:21:05",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:21:03",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:21:00",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:20:59",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:20:02",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:20:00",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:19:58",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:19:56",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "UPDATE",\n            "changedAt": "2019-11-12 19:19:55",\n            "changedBy": "SYSTEM"\n        },\n        {\n            "targetId": "511485064899461120",\n            "type": "PRODUCT",\n            "operation": "CREATE",\n            "changedAt": "2019-11-12 19:19:01",\n            "changedBy": "127.0.0.1"\n        }\n    ]\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewTourProductHistory;
	}(_react2.default.Component);
	
	exports.default = ViewTourProductHistory;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewTourProductHistory.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 3125539019903573:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StartToSellTicketProduct = function (_React$Component) {
	    _inherits(StartToSellTicketProduct, _React$Component);
	
	    function StartToSellTicketProduct(props) {
	        _classCallCheck(this, StartToSellTicketProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    StartToSellTicketProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC0C1\uD488 \uD310\uB9E4 \uC2DC\uC791'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC744 \uD310\uB9E4\uC911 \uC73C\uB85C \uBCC0\uACBD\uD569\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets/',
	                                '{travelProductId}',
	                                '/start'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890/start'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": 1234567890\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return StartToSellTicketProduct;
	}(_react2.default.Component);
	
	exports.default = StartToSellTicketProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "StartToSellTicketProduct.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 3161203245340427:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateLodgingProductRooms = function (_React$Component) {
	    _inherits(CreateLodgingProductRooms, _React$Component);
	
	    function CreateLodgingProductRooms(props) {
	        _classCallCheck(this, CreateLodgingProductRooms);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    CreateLodgingProductRooms.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uB8F8 API \uC0DD\uC131'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC219\uBC15 \uC0C1\uD488\uC5D0 \uB300\uD55C \uD558\uB098 \uC774\uC0C1\uC758 \uAC1D\uC2E4 \uC0DD\uC131'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/lodgings/',
	                                '{travelProductId',
	                                '}/rooms'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings/1234567890/rooms'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'rooms'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uC0DD\uC131'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRoomId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC790\uC0AC\uC0AC\uC774\uD2B8\uC758 \uAC1D\uC2E4ID.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'bedType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA0\uB4DC\uD0C0\uC785. \uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'viewType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4\uC804\uB9DD, \uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'additionalInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uCD94\uAC00 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'area'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uC5ED'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'components'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'componentType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'count'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'beds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'bedType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'count'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'images'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\uAC00 \uC0C1\uD488 \uB300\uD45C\uD568, \uC0C1\uD488\uB2F9 \uB2E8\uC77C \uB300\uD45C\uC774\uBBF8\uC9C0 \uBCF4\uC720. Default: FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'imageGroup'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85. Default Value:BASIC',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'VIEW'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FACILITY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD80\uB300\uC2DC\uC124'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESTAURANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DD\uB2F9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ROOM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'amenities'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uAD6C\uBE44 \uD488\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'occupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'standardOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE30\uC900\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'maximumOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD5C\uB300\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'maximumChildrenOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uBB34\uB8CC \uB3D9\uBC18 \uC785\uC2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'freeChildrenAllowed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uBB34\uB8CC \uB3D9\uBC18 \uC785\uC2E4 \uAC00\uB2A5 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'freeChildrenAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC785\uC2E4 \uAC00\uB2A5\uD55C \uC5B4\uB9B0\uC774 \uB098\uC774'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'freeChildrenOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC785\uC2E4 \uAC00\uB2A5\uD55C \uC5B4\uB9B0\uC774 \uC778\uC6D0'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#createTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'createTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n  {"lodgingRoomCreateDtos": [\n  \t {\n        \t"viewType":"ROOM_VIEW_110",\n        \t"bedType":"ROOM_BED_TYPE_95",\n        "sellerRoomId":"room_7",\n          "name": "\uD328\uBC00\uB9AC \uD0C0\uC6B4\uD648_room7",\n          "additionalInfo":"additionalInfo",\n          "area":20.01,\n           "beds": [\n            {\n              "count": 1,\n              "bedType": "BED_TYPE_89"\n            }\n            ],\n          "components": [\n          {\n             "count": 1,\n             "componentType": "ROOM_COMPONENT_COUNT_109"\n          }\n          ],\n          "occupancy": {\n            "freeChildrenAge": 9,\n            "freeChildrenAllowed": true,\n            "freeChildrenOccupancy": 1,\n            "maximumChildrenOccupancy": 1,\n            "maximumOccupancy": 4,\n            "standardOccupancy": 2\n          },\n           "images": [\n        {\n          "description": null,\n          "imageGroup": "ROOM",\n          "representative": true, \n          "sellerUrl": "https://i.travelapi.com/hotels/46000000/45590000/45583000/45582932/c86f2711_z.jpg",\n          "sellerUrlMethod": "GET"\n        }],\n        "amenities":["ROOM_AMENITY_GENERAL_12","ROOM_AMENITY_GENERAL_13","ROOM_AMENITY_GENERAL_5","ROOM_AMENITY_GENERAL_1","ROOM_AMENITY_GENERAL_2"] \n        },\n        {\n       "sellerRoomId":"room_8",\n       "viewType":"ROOM_VIEW_115",\n       "bedType":"ROOM_BED_TYPE_98",\n        "images": [\n        {\n          "description": null,\n          "imageGroup": "BASIC",\n          "representative": true,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 0\n        },\n        {\n          "description": null,\n          "imageGroup": "ROOM",\n          "representative": false,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/db272720_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 1\n        },\n        {\n          "description": null,\n          "imageGroup": "VIEW",\n          "representative": false,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 2\n        },\n        {\n          "description": null,\n          "imageGroup": "VIEW",\n          "representative": false,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 3\n        }\n      ],\n          "name": "\uD328\uBC00\uB9AC \uD0C0\uC6B4\uD648_room8",\n          "occupancy": {\n            "freeChildrenAge": 0,\n            "freeChildrenAllowed": false,\n            "freeChildrenOccupancy": 0,\n            "maximumChildrenOccupancy": 1,\n            "maximumOccupancy": 4,\n            "standardOccupancy": 2\n          }\n        }\n      ]\n  }\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<LodgingRoomResponseDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRoomId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uB8F8 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4\uBA85'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Room create request successfully received",\n    "data": [\n        {\n            "travelItemId": 577900056191959040,\n            "sellerRoomId": "room_7",\n            "name": "\uD328\uBC00\uB9AC \uD0C0\uC6B4\uD648_room7"\n        },\n        {\n            "travelItemId": 577900056204541952,\n            "sellerRoomId": "room_8",\n            "name": "\uD328\uBC00\uB9AC \uD0C0\uC6B4\uD648_room8"\n        }\n    ]\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforCreateProduct' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforCreateProduct', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement('div', { className: 'panel-body' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return CreateLodgingProductRooms;
	}(_react2.default.Component);
	
	exports.default = CreateLodgingProductRooms;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "CreateLodgingProductRooms.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 3209419146436878:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewTicketBuyerInfoByOrderV2 = function (_React$Component) {
	    _inherits(ViewTicketBuyerInfoByOrderV2, _React$Component);
	
	    function ViewTicketBuyerInfoByOrderV2(props) {
	        _classCallCheck(this, ViewTicketBuyerInfoByOrderV2);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewTicketBuyerInfoByOrderV2.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uD2F0\uCF13 \uAD6C\uB9E4\uC790 \uC815\uBCF4 \uC870\uD68C \uC8FC\uBB38\uBC88\uD638\uB85C \uADF8\uB8F9\uD551 V2 API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uD2F0\uCF13 \uAD6C\uB9E4\uC790\uC5D0 \uB300\uD55C \uC77C\uBC18\uC801\uC778 \uC815\uBCF4\uB97C \uC8FC\uBB38\uBC88\uD638\uB85C \uADF8\uB8F9\uD551\uD574 \uC870\uD68C\uD569\uB2C8\uB2E4. \uC774 API\uB97C \uC774\uC6A9\uD574 \uAC80\uC0C9\uC77C\uC758 \uAD6C\uB9E4\uC790 \uC815\uBCF4\uB97C \uAC00\uC838\uC62C \uC218 \uC788\uC2B5\uB2C8\uB2E4. '
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v2/purchasers/grouping-order-unit?dealId=',
	                                '{dealId}',
	                                '&targetDate=',
	                                '{targetDate}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v2/purchasers/grouping-order-unit?dealId=3000001&targetDate=2018-08-01'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'true'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'targetDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'true'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC77C\uC790'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'orderId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBB38\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'userName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 \uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'phoneNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uD654\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'email'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBA54\uC77C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC00\uACA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'status'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD0DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'purchaseDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC77C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'canceledDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC77C'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n    {\n        "100001":[\n            {\n                "ticketNumber": "9C320B-9000000000234",\n                "userName": "\uAE40\uCFE0\uD321",\n                "phoneNumber": null,\n                "email": "coupang@coupang.com",\n                "dealId": 6500124641,\n                "dealName": "\uCFE0\uD321\uACFC \uD568\uAED8 \uBC14\uB85C\uC140\uB85C\uB098",\n                "optionId": 53000424227,\n                "optionName": "\uC989\uC2DC \uAC00\uAE30  ",\n                "price": "1,000",\n                "purchaseDateTime": "2017-07-05 05:17:13",\n                "canceledDateTime":"",\n                "status": "PURCHASE_COMPLETE",\n                "orderId":"100001"\n            },\n            {\n                "ticketNumber": "DCAA6C-9000000000235",\n                "userName": "\uAE40\uCFE0\uD321",\n                "phoneNumber": null,\n                "email": "coupang@coupang.com",\n                "dealId": 6500124641,\n                "dealName": "\uCFE0\uD321\uACFC \uD568\uAED8 \uBC14\uB85C\uC140\uB85C\uB098",\n                "optionId": 53000424227,\n                "optionName": "\uC989\uC2DC \uAC00\uAE30  ",\n                "price": "1,000",\n                "purchaseDateTime": "2017-07-05 05:17:13",\n                "canceledDateTime":"",\n                "status": "PURCHASE_COMPLETE",\n                "orderId":"100001"\n            }\n        ],\n        "200001":[\n            {\n                "ticketNumber": "9C320B-9000000000234",\n                "userName": "\uAE40\uCFE0\uD321",\n                "phoneNumber": null,\n                "email": "coupang@coupang.com",\n                "dealId": 6500124641,\n                "dealName": "\uCFE0\uD321\uACFC \uD568\uAED8 \uBC14\uB85C\uC140\uB85C\uB098",\n                "optionId": 53000424227,\n                "optionName": "\uC989\uC2DC \uAC00\uAE30  ",\n                "price": "1,000",\n                "purchaseDateTime": "2017-07-05 05:17:13",\n                "canceledDateTime":"",\n                "status": "PURCHASE_COMPLETE",\n                "orderId":"200001"\n            }\n        ],\n    }\n                    '
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewTicketBuyerInfoByOrderV2;
	}(_react2.default.Component);
	
	exports.default = ViewTicketBuyerInfoByOrderV2;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewTicketBuyerInfoByOrderV2.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 3266623286041231:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(7932631929871328);
	
	var _GuideEntryContainer = __webpack_require__(1482121859620419);
	
	var _GuideEntryContainer2 = _interopRequireDefault(_GuideEntryContainer);
	
	__webpack_require__(5256309363921096);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HMacSignatureContent = function (_React$Component) {
	    _inherits(HMacSignatureContent, _React$Component);
	
	    function HMacSignatureContent(props) {
	        _classCallCheck(this, HMacSignatureContent);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    HMacSignatureContent.prototype.renderHTML = function renderHTML(fileName) {
	        return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _GuideEntryContainer2.default.pathToHTML(fileName, true) } });
	    };
	
	    HMacSignatureContent.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'section-02 page-header', id: 'guides-section-02' },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'blog-title' },
	                    'HMAC Signature \uC0DD\uC131'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'mt40' },
	                    'HMAC\uC774 \uBB34\uC5C7\uC774\uACE0 \uC65C \uD544\uC694\uD55C\uAC00\uC694?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'HMAC\uC740 \uD574\uC2DC \uBA54\uC2DC\uC9C0 \uC778\uC99D\uCF54\uB4DC(keyed-hash message authentication code)\uC758 \uC900\uB9D0\uB85C\uC368 RFC2014 \uD45C\uC900 \uC554\uD638\uD654 \uD504\uB85C\uD1A0\uCF5C\uC785\uB2C8\uB2E4. \uD604\uC7AC Coupang Open API\uB294 HMAC\uAE30\uBC18\uC73C\uB85C \uC81C\uC791\uB418\uC5C8\uC73C\uBA70 \uBAA8\uB4E0 request header \'Authorization\'\uC5D0 \uC0DD\uC131\uD55C HMAC signature\uB97C \uD568\uAED8 \uBCF4\uB0B4\uC8FC\uC154\uC57C \uD569\uB2C8\uB2E4.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'mt40' },
	                    'HMAC Signature \uC0DD\uC131+API \uC694\uCCAD \uC608\uC81C'
	                ),
	                _react2.default.createElement(
	                    _reactTabs.Tabs,
	                    null,
	                    _react2.default.createElement(
	                        _reactTabs.TabList,
	                        null,
	                        _react2.default.createElement(
	                            _reactTabs.Tab,
	                            null,
	                            'Java'
	                        ),
	                        _react2.default.createElement(
	                            _reactTabs.Tab,
	                            null,
	                            'PHP'
	                        ),
	                        _react2.default.createElement(
	                            _reactTabs.Tab,
	                            null,
	                            'Python'
	                        ),
	                        _react2.default.createElement(
	                            _reactTabs.Tab,
	                            null,
	                            'C#'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactTabs.TabPanel,
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            { className: 'mt40' },
	                            'Java HMAC Signature Generate Example'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { download: '', href: 'https://img2a.coupangcdn.com/files/hmac_sdk.zip?v=2' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { 'md-raised-button': '', className: 'mat-raised-button' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'mat-button-wrapper' },
	                                        'Java HMAC Generator Download'
	                                    ),
	                                    _react2.default.createElement('div', { className: 'mat-button-ripple mat-ripple', 'md-ripple': '' }),
	                                    _react2.default.createElement('div', { className: 'mat-button-focus-overlay' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'position-releative' },
	                            this.renderHTML('./guides/HMAC_Signature_java.html')
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactTabs.TabPanel,
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            { className: 'mt40' },
	                            'PHP HMAC Signature Generate Example'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'position-releative' },
	                            this.renderHTML('./guides/HMAC_Signature_PHP.html')
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactTabs.TabPanel,
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            { className: 'mt40' },
	                            'Python HMAC Signature Generate Example'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'position-releative' },
	                            this.renderHTML('./guides/HMAC_Signature_Python.html')
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactTabs.TabPanel,
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            { className: 'mt40' },
	                            'C# HMAC Signature Generate Example'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'position-releative' },
	                            this.renderHTML('./guides/HMAC_Signature_C.html')
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return HMacSignatureContent;
	}(_react2.default.Component);
	
	HMacSignatureContent.pathToHTML = __webpack_require__(3);
	HMacSignatureContent.HTML_PREFIX = "./";
	exports.default = HMacSignatureContent;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "HMacSignatureContent.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 3391341478554248:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GetLodgingProductInfo = function (_React$Component) {
	    _inherits(GetLodgingProductInfo, _React$Component);
	
	    function GetLodgingProductInfo(props) {
	        _classCallCheck(this, GetLodgingProductInfo);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    GetLodgingProductInfo.prototype.render = function render() {
	        var col_number_8 = 9;
	        var total_levels = 6;
	        var level1 = 6;
	        var level2 = 5;
	        var level2_prefix = level1 - level2;
	        var level3 = 4;
	        var level3_prefix = level1 - level3;
	        var level4 = 3;
	        var level4_prefix = level1 - level4;
	        var level5 = 2;
	        var level6 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC219\uBC15 \uC0C1\uD488 \uBCF4\uAE30'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC219\uBC15 \uC0C1\uD488 \uC815\uBCF4 \uBCF4\uAE30'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/lodgings/',
	                                '{travelProductId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings/1234567890'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'AccommodationDTO'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD504\uB85C\uB355\uD2B8 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productDetailType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC138\uBD80 \uBD84\uB958',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HOTEL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD638\uD154'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESORT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB9AC\uC870\uD2B8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PENSION'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD39C\uC158'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'GUEST_HOUSE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC8C\uC2A4\uD2B8\uD558\uC6B0\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CAMPING'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCEA0\uD551'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MOTEL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBAA8\uD154'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    '\uC5EC\uD589 \uBD84\uB958',
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAD6D\uB0B4\uC5EC\uD589'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OVERSEAS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uC678\uC5EC\uD589'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'qcStatus'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SAVED_TEMPORARY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC784\uC2DC \uC800\uC7A5'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WAITING_APPROVAL_MD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MD \uC2B9\uC778 \uB300\uAE30'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WAITING_APPROVAL_QC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'QC \uC2B9\uC778 \uB300\uAE30'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'COMPLETE_APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778 \uC644\uB8CC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'REJECTED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778 \uBC18\uB824'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BLOCKED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB9C9\uD78C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleStatus'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC0C1\uD0DC',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BEFORE_SALE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD310\uB9E4\uC804'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ON_SALE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD310\uB9E4\uC911'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SUSPENDED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC815\uC9C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ABORTED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uB2E8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CLOSED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB9C8\uAC10'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'introduction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uC18C\uAC1C '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uACF5\uC9C0\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'benefits'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uD2B9\uBCC4\uD61C\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'displayKeyword'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uC5D0 \uD45C\uC2DC\uD560 \uC9C0\uC5ED \uD0A4\uC6CC\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'searchTags'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC11C\uCE58\uD0DC\uADF8 \uB9AC\uC2A4\uD2B8'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'images'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\uAC00 \uC0C1\uD488 \uB300\uD45C\uD568, \uC0C1\uD488\uB2F9 \uB2E8\uC77C \uB300\uD45C\uC774\uBBF8\uC9C0 \uBCF4\uC720.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'imageGroup'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'VIEW'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FACILITY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD80\uB300\uC2DC\uC124'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESTAURANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DD\uB2F9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ROOM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundByBusinessDay'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uADFC\uBB34\uC77C\uC5D0 \uD658\uBD88'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uC815\uCC45',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AUTO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uB3D9\uCDE8\uC18C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778\uCDE8\uC18C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelPolicyNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'instantBooking'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2E4\uC2DC\uAC04 \uC608\uC57D \uAC00\uB2A5 \uC5EC\uBD80 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'additionalInfoPrompt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBB38 \uCD94\uAC00\uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'usageGuide'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uC6A9 \uC548\uB0B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'usageNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC758\uC0AC\uD56D \uAE30\uC7AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'locations'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uACBD\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'roadNameAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uB85C\uBA85 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'landNumberAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uBC88 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6D\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'province'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'city'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'district'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'town'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'zipCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B0\uD3B8\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'reservationNotifications'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D/\uCDE8\uC18C \uC54C\uB9BC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'contactInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'contactDescription'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contacts'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'contactType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98 \uC720\uD615',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WEBSITE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC6F9\uC0AC\uC774\uD2B8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'contactUseType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                ' ',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'REPRESENTATIVE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD45C\uC5F0\uB77D\uCC98'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BOOKING_INQUIRY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D\uBB38\uC758 \uC5F0\uB77D\uCC98'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CANCEL_INQUIRY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uBB38\uC758 \uC5F0\uB77D\uCC98'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMERGENCY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE34\uAE09\uC5F0\uB77D\uB9DD'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'contact'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'trafficInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCC3E\uC544\uAC00\uB294 \uAE38 \uC124\uBA85\uD558\uB294 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'publicTransportInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uB300\uC911\uAD50\uD1B5 \uC815\uBCF4 \uC124\uBA85\uD558\uB294 \uC790\uC720 \uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'nearbyLandmarks'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uAD00\uAD11\uC9C0 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'distanceUnit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'KILOMETER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD0AC\uB85C\uBBF8\uD130'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'METER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uD130'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'amenities'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uACF5\uD1B5 \uAD6C\uBE44 \uD488\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'amenity id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'themes'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD14C\uB9C8\uC815\uBCF4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'theme id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rooms'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'saleStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC2DC\uC791\uC77C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'saleEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC885\uB8CC\uC77C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'totalCount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD569\uACC4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'area'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uC5ED'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'floor'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE35'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'roomComponent'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'RoomComponent'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'images'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uACBD\uB85C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'UrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\uAC00 \uC0C1\uD488 \uB300\uD45C\uD568, \uC0C1\uD488\uB2F9 \uB2E8\uC77C \uB300\uD45C\uC774\uBBF8\uC9C0 \uBCF4\uC720'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'imageGroup'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'VIEW'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FACILITY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD80\uB300\uC2DC\uC124'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESTAURANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DD\uB2F9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ROOM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'descriptions'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD568\uC720\uB7C9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                ' ',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HTML'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HTML'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'JSON'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'JSON'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'URL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'URL'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'amenities'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                ' \uAC1D\uC2E4 \uACF5\uD1B5 \uAD6C\uBE44 \uD488\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'amentity id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'bedGroups'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'configurations'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'type'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'occupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'standardOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE30\uC900\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'totalMaxAllowed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD5C\uB300\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'childMaxAllowed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uBB34\uB8CC \uB3D9\uBC18 \uC785\uC2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'ageCategories'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB839 \uC720\uD615. ADULT or CHILD.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 12\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'views'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AD\uC81C\uB428'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'rates'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'rateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'rateId'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'travelItemIds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uC694\uAE08 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08\uCE74\uD14C\uACE0\uB9AC\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'saleStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219 \uAE30\uAC04 - \uC2DC\uC791'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'saleEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219 \uAE30\uAC04 - \uC885\uB8CC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'valid'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uD6A8'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'mealPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC815\uCC45'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'meals'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'mealType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                ' ',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BREAKFAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC870\uC2DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'LUNCH'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC810\uC2EC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DINNER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC800\uB141'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'included'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD3EC\uD568 \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'numberOfGuests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC720\uD615'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'surchargeAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uCD94\uAC00 \uC694\uAE08'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'mealStyle'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC720\uD615'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uCD94\uAC00 \uC694\uAE08 \uC124\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 12\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC694\uAE08 \uC785\uB825 (\'\uD604\uC7A5\uACB0\uC81C\' \uAE30\uC900\uC73C\uB85C \uC694\uAE08\uC744 \uC124\uC815\uD574\uC8FC\uC138\uC694.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE30\uC220'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'cancelPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uADDC\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'nonRefundable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88 \uBD88\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'refundRates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC790\uBCC4 \uCDE8\uC18C \uD658\uBD88 \uADDC\uC815 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'offset'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC624\uD504\uC14B'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'offsetTimeUnit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'TimeUnit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC624\uD504\uC14B \uC2DC\uAC04 \uC720\uB2DB'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'refundRate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC728 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE30\uC220'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraGuestPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uBE44\uC6A9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surchargeAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uC124\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 12\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC694\uAE08 \uC785\uB825 (\'\uD604\uC7A5\uACB0\uC81C\' \uAE30\uC900\uC73C\uB85C \uC694\uAE08\uC744 \uC124\uC815\uD574\uC8FC\uC138\uC694.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraBedPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uC124\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'extraBedAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uAC00\uB2A5 \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surchargeAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'extraBeds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uC885\uB958'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'extraBedType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'surcharges'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 12\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC694\uAE08 \uC785\uB825 (\'\uD604\uC7A5\uACB0\uC81C\' \uAE30\uC900\uC73C\uB85C \uC694\uAE08\uC744 \uC124\uC815\uD574\uC8FC\uC138\uC694.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'checkInOutPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778/\uCCB4\uD06C\uC544\uC6C3 \uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'checkInStartTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778 \uC2DC\uAC04 (HH:mm)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'checkOutEndTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC544\uC6C3 \uC2DC\uAC04 (HH:mm)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'instructions'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC548\uB0B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'freeServicePolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778/\uCCB4\uD06C\uC544\uC6C3 \uC548\uB0B4 \uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'freeServices'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                ' \uBB34\uB8CC \uC11C\uBE44\uC2A4 \uC81C\uACF5 \uC720\uD615'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'freeServiceType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_DRINK'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBB34\uB8CC \uC74C\uB8CC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_GIFT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBB34\uB8CC \uC120\uBB3C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_ROOM_UPGRADE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4 \uBB34\uB8CC \uC5C5\uADF8\uB808\uC774\uB4DC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_VIEW_UPGRADE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4 \uBDF0 \uBB34\uB8CC \uC5C5\uADF8\uB808\uC774\uB4DC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBB34\uB8CC \uC11C\uBE44\uC2A4\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE30\uC220'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraPackagePolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'extraPackages'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'extraPackages'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'name'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'extraPackageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ENTRANCE_TICKET'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC785\uC7A5\uAD8C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AD\uC81C\uB428'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'errors'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ArrayList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC624\uB958'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AD\uC81C\uB428'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6D\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'localName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB85C\uCEEC\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'localAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD604\uC9C0 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'createdAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0DD\uC131 \uC77C\uC790'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'modifiedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC218\uC815 \uC77C\uC790'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'createdBy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0DD\uC131\uC790'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'modifiedBy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC218\uC815\uC790'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": {\n        "createdAt": "2020-04-29T23:44:16.216",\n        "modifiedAt": "2020-04-30T00:29:54.704",\n        "createdBy": "SYSTEM",\n        "modifiedBy": "SYSTEM",\n        "travelProductId": 572809504203210754,\n        "sellerProductId": "seller product 1",\n        "vendorId": "A001000111",\n        "productId": 100000000051860,\n        "sellerCategoryId": null,\n        "sellerCategoryName": null,\n        "productDetailType": "HOTEL",\n        "vendorItemPackageId": 300000000051806,\n        "travelType": "OVERSEAS",\n        "qcStatus": "COMPLETE_APPROVAL",\n        "saleStatus": "ON_SALE",\n        "name": "\uD558\uC774 \uC778",\n        "introduction": "product introduction - 2",\n        "notice": "product notice - 2",\n        "benefits": [\n            "benefit 3",\n            "benefit 4"\n        ],\n        "displayCategoryCode": 105393,\n        "displayKeyword": "Shanghai",\n        "searchTags": [\n            "shanghai",\n            "disney"\n        ],\n        "images": [\n            {\n                "path": "travelConnect/hotel/A00100622/1b197184-e64e-416f-808d-470728087a98.jpg",\n                "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",\n                "sellerUrlMethod": "GET",\n                "representative": true,\n                "sellerImageCategory": null,\n                "imageGroup": "VIEW",\n                "resizedImages": [\n                    {\n                        "type": "RESIZE_1180_630_60",\n                        "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/1b197184-e64e-416f-808d-470728087a98.jpg"\n                    }\n                ],\n                "description": null,\n                "seq": 0\n            },\n            {\n                "path": "travelConnect/hotel/A00100622/1b955960-8ca3-498c-abde-40a2b03d2841.jpg",\n                "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/db272720_z.jpg",\n                "sellerUrlMethod": "GET",\n                "representative": false,\n                "sellerImageCategory": null,\n                "imageGroup": "ROOM",\n                "resizedImages": [\n                    {\n                        "type": "RESIZE_1180_630_60",\n                        "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/1b955960-8ca3-498c-abde-40a2b03d2841.jpg"\n                    }\n                ],\n                "description": null,\n                "seq": 0\n            },\n            {\n                "path": "travelConnect/hotel/A00100622/b239efbe-fdf0-4dd3-bbc4-e48413f4a36f.jpg",\n                "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",\n                "sellerUrlMethod": "GET",\n                "representative": false,\n                "sellerImageCategory": null,\n                "imageGroup": "VIEW",\n                "resizedImages": [\n                    {\n                        "type": "RESIZE_1180_630_60",\n                        "path": "resized_image/"\n                    }\n                ],\n                "description": null,\n                "seq": 0\n            },\n            {\n                "path": "travelConnect/hotel/A00100622/02e3c266-abb5-40bf-af5b-c4943d5b12a1.jpg",\n                "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",\n                "sellerUrlMethod": "GET",\n                "representative": false,\n                "sellerImageCategory": null,\n                "imageGroup": "VIEW",\n                "resizedImages": [\n                    {\n                        "type": "RESIZE_1180_630_60",\n                        "path": "resized_image/"\n                    }\n                ],\n                "description": null,\n                "seq": 0\n            },\n            {\n                "path": "travelConnect/hotel/A00100622/8a01c3ba-b054-4e19-8d5c-1e6756cb444e.jpg",\n                "sellerUrl": "https://i.travelapi.com/hotels/15000000/14740000/14736800/14736767/3394096f_z.jpg",\n                "sellerUrlMethod": "GET",\n                "representative": false,\n                "sellerImageCategory": null,\n                "imageGroup": "ROOM",\n                "resizedImages": [\n                    {\n                        "type": "RESIZE_1180_630_60",\n                        "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/8a01c3ba-b054-4e19-8d5c-1e6756cb444e.jpg"\n                    }\n                ],\n                "description": null,\n                "seq": 0\n            }\n        ],\n        "sellerPropertyCategory": null,\n        "areaId": null,\n        "sellerBrandId": null,\n        "brandCode": null,\n        "brandName": null,\n        "sellerChainId": null,\n        "chainCode": null,\n        "chainName": null,\n        "airportCode": null,\n        "cityCode": null,\n        "registryNumber": null,\n        "multiUnit": null,\n        "buildDate": null,\n        "renovationDate": null,\n        "propertyCode": null,\n        "ttiCode": null,\n        "childrenAllowed": null,\n        "petsAllowed": null,\n        "breakfastServed": null,\n        "sellerTaxId": null,\n        "allRatePlanInclusive": null,\n        "someRatePlanInclusive": null,\n        "allInclusiveDetail": null,\n        "minLOS": 0,\n        "maxLOS": 0,\n        "roomQuantity": 0,\n        "totalFloors": 0,\n        "rating": null,\n        "refundByBusinessDay": true,\n        "cancelType": "AUTO",\n        "cancelPeriodType": null,\n        "cancelPolicyNotice": "cancel policy notice-2",\n        "sellerInstanceBooking": null,\n        "instantBooking": true,\n        "additionalInfoPrompt": "changed: additional info prompt",\n        "usageGuide": "usage guide - 2",\n        "usageNotice": "usage notice - 2",\n        "legalTerms": null,\n        "descriptions": null,\n        "locations": [\n            {\n                "latitude": 32.260077,\n                "longitude": 122.448697,\n                "roadNameAddress": "Shanghai \uC0C1\uD558\uC774 shanghaihutail617-2",\n                "landNumberAddress": null,\n                "nation": "CN",\n                "province": "shanghai-2",\n                "city": "shanghai-2",\n                "district": null,\n                "town": null,\n                "zipCode": "200000-2"\n            }\n        ],\n        "reservationNotifications": [\n            {\n                "type": "PHONE",\n                "contactInfo": "010-2345-6789",\n                "contactDescription": "reservation notification 1 - 2"\n            }\n        ],\n        "contacts": [\n            {\n                "contactType": "WEBSITE",\n                "contactUseType": "REPRESENTATIVE",\n                "contact": "www.example.com"\n            },\n            {\n                "contactType": "PHONE",\n                "contactUseType": "REPRESENTATIVE",\n                "contact": "010-2345-6789"\n            },\n            {\n                "contactType": "PHONE",\n                "contactUseType": "BOOKING_INQUIRY",\n                "contact": "010-2345-6789"\n            },\n            {\n                "contactType": "PHONE",\n                "contactUseType": "CANCEL_INQUIRY",\n                "contact": "010-2345-6789"\n            },\n            {\n                "contactType": "PHONE",\n                "contactUseType": "EMERGENCY",\n                "contact": "010-2345-6789"\n            }\n        ],\n        "review": null,\n        "trafficInfo": "traffic info - 2",\n        "publicTransportInfo": "public transport infomation - 2",\n        "nearbyLandmarks": [\n            {\n                "name": "nearbyLandmark 1",\n                "latitude": 31,\n                "longitude": 121,\n                "distance": 1,\n                "distanceUnit": "KILOMETER",\n                "direction": null,\n                "transportations": null\n            },\n            {\n                "name": "nearbyLandmark 1",\n                "latitude": 31.1,\n                "longitude": 121.1,\n                "distance": 500,\n                "distanceUnit": "METER",\n                "direction": null,\n                "transportations": null\n            }\n        ],\n        "amenities": [\n            {\n                "sellerAmenityId": null,\n                "id": "ACCOMMODATION_LEISURE_43",\n                "name": null,\n                "value": null\n            },\n            {\n                "sellerAmenityId": null,\n                "id": "ACCOMMODATION_LEISURE_57",\n                "name": null,\n                "value": null\n            },\n            {\n                "sellerAmenityId": null,\n                "id": "ACCOMMODATION_COMFORT_37",\n                "name": null,\n                "value": null\n            }\n        ],\n        "attributes": null,\n        "themes": [\n            {\n                "sellerThemeId": null,\n                "id": "ACCOMMODATION_THEME_65",\n                "name": null\n            }\n        ],\n        "statistics": null,\n        "meetingRooms": null,\n        "restaurants": null,\n        "operationPeriods": null,\n        "rooms": [\n            {\n                "travelItemId": 572809504203210753,\n                "sellerItemId": "seller room 1",\n                "name": "\uD328\uBC00\uB9AC \uD0C0\uC6B4\uD648",\n                "roomType": null,\n                "roomCategory": null,\n                "saleStatus": null,\n                "saleStartedAt": "2020-01-01T00:00:01",\n                "saleEndedAt": "2099-12-31T23:59:59",\n                "taxType": null,\n                "totalCount": 30,\n                "area": 22,\n                "floor": null,\n                "roomComponent": {\n                    "componentsCount": {\n                        "ROOM_COMPONENT_COUNT_106": 1,\n                        "ROOM_COMPONENT_COUNT_105": 1\n                    },\n                    "bedsCount": {\n                        "BED_TYPE_89": 1\n                    }\n                },\n                "images": [\n                    {\n                        "path": "travelConnect/hotel/A00100622/d452ed5f-5766-4cdc-8794-584fded4f99e.jpg",\n                        "sellerUrl": "https://i.travelapi.com/hotels/43000000/42710000/42709900/42709843/01dc966d_z.jpg",\n                        "sellerUrlMethod": "GET",\n                        "representative": true,\n                        "sellerImageCategory": null,\n                        "imageGroup": "ROOM",\n                        "resizedImages": [\n                            {\n                                "type": "RESIZE_1180_630_60",\n                                "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/d452ed5f-5766-4cdc-8794-584fded4f99e.jpg"\n                            }\n                        ],\n                        "description": null,\n                        "seq": 0\n                    },\n                    {\n                        "path": "travelConnect/hotel/A00100622/1c3742cd-6a13-4a20-8d09-8d3ba4ca2fc3.jpg",\n                        "sellerUrl": "https://i.travelapi.com/hotels/43000000/42710000/42709900/42709843/15eb6d89_z.jpg",\n                        "sellerUrlMethod": "GET",\n                        "representative": true,\n                        "sellerImageCategory": null,\n                        "imageGroup": "ROOM",\n                        "resizedImages": [\n                            {\n                                "type": "RESIZE_1180_630_60",\n                                "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/1c3742cd-6a13-4a20-8d09-8d3ba4ca2fc3.jpg"\n                            }\n                        ],\n                        "description": null,\n                        "seq": 0\n                    },\n                    {\n                        "path": "travelConnect/hotel/A00100622/2e216e53-502e-4742-ac62-7be4b5d463c7.jpg",\n                        "sellerUrl": "https://i.travelapi.com/hotels/43000000/42710000/42709900/42709843/b16aa16a_z.jpg",\n                        "sellerUrlMethod": "GET",\n                        "representative": true,\n                        "sellerImageCategory": null,\n                        "imageGroup": "ROOM",\n                        "resizedImages": [\n                            {\n                                "type": "RESIZE_1180_630_60",\n                                "path": "resized_image/"\n                            }\n                        ],\n                        "description": null,\n                        "seq": 0\n                    }\n                ],\n                "descriptions": [\n                    {\n                        "title": null,\n                        "type": null,\n                        "content": "room additional information",\n                        "format": "TEXT",\n                        "path": null,\n                        "sellerUrl": null,\n                        "sellerUrlMethod": "GET",\n                        "seq": 0\n                    }\n                ],\n                "amenities": [\n                    {\n                        "sellerAmenityId": null,\n                        "id": "ROOM_AMENITY_GENERAL_6",\n                        "name": null,\n                        "value": null\n                    },\n                    {\n                        "sellerAmenityId": null,\n                        "id": "ROOM_AMENITY_BATH_78",\n                        "name": null,\n                        "value": null\n                    },\n                    {\n                        "sellerAmenityId": null,\n                        "id": "ROOM_AMENITY_SERVICE_22",\n                        "name": null,\n                        "value": null\n                    }\n                ],\n                "bedGroups": [\n                    {\n                        "sellerBedGroupId": null,\n                        "description": null,\n                        "configurations": [\n                            {\n                                "size": null,\n                                "type": "BED_TYPE_131",\n                                "quantity": null\n                            }\n                        ],\n                        "priceCheck": null\n                    }\n                ],\n                "occupancy": {\n                    "standardOccupancy": 2,\n                    "totalMaxAllowed": 4,\n                    "adultMaxAllowed": null,\n                    "childMaxAllowed": 1,\n                    "ageCategories": []\n                },\n                "views": [\n                    {\n                        "sellerViewId": null,\n                        "id": "ROOM_VIEW_115",\n                        "name": null\n                    }\n                ],\n                "extension": {},\n                "deleted": false\n            },\n            {\n                "travelItemId": 572811199108874240,\n                "sellerItemId": "seller room 2 - update room",\n                "name": "\uD328\uBC00\uB9AC \uD0C0\uC6B4\uD648",\n                "roomType": null,\n                "roomCategory": null,\n                "saleStatus": null,\n                "saleStartedAt": "2020-02-01T00:00:01",\n                "saleEndedAt": "2098-12-31T23:59:59",\n                "taxType": null,\n                "totalCount": 10,\n                "area": 30,\n                "floor": null,\n                "roomComponent": {\n                    "componentsCount": {\n                        "ROOM_COMPONENT_COUNT_109": 1\n                    },\n                    "bedsCount": {\n                        "ROOM_COMPONENT_COUNT_108": 1\n                    }\n                },\n                "images": [\n                    {\n                        "path": "travelConnect/hotel/A00100622/02e3c266-abb5-40bf-af5b-c4943d5b12a1.jpg",\n                        "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",\n                        "sellerUrlMethod": "GET",\n                        "representative": true,\n                        "sellerImageCategory": null,\n                        "imageGroup": "ROOM",\n                        "resizedImages": [\n                            {\n                                "type": "RESIZE_1180_630_60",\n                                "path": "resized_image/"\n                            }\n                        ],\n                        "description": null,\n                        "seq": 0\n                    },\n                    {\n                        "path": "travelConnect/hotel/A00100622/b239efbe-fdf0-4dd3-bbc4-e48413f4a36f.jpg",\n                        "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",\n                        "sellerUrlMethod": "GET",\n                        "representative": true,\n                        "sellerImageCategory": null,\n                        "imageGroup": "ROOM",\n                        "resizedImages": [\n                            {\n                                "type": "RESIZE_1180_630_60",\n                                "path": "resized_image/"\n                            }\n                        ],\n                        "description": null,\n                        "seq": 0\n                    },\n                    {\n                        "path": "travelConnect/hotel/A00100622/1b197184-e64e-416f-808d-470728087a98.jpg",\n                        "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",\n                        "sellerUrlMethod": "GET",\n                        "representative": true,\n                        "sellerImageCategory": null,\n                        "imageGroup": "VIEW",\n                        "resizedImages": [\n                            {\n                                "type": "RESIZE_1180_630_60",\n                                "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/1b197184-e64e-416f-808d-470728087a98.jpg"\n                            }\n                        ],\n                        "description": null,\n                        "seq": 0\n                    }\n                ],\n                "descriptions": [\n                    {\n                        "title": null,\n                        "type": null,\n                        "content": "add room - room additional information",\n                        "format": "TEXT",\n                        "path": null,\n                        "sellerUrl": null,\n                        "sellerUrlMethod": "GET",\n                        "seq": 0\n                    }\n                ],\n                "amenities": [\n                    {\n                        "sellerAmenityId": null,\n                        "id": "ROOM_AMENITY_GENERAL_14",\n                        "name": null,\n                        "value": null\n                    },\n                    {\n                        "sellerAmenityId": null,\n                        "id": "ROOM_AMENITY_BATH_85",\n                        "name": null,\n                        "value": null\n                    },\n                    {\n                        "sellerAmenityId": null,\n                        "id": "ROOM_AMENITY_SERVICE_24",\n                        "name": null,\n                        "value": null\n                    }\n                ],\n                "bedGroups": [\n                    {\n                        "sellerBedGroupId": null,\n                        "description": null,\n                        "configurations": [\n                            {\n                                "size": null,\n                                "type": "BED_TYPE_131",\n                                "quantity": null\n                            }\n                        ],\n                        "priceCheck": null\n                    }\n                ],\n                "occupancy": {\n                    "standardOccupancy": 2,\n                    "totalMaxAllowed": 4,\n                    "adultMaxAllowed": null,\n                    "childMaxAllowed": 2,\n                    "ageCategories": null\n                },\n                "views": [\n                    {\n                        "sellerViewId": null,\n                        "id": "string",\n                        "name": null\n                    }\n                ],\n                "extension": null,\n                "deleted": false\n            }\n        ],\n        "rates": [\n            {\n                "rateId": 572809504203210752,\n                "travelItemIds": [\n                    572809504203210753\n                ],\n                "sellerRateId": "seller rate 1",\n                "name": "With Breakfast",\n                "saleStartedAt": "2020-01-01T00:00:01",\n                "saleEndedAt": "2099-12-31T23:59:59",\n                "useSellerProvidedPrice": false,\n                "useSellerProvidedFee": false,\n                "valid": false,\n                "rateType": null,\n                "amenities": [],\n                "bedGroups": [],\n                "mealPolicy": {\n                    "meals": [\n                        {\n                            "mealType": "BREAKFAST",\n                            "included": true,\n                            "numberOfGuests": 2,\n                            "surchargeAvailable": true,\n                            "sameRoomStandardOccupancy": false,\n                            "mealStyle": "Chinese",\n                            "surcharges": [\n                                {\n                                    "name": null,\n                                    "ageType": "CHILD",\n                                    "minAge": 9,\n                                    "surcharge": 10000\n                                }\n                            ]\n                        }\n                    ],\n                    "description": "meal policy notice"\n                },\n                "cancelPolicy": {\n                    "code": null,\n                    "nonRefundable": false,\n                    "refundRates": [\n                        {\n                            "offset": 5,\n                            "offsetTimeUnit": "DAYS",\n                            "refundRate": 90\n                        },\n                        {\n                            "offset": 4,\n                            "offsetTimeUnit": "DAYS",\n                            "refundRate": 80\n                        },\n                        {\n                            "offset": 3,\n                            "offsetTimeUnit": "DAYS",\n                            "refundRate": 50\n                        }\n                    ],\n                    "description": "cancel policy notice"\n                },\n                "extraGuestPolicy": {\n                    "surchargeAvailable": true,\n                    "surcharges": [\n                        {\n                            "name": null,\n                            "ageType": "ADULT",\n                            "minAge": 18,\n                            "surcharge": 50000\n                        }\n                    ],\n                    "description": null\n                },\n                "extraBedPolicy": {\n                    "extraBedAvailable": true,\n                    "surchargeAvailable": true,\n                    "extraBeds": [\n                        {\n                            "name": "extra bed 1",\n                            "extraBedType": "ADULT",\n                            "surcharges": [\n                                {\n                                    "name": null,\n                                    "ageType": "ADULT",\n                                    "minAge": 18,\n                                    "surcharge": 80000\n                                }\n                            ],\n                            "description": null\n                        }\n                    ]\n                },\n                "checkInOutPolicy": {\n                    "wholeDay": false,\n                    "checkInStartTime": "15:00",\n                    "checkInEndTime": null,\n                    "checkOutEndTime": "11:00",\n                    "minAge": null,\n                    "instructions": [\n                        {\n                            "title": null,\n                            "type": "instructions",\n                            "content": "check in/out instruction",\n                            "format": "TEXT",\n                            "path": null,\n                            "sellerUrl": null,\n                            "sellerUrlMethod": "GET",\n                            "seq": 0\n                        }\n                    ]\n                },\n                "freeServicePolicy": {\n                    "freeServices": [\n                        {\n                            "freeServiceType": "FREE_DRINK",\n                            "name": "Welcome drink",\n                            "description": null\n                        }\n                    ],\n                    "description": "free service policy notice"\n                },\n                "extraPackagePolicy": {\n                    "extraPackages": [\n                        {\n                            "name": "Disney land",\n                            "extraPackageType": "ENTRANCE_TICKET"\n                        }\n                    ],\n                    "description": "extra package notice"\n                },\n                "dayUsePolicy": null,\n                "extraPricePolicy": null,\n                "description": [],\n                "extension": {},\n                "deleted": false\n            },\n            {\n                "rateId": 572816506971226112,\n                "travelItemIds": [\n                    572811199108874240\n                ],\n                "sellerRateId": "seller rate 2",\n                "name": "With Breakfast - Korean",\n                "saleStartedAt": "2020-01-01T00:00:01",\n                "saleEndedAt": "2099-12-31T23:59:59",\n                "useSellerProvidedPrice": false,\n                "useSellerProvidedFee": false,\n                "valid": false,\n                "rateType": null,\n                "amenities": null,\n                "bedGroups": null,\n                "mealPolicy": {\n                    "meals": [\n                        {\n                            "mealType": "BREAKFAST",\n                            "included": true,\n                            "numberOfGuests": 1,\n                            "surchargeAvailable": true,\n                            "sameRoomStandardOccupancy": false,\n                            "mealStyle": "Korean",\n                            "surcharges": [\n                                {\n                                    "name": null,\n                                    "ageType": "CHILD",\n                                    "minAge": 9,\n                                    "surcharge": 12000\n                                }\n                            ]\n                        }\n                    ],\n                    "description": "meal policy notice - 3"\n                },\n                "cancelPolicy": {\n                    "code": null,\n                    "nonRefundable": false,\n                    "refundRates": [\n                        {\n                            "offset": 6,\n                            "offsetTimeUnit": "DAYS",\n                            "refundRate": 80\n                        },\n                        {\n                            "offset": 5,\n                            "offsetTimeUnit": "DAYS",\n                            "refundRate": 60\n                        },\n                        {\n                            "offset": 3,\n                            "offsetTimeUnit": "DAYS",\n                            "refundRate": 40\n                        }\n                    ],\n                    "description": "cancel policy notice - 3"\n                },\n                "extraGuestPolicy": {\n                    "surchargeAvailable": false,\n                    "surcharges": [],\n                    "description": null\n                },\n                "extraBedPolicy": {\n                    "extraBedAvailable": false,\n                    "surchargeAvailable": false,\n                    "extraBeds": []\n                },\n                "checkInOutPolicy": {\n                    "wholeDay": false,\n                    "checkInStartTime": "15:00",\n                    "checkInEndTime": null,\n                    "checkOutEndTime": "11:00",\n                    "minAge": null,\n                    "instructions": [\n                        {\n                            "title": null,\n                            "type": "instructions",\n                            "content": "check in/out instruction - 3",\n                            "format": "TEXT",\n                            "path": null,\n                            "sellerUrl": null,\n                            "sellerUrlMethod": "GET",\n                            "seq": 0\n                        }\n                    ]\n                },\n                "freeServicePolicy": {\n                    "freeServices": [\n                        {\n                            "freeServiceType": "FREE_DRINK",\n                            "name": "Welcome drink",\n                            "description": null\n                        }\n                    ],\n                    "description": "free service policy notice"\n                },\n                "extraPackagePolicy": {\n                    "extraPackages": [\n                        {\n                            "name": "Disney land",\n                            "extraPackageType": "ENTRANCE_TICKET"\n                        }\n                    ],\n                    "description": "extra package notice"\n                },\n                "dayUsePolicy": null,\n                "extraPricePolicy": null,\n                "description": null,\n                "extension": null,\n                "deleted": true\n            }\n        ],\n        "checkInOutPolicy": null,\n        "spokenLanguages": null,\n        "extension": null,\n        "errors": null,\n        "deleted": false,\n        "nation": "CN",\n        "localName": "\u5047\u65E5\u9152\u5E97",\n        "localAddress": null\n    }\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return GetLodgingProductInfo;
	}(_react2.default.Component);
	
	exports.default = GetLodgingProductInfo;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "GetLodgingProductInfo.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 3555176258568410:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateLodgingProductRoom = function (_React$Component) {
	    _inherits(UpdateLodgingProductRoom, _React$Component);
	
	    function UpdateLodgingProductRoom(props) {
	        _classCallCheck(this, UpdateLodgingProductRoom);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateLodgingProductRoom.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uB8F8 \uC5C5\uB370\uC774\uD2B8'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC219\uBC15 \uC0C1\uD488\uC758 \uB8F8 \uC5C5\uB370\uC774\uD2B8.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'PUT'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/lodgings/',
	                                '{travelProductId}',
	                                '/rooms/',
	                                '{travelItemId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings/1234567890/rooms/11111111'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'rooms'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<LodgingRoomCreateDto>'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uC0DD\uC131'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRoomId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC790\uC0AC\uC0AC\uC774\uD2B8\uC758 \uAC1D\uC2E4ID'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'bedType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA0\uB4DC\uD0C0\uC785,\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'viewType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4\uC804\uB9DD,\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'additionalInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uCD94\uAC00 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'area'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uC5ED'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'components'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'componentType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'count'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'beds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'bedType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'count'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'images'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\uAC00 \uC0C1\uD488 \uB300\uD45C\uD568, \uC0C1\uD488\uB2F9 \uB2E8\uC77C \uB300\uD45C\uC774\uBBF8\uC9C0 \uBCF4\uC720. Default: FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'imageGroup'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85. Default Value:BASIC',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'VIEW'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FACILITY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD80\uB300\uC2DC\uC124'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESTAURANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DD\uB2F9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ROOM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'amenities'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uAD6C\uBE44 \uD488\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'occupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'standardOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE30\uC900\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'maximumOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD5C\uB300\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'maximumChildrenOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uBB34\uB8CC \uB3D9\uBC18 \uC785\uC2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'freeChildrenAllowed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uBB34\uB8CC \uB3D9\uBC18 \uC785\uC2E4 \uAC00\uB2A5 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'freeChildrenAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC785\uC2E4 \uAC00\uB2A5\uD55C \uC5B4\uB9B0\uC774 \uB098\uC774'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'freeChildrenOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC785\uC2E4 \uAC00\uB2A5\uD55C \uC5B4\uB9B0\uC774 \uC778\uC6D0'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#createTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'createTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n  "additionalInfo": "add room - room additional information",\n  "amenities": [\n    "ROOM_AMENITY_GENERAL_14",\n    "ROOM_AMENITY_BATH_85",\n    "ROOM_AMENITY_SERVICE_24"\n  ],\n  "area": 30,\n  "bedType": "ROOM_BED_TYPE_101",\n  "beds": [\n    {\n      "count": 1,\n      "bedType": "BED_TYPE_89"\n    }\n  ],\n  "components": [\n    {\n      "count": 1,\n      "componentType": "ROOM_COMPONENT_COUNT_109"\n    }\n  ],\n  "images": [\n    {\n      "description": null,\n      "imageGroup": "ROOM",\n      "representative": true,\n      "sellerImageCategory": null,\n      "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",\n      "sellerUrlMethod": "GET",\n      "seq": 0\n    },\n    {\n      "description": null,\n      "imageGroup": "ROOM",\n      "representative": false,\n      "sellerImageCategory": null,\n      "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",\n      "sellerUrlMethod": "GET",\n      "seq": 0\n    },\n    {\n      "description": null,\n      "imageGroup": "VIEW",\n      \n      "sellerImageCategory": null,\n      "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",\n      "sellerUrlMethod": "GET",\n      "seq": 0\n    }\n  ],\n  "name": "\uD328\uBC00\uB9AC \uD0C0\uC6B4\uD648_update",\n  "occupancy": {\n    "freeChildrenAge": 9,\n    "freeChildrenAllowed": false,\n    "freeChildrenOccupancy": 0,\n    "maximumChildrenOccupancy": 2,\n    "maximumOccupancy": 4,\n    "standardOccupancy": 2\n  },\n  "saleEndedAt": "2098-12-31 23:59:59",\n  "saleStartedAt": "2020-02-01 00:00:01",\n  "sellerRoomId": "seller room 2 - update room",\n  "totalCount": 10,\n  "viewType": "ROOM_VIEW_113"\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travel Item Id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Room update request successfully received",\n    "data": 576983927370022915\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforCreateProduct' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforCreateProduct', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement('div', { className: 'panel-body' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateLodgingProductRoom;
	}(_react2.default.Component);
	
	exports.default = UpdateLodgingProductRoom;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateLodingProductRoom.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 3703933408804179:
2692642590089237,

/***/ 3706460768780088:
/***/ (function(module, exports) {

	module.exports = "<div class=container> <div class=\"jumbotron mt100\"> <h1 class=text-center>500 Internal server error<p> </p></h1> <p class=text-center>There is a problem with the resource you are looking for and it cannot be displayed.</p> <p class=text-center><a class=\"btn btn-primary\" href=#><i class=\"fa fa-home\"></i> Take Me Home</a></p> </div> </div>";

/***/ }),

/***/ 3744858885512850:
/***/ (function(module, exports) {

	module.exports = {
		"apiData": {
			"title": "XYZ API title 입니다.",
			"content": "XYZ API content 입니다.",
			"apiTestCode": ""
		}
	};

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

	module.exports = React;

/***/ }),

/***/ 3971358181474996:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateTourProductV2 = function (_React$Component) {
	    _inherits(UpdateTourProductV2, _React$Component);
	
	    function UpdateTourProductV2(props) {
	        _classCallCheck(this, UpdateTourProductV2);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateTourProductV2.prototype.render = function render() {
	        var col_number_8 = 8;
	        var level1 = 5;
	        var level2 = 4;
	        var level3 = 3;
	        var level4 = 2;
	        var level5 = 1;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'mb0 mt40', id: 'create-tour-product' },
	            _react2.default.createElement(
	                'h3',
	                null,
	                '\uC0C1\uD488 \uC218\uC815'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uCFE0\uD321\uC5D0\uC11C \uD310\uB9E4\uD560 \uD574\uC678 \uD328\uD0A4\uC9C0/\uD56D\uACF5 \uC0C1\uD488\uC744 \uC218\uC815\uD558\uB294 API \uC785\uB2C8\uB2E4. ',
	                    _react2.default.createElement('br', null),
	                    '\uC218\uC815 \uC694\uCCAD \uD6C4 \uBC18\uB4DC\uC2DC \uC870\uD68C API\uB85C \uC218\uC815 \uC5EC\uBD80\uB97C \uD655\uC778 \uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'PUT'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: 3 },
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/marketplace/update/',
	                                '{type}',
	                                '/tour/product'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: 3 },
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v2/marketplace/update/overseas/tour/product'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD84\uB958 \uCE74\uD14C\uACE0\uB9AC'
	                                            ),
	                                            _react2.default.createElement('td', null),
	                                            _react2.default.createElement('td', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Type'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'overseas'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'String'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uC678'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'domestic'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'String'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAD6D\uB0B4'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCFE0\uD321 \uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'propertyId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488\uBA85 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 50\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'introduction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488\uC18C\uAC1C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'searchTags'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC11C\uCE58\uD0DC\uADF8 \uB9AC\uC2A4\uD2B8 (\uAC01 \uC11C\uCE58\uD0DC\uADF8 \uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 10\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'destination'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uC5D0 \uD45C\uC2DC\uD560 \uB3C4\uCC29 \uC9C0\uC5ED \uD0A4\uC6CC\uB4DC (\uAC01 \uD0A4\uC6CC\uB4DC \uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 10\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'displayCategoryCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uC758 \uB178\uCD9C \uCE74\uD14C\uACE0\uB9AC. Example: 106774 (\uC0DD\uC131 \uD6C4 \uBCC0\uACBD\uBD88\uAC00 \uD56D\uBAA9 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'airportCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'IATA \uACF5\uD56D \uCF54\uB4DC. Example: SHA'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'representativeImages'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCF5\uC218 \uB300\uD45C \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'composition'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC0C1\uD488 \uAD6C\uC131 \uC694\uC18C'
	                                            ),
	                                            _react2.default.createElement('td', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FUEL_SURCHARGE_INCLUDED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uB958\uD560\uC99D\uB8CC \uD3EC\uD568'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FUEL_SURCHARGE_TAX_EXCLUDED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uB958\uD560\uC99D\uB8CC+\uC138\uAE08\uBD88\uD3EC\uD568'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FUEL_SURCHARGE_NOT_APPLICABLE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uB2F9\uC5C6\uC74C(\uC720\uB958\uD560\uC99D\uB8CC)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SHOPPING_INCLUDE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC1FC\uD551 \uD3EC\uD568'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SHOPPING_EXCLUDE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC1FC\uD551 \uBD88\uD3EC\uD568'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADDITIONAL_EXPENSE_INCLUDE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD94\uAC00\uACBD\uBE44 \uD3EC\uD568'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADDITIONAL_EXPENSE_EXCLUDE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD94\uAC00\uACBD\uBE44 \uBD88\uD3EC\uD568'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_SCHEDULE_INCLUDE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC720\uC77C\uC815 \uD3EC\uD568'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_SCHEDULE_EXCLUDE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC720\uC77C\uC815 \uBD88\uD3EC\uD568'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'saleStatus'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC0C1\uD488 \uD310\uB9E4 \uC0C1\uD0DC. \uAE30\uBCF8\uAC12: ON_SALE'
	                                            ),
	                                            _react2.default.createElement('td', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ON_SALE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD310\uB9E4\uC911'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SUSPENDED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD310\uB9E4\uC77C\uC2DC\uC911\uC9C0'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'items'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCFE0\uD321 \uC0C1\uD488 \uC544\uC774\uD15C \uC544\uC774\uB514. (travelItemId\uAC00 travelProduct \uD558\uC704\uC5D0 \uC874\uC7AC\uD558\uC9C0 \uC54A\uB294 \uACBD\uC6B0\uB294 Item \uCD94\uAC00, \uC874\uC7AC\uD558\uB294 \uACBD\uC6B0\uB294 Item \uC815\uBCF4 \uC218\uC815\uC73C\uB85C \uC9C4\uD589\uB429\uB2C8\uB2E4.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'propertyItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC544\uC774\uD15C \uB2E8\uC704 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC544\uC774\uD15C\uBA85 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 50\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'departure'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD9C\uBC1C \uD56D\uACF5\uD3B8 \uC815\uBCF4'
	                                            ),
	                                            _react2.default.createElement('td', null),
	                                            _react2.default.createElement('td', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Name'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Type'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'takeOffDate'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'String (format : yyyy-MM-dd HH:mm:ss)'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uB959\uC2DC\uAC04'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'landingDate'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'String (format : yyyy-MM-dd HH:mm:ss)'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCC29\uB959\uC2DC\uAC04'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'flight'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'String'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD56D\uACF5\uD3B8 (\uC608 : OZ757)'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'arrival'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB3C4\uCC29 \uD56D\uACF5\uD3B8 \uC815\uBCF4'
	                                            ),
	                                            _react2.default.createElement('td', null),
	                                            _react2.default.createElement('td', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Name'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Type'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'takeOffDate'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'String (format : yyyy-MM-dd HH:mm:ss)'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uB959\uC2DC\uAC04'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'landingDate'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'String (format : yyyy-MM-dd HH:mm:ss)'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCC29\uB959\uC2DC\uAC04'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'flight'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'String'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD56D\uACF5\uD3B8 (\uC608 : OZ757)'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'hasChildRate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC0C1\uD0DC \uC124\uC815 / \uD310\uB9E4\uC911 : TRUE, \uD310\uB9E4\uC911\uC9C0 : FALSE (Default: TRUE)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notices'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'usage'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'inclusion'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD3EC\uD568\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'exclusion'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBD88\uD3EC\uD568\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'reservation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D\uC548\uB0B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'customerCenter'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uACE0\uAC1D\uC13C\uD130 \uC6B4\uC601\uC2DC\uAC04. Example: \uACE0\uAC1D\uC13C\uD130 \uBB38\uC758\uC2DC\uAC04: 1644-2888, \uD3C9\uC77C 09:30~17:30 (\uB2E8, \uD1A0/\uC77C, \uACF5\uD734\uC77C\uC740 \uD734\uBB34)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'duration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'days'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uC815 \uC77C \uC218 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'nights'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uC815 \uC219\uBC15 \uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'itinerary'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'days'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815 \uCC28\uC218. Exmaple: 1, 2'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'order'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC815\uB82C \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'courseName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815 \uC81C\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'location'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uCE58\uC548\uB0B4\uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'mealName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2DD\uC0AC\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'hotelName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uC18C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'representativeImage'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815 \uC774\uBBF8\uC9C0 URL'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#createTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'createTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n  "tourProductDtoList": [\n    {\n      "displayCategoryCode": 108804,\n      "propertyId": "seller-product-id",\n      "title": "[\uC778\uCC9C/\uAE40\uD3EC\uCD9C\uBC1C] \uC0C1\uD574+\uD56D\uC8FC+\uC218\uD5A5\uB9C8\uC744 \uD328\uD0A4\uC9C0",\n      "items": [\n        {\n          "propertyItemId": "seller-item-id-1",\n          "title": "\uC0C1\uD574/\uD56D\uC8FC/\uC8FC\uAC00\uAC01 1\uC77C",\n          "departure":{\n              "takeOffDate":"2020-03-16 09:30:00",\n              "landingDate":"2020-03-16 13:30:00",\n              "flight":"KE982"\n           },\n           "arrival":{\n              "takeOffDate":"2020-03-25 18:30:00",\n              "landingDate":"2020-03-25 22:30:00",\n              "flight":"KE982"\n           },\n          "duration": {\n            "days": 3,\n            "nights": 4\n          },\n          "itinerary": [\n            {\n              "courseName": "\uD56D\uACF5\uC2A4\uCF00\uC974",\n              "days": 1,\n              "order": 1,\n              "descriptions": "[KE893] 08:35 \uC778\uCC9C \uC0C1\uD574 \uD5A5\uBC1C (\uC57D 02\uC2DC\uAC04 10\uBD84 \uC18C\uC694) 09:45 \uC0C1\uD574 \uB3C4\uCC29",\n              "location": ""\n            },\n            {\n              "courseName": "[\uAD00\uAD11] \uC0C1\uD574",\n              "days": 1,\n              "order": 2,\n              "descriptions": "\uB3C4\uC2DC\uAC1C\uC694 - \uC18C\uAC1C : \uC0C1\uD558\uC774\uB294 \uC911\uAD6D \uC591\uCBD4\uAC15 \uC5B4\uADC0\uC5D0 \uC788\uB294 \uC0C1\uACF5\uC5C5 \uB3C4\uC2DC\uB85C \uC815\uBD80 \uC9C1\uD560\uC2DC\uC774\uB2E4",\n              "location": "",\n              "representativeImage": "http://img.test-tour.com/test.jpg"\n            },\n            {\n              "courseName": "\uC0C1\uD574-\uD56D\uC8FC \uC774\uB3D9 (\uC57D3\uC2DC\uAC04 \uC18C\uC694)",\n              "days": 1,\n              "order": 3,\n              "descriptions": "",\n              "location": "",\n              "representativeImage": "http://img.test-tour.com/test.jpg"\n            },\n            {\n              "courseName": "[\uAD00\uAD11] \uD56D\uC8FC",\n              "days": 1,\n              "order": 4,\n              "descriptions": "\uC624\uB798\uB41C \uC61B \uCC3B\uC9D1\uB4E4\uB85C \uC720\uBA85\uD55C \uACF3"\n            }\n          ],\n          "notices": {\n            "usage": "\uBCF8 \uC0C1\uD488\uC740 \uB2E8\uCCB4\uAD00\uAD11\uC744 \uBAA9\uC801\uC73C\uB85C \uD558\uB294 \uD328\uD0A4\uC9C0\uC5EC\uD589\uC73C\uB85C, \uAD00\uAD11\uC5D0 \uCC38\uC5EC\uD558\uC9C0 \uC54A\uACE0 \uAC1C\uBCC4\uC801\uC778 \uD65C\uB3D9\uC744 \uC6D0\uD558\uC2DC\uB294 \uBD84\uB4E4\uC740 \uC790\uC720\uC5EC\uD589 \uC0C1\uD488\uC73C\uB85C \uC608\uC57D\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.",\n            "inclusion": "\uC655\uBCF5 \uD56D\uACF5\uAD8C \uD3EC\uD568",\n            "exclusion": "1\uC778\uB2F9 \uC804\uC77C\uC815 \uAC00\uC774\uB4DC",\n            "reservation": "\uB2F4\uB2F9\uC790\uAC00 \uC608\uC57D\uD655\uC815\uC5EC\uBD80\uB97C \uBB38\uC790\uB85C \uC54C\uB824\uB4DC\uB9BD\uB2C8\uB2E4.",\n            "customerCenter": "\uACE0\uAC1D\uC13C\uD130 \uBB38\uC758\uC2DC\uAC04: 1644-2888, \uD3C9\uC77C 09:30~17:30 (\uB2E8, \uD1A0/\uC77C, \uACF5\uD734\uC77C\uC740 \uD734\uBB34)"\n          }\n        },\n        {\n          "propertyItemId": "seller-item-id-2",\n          "title": "\uC0C1\uD574/\uD56D\uC8FC/\uC8FC\uAC00\uAC01 2\uC77C",\n          "departure":{\n              "takeOffDate":"2020-03-16 09:30:00",\n              "landingDate":"2020-03-16 13:30:00",\n              "flight":"KE982"\n           },\n           "arrival":{\n              "takeOffDate":"2020-03-25 18:30:00",\n              "landingDate":"2020-03-25 22:30:00",\n              "flight":"KE982"\n           },\n          "duration": {\n            "days": 3,\n            "nights": 4\n          },\n          "itinerary": [\n            {\n              "courseName": "\uD56D\uACF5\uC2A4\uCF00\uC974",\n              "days": 1,\n              "order": 1,\n              "descriptions": "[KE893] 08:35 \uC778\uCC9C \uC0C1\uD574 \uD5A5\uBC1C (\uC57D 02\uC2DC\uAC04 10\uBD84 \uC18C\uC694) 09:45 \uC0C1\uD574 \uB3C4\uCC29",\n              "location": ""\n            },\n            {\n              "courseName": "[\uAD00\uAD11] \uC0C1\uD574",\n              "days": 1,\n              "order": 2,\n              "descriptions": "\uB3C4\uC2DC\uAC1C\uC694 - \uC18C\uAC1C : \uC0C1\uD558\uC774\uB294 \uC911\uAD6D \uC591\uCBD4\uAC15 \uC5B4\uADC0\uC5D0 \uC788\uB294 \uC0C1\uACF5\uC5C5 \uB3C4\uC2DC\uB85C \uC815\uBD80 \uC9C1\uD560\uC2DC\uC774\uB2E4",\n              "location": "",\n              "representativeImage": "http://img.test-tour.com/test.jpg"\n            },\n            {\n              "courseName": "\uC0C1\uD574-\uD56D\uC8FC \uC774\uB3D9 (\uC57D3\uC2DC\uAC04 \uC18C\uC694)",\n              "days": 1,\n              "order": 3,\n              "descriptions": "",\n              "location": "",\n              "representativeImage": "http://img.test-tour.com/test.jpg"\n            },\n            {\n              "courseName": "[\uAD00\uAD11] \uD56D\uC8FC",\n              "days": 1,\n              "order": 4,\n              "descriptions": "\uC624\uB798\uB41C \uC61B \uCC3B\uC9D1\uB4E4\uB85C \uC720\uBA85\uD55C \uACF3"\n            }\n          ],\n          "notices": {\n            "usage": "\uBCF8 \uC0C1\uD488\uC740 \uB2E8\uCCB4\uAD00\uAD11\uC744 \uBAA9\uC801\uC73C\uB85C \uD558\uB294 \uD328\uD0A4\uC9C0\uC5EC\uD589\uC73C\uB85C, \uAD00\uAD11\uC5D0 \uCC38\uC5EC\uD558\uC9C0 \uC54A\uACE0 \uAC1C\uBCC4\uC801\uC778 \uD65C\uB3D9\uC744 \uC6D0\uD558\uC2DC\uB294 \uBD84\uB4E4\uC740 \uC790\uC720\uC5EC\uD589 \uC0C1\uD488\uC73C\uB85C \uC608\uC57D\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.",\n            "inclusion": "\uC655\uBCF5 \uD56D\uACF5\uAD8C \uD3EC\uD568",\n            "exclusion": "1\uC778\uB2F9 \uC804\uC77C\uC815 \uAC00\uC774\uB4DC",\n            "reservation": "\uB2F4\uB2F9\uC790\uAC00 \uC608\uC57D\uD655\uC815\uC5EC\uBD80\uB97C \uBB38\uC790\uB85C \uC54C\uB824\uB4DC\uB9BD\uB2C8\uB2E4.",\n            "customerCenter": "\uACE0\uAC1D\uC13C\uD130 \uBB38\uC758\uC2DC\uAC04: 1644-2888, \uD3C9\uC77C 09:30~17:30 (\uB2E8, \uD1A0/\uC77C, \uACF5\uD734\uC77C\uC740 \uD734\uBB34)"\n          }\n        }\n      ],\n      "searchTags": [\n        "\uC0C1\uD574",\n        "\uD56D\uC8FC",\n        "\uC218\uD5A5\uB9C8\uC744"\n      ],\n      "destination": "\uC0C1\uD558\uC774",\n      "representativeImages": [\n        "http://img.test-tour.com/test.jpg"\n      ],\n      "composition": [\n        "FUEL_SURCHARGE_INCLUDED",\n        "SHOPPING_INCLUDE",\n        "ADDITIONAL_EXPENSE_INCLUDE",\n        "FREE_SCHEDULE_INCLUDE"\n      ],\n      "airportCode": "SHA",\n      "saleStatus": "ON_SALE",\n      "introduction": "\uACE0\uD488\uC73C\uB85C \uC54C\uCC2C \uC0C1\uD574\uC5EC\uD589\uD2B9\uC8041. NO\uD301 NO\uC635\uC158\uD2B9\uC8042. \uC804 \uC77C\uC815VIP\uB9AC\uBB34\uC9C4 \uD0D1\uC2B9\uD2B9\uC8043. \uC1A1\uC131\uAC00\uBB34\uC1FCVIP /\uD669\uD3EC\uAC15\uC720\uB78C\uC120/ \uC804\uC2E0\uB9C8\uC0AC\uC9C0 \uD3EC\uD568\uD2B9\uC8044. \uCC28\uBCC4\uD654\uB41C \uD2B9\uC2DD \uB3D9\uD30C\uC721,\uC0AC\uCC9C\uC694\uB9AC,\uC0BC\uACB9\uC0B4\uBB34\uC81C\uD55C \uC81C\uACF5"\n    }\n  ]\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'productCreateResponseDto'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'itemCreateResponse'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<itemCreateResponse>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerTravelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC544\uC774\uD15C \uB2E8\uC704 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCFE0\uD321 \uC0C1\uD488 \uC544\uC774\uD15C \uC544\uC774\uB514'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n  "code": 200,\n  "message": "SUCCESS",\n  "data": [\n    {\n      "travelProductId": 542240730693763100,\n      "sellerProductId": "seller-product-id",\n      "itemCreateResponse": [\n        {\n          "name": "\uC0C1\uD574/\uD56D\uC8FC/\uC8FC\uAC00\uAC01 1\uC77C",\n          "travelItemId": 542240730999947260,\n          "sellerTravelItemId": "seller-item-id-1"\n        },\n        {\n          "name": "\uC0C1\uD574/\uD56D\uC8FC/\uC8FC\uAC00\uAC01 2\uC77C",\n          "travelItemId": 542240731289354240,\n          "sellerTravelItemId": "seller-item-id-2"\n        }\n      ]\n    }\n  ]\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforCreateProduct' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforCreateProduct', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel-body' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC774\uB118 \uD0C0\uC785 ',
	                                            '${enumClazz.getSimpleName()}',
	                                            '\uC5D0 \uB300\uD55C \uBB34\uD6A8 \uBB38\uC790\uC5F4 \uAC12'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 display category code   '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'images\uAC00 \uBE44\uC5B4\uC788\uC744 \uC218 \uC5C6\uC74C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBCF5\uC81C \uB41C \uC774\uBBF8\uC9C0 \uACBD\uB85C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uB300\uD45C \uC774\uBBF8\uC9C0 \uB2E8 \uD55C\uC7A5\uB9CC \uD5C8\uC6A9 \uAC00\uB2A5'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uAD6D\uB0B4 \uC5EC\uD589\uC5D0 \uB300\uD55C locations\uAC00 \uBE44\uC5B4\uC788\uC73C\uBA74 \uC548\uB428 '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'landNumberAddress\uC911 \uD558\uB098\uC640 roadNameAddress\uB97C \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 seqs  '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uAC00 \uC544\uB2CC \uACBD\uC6B0 content\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uC778 \uACBD\uC6B0 sellerUrl\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'title\uC744 \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'travelType \uBC0F productDetailType\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC74C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 theme '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'instantBooking\uC774 false\uC778 \uACBD\uC6B0 estimatedBookingDuration\uC7740\uBCF4\uB2E4 \uD06C\uACE0 72\uBCF4\uB2E4 \uC791\uAC70\uB098 \uAC19\uC544\uC57C\uB428'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC5F0\uB77D\uCC98\uC5D0 \uB300\uD45C \uC804\uD654 \uBC88\uD638\uAC00 \uD558\uB098 \uC788\uC5B4\uC57C\uD568 '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour feature id '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour feature value'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour item feature id'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour item feature value  '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 \uC77C\uC790/\uC2DC\uAC04 \uD3EC\uB9F7, \uD3EC\uB9F7\uC774 ',
	                                            '{pattern}',
	                                            '\uC774\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uD310\uB9E4 \uC2DC\uC791\uC77C\uC740 \uD310\uB9E4 \uC885\uB8CC\uC77C\uBCF4\uB2E4 \uB2A6\uC9C0 \uC54A\uC544\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC911\uBCF5 \uCDE8\uC18C \uD658\uBD88\uC728refund rates'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateTourProductV2;
	}(_react2.default.Component);
	
	exports.default = UpdateTourProductV2;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateTourProductV2.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 4101044272864973:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TravelTicketBuyerInfoByV1API = function (_React$Component) {
	    _inherits(TravelTicketBuyerInfoByV1API, _React$Component);
	
	    function TravelTicketBuyerInfoByV1API(props) {
	        _classCallCheck(this, TravelTicketBuyerInfoByV1API);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    TravelTicketBuyerInfoByV1API.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC5EC\uD589 \uC0C1\uD488 \uAD6C\uB9E4\uC790 \uC815\uBCF4 \uCFFC\uB9AC V1 API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC0C1\uD488 \uAD6C\uB9E4\uC790 \uAD00\uB828 \uC77C\uBC18\uC815\uBCF4 \uAC80\uC0C9.\xA0\uC774 API\uB97C \uC774\uC6A9\uD574 \uD558\uB098\uC758 \uD2F0\uCF13\uC744 \uC0AC\uC6A9\uCC98\uB9AC \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/travel-api/v1/product/purchasers?searchStartDateTime=',
	                                '{searchStartDateTime}',
	                                '&searchEndDateTime=',
	                                '{searchEndDateTime}',
	                                '&dealId=',
	                                '{dealId}',
	                                '&offset=',
	                                '{offset}',
	                                '&limit=',
	                                '{limit}',
	                                '&productType=',
	                                '{productType}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/travel-api/v1/product/purchasers?searchStartDateTime=2019-05-01 00:00:00&searchEndDateTime=2019-05-24 23:59:59&dealId=3000000001&offset=0&limit=1000&productType=ACCOMMODATION'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Query String Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'productType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488 \uC720\uD615: ACCOMMODATION, TICKET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'offset'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0 \uBC88\uD638 (\uCCAB\uBC88\uC9F8 \uD398\uC774\uC9C0 = 0)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'limit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD5C\uB300 \uC694\uCCAD \uAC2F\uC218 (\uCD5C\uB313\uAC12 = 1000)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'searchStartDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC \uAC80\uC0C9\uC2DC\uC791\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'searchEndDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC \uAC80\uC0C9\uC885\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'productType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488 \uC720\uD615'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'userName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 \uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'phoneNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 \uD578\uB4DC\uD3F0 \uBC88\uD638 (010-xxxx-xxxx)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'email'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 email'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C \uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C \uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'purchaseDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'canceledDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uAC00\uACA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'status'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'CANCEL_COMPLETE(\uCDE8\uC18C\uC644\uB8CC), PURCHASE_COMPLETE(\uAD6C\uB9E4\uC644\uB8CC)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'orderId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 \uC8FC\uBB38\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'checkInDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778 \uB0A0\uC9DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'checkOutDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC544\uC6C3 \uB0A0\uC9DC'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "totalCount": 2,\n            "totalPageCount": 1,\n            "countPerPage": 1000,\n            "currentPage": 0,\n            "ticketPurchasers": [\n                {\n                    "ticketNumber": "9C320B-9000000000234",\n                    "productType": "ACCOMMODATION",\n                    "userName": "\uAE40\uCFE0\uD321",\n                    "phoneNumber": null,\n                    "email": "coupang@coupang.com",\n                    "dealId": 6500124641,\n                    "dealName": "\uB86F\uB370 \uD638\uD154 3 \uBC15",\n                    "optionId": 53000424227,\n                    "optionName": "\uC989\uC2DC \uAC00\uAE30  ",\n                    "price": 1000,\n                    "purchaseDateTime": "2019-05-05 05:17:13",\n                    "canceledDateTime": null,\n                    "checkInDate":"2019-08-15 15:00:00",\n                    "checkOutDate":"2019-08-19 11:00:00",\n                    "status": "PURCHASE_COMPLETE",\n                    "orderId" : "2ma*aBZy*ho+zQO+dRZlCQJ8pEKWuZspZg8kCVCyx9Q="\n                },\n                {\n                    "ticketNumber": "DCAA6C-9000000000235",\n                    "productType": "ACCOMMODATION",\n                    "userName": "\uAE40\uCFE0\uD321",\n                    "phoneNumber": null,\n                    "email": "coupang@coupang.com",\n                    "dealId": 6500124641,\n                    "dealName": "\uB86F\uB370 \uD638\uD154 3 \uBC15",\n                    "optionId": 53000424227,\n                    "optionName": "\uC989\uC2DC \uAC00\uAE30  ",\n                    "price": 1000,\n                    "purchaseDateTime": "2019-05-05 05:17:13",\n                    "canceledDateTime": "2019-05-06 07:27:21",\n                    "checkInDate":"2019-08-15 15:00:00",\n                    "checkOutDate":"2019-08-19 11:00:00",\n                    "status": "CANCEL_COMPLETE",\n                    "orderId" : "2ma*aBZy*ho+zQO+dRZlCQJ8pEKWuZspZg8kCVCyx9Q="\n                }\n            ]\n        }\n                        '
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return TravelTicketBuyerInfoByV1API;
	}(_react2.default.Component);
	
	exports.default = TravelTicketBuyerInfoByV1API;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "TravelTicketBuyerInfoByV1API.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 4108427237230249:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateTicketProductItem = function (_React$Component) {
	    _inherits(CreateTicketProductItem, _React$Component);
	
	    function CreateTicketProductItem(props) {
	        _classCallCheck(this, CreateTicketProductItem);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    CreateTicketProductItem.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC0C1\uD488 \uC635\uC158 \uB4F1\uB85D'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC758 \uC815\uBCF4\uB97C \uC218\uC815/\uC5C5\uB370\uC774\uD2B8 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets/',
	                                '{travelProductId}',
	                                '/items'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890/items'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'sellerTravelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uBA85. (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 50\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'onSale'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC911:true, \uD310\uB9E4\uC911\uC9C0:false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC124\uBA85 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'features'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Feature \uAD00\uB828 \uC138\uBD80 \uC0AC\uD56D\uC740 \uC5D1\uC140 \uD30C\uC77C \uCC38\uC870 \uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureValues'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<String>'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Feature \uAD00\uB828 \uC138\uBD80 \uC0AC\uD56D\uC740 \uC5D1\uC140 \uD30C\uC77C \uCC38\uC870 \uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'taxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'TaxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 taxType\uC774 \uC790\uB3D9\uC73C\uB85C \uBA74\uC138(FREE)\uB85C \uC124\uC815\uB418\uBA70, \uC774\uC678\uC758 taxType\uB97C \uC124\uC815 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACFC\uC138 (\uAE30\uBCF8\uAC12)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBA74\uC138'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ZERO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC138'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'usePeriod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '<UsePeriodDto>'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uBCA4\uD1A0\uB9AC \uD0C0\uC785\uC774 \u2018PERIOD\u2019 \uC774\uBA74 \uC0AC\uC6A9\uAE30\uAC04\uC740 \uD544\uC218\uC774\uACE0 \uC778\uBCA4\uD1A0\uB9AC \uD0C0\uC785\uC774 \u2018DAILY\u2019 \uC778 \uACBD\uC6B0 \uC0AC\uC6A9\uAE30\uAC04\uC740 \uC0AC\uC6A9\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'usePeriodName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9 \uAE30\uAC04\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'useStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBD80\uD130 \uC0AC\uC6A9 \uAC00\uB2A5. Format: yyyy-MM-dd HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'useEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE4C\uC9C0 \uC0AC\uC6A9 \uC911\uC9C0. Format: yyyy-MM-dd HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'rates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<TravelRateDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC rate id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'TourRateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN_AND_CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778/\uC18C\uC778\uB3D9\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNIVERSITY_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACE0\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_AND_MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEENS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCCAD\uC18C\uB144'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PRESCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uCDE8\uD559\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC18C\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'INFANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'priceType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'COUPANG_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCFE0\uD321 \uAC00\uACA9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TOTAL_PRODUCT_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD1D \uC0C1\uD488 \uAC00\uACA9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC \uD648\uD398\uC774\uC9C0\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_MALL_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC\uBAB0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ONLINE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC628\uB77C\uC778 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TRAVEL_AGENCY_SPECIAL_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5EC\uD589\uC0AC \uD2B9\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESERVATION_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uB9E4\uCC98 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HOMEPAGE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD648\uD398\uC774\uC9C0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SITE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD604\uC7A5 \uD310\uB9E4\uAC00'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC6D0\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB300\uD45C\uAC00 \uC124\uC815 \uC5EC\uBD80 / False\uB85C \uC124\uC815\uD560 \uACBD\uC6B0 \uB300\uD45C\uAC00 \uB178\uCD9C\uC5D0\uC11C \uC81C\uC678\uB429\uB2C8\uB2E4. (Default: TRUE)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC2DC\uC791\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC885\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss). Default: 2099-12-31 23:59:59'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'maxPurchaseQtyPerPerson'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uB2F9 \uCD5C\uB300 \uAD6C\uB9E4 \uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'maxPurchaseQtyPeriod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4 \uC81C\uD55C \uAE30\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08 \uB4F1\uB85D \uC21C\uC11C'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#createTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'createTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n    {\n      "description": "string",\n        "features": [\n        \t{\n        \t\t"description":"",\n        \t\t"featureId":"OFFERING_SERVICE",\n        \t\t"featureValues":[\n        \t\t\t"NO_CHARGE_CALL","UNLIMITED_USE"\n        \t\t\t]\n        \t}\n      ],\n      "name": "test_item_5",\n      "onSale": true,\n      "rates": [\n        {\n          "maxPurchaseQtyPerPerson": 0,\n          "maxPurchaseQtyPeriod": 0,\n          "price": 0,\n          "priceType": "COUPANG_PRICE",\n          "rateType": "BASIC",\n          "representative": true,\n          "saleEndedAt": "2019-12-31 23:59:59",\n          "saleStartedAt": "2019-10-01 00:00:00",\n          "sellerRateId": "",\n          "seq": 0\n        }\n      ],\n      "sellerTravelItemId": "string",\n      "seq": 0,\n      "taxType": "TAX",\n      "usePeriod": {\n        "useEndedAt": "2019-12-31 23:59:59",\n        "usePeriodName": "string",\n        "useStartedAt": "2019-12-01 23:59:59"\n      }\n    }\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": 11111111\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforCreateProductItem' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforCreateProductItem', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel-body' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC774\uB118 \uD0C0\uC785 ',
	                                            '${enumClazz.getSimpleName()}',
	                                            '\uC5D0 \uB300\uD55C \uBB34\uD6A8 \uBB38\uC790\uC5F4 \uAC12'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 seqs  '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uC778 \uACBD\uC6B0 sellerUrl\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 travel item feature id '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 travel item feature value '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 \uC77C\uC790/\uC2DC\uAC04 \uD3EC\uB9F7, \uD3EC\uB9F7\uC774 ',
	                                            '{pattern}',
	                                            '\uC774\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uD310\uB9E4 \uC2DC\uC791\uC77C\uC740 \uD310\uB9E4 \uC885\uB8CC\uC77C\uBCF4\uB2E4 \uB2A6\uC9C0 \uC54A\uC544\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC0C1\uD488 inventoryType\uC774 PERIOD\uC778 \uACBD\uC6B0 usePeriod\uAC00 NULL\uC774\uBA74 \uC548\uB428'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'inventoryType\uC774 DAILY\uC778 \uACBD\uC6B0 usePeriod\uAC00 \uBD88\uD544\uC694\uD568'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return CreateTicketProductItem;
	}(_react2.default.Component);
	
	exports.default = CreateTicketProductItem;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "CreateTicketProductItem.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 4150089103159804:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateTourProduct = function (_React$Component) {
	    _inherits(UpdateTourProduct, _React$Component);
	
	    function UpdateTourProduct(props) {
	        _classCallCheck(this, UpdateTourProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateTourProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { id: "update-tour-product" },
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC0C1\uD488 \uC218\uC815'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC758 \uC815\uBCF4\uB97C \uC218\uC815/\uC5C5\uB370\uC774\uD2B8 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'PUT'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tours/',
	                                '{travelProductId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/1234567890'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'adultOnly'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '19\uC138\uBBF8\uB9CC \uAD6C\uB9E4\uBD88\uAC00.. Default:FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'subordinateIds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uAD00\uB9AC \uC11C\uBE0CID \uB9AC\uC2A4\uD2B8'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'searchTags'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC11C\uCE58\uD0DC\uADF8 \uB9AC\uC2A4\uD2B8'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'displayKeyword'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uC5D0 \uD45C\uC2DC\uD560 \uC9C0\uC5ED \uD0A4\uC6CC\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'images'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\uAC00 \uC0C1\uD488 \uB300\uD45C\uD568, \uC0C1\uD488\uB2F9 \uB2E8\uC77C \uB300\uD45C\uC774\uBBF8\uC9C0 \uBCF4\uC720. Default: FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerImageCategory'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 \uCE74\uD14C\uACE0\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'imageGroup'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'VIEW'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FACILITY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD80\uB300\uC2DC\uC124'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESTAURANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DD\uB2F9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ROOM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        )
	                                    )
	                                ),
	                                '\uB514\uD3F4\uD2B8 \uAC12: BASIC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'trafficInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCC3E\uC544\uAC00\uB294 \uAE38 \uC124\uBA85\uD558\uB294 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'publicTransportInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uB300\uC911\uAD50\uD1B5 \uC815\uBCF4 \uC124\uBA85\uD558\uB294 \uC790\uC720 \uD14D\uC2A4\uD2B8 \uC785\uB825.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'nearbyLandmarks'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uAD00\uAD11\uC9C0 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C \uC704\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C \uACBD\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C\uAE4C\uC9C0\uC758 \uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'distanceUnit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'KILOMETER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD0AC\uB85C\uBBF8\uD130'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'METER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uD130'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'direction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC11C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTH'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTH'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTHEAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTHWEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81\uC11C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTHEAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTHWEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8\uC11C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'transportations'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SUBWAY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC9C0\uD558\uCCA0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BUS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC84\uC2A4'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'operationPeriods'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'startTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'endTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'locations'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 locations\uAC00 \uD544\uC218 \uAC12\uC774 \uC544\uB2D8. Locations \uAC12\uC774 \uC785\uB825\uB41C \uACBD\uC6B0 \uAF2D \uC815\uD655\uD55C \uAC12\uC73C\uB85C \uC785\uB825\uD574\uC57C\uD568.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0 \uC704\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0 \uACBD\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'roadNameAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uB85C\uBA85\uC8FC\uC18C.\uB3C4\uB85C\uBA85 \uB610\uB294 \uC9C0\uBC88\uC8FC\uC18C \uC911 \uCD5C\uC18C\uD55C \uD55C\uAC00\uC9C0\uB294 \uC785\uB825\uD574\uC57C \uD568'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'landNumberAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uBC88\uC8FC\uC18C. \uB3C4\uB85C\uBA85 \uB610\uB294 \uC9C0\uBC88\uC8FC\uC18C \uC911 \uCD5C\uC18C\uD55C \uD55C\uAC00\uC9C0\uB294 \uC785\uB825\uD574\uC57C \uD568'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6D\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'province'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD589\uC815\uB2E8\uC704 \uC8FC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'city'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'district'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C, \uAD6C\uC5ED'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'town'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC74D \uBA74 \uB3D9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'zipCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B0\uD3B8\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'contents'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uCEE8\uD150\uCE20 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785\uC5D0 \uB300\uD55C \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825. \uC608:\uD328\uD0A4\uC9C0 \uD22C\uC5B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '(\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \u2018\uC774\uBBF8\uC9C0\u2019\uC774\uBA74 \uD544\uC218)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '(\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'features'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                ' \uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureValues'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                ' \uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Free text to describe features (\uC18D\uC131 \uC124\uBA85)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'themes'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'reservationNotifications'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBA54\uC77C \uC8FC\uC18C, \uC804\uD654\uBC88\uD638 \uD639\uC740 \uD329\uC2A4 \uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactDescription'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'contacts'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WEBSITE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC6F9\uC0AC\uC774\uD2B8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactUseType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'REPRESENTATIVE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD45C\uC5F0\uB77D\uCC98*\uD544\uC218'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BOOKING_INQUIRY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D\uBB38\uC758 \uC5F0\uB77D\uCC98'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CANCEL_INQUIRY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uBB38\uC758 \uC5F0\uB77D\uCC98'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMERGENCY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE34\uAE09\uC5F0\uB77D\uB9DD'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contact'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608: \uC5F0\uB77D\uCC98 \uD0C0\uC785\uC774 \uD3F0\uC774\uBA74: 010-0000-0000'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'itineraries'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC77C\uC815 \uC81C\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815\uC5D0 \uAD00\uD55C \uACF5\uC9C0\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'courses'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC81C\uBAA9 \uC608) 1\uC77C\uCC28 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'summary'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC694\uC57D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'from'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD9C\uBC1C\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'to'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'details'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'HOTEL, FLIGHT, MEAL, SIGHTSEEING, SHOPPING, NOTICE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'mealName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2DD\uC0AC \uC81C\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'location'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC7A5\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightFrom'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uCD9C\uBC1C\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightTo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uBAA9\uC801\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightDepartureTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uCD9C\uBC1C\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightArrivalTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uB3C4\uCC29\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'duration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC18C\uC694\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'descriptions'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uB0B4\uC6A9 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uB0B4\uC6A9(\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74  \uD544\uC218)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT  \uB514\uD3F4\uD2B8 \uAC12'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url \uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC11C\uBD80\uC77C\uC815 \uB0B4\uC6A9 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'feeIncluded'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08 \uD3EC\uD568\uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'optional'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815 \uC790\uC720\uC120\uD0DD \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'cancelPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uACF5\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AUTO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uB3D9\uCDE8\uC18C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778\uCDE8\uC18C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelPeriodType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BEFORE_USE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC0AC\uC6A9 \uCC98\uB9AC\uC804 \uAC00\uB2A5(\uC720\uD6A8\uAE30\uAC04 \uC885\uB8CC\uC2DC\uAE4C\uC9C0)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AFTER_7DAYS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAD6C\uB9E4\uC77C + 7\uC77C \uC774\uB0B4 \uAC00\uB2A5'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelMarkType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uB2F9 \uC5C6\uC74C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_CANCELED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNUSE_REFUND_ALL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uC0AC\uC6A9 100%\uD658\uBD88'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_REFUND_AFTER_RECEIPT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD2F0\uCF13 \uBC1C\uC1A1 \uD6C4 \uD658\uBD88 \uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_REFUND_AFTER_RESERVATION_CONFIRM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D \uD655\uC815 \uD6C4 \uD658\uBD88 \uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNUSE_REFUND_ALL_BEFORE_ONE_DAY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uC6A9\uC77C 1\uC77C\uC804\uAE4C\uC9C0 100%\uD658\uBD88'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DEPENDING_ON_VENDOR'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5C5\uCCB4 \uADDC\uC815\uC5D0 \uB530\uB984'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundOnBusinessDay'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC601\uC5C5\uC77C \uAE30\uC900 \uCDE8\uC18C \uC811\uC218 \uC5EC\uBD80 (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundUnusedTicket'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBBF8\uC0AC\uC6A9 \uD2F0\uCF13 100% \uD658\uBD88 \uC5EC\uBD80 (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundRates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9CC\uC57D cancelMarkType \uC774 \u2018\uC5C5\uCCB4\uADDC\uC815\uC5D0 \uB530\uB984\u2019\uC778 \uACBD\uC6B0, \uD658\uBD88\uC728 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'conditionDays'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uC77C x \uC77C \uC804 \uAE4C\uC9C0 \uD658\uBD88 \uAC00\uB2A5'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'conditionTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uC77C x \uC77C y \uC2DC \uC804 \uAE4C\uC9C0 \uD658\uBD88 \uAC00\uB2A5 format: HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'refundRate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC728 ex: rate 70% is 70'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'cancellable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uAC00\uB2A5 \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'introduction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC0C1\uD488 \uC18C\uAC1C\uB9D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uC6A9\uC548\uB0B4 \uBC0F \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'benefits'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uBCC4\uD788 \uC81C\uACF5\uB418\uB294 \uD61C\uD0DD \uBC0F \uBCF4\uB108\uC2A4\u2018\uB780 \uAD6C\uB9E4 \uACE0\uAC1D\uC5D0\uAC8C \uD2B9\uBCC4\uD558\uAC8C \uC81C\uACF5\uB418\uB294 \uD61C\uD0DD\uC73C\uB85C \uC2E4\uC81C \uBCF8 \uC0C1\uD488\uC678\uC5D0 \uBB34\uB8CC \uD639\uC740 \uD560\uC778\uB418\uC5B4 \uC81C\uACF5\uB418\uB294 \uC120\uBB3C\uC774\uB098 \uC11C\uBE44\uC2A4\uB97C \uB9D0\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'flightInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uC0AC \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825,\uC608: \uD56D\uACF5\uD3B8 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74  \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'visaInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBE44\uC790 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'meetingNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9D1\uD569 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825,\uC608: \uD56D\uACF5\uD3B8 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DDl'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC8FC\uBB38'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'guideInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC00\uC774\uB4DC \uC815\uBCF4 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'shoppingInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'details'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'shoppingCategory'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC1FC\uD305 \uCE74\uD14C\uACE0\uB9AC \uC790\uC720 \uD14D\uC2A4\uD2B8 \uC785\uB825 example : "\uB77C\uD14D\uC2A4"'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'shoppingPlace'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC1FC\uD551 \uC7A5\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'duration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC1FC\uD551 \uC18C\uC694\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'refundable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88 \uAC00\uB2A5 \uC5EC\uBD80 Default: true'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'exchangeRefundNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD50\uD658 \uD658\uBD88 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825,\uC608: \uD56D\uACF5\uD3B8 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'tourGuides'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC5B4 \uAC00\uC774\uB4DC \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'safetyInstructions'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC548\uC804\uC218\uCE59 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74  \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'hotelInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD638\uD154\uC815\uBCF4 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'insuranceInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCF4\uD5D8\uC815\uBCF4 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74  \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DDl'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'inclusionNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD3EC\uD568\uC0AC\uD56D \uAE30\uC7AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'exclusionNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBD88\uD3EC\uD568 \uC0AC\uD56D \uAE30\uC7AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'usageNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC758\uC0AC\uD56D \uAE30\uC7AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'reservationGuide'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D\uAC00\uC774\uB4DC \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74  \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'additionalInfoPrompt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488 \uC8FC\uBB38/\uC608\uC57D\uC5D0 \uD544\uC694\uD55C \uACE0\uAC1D \uC815\uBCF4\uB97C \uC218\uC9D1\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'maxPurchaseQuantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC778\uB2F9 \uAD6C\uB9E4 \uCD5C\uB300 \uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'csContactInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uACE0\uAC1D\uC13C\uD130 \uBB38\uC758 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'taxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 taxType\uC774 \uC790\uB3D9\uC73C\uB85C \uBA74\uC138(FREE)\uB85C \uC124\uC815\uB418\uBA70, \uC774\uC678\uC758 taxType\uB97C \uC124\uC815 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACFC\uC138 (\uAE30\uBCF8\uAC12)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBA74\uC138'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ZERO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC138'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'instantBooking'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC989\uC2DC \uC608\uC57D (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'estimatedBookingDuration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D\uD655\uC815 \uC18C\uC694\uC2DC\uAC04, \uC989\uC2DC\uC608\uC57D\uC774 FALSE \uB77C\uBA74 \uD544\uC694'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'extension'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE30\uD0C0 \uC815\uBCF4\uC0AC\uD56D \uC790\uC720 \uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#updateTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'updateTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n  "sellerProductId": "seller-product-id",\n  "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 6/7\uC77C \uD328\uD0A4\uC9C0",\n  "adultOnly": false,\n  "searchTags": [\n    "\uC911\uAD6D\uC7A5\uAC00\uACC4",\n    "\uC7A5\uAC00\uACC4\uC5EC\uD589"\n  ],\n  "displayKeyword": "\uC778\uCC9C\u51FA",\n  "images": [\n    {\n      "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n      "sellerUrlMethod": "GET",\n      "representative": true,\n      "sellerImageCategory": "1234",\n      "imageGroup": "BASIC",\n      "description": "image 1 description",\n      "seq": 0\n    },\n    {\n      "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n      "sellerUrlMethod": "GET",\n      "representative": false,\n      "sellerImageCategory": "1234",\n      "imageGroup": "BASIC",\n      "description": "image 2 description",\n      "seq": 1\n    },\n    {\n      "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",\n      "sellerUrlMethod": "GET",\n      "representative": false,\n      "sellerImageCategory": "1234",\n      "imageGroup": "BASIC",\n      "description": "image 3 description",\n      "seq": 2\n    },\n    {\n      "sellerUrl": "http://image15.coupangcdn.com/image/bannerunit/bannerunit_c5b412fb-44cd-4cfb-b632-bafd1270fef8.jpg",\n      "sellerUrlMethod": "GET",\n      "representative": false,\n      "sellerImageCategory": "1234",\n      "imageGroup": "BASIC",\n      "description": "image 4 description",\n      "seq": 3\n    }\n  ],\n  "trafficInfo": "\uC81C\uC8FC\uACF5\uD56D \uCC28\uB7C9 \uC57D 3km",\n  "publicTransportInfo": "\uC6A9\uB450\uC554 \uCC28\uB7C9 \uC57D 1km",\n  "nearbyLandmarks": [\n    {\n      "name": "nearby 1",\n      "latitude": 10.1,\n      "longitude": 20.2,\n      "distance": 300,\n      "distanceUnit": "METER",\n      "direction": null,\n      "transportations": [\n        \n      ]\n    },\n    {\n      "name": "nearby 2",\n      "latitude": 30.3,\n      "longitude": 40.4,\n      "distance": 2,\n      "distanceUnit": "KILOMETER",\n      "direction": null,\n      "transportations": [\n        \n      ]\n    }\n  ],\n  "locations": [\n    {\n      "latitude": 110.11,\n      "longitude": 20.12,\n      "roadNameAddress": "\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4 \uC81C\uC8FC\uC2DC \uC6A9\uD574\uB85C 21-6",\n      "landNumberAddress": "\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4 \uC81C\uC8FC\uC2DC \uC6A9\uB2F4\uC0BC\uB3D9 1016",\n      "nation": "\uB300\uD55C\uBBFC\uAD6D",\n      "province": null,\n      "city": "\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4",\n      "district": "\uC81C\uC8FC\uC2DC",\n      "town": "\uC6A9\uB2F4\uC0BC\uB3D9",\n      "zipCode": "63150"\n    }\n  ],\n  "contents": [\n    {\n      "title": "product content title 1",\n      "type": "Product-Content",\n      "content": "product content 1: text",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 0\n    },\n    {\n      "title": "product content title 2",\n      "type": "Product-Content",\n      "content": null,\n      "format": "IMAGE",\n      "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg.jpg",\n      "sellerUrlMethod": "GET",\n      "seq": 1\n    },\n    {\n      "title": "product content title 3",\n      "type": "Product-Content",\n      "content": null,\n      "format": "IMAGE",\n      "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n      "sellerUrlMethod": "GET",\n      "seq": 2\n    },\n    {\n      "title": "product content title 2",\n      "type": "Product-Content",\n      "content": null,\n      "format": "IMAGE",\n      "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",\n      "sellerUrlMethod": "GET",\n      "seq": 3\n    }\n  ],\n  "features": [\n    {\n      "featureId": "ADDITIONAL_EXPENSE",\n      "featureValues": [\n        "ADDITIONAL_EXPENSE_EXCLUDE"\n      ],\n      "description": null\n    },\n    {\n      "featureId": "SHOPPING",\n      "featureValues": [\n        "SHOPPING_INCLUDE"\n      ],\n      "description": null\n    },\n    {\n      "featureId": "FREE_SCHEDULE",\n      "featureValues": [\n        "FREE_SCHEDULE_EXCLUDE"\n      ],\n      "description": null\n    }\n  ],\n  "themes": [\n    "SIGHT_SEEING",\n    "WATER_SPORTS"\n  ],\n  "reservationNotifications": [\n    {\n      "type": "PHONE",\n      "contactInfo": "010-1234-5678",\n      "contactDescription": "order notification phone number"\n    },\n    {\n      "type": "EMAIL",\n      "contactInfo": "coupang@coupang.com",\n      "contactDescription": "order notification email"\n    }\n  ],\n  "contacts": [\n    {\n      "contactType": "PHONE",\n      "contactUseType": "REPRESENTATIVE",\n      "contact": "02-1544-3663"\n    },\n    {\n      "contactType": "PHONE",\n      "contactUseType": "BOOKING_INQUIRY",\n      "contact": "02-1544-3663"\n    },\n    {\n      "contactType": "PHONE",\n      "contactUseType": "EMERGENCY",\n      "contact": "02-1544-3663"\n    },\n    {\n      "contactType": "PHONE",\n      "contactUseType": "CANCEL_INQUIRY",\n      "contact": "02-1544-3663"\n    }\n  ],\n  "itineraries": [\n    {\n      "name": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4 3\uBC155\uC77C]",\n      "notice": "\u203B\uBCF8 \uC0C1\uD488\uC740 \uBAA8\uB450\uD22C\uC5B4\uC758 \uB3D9\uC77C\uD56D\uACF5\uC758 \uB2E4\uB978\uC0C1\uD488\uACFC \uD604\uC9C0\uC5D0\uC11C \uC870\uC778(\uD569\uB958) \uB418\uC5B4 \uC9C4\uD589\uB420 \uC218 \uC788\uC73C\uBA70, \uCD9C\uBC1C 1\uC77C\uC804\uAE4C\uC9C0 \uC77C\uC815 \uD655\uC815\uC2DC \uD648\uD398\uC774\uC9C0 \uB4F1\uC744 \uD1B5\uD574 \uD655\uC778 \uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n\u203B\uBCF8 \uC0C1\uD488\uC740 \uC608\uC57D\uC2DC\uC810\uC5D0 \uB530\uB77C \uC0C1\uD488\uAC00\uAC00 \uC0C1\uC774\uD560 \uC218 \uC788\uC73C\uBA70 \uAE08\uC561 \uCC28\uC774\uC5D0 \uB300\uD574\uC11C\uB294 \uCD94\uD6C4 \uD658\uBD88 \uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\\n\u203B\uC77C\uC815\uC0C1\uC758 \uD45C\uAE30\uB41C \uD638\uD154\uC740 \uD604\uC9C0 \uC0AC\uC815\uC0C1 \uAC00\uB2A5\uD55C \uD638\uD154\uC774\uB098 \uB3D9\uAE09 \uD638\uD154\uB85C \uBCC0\uACBD\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\u203B\uC7A5\uAC00\uACC4 \uC77C\uC815 \uC911 \uC1FC\uD551\uC13C\uD130 \uC678 \uCC28\uB7C9\uB0B4 \uAE30\uB150\uD488 \uD310\uB9E4 \uBC0F \uB18D\uC218\uC0B0\uD488 \uD310\uB9E4\uB97C \uD558\uBA70, \uD544\uC694\uD55C \uACE0\uAC1D\uC5D0 \uD55C\uD558\uBA70 \uAD6C\uB9E4\uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n\u203B\uD604\uC9C0\uC0AC\uC815(\uAE30\uD6C4, \uB3C4\uB85C\uB4F1)\uC5D0 \uB530\uB77C \uC18C\uBE44\uC790\uC758 \uB3D9\uC758\uB97C \uC5BB\uC5B4 \uC5EC\uD589\uC77C\uC815 \uBCC0\uACBD\uC774 \uAC00\uB2A5\uD558\uBA70, \uAE30\uC0C1\uC545\uD654\uC5D0 \uB530\uB77C \uC77C\uBD80 \uAD00\uAD11\uC9C0\uAC00 \uC81C\uD55C\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n---111111",\n      "courses": [\n        {\n          "name": "1 \uC77C\uCC28 - 1",\n          "summary": "2019\uB144 10\uC6D4 14\uC77C \uC6D4\uC694\uC77C - 1",\n          "from": "\uC778\uCC9C (ICN)\uCD9C\uBC1C - 1",\n          "to": "\uC911\uACBD (CKG)\uB3C4\uCC29 - 1",\n          "details": [\n            {\n              "type": "NOTICE",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": "19:00:00",\n              "flightArrivalTime": "19:00:00",\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "\uC911\uACBD \uB2E8\uCCB4\uBE44\uC790 \uC785\uAD6D\uC2DC \uC720\uC758 \uC0AC\uD56D - 1",\n                  "type": null,\n                  "content": "\uAC1C\uC694 : \u25CE \uC911\uAD6D \uBE44\uC790 \uC785\uAD6D \uC21C\uC11C \u25CE\\n1. \uC5EC\uAD8C\uACFC \uBE44\uC790 \uC6D0\uBCF8\uC744 \uD655\uC778 \uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n-\uC911\uAD6D \uBE44\uC790 \uC6D0\uBCF8\uC740 \uBD89\uC740\uC0C9 \uB3C4\uC7A5\uC774 \uCC0D\uD600 \uC788\uC2B5\uB2C8\uB2E4.\\n2. \uBE44\uC790 1\uBC88\uC5D0 \uC788\uB294 \uC190\uB2D8\uAED8\uC11C \uC5EC\uAD8C\uACFC \uBE44\uC790 \uC6D0\uBCF8, \uBCF5\uC0AC\uBCF8 1\uBD80\uB97C \uC785\uAD6D\uC2EC\uC0AC\uB300\uC5D0 \uC81C\uCD9C \uD569\uB2C8\uB2E4.\\n3. \uBE44\uC790\uC5D0 \uB098\uC640 \uC788\uB294 \uC21C\uC11C\uB300\uB85C \uC785\uAD6D\uC2EC\uC0AC\uB300\uB97C \uD1B5\uACFC\uD569\uB2C8\uB2E4.\\n4. \uBE44\uC790 \uB9C8\uC9C0\uB9C9\uC5D0 \uC788\uB294 \uC190\uB2D8\uAED8\uC11C\uB294 \uBE44\uC790 \uC6D0\uBCF8\uC744 \uBC1B\uC544 \uC624\uC154\uC57C \uD569\uB2C8\uB2E4.\\n(\uBE44\uC790 \uC6D0\uBCF8\uC740 \uCD9C\uAD6D \uC2DC \uC81C\uCD9C\uD569\uB2C8\uB2E4.)\\n---111111",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                }\n              ],\n              "seq": 0,\n              "feeIncluded": true,\n              "optional": false\n            },\n            {\n              "type": "FLIGHT",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": "\uC778\uCC9C (ICN)\uCD9C\uBC1C - 1",\n              "flightTo": "\uC911\uACBD (CKG)\uB3C4\uCC29 - 1",\n              "flightDepartureTime": "10-14 (\uC6D4) 15:10",\n              "flightArrivalTime": "10-14 (\uC6D4) 17:40",\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "Fight Title Required",\n                  "type": null,\n                  "content": "CA440\uD3B8-03\uC2DC\uAC04 30\uBD84 \uC18C\uC694",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                }\n              ],\n              "seq": 1,\n              "feeIncluded": true,\n              "optional": false\n            },\n            {\n              "type": "MEAL",\n              "mealName": "\uC11D\uC2DD",\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "Meal Title Required",\n                  "type": null,\n                  "content": "\uD604\uC9C0\uC2DD",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                }\n              ],\n              "seq": 2,\n              "feeIncluded": true,\n              "optional": false\n            },\n            {\n              "type": "HOTEL",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "Hotel Title Required",\n                  "type": null,\n                  "content": "\uCD1D 2\uAC1C\uC758 \uC608\uC815 \uD638\uD154\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uD655\uC815 \uB418\uB294\uB300\uB85C(\uCD9C\uBC1C 1\uC77C\uC804\uAE4C\uC9C0) \uD648\uD398\uC774\uC9C0, \uC774\uBA54\uC77C \uB610\uB294 \uC54C\uB9BC\uD1A1 \uB4F1\uC744 \uD1B5\uD574 \uC548\uB0B4 \uB4DC\uB9AC\uACA0\uC2B5\uB2C8\uB2E4.",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                }\n              ],\n              "seq": 3,\n              "feeIncluded": true,\n              "optional": false\n            }\n          ]\n        },\n        {\n          "name": "2 \uC77C\uCC28",\n          "summary": "2019\uB144 10\uC6D4 15\uC77C \uD654\uC694\uC77C",\n          "from": null,\n          "to": null,\n          "details": [\n            {\n              "type": "SIGHTSEEING",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "\uBCF4\uBD09\uD638",\n                  "type": null,\n                  "content": "\uBCF4\uBD09\uD638\uC218\uB294 \uB310\uC744 \uC313\uC544 \uBB3C\uC744 \uB9C9\uC544\uC11C \uB9CC\uB4E0 \uC778\uACF5\uD638\uC218\uB85C \uC8FC\uB85C \uC218\uB825\uBC1C\uC804\uACFC \uC591\uC2DD\uC7A5\uC73C\uB85C \uC0AC\uC6A9 \uB418\uB358 \uC911 \uBCF4\uBD09\uD638\uC758 \uC544\uB984\uB2E4\uC6C0\uC5D0 \uAD00\uAD11\uC9C0\uB85C \uAC1C\uBC1C\uB418\uC5C8\uC2B5\uB2C8\uB2E4 \uD574\uBC1C 430m \uC704\uC5D0 \uC788\uB294 \uC0B0\uC815\uD638\uC218\uB85C \uD3C9\uADE0\uC218\uC2EC\uC740 72m\uC774\uBA70 \uAC00\uC7A5 \uB113\uC740 \uACF3\uC758 \uD3ED\uC740 150m\uC5D0 \uC774\uB978\uB2E4. \uC120\uB140\uBC14\uC704, \uB450\uAEBC\uBE44\uBC14\uC704, \uACF5\uC791\uC0C8\uBC14\uC704 \uB4F1\uACFC \uAC19\uC774 \uC0AC\uB78C \uD639\uC740 \uC9D0\uC2B9\uBAA8\uC591\uC73C\uB85C \uB418\uC5B4\uC788\uB294 \uBC14\uC704\uB4E4\uC774 \uBCF4\uBD09\uD638\uC758 \uC544\uB984\uB2E4\uC6C0\uC744 \uB354\uC6B1 \uC2E0\uBE44\uC2A4\uB7FD\uAC8C \uB9CC\uB4E4...",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 1\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 2\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 3\n                }\n              ],\n              "seq": 0,\n              "feeIncluded": true,\n              "optional": false\n            },\n            {\n              "type": "SIGHTSEEING",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "\uC120\uD0DD\uAD00\uAD11-\uD669\uB8E1\uB3D9\uAD74($30)",\n                  "type": null,\n                  "content": "\uAC1C\uC694 : \uAD70\uC9C0\uD3C9 \uB3D9\uCABD\uC73C\uB85C 8km \uB5A8\uC5B4\uC9C4 \uACF3\uC5D0 \uC704\uCE58\uD574 \uC788\uB2E4. \uC9C0\uAC01\uC6B4\uB3D9\uC73C\uB85C \uC778\uD574 \uC0DD\uC131\uB41C \uC11D\uD68C\uC554 \uC6A9\uC554\uB3D9\uAD74\uB85C \uC0C1\uD558 4\uCE35\uC73C\uB85C \uB418\uC5B4 \uC788\uACE0, \uC544\uB798 2\uCE35\uC5D0\uB294 4\uAC1C\uC758 \uC2DC\uB0B4\uAC00 \uD758\uB7EC\uB0B4\uB9AC\uB294 \uB3D9\uAD74\uC774\uB2E4. \uC218\uC9C1\uACE0\uB3C4\uB294 160m, \uB3D9\uAD74 \uAE38\uC774\uB294 15km\uC774\uBA70, \uC774\uBBF8 \uAC1C\uBC1C\uB418\uC5B4 \uC788\uB294 \uBA74\uC801\uC774 6\uB9CC\uD3C9\uC5D0 \uB2EC\uD55C\uB2E4. \uB610\uD55C \uB3D9\uAD74 \uC548\uC5D0\uB294 \uC218\uB9CE\uC740 \uAE30\uC774\uD55C \uC885\uC720\uC11D\uC774 \uCC9C\uD0DC\uB9CC\uC0C1\uC744 \uBCF4\uC5EC\uC8FC\uACE0 \uC788\uB2E4.",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 1\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 2\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 3\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 4\n                }\n              ],\n              "seq": 1,\n              "feeIncluded": false,\n              "optional": true\n            },\n            {\n              "type": "SIGHTSEEING",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "\uC120\uD0DD\uAD00\uAD11-\uC720\uB9AC\uB2E4\uB9AC+\uB300\uD611\uACE1($95)",\n                  "type": null,\n                  "content": "\uAC1C\uC694 : \uC720\uB9AC\uB2E4\uB9AC\uC640 \uB300\uD611\uACE1\uC744 \uD568\uAC8C \uBCFC \uC218 \uC788\uB294 \uC120\uD0DD\uAD00\uAD11",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 1\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 2\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 3\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 4\n                }\n              ],\n              "seq": 2,\n              "feeIncluded": false,\n              "optional": true\n            },\n            {\n              "type": "HOTEL",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": "\uCD1D 2\uAC1C\uC758 \uC608\uC815 \uD638\uD154\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uD655\uC815 \uB418\uB294\uB300\uB85C(\uCD9C\uBC1C 1\uC77C\uC804\uAE4C\uC9C0) \uD648\uD398\uC774\uC9C0, \uC774\uBA54\uC77C \uB610\uB294 \uC54C\uB9BC\uD1A1 \uB4F1\uC744 \uD1B5\uD574 \uC548\uB0B4 \uB4DC\uB9AC\uACA0\uC2B5\uB2C8\uB2E4.",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                }\n              ],\n              "seq": 3,\n              "feeIncluded": true,\n              "optional": false\n            }\n          ]\n        }\n      ]\n    }\n  ],\n  "cancelPolicy": {\n    "notice": "\u2022 \uCDE8\uC18C\uB8CC\uB294 \uCFE0\uD321\uAC00(\uC989\uC2DC\uD560\uC778 \uC801\uC6A9 \uC804 \uC0C1\uD488\uAC00) \uAE30\uC900\uC73C\uB85C \uBD80\uACFC\uB429\uB2C8\uB2E4.(\uC5EC\uD589\uC0AC\uC758 \uADC0\uCC45 \uC0AC\uC720\uB85C \uC778\uD55C \uCDE8\uC18C\uC758 \uACBD\uC6B0\uC5D0\uB3C4 \uB3D9\uC77C\uD558\uAC8C \uC801\uC6A9\uB429\uB2C8\uB2E4.) \u2022 \uC989\uC2DC\uD560\uC778\uC740 \uC0C1\uD669\uC5D0 \uB530\uB77C \uC608\uACE0\uC5C6\uC774 \uD560\uC778\uAE08\uC561\uC758 \uC870\uC815 \uBC0F \uC870\uAE30\uC885\uB8CC \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \u2022 \uC989\uC2DC\uD560\uC778 \uC774\uBCA4\uD2B8\uAC00 \uC885\uB8CC\uB41C \uD6C4\uC5D0\uB294 \uAE30\uC801\uC6A9\uB41C \uC989\uC2DC\uD560\uC778 \uC0C1\uD488\uC744 \uCDE8\uC18C \uD6C4\uC5D0 \uC7AC\uAD6C\uB9E4\uD558\uB354\uB77C\uB3C4 \uD560\uC778 \uC801\uC6A9\uC774 \uC720\uC9C0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \u2022 \uBCF8 \uC0C1\uD488\uC740 \uC608\uC57D \uD6C4 \uCDE8\uC18C\uD560 \uACBD\uC6B0 \uC5EC\uD589\uC57D\uAD00 \uC81C5\uC870 (\uD2B9\uC57D)\uC5D0 \uB530\uB77C \uD45C\uC900\uC57D\uAD00\uACFC\uB294 \uBCC4\uB3C4\uC758 \uCDE8\uC18C\uC218\uC218\uB8CC\uAC00 \uC801\uC6A9\uB429\uB2C8\uB2E4. (\uC774 \uC0C1\uD488\uC740 \uD56D\uACF5(\uB610\uB294 \uC120\uBC15)\uC88C\uC11D \uB610\uB294 \uD638\uD154 \uAC1D\uC2E4\uC5D0 \uB300\uD55C \uBE44\uC6A9\uC744 \uC120\uB0A9\uD574 \uB193\uC740 \uC0C1\uD488\uC73C\uB85C\uC11C, \uCDE8\uC18C\uC2DC \uBCC4\uB3C4\uC758 \uCDE8\uC18C\uC218\uC218\uB8CC\uAC00 \uC801\uC6A9\uB428\uC744 \uC591\uD574 \uBC14\uB78D\uB2C8\uB2E4.) \u2022 \uD574\uD53C\uCF5C\uC744 \uD1B5\uD574 \uC608\uC57D \uD655\uC815 \uD6C4 \uC5EC\uD589\uC790\uC758 \uCDE8\uC18C\uC694\uCCAD \uC2DC \uC5C5\uCCB4\uAC00 \uC815\uD55C \uD2B9\uBCC4\uC57D\uAD00\uC5D0 \uC758\uAC70 \uCDE8\uC18C\uB8CC\uAC00 \uBD80\uACFC\uB429\uB2C8\uB2E4. (\uAD6D\uC678\uC5EC\uD589\uC57D\uAD00 \uC81C5\uC870 \uD2B9\uC57D) \u261E \uCDE8\uC18C\uC218\uC218\uB8CC \uD2B9\uBCC4 \uADDC\uC815 (\u203B \uC804\uC138\uAE30 \uC0C1\uD488 \uBC0F \uC911\uAD6D \uBBFC\uD56D\uAE30 \uC0C1\uD488 \uADDC\uC815\u203B) - \uD574\uD53C\uCF5C \uD655\uC815 \uD6C4 ~30\uC77C \uC774\uC804 \uCDE8\uC18C \uC704\uC57D\uAE08 20\uB9CC\uC6D0 - \uC5EC\uD589\uAC1C\uC2DC 20\uC77C \uC804\uAE4C\uC9C0(29 ~ 20) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 30% \uBC30\uC0C1 - \uC5EC\uD589\uAC1C\uC2DC 10\uC77C \uC804\uAE4C\uC9C0(19 ~ 10) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 55% \uBC30\uC0C1 - \uC5EC\uD589\uAC1C\uC2DC   8\uC77C \uC804\uAE4C\uC9C0( 9 ~   8) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 85% \uBC30\uC0C1 - \uC5EC\uD589\uAC1C\uC2DC   1\uC77C \uC804\uAE4C\uC9C0( 7 ~   1) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 90% \uBC30\uC0C1 - \uC5EC\uD589 \uB2F9\uC77C \uD1B5\uBCF4 \uC2DC : \uC5EC\uD589\uC694\uAE08\uC758 100% \uBC30\uC0C1",\n    "cancelType": "APPROVAL",\n    "cancelPeriodType": "BEFORE_USE",\n    "cancelMarkType": "DEPENDING_ON_VENDOR",\n    "refundOnBusinessDay": true,\n    "refundUnusedTicket": true,\n    "refundRates": [\n      {\n        "conditionDays": 5,\n        "conditionTime": "17:00:00",\n        "refundRate": 100,\n        "cancellable": false\n      },\n      {\n        "conditionDays": 3,\n        "conditionTime": "17:00:00",\n        "refundRate": 70,\n        "cancellable": false\n      },\n      {\n        "conditionDays": 1,\n        "conditionTime": "17:00:00",\n        "refundRate": 50,\n        "cancellable": false\n      }\n    ]\n  },\n  "introduction": "\uC7A5\uAC00\uACC4 \uD56D\uACF5\uC774\uB3D9&\uBC84\uC2A4\uC774\uB3D9 \uC120\uD0DD\uAC00\uB2A5",\n  "notice": "\uB0A0\uC9DC\uB2F9 \uC131\uC778\uAE30\uC900 10\uBA85 \uC774\uC0C1 \uBAA8\uAC1D \uC2DC \uCD9C\uBC1C\uD655\uC815 \uAC00\uB2A5",\n  "benefits": [\n    "Special Offer 1",\n    "Special Offer 2"\n  ],\n  "flightInfo": {\n    "title": "Flight Information",\n    "type": "Flight Info",\n    "content": "\uD56D\uACF5\uD3B8:\uC911\uAD6D\uAD6D\uC81C\uD56D\uACF5\\n\uBB34\uB8CC\uC704\uD0C1\uC218\uD558\uBB3C:1pc 23kg [\uB2E8, \uC0B0\uB3D9\uB178\uC120(\uCCAD\uB3C4, \uC81C\uB0A8, \uC704\uD574, \uC5F0\uD0DC)\uC740 2pc 23kg]\\n\uD5C8\uC6A9\uAE30\uB0B4\uC218\uD558\uBB3C:1pc 5kg\\n",\n    "format": "TEXT",\n    "sellerUrl": null,\n    "sellerUrlMethod": "GET",\n    "seq": 0\n  },\n  "visaInfo": {\n    "title": "\uBE44 \uC790",\n    "type": "VISA Info",\n    "content": null,\n    "format": "IMAGE",\n    "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n    "sellerUrlMethod": "GET",\n    "seq": 0\n  },\n  "meetingPlace": "\uC778\uCC9C\uAD6D\uC81C\uACF5\uD56D 1\uD130\uBBF8\uB110 3\uCE35 \uCD9C\uAD6D\uC7A5 14\uBC88 \uCD9C\uAD6C \uC55E(N\uCE74\uC6B4\uD130 \uC606 \uCC3D\uCE21) \uC5EC\uD589\uC0AC\uCE74\uC6B4\uD130 38~42\uBC88 \uD14C\uC774\uBE14",\n  "meetingTime": "2019-11-01 12:30:00",\n  "meetingNotice": {\n    "title": "Map - Meeting Point",\n    "type": "Meeting Notice",\n    "content": null,\n    "format": "IMAGE",\n    "sellerUrl": "http://image11.coupangcdn.com/image/product/image/vendoritem/2017/02/21/3000169918/34b79649-d625-4f49-a260-b78bf7a573a8.jpg",\n    "sellerUrlMethod": "GET",\n    "seq": 0\n  },\n  "guideInfo": "\uC778\uC194\uC790\uB294 \uB3D9\uBC18\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",\n  "shoppingInfo": {\n    "details": [\n      {\n        "shoppingCategory": "\uB77C\uD14D\uC2A4",\n        "shoppingPlace": "\uBB34\uB989\uC6D0 \uCC9C\uC790\uAC70\uB9AC \uB300\uC9C0\uB77C\uD14D\uC2A4",\n        "duration": "\uC57D 7-80\uBD84",\n        "refundable": false\n      },\n      {\n        "shoppingCategory": "\uC9C4\uC8FC",\n        "shoppingPlace": "\uCC9C\uBB381\uD638 \uC591\uC0C1 \uBC15\uB78C\uC911\uC2EC",\n        "duration": "\uC57D 60\uBD84",\n        "refundable": false\n      },\n      {\n        "shoppingCategory": "\uD788\uB178\uB07C",\n        "shoppingPlace": "\uBB34\uB989\uC6D0 \uBCF4\uBD09\uC0B0\uC7A5 \uB0B4 \uD788\uB178\uB07C \uB9E4\uC7A5",\n        "duration": "\uC57D 60\uBD84",\n        "refundable": false\n      },\n      {\n        "shoppingCategory": "\uAC8C\uB974\uB9C8\uB284",\n        "shoppingPlace": "\uBB34\uB989\uC6D0\uAD6C \uBC31\uB85C\uB85C \uAC74\uC124\uC740\uD589 \uD6C4\uC6D0",\n        "duration": "\uC57D 60\uBD84",\n        "refundable": true\n      }\n    ],\n    "exchangeRefundNotice": {\n      "title": null,\n      "type": "Exchange Refund Notice",\n      "content": "? \uD658\uBD88\uC811\uC218\uAE30\uAC04 : \uC5EC\uD589\uC885\uB8CC \uD6C4 30\uC77C \uC774\uB0B4\\n? \uD658\uBD88\uAC00\uB2A5\uBB3C\uD488 : \uC9C0\uC815\uB41C \uC1FC\uD551\uC7A5\uC18C\uC5D0\uC11C \uAD6C\uB9E4\uD55C \uBB3C\uD488,\uAC1C\uC778 \uAD6C\uB9E4 \uBB3C\uD488 \uD639\uC740 \uB2E8\uC21C \uACE0\uAC1D \uBCC0\uC2EC\uC758 \uAD50\uD658/\uD658\uBD88 \uB300\uD589 \uBD88\uAC00\\n? \uD658\uBD88\uC694\uCCAD\uBC29\uBC95 : \uC5EC\uD589\uC0C1\uD488\uBA85,\uCD9C\uBC1C\uC77C,\uC778\uC194\uC790\uBA85,\uAC04\uB2E8\uD55C \uC0AC\uC720\uB97C \uB300\uB9AC\uC810 \uD639\uC740 \uC608\uC57D\uB2F4\uB2F9\uC790\uC5D0\uAC8C \uC720\uC120 \uBB38\uC758 \uD6C4 \uC870\uCE58\\n? \uD658\uBD88\uD544\uC694\uC11C\uB958 : \uBCF8\uC778 \uC5F0\uB77D\uCC98/\uD1B5\uC7A5\uBC88\uD638(\uC218\uCDE8\uC778 \uBCF8\uC778\uB9CC \uAC00\uB2A5),\uC6D0\uBCF8 \uC601\uC218\uC99D(\uC0AC\uBCF8 \uBCF4\uAD00 \uD544\uC218),\uD658\uBD88 \uD639\uC740 \uAD50\uD658 \uC694\uCCAD \uBB3C\uD488\\n? \uD658\uBD88\uBC30\uC1A1\uBE44\uBD80\uB2F4 : \uACE0\uAC1D\uBCF8\uC778\\n? \uD658\uBD88\uC18C\uC694\uAE30\uAC04 : \uC811\uC218\uC77C\uB85C\uBD80\uD130 \uCD5C\uC18C 15\uC77C ~ \uCD5C\uB300 60\uC77C\\n\u25CE\uD658\uBD88\uC2DC \uC8FC\uC758\uC0AC\uD56D\u25CE\\n-\uD658\uBD88\uC218\uC218\uB8CC: \uCE74\uB4DC\uACB0\uC81C\uC778 \uACBD\uC6B0 \uD658\uBD88\uC2DC \uCE74\uB4DC\uC218\uC218\uB8CC 5% \uBD80\uACFC (\uD658\uBD88\uC218\uC218\uB8CC\uB294 \uC0C1\uD488 \uBC0F \uC1FC\uD551\uC810 \uAE30\uC900\uC5D0 \uB530\uB77C \uC0C1\uC774\uD558\uBA70, \uC601\uC218\uC99D \uBBF8\uC9C0\uCC38\uC2DC \uD658\uBD88 \uBD88\uAC00)\\n-\uC720\uC758\uC0AC\uD56D\\n1)\uBCF4\uC11D\uB958\\n\uC131\uBD84\uD568\uB7C9\uC774 \uBBF8\uB2EC\uB418\uB294 \uC81C\uD488\uC774 \uB9CE\uC73C\uB2C8, \uACE0\uAC00\uC758 \uC0C1\uD488\uC740 \uAD6C\uC785\uC744 \uC790\uC81C\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n2)\uB77C\uD14D\uC2A4\\n\uD3EC\uC7A5\uC774 \uC81C\uAC70\uB418\uC9C0 \uC54A\uC740 \uC81C\uD488\uC77C\uACBD\uC6B0 100% \uD658\uBD88 \uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n30\uC77C \uC774\uB0B4\uC5D0 \uB2E8\uC21C\uBCC0\uC2EC\uC73C\uB85C \uC778\uD55C \uD658\uBD88\uC2DC \uAD6C\uB9E4\uAE08\uC561\uC758 30% \uD658\uBD88\uC218\uC218\uB8CC \uBC1C\uC0DD\\n90\uC77C \uC774\uB0B4\uC5D0 \uB2E8\uC21C\uBCC0\uC2EC\uC73C\uB85C \uC778\uD55C \uD658\uBD88\uC2DC \uAD6C\uB9E4\uAE08\uC561\uC758 50% \uD658\uBD88\uC218\uC218\uB8CC \uBC1C\uC0DD\\n\uD604\uC9C0\uC5D0\uC11C \uBC30\uC1A1\uBC1B\uB294 \uACBD\uC6B0 \uBCC4\uB3C4\uC758 \uBC30\uC1A1\uBE44\uAC00 \uBD80\uACFC\\n3)\uAC8C\uB974\uB9C8\uB284\\n\uD658\uBD88\uC2DC \uC54C\uB808\uB974\uAE30 \uBC1C\uC0DD\uC740 \uAD6C\uB9E4\uC77C\uB85C\uBD80\uD130 7\uC77C \uB0B4\uC5D0 \uD658\uBD88\uC2E0\uCCAD, \uADF8 \uC678\uC758 \uD658\uBD88\uC740 \uAD6C\uB9E4\uC77C\uB85C\uBD80\uD130 15\uC77C \uB0B4\uC5D0 \uD658\uBD88 \uC2E0\uCCAD\\n\uD658\uBD88\uC2DC 5% \uCE74\uB4DC\uC218\uC218\uB8CC + 10% \uC704\uC57D\uAE08 \uBC1C\uC0DD\\n\uB3C4\uAE08\uBCC0\uC0C9\uC740 A/S \uBD88\uAC00\\n4)\uB18D\uC218\uC0B0\uBB3C(\uAE68,\uC7A3 \uB4F1)\\n\uAD50\uD658 \uBC0F \uD658\uBD88 \uC808\uB300 \uBD88\uAC00\\n",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 0\n    }\n  },\n  "tourGuides": [\n    {\n      "title": "\uC120\uD0DD\uAD00\uAD11 \uC548\uB0B4",\n      "type": "Tour Guide",\n      "content": "1. \uC120\uD0DD\uAD00\uAD11 \uBC0F \uC790\uC720\uC2DC\uAC04 \uC911 \uACE0\uAC1D\uB2D8\uC758 \uC548\uC804\uC744 \uC704\uD558\uC5EC \uAC00\uC774\uB4DC\uC758 \uC548\uB0B4\uC0AC\uD56D \uBC0F \uC548\uC804\uC218\uCE59\uC744 \uC900\uC218\uD558\uC5EC \uBAA8\uB4E0 \uC548\uC804\uC0AC\uACE0\uC5D0 \uC720\uC758\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n2. \uD604\uC9C0 \uC120\uD0DD\uAD00\uAD11\uC740 \uAC00\uC774\uB4DC\uC758 \uC8FC\uC758\uC0AC\uD56D\uC744 \uC219\uC9C0 \uD6C4 \uCC38\uC5EC \uC5EC\uBD80\uB97C \uACB0\uC815\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB77C\uBA70, \uCC38\uC5EC \uC804 \uBC18\uB4DC\uC2DC \uBC30\uD3EC\uB418\uB294 \uC548\uC804\uC218\uCE59 \uB3D9\uC758\uC11C\uB97C \uC219\uC9C0 \uBC0F \uB3D9\uC758 \uD6C4 \uCC38\uC5EC\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n3. \uC774\uC6A9\uC790 \uBCF8\uC778\uC758 \uACFC\uC2E4 \uBC0F \uAC74\uAC15\uC0C1\uD0DC\uB85C \uC778\uD558\uC5EC \uBC1C\uC0DD\uD55C \uC548\uC804\uC0AC\uACE0\uC5D0 \uB300\uD558\uC5EC \uB2F9\uC0AC\uB294 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\\n4. \uC120\uD0DD\uAD00\uAD11\uC740 \uACE0\uAC1D\uB2D8\uC774 \uC790\uC720\uB86D\uAC8C \uC9C0\uBD88\uC5EC\uBD80\uB97C \uACB0\uC815\uD560 \uC218 \uC788\uC73C\uBA70 \uC120\uD0DD\uAD00\uAD11\uC5D0 \uCC38\uC5EC\uD558\uC9C0 \uC54A\uC74C\uC73C\uB85C \uC778\uD55C \uCD94\uAC00\uC801\uC778 \uBE44\uC6A9 \uB610\uB294 \uC77C\uC815\uC0C1\uC758 \uBD88\uC774\uC775\uC740 \uC5C6\uC2B5\uB2C8\uB2E4.\\n",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 0\n    },\n    {\n      "title": "Tour Guide",\n      "type": "Tour Guide",\n      "content": "\u25C7 \uBBF8\uD305\uC7A5\uC18C : \uC778\uCC9C\uAD6D\uC81C\uACF5\uD56D \uC81C1\uD130\uBBF8\uB110 3\uCE35 N\uCE74\uC6B4\uD130(14\uBC88 \uCD9C\uC785\uBB38) \uC55E <\uD22C\uC5B42000> \uD14C\uC774\uBE14 \uBBF8\uD305\\n\u25C7 \uC778\uCC9C\uACF5\uD56D : \uC778\uCC9C\uACF5\uD56D \uC5F0\uB77D\uCC98 010-2742-6200\\n\u25C7 \uCD5C\uC18C \uCD9C\uBC1C \uC778\uC6D0 : \uC131\uC77810\uBA85 \uC774\uC0C1 \uCD9C\uBC1C \uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n\u25C7 \uCD9C\uBC1C\uC778\uC6D0\uC774 \uBD80\uC871\uD560 \uACBD\uC6B0 \uD0C0\uC0AC\uC640 \uACF5\uB3D9 \uC9C4\uD589 \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\u25C7 \uC778\uC194\uC790\uB294 \uB3D9\uD589\uD558\uC9C0 \uC54A\uC73C\uBA70, \uD604\uC9C0 \uB3C4\uCC29 \uD6C4 \uAC00\uC774\uB4DC\uC640 \uBBF8\uD305 \uD569\uB2C8\uB2E4.\\n\u25C7 \uB3C5\uC2E4\uC0AC\uC6A9\uB8CC : 1\uBC15 40,000\uC6D0(\uC804 \uC77C\uC815 3\uBC15 120,000\uC6D0) \uC785\uB2C8\uB2E4.\\n- \uD638\uD154: 2\uC7781\uC2E4 \uAE30\uC900\uC774\uBA70, 3\uC778\uC2E4 \uC774\uC6A9\uC2DC \uAC04\uC774\uCE68\uB300\uAC00 \uC81C\uACF5 \uB429\uB2C8\uB2E4.\\n- \uC5EC\uD589 \uD558\uC2DC\uB294 \uC778\uC6D0\uC774 \uD640\uC218\uC778 \uACBD\uC6B0 \uBCC4\uB3C4\uC758 \uC694\uCCAD\uC774 \uC5C6\uC73C\uC2E4 \uACBD\uC6B0 3\uC7781\uC2E4\uB85C \uBC30\uC815 \uB429\uB2C8\uB2E4.\\n\u25C7 \uC790\uC720\uC77C\uC815 : \uD328\uD0A4\uC9C0\uC77C\uC815\uC758 \uD2B9\uC131\uC0C1 \uAC1C\uBCC4\uC77C\uC815 \uBD88\uAC00\uD569\uB2C8\uB2E4.\\n\u25C7 \uC77C\uC815 \uC9C4\uD589 \uC911 \uC1FC\uD551\uC810 \uBC29\uBB38\uC774 \uC788\uC2B5\uB2C8\uB2E4.(*\uC1FC\uD551\uC815\uBCF4 \uCC38\uC870)\\n\u25C7 \uC5EC\uD589\uC790 \uBCF4\uD5D8\uC740 \'DB \uC190\uD574\uBCF4\uD5D8\'\uC73C\uB85C \uC790\uB3D9 \uAC00\uC785 \uB429\uB2C8\uB2E4. (*\uC5EC\uD589\uC790\uBCF4\uD5D8 \uCC38\uC870)\\n\u25C7 \uBCF8 \uC5EC\uD589\uC0C1\uD488\uC740 \uACC4\uC57D\uAE08 \uC9C0\uBD88 \uC2DC\uC810\uBD80\uD130 \uACC4\uC57D\uC774 \uCCB4\uACB0\uB418\uBA70, \uACC4\uC57D \uD574\uC81C \uC694\uCCAD \uC2DC \uADC0\uCC45\uC0AC\uC720\uC5D0 \uB530\uB77C \uCDE8\uC18C\uC218\uC218\uB8CC\uAC00 \uBD80\uACFC\uB429\uB2C8\uB2E4. \uCDE8\uC18C\uC218\uC218\uB8CC \uBD80\uACFC\uAE30\uC900\uC740 [\uAD6D\uC678\uC5EC\uD589\uD45C\uC900\uC57D\uAD00/\uD2B9\uBCC4\uC57D\uAD00]\uC5D0 \uB530\uB985\uB2C8\uB2E4.\\n\u25C7 \uC0C1\uAE30 \uC77C\uC815\uC740 \uD56D\uACF5 \uBC0F \uD604\uC9C0\uC0AC\uC815\uC5D0 \uC758\uD558\uC5EC \uBCC0\uACBD\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\u25C7 \uC720\uB958\uD560\uC99D\uB8CC\uB294 \uC608\uC57D\uC2DC\uC810\uC774 \uC544\uB2CC \uBC1C\uAD8C\uC77C \uAE30\uC900\uC73C\uB85C \uC801\uC6A9\uB418\uBA70, \uAD6D\uC81C\uC720\uAC00\uC640 \uD56D\uACF5\uC0AC \uC601\uC5C5\uD658\uACBD\uC744 \uACE0\uB824\uD55C \uAC74\uC124\uAD50\uD1B5\uBD80\uC758 \uAD6D\uC81C\uC120 \uD56D\uACF5\uC694\uAE08\uACFC \uC720\uB958\uD560\uC99D\uB8CC \uD655\uB300\uBC29\uC548\uC5D0 \uB530\uB77C \uC608\uACE0\uC5C6\uC774 \uC778\uC0C1\uB418\uAC70\uB098 \uC778\uD558\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 1\n    }\n  ],\n  "safetyInstructions": [\n    {\n      "title": "\uC5EC\uD589\uAE08\uC9C0\uAD6D\uAC00 \uD604\uD669 \uBC0F \uBC95\uC801\uADFC\uAC70",\n      "type": "Safety Instruction",\n      "content": "\u25CF \uC5EC\uD589\uAE08\uC9C0\uAD6D\uAC00 \uC9C0\uC815 \uD604\uD669\\n\uC678\uAD50\uBD80\uB294 \uC6B0\uB9AC \uAD6D\uBBFC\uC758 \uC0DD\uBA85\xB7\uC548\uC804\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD558\uC5EC \uC5EC\uAD8C\uBC95 \uC81C 17\uC870\uC5D0 \uB530\uB77C \uC544\uB798\uC758 \uAD6D\uAC00\uB4E4\uC740 \uC9C0\uC815\uB41C \uAE30\uAC04 \uB3D9\uC548 \uC5EC\uD589\uAE08\uC9C0\uAD6D\uC73C\uB85C \uC9C0\uC815\uD558\uC5EC \uC6B0\uB9AC \uAD6D\uBBFC\uB4E4\uC758 \uBC29\uBB38 \uBC0F \uCCB4\uB958\uB97C \uAE08\uC9C0\uD569\uB2C8\uB2E4.\\n- \uC774\uB77C\uD06C(2007\uB144 8\uC6D4 7\uC77C ~ 2017\uB144 1\uC6D431\uC77C\uAE4C\uC9C0)\\n- \uC18C\uB9D0\uB9AC\uC544\xB7\uC544\uD504\uAC00\uB2C8\uC2A4\uD0C4(2007\uB144 8\uC6D4 7\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uC608\uBA58(2011\uB144 6\uC6D4 28\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uC2DC\uB9AC\uC544(2011\uB144 8\uC6D4 20\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uB9AC\uBE44\uC544(2014\uB144 8\uC6D4 4\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uD544\uB9AC\uD540 \uC77C\uBD80\uC9C0\uC5ED(\uC7A0\uBCF4\uC559\uAC00, \uC220\uB8E8 \uAD70\uB3C4, \uBC14\uC2E4\uB780, \uD0C0\uC704\uD0C0\uC704 \uAD70\uB3C4) (2015\uB144 12\uC6D4 1\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n\u25CF \uBC95\uC801\uADFC\uAC70\\n- \uC5EC\uAD8C\uBC95 17\uC870(\uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uC81C\uD55C \uB4F1)\\n\uC678\uAD50\uBD80\uC7A5\uAD00\uC740 \uCC9C\uC7AC\uC9C0\uBCC0\xB7\uC804\uC7C1\xB7\uB0B4\uB780\xB7\uD3ED\uB3D9\xB7\uD14C\uB7EC \uB4F1 \uB300\uD1B5\uB839\uB839\uC73C\uB85C \uC815\uD558\uB294 \uAD6D\uC678 \uC704\uB09C\uC0C1\uD669(\u5371\u96E3\u72C0\u6CC1)\uC73C\uB85C \uC778\uD558\uC5EC \uAD6D\uBBFC\uC758 \uC0DD\uBA85\xB7\uC2E0\uCCB4\uB098 \uC7AC\uC0B0\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD558\uC5EC \uAD6D\uBBFC\uC774 \uD2B9\uC815 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC744 \uBC29\uBB38\uD558\uAC70\uB098 \uCCB4\uB958\uD558\uB294 \uAC83\uC744 \uC911\uC9C0\uC2DC\uD0A4\uB294 \uAC83\uC774 \uD544\uC694\uD558\uB2E4\uACE0 \uC778\uC815\uD558\uB294 \uB54C\uC5D0\uB294 \uAE30\uAC04\uC744 \uC815\uD558\uC5EC \uD574\uB2F9 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC5D0\uC11C\uC758 \uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uC744 \uC81C\uD55C\uD558\uAC70\uB098 \uBC29\uBB38\xB7\uCCB4\uB958\uB97C \uAE08\uC9C0 (\uC774\uD558 \\"\uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uC81C\uD55C \uB4F1\\"\uC774\uB77C \uD55C\uB2E4)\uD560\uC218 \uC788\uB2E4. \uB2E4\uB9CC, \uC601\uC8FC(\u6C38\u4F4F), \uCDE8\uC7AC\xB7\uBCF4\uB3C4, \uAE34\uAE09\uD55C \uC778\uB3C4\uC801 \uC0AC\uC720, \uACF5\uBB34 \uB4F1 \uB300\uD1B5\uB839\uB839\uC73C\uB85C \uC815\uD558\uB294 \uBAA9\uC801\uC758 \uC5EC\uD589\uC73C\uB85C\uC11C \uC678\uAD50\uBD80\uC7A5\uAD00\uC774 \uD544\uC694\uD558\uB2E4\uACE0 \uC778\uC815\uD558\uBA74 \uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uACFC \uBC29\uBB38\xB7\uCCB4\uB958\uB97C \uD5C8\uAC00\uD560 \uC218 \uC788\uB2E4.\\n- \uC5EC\uAD8C\uBC95 \uC81C26\uC870 \uC81C17\uC870\uC81C1\uD56D \uBCF8\uBB38 \uBC0F \uC81C2\uD56D\uC5D0 \uB530\uB77C \uBC29\uBB38 \uBC0F \uCCB4\uB958\uAC00 \uAE08\uC9C0\uB41C \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC73C\uB85C \uACE0\uC2DC\uB41C \uC0AC\uC815\uC744 \uC54C\uBA74\uC11C\uB3C4 \uAC19\uC740 \uC870 \uC81C1\uD56D \uB2E8\uC11C\uC5D0 \uB530\uB978 \uD5C8\uAC00(\uC81C14\uC870\uC81C3\uD56D\uC5D0 \uB530\uB77C \uC900\uC6A9\uB418\uB294 \uACBD\uC6B0\uB97C \uD3EC\uD568\uD55C\uB2E4)\uB97C \uBC1B\uC9C0 \uC544\uB2C8\uD558\uACE0 \uD574\uB2F9 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC5D0\uC11C \uC5EC\uAD8C \uB4F1\uC744 \uC0AC\uC6A9\uD558\uAC70\uB098 \uD574\uB2F9 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC744 \uBC29\uBB38\uD558\uAC70\uB098 \uCCB4\uB958\uD55C \uC0AC\uB78C\uC740 1\uB144 \uC774\uD558\uC758 \uC9D5\uC5ED \uB610\uB294 1000\uB9CC\uC6D0 \uC774\uD558\uC758 \uBC8C\uAE08\uC5D0 \uCC98\uD55C\uB2E4.\\n",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 0\n    },\n    {\n      "title": "\uC5EC\uD589\uC9C0(\uAD6D\uAC00/\uC9C0\uC5ED) \uC5EC\uD589\uACBD\uBCF4 \uBC1C\uB839\uD604\uD669",\n      "type": "Safety Instruction",\n      "content": "\u25CF \uC911\uAD6D\\n- \uC5EC\uD589\uC720\uC758(\uC77C\uBD80) : \uC911\uAD6D\u318D\uBD81\uD55C \uAD6D\uACBD\uC9C0\uC5ED : \uB2E8\uB465\uC2DC, \uAD00\uC804\uB9CC\uC871\uC790\uCE58\uD604, \uC9D1\uC548\uC2DC, \uBC31\uC0B0\uC2DC, \uC784\uAC15\uC2DC, \uC7A5\uBC31\uC870\uC120\uC871\uC790\uCE58\uD604, \uC548\uB3C4\uD604, \uD654\uB8E1\uC2DC, \uC6A9\uC815\uC2DC, \uB3C4\uBB38\uC2DC, \uD6C8\uCD98\uC2DC\\n- \uC5EC\uD589\uC790\uC81C(\uC77C\uBD80) : \uD2F0\uBCB3, \uC2E0\uC7A5\uC704\uAD6C\uB974\uC790\uCE58\uAD6C\\n\uC678\uAD50\uBD80\uB294 \uC6B0\uB9AC \uAD6D\uBBFC\uC758 \uC0DD\uBA85\xB7\uC548\uC804\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD558\uC5EC \uC5EC\uAD8C\uBC95 \uC81C 17\uC870\uC5D0 \uB530\uB77C \uC544\uB798\uC758 \uAD6D\uAC00\uB4E4\uC740 \uC9C0\uC815\uB41C \uAE30\uAC04 \uB3D9\uC548 \uC5EC\uD589\uAE08\uC9C0\uAD6D\uC73C\uB85C \uC9C0\uC815\uD558\uC5EC \uC6B0\uB9AC \uAD6D\uBBFC\uB4E4\uC758 \uBC29\uBB38 \uBC0F \uCCB4\uB958\uB97C \uAE08\uC9C0\uD569\uB2C8\uB2E4.\\n\u203B \uC5EC\uD589\uACBD\uBCF4\uB2E8\uACC4\uB294 \uC5EC\uD589\uC720\uC758/\uC790\uC81C/\uC81C\uD55C/\uAE08\uC9C0 4\uB2E8\uACC4\uB85C \uAD6C\uBD84\uB418\uBA70, \uC678\uAD50\uBD80 \'\uD574\uC678\uC548\uC804\uC5EC\uD589\' \uC0AC\uC774\uD2B8(www.0404.go.kr)\uC5D0\uC11C \uC0C1\uC138\uC815\uBCF4\uB97C \uD655\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\uB610\uD55C \uCD9C\uAD6D \uC804 \uB3D9\uC0AC\uC774\uD2B8\uC758 \uD574\uC678\uC5EC\uD589 \uB4F1\uB85D\uC81C \\"\uB3D9\uD589\\"\uC5D0 \uAC00\uC785\uD558\uC2DC\uBA74 \uC548\uC804\uC815\uBCF4\uB97C \uC218\uC2DC\uB85C \uC81C\uACF5 \uBC1B\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 1\n    }\n  ],\n  "hotelInfo": {\n    "title": "Hotel Information",\n    "type": "Hotel Information",\n    "content": "\u2022 \uD638\uD154\uBA85 :\\n\u2022 \uB4F1\uAE09 : \\n\u2022 \uB8F8\uD0C0\uC785 : \\n\u2022 1\uC778 \uC2F1\uAE00 \uB8F8 \uC0AC\uC6A9\uC2DC :\\n- \uD638\uD154\uC740 \uBD80\uB4DD\uC774\uD55C \uACBD\uC6B0 \uB3D9\uAE09\uC758 \uB2E4\uB978 \uD638\uD154\uB85C \uBCC0\uB3D9 \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n",\n    "format": "TEXT",\n    "sellerUrl": null,\n    "sellerUrlMethod": "GET",\n    "seq": 0\n  },\n  "insuranceInfo": null,\n  "inclusionNotice": "\uC655\uBCF5 \uD56D\uACF5\uAD8C \uD3EC\uD568 -\\n\uC720\uB958\uD560\uC99D\uB8CC \uBC0F \uAC01\uC885 TAX(\uC655\uBCF5\uACF5\uD56D\uC138, \uC804\uC7C1\uBCF4\uD5D8\uB8CC, \uAD00\uAD11\uC9C4\uD765\uAC1C\uBC1C\uAE30\uAE08 \uB4F1) \uD3EC\uD568:   XXX\uD56D\uACF5 00,\\n000 \uC6D0(\uC131\uC778 / \uC18C\uC544 \uB3D9\uC77C) -\\n\uC720\uB958\uD560\uC99D\uB8CC\uB294 \uAD6D\uC81C \uC720\uAC00 \uBC0F IATA\uAD6D\uC81C\uD56D\uACF5\uC218\uC1A1\uD611\uD68C\uC758 \uACF5\uC2DC \uD658\uC728\uC5D0 \uB530\uB77C \uBCC0\uB3D9 \uB420 \uC218 \uC788\uC74C. \uBCC0\uB3D9\uC5D0 \uB530\uB77C \uCD94\uAC00\uC694\uAE08\uC774 \uBC1C\uC0DD\uB420 \uC218 \uC788\uC73C\uBA70,\\n\uCD94\uAC00\uC694\uAE08 \uBC1C\uC0DD\uC758 \uACBD\uC6B0 \uD574\uD53C\uCF5C\uC2DC \uC548\uB0B4\uB4DC\uB9BD\uB2C8\uB2E4.\u2022\uC804 \uC77C\uC815 \uC219\uBC15 \uBE44\uC6A9(\uC131\uC778 2 \uC778 1 \uC2E4 \uAE30\uC900)\u2022 \uC77C\uC815\uD45C\uC0C1 \uAE30\uC81C\uB41C \uAD00\uAD11\uC9C0 \uC785\uC7A5\uB8CC \uBC0F \uC2DD\uC0AC\u2022 \uC77C\uC815 \uC911 \uC804\uC6A9\uCC28\uB7C9 \uBC0F \uAE30\uC0AC\u2022 \uC5EC\uD589\uC790 \uBCF4\uD5D8\u2022 \uAC01\uC885 \uD2B9\uC804 \uC81C\uACF5(\uCEE8\uD150\uCE20 \uC0C1\uC138\uD398\uC774\uC9C0 \uCC38\uC870)\\n---111111",\n  "exclusionNotice": "1 \uC778\uB2F9 \uC804\uC77C\uC815 $00 (0 \uBC150\uC77C) \uC758 \uAC00\uC774\uB4DC / \uAE30\uC0AC \uACBD\uBE44 \uD604\uC9C0 \uC9C0\uBD88(\uC131\uC778 / \uC544\uB3D9 \uB3D9\uC77C)\u2022 \uC120\uD0DD \uAD00\uAD11 \uACBD\uBE44 \uBC0F \uAE30\uD0C0 \uAC1C\uC778\uACBD\uBE44 -\\n\uC120\uD0DD \uAD00\uAD11\uC740 \uC790\uC720\uC758\uC0AC\uB85C \uBBF8 \uC120\uD0DD\uC5D0 \uB530\uB978 \uBD88\uC774\uC775 \uBC0F \uCD94\uAC00\uAE08\uC740 \uC5C6\uC2B5\uB2C8\uB2E4.\\n---111111",\n  "usageNotice": "\uC544\uB3D9(24 \uAC1C\uC6D4\uC774\uC0C1~\uB9CC12\uC138\uBBF8\uB9CC) \uC694\uAE08: \uC131\uC778\uACFC \uB3D9\uC77C -\\n\uD56D\uACF5 \uC88C\uC11D \uC788\uC74C,\\n\uC131\uC778\uACFC \uD55C\uBC29 \uC0AC\uC6A9\u2022 \uC720\uC544(24 \uAC1C\uC6D4\uBBF8\uB9CC) \uC694\uAE08: 000,\\n000 \uC6D0 / \uC778 -\\n\uBCC4\uB3C4\uC758 \uD56D\uACF5\uC88C\uC11D \uC5C6\uC74C,\\n\uB178\uBCA0\uB4DC \uC870\uAC74(\uC5EC\uD589\uC0AC\uC5D0 \uC9C1\uC811 \uACB0\uC81C) \u2022 \uC5EC\uAD8C \uC720\uD6A8\uAE30\uAC04\uC740 6 \uAC1C\uC6D4 \uC774\uC0C1 \uB0A8\uC544 \uC788\uC5B4\uC57C \uD569\uB2C8\uB2E4.\u2022\uB2E8\uC218\uC5EC\uAD8C\uC758 \uACBD\uC6B0 \uBCC4\uB3C4 \uBB38\uC758 \uBD80\uD0C1 \uB4DC\uB9BD\uB2C8\uB2E4.\u2022\uD574\uD53C\uCF5C\uC2DC \uC5EC\uD589\uC0AC\uC5D0 \uC815\uD655\uD55C \uC5EC\uAD8C\uC0C1\uC758 \uC601\uBB38\uC774\uB984\uC744 \uC54C\uB824\uC8FC\uC154\uC57C \uD569\uB2C8\uB2E4.\u2022\uBCF8 \uC0C1\uD488\uC740 \uC1FC\uD551\uC13C\uD130 0 \uD68C(XX, XX, XX \uC911 0 \uD68C) \uBC29\uBB38 \uC608\uC815\\n---111111",\n  "reservationGuide": {\n    "title": null,\n    "type": "Reservation Guide",\n    "content": "\u2022 \uCD9C\uBC1C\uC870\uAC74\\n-  \uB0A0\uC9DC\uB2F9 \uC131\uC778\uAE30\uC900 0\uBA85 \uC774\uC0C1 \uBAA8\uAC1D \uC2DC \uCD9C\uBC1C\uD655\uC815 \uAC00\uB2A5\\n- \uCFE0\uD321\uACFC \uC5C5\uCCB4\uC758 \uBAA8\uAC1D\uC778\uC6D0\uC744 \uD569\uC0B0\uD55C \uCD5C\uC18C\uC778\uC6D0\\n- \uCD5C\uC18C\uC778\uC6D0 \uBBF8\uB2EC \uC2DC \uCD9C\uBC1C 7\uC77C\uC804\uAE4C\uC9C0 \uC5EC\uD589 \uCDE8\uC18C \uD1B5\uC9C0\\n\u2022 \uC5EC\uD589\uC9C0 \uC548\uC804\uC815\uBCF4: \uAD6D\uAC00\uBCC4 \uC5EC\uD589\uACBD\uBCF4 \uB2E8\uACC4 \uBCF4\uAE30 (http://www.0404.go.kr/dev/main.mofa)",\n    "format": "TEXT",\n    "sellerUrl": null,\n    "sellerUrlMethod": "GET",\n    "seq": 0\n  },\n  "additionalInfoPrompt": "please leave your phone number,dob,name and gender",\n  "maxPurchaseQuantity": 1000,\n  "csContactInfo": "\uD3C9\uC77C 09: 00~18: 00(\uB2E8, \uD1A0 / \uC77C, \uACF5\uD734\uC77C\uC740 \uD734\uBB34)",\n  "taxType": "TAX",\n  "instantBooking": false,\n  "estimatedBookingDuration": 1,\n  "extension": null\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "code": "200",\n            "message" : "success",\n            "data": 315854700\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesForUpdateProduct' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesForUpdateProduct', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel-body' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC774\uB118 \uD0C0\uC785 ',
	                                            '${enumClazz.getSimpleName()}',
	                                            '\uC5D0 \uB300\uD55C \uBB34\uD6A8 \uBB38\uC790\uC5F4 \uAC12'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'images\uAC00 \uBE44\uC5B4\uC788\uC744 \uC218 \uC5C6\uC74C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBCF5\uC81C \uB41C \uC774\uBBF8\uC9C0 \uACBD\uB85C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uB300\uD45C \uC774\uBBF8\uC9C0 \uB2E8 \uD55C\uC7A5\uB9CC \uD5C8\uC6A9 \uAC00\uB2A5'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uAD6D\uB0B4 \uC5EC\uD589\uC5D0 \uB300\uD55C locations\uAC00 \uBE44\uC5B4\uC788\uC73C\uBA74 \uC548\uB428'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'landNumberAddress\uC911 \uD558\uB098\uC640 roadNameAddress\uB97C \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 seqs'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uAC00 \uC544\uB2CC \uACBD\uC6B0 content\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uC778 \uACBD\uC6B0 sellerUrl\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'title\uC744 \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 theme'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'instantBooking\uC774 false\uC778 \uACBD\uC6B0 estimatedBookingDuration\uC7740\uBCF4\uB2E4 \uD06C\uACE0 72\uBCF4\uB2E4 \uC791\uAC70\uB098 \uAC19\uC544\uC57C\uB428'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC5F0\uB77D\uCC98\uC5D0 \uB300\uD45C \uC804\uD654 \uBC88\uD638\uAC00 \uD558\uB098 \uC788\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour feature id'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour feature value'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 \uC77C\uC790/\uC2DC\uAC04 \uD3EC\uB9F7, \uD3EC\uB9F7\uC774 ',
	                                            '{pattern}',
	                                            '\uC774\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC911\uBCF5 \uCDE8\uC18C \uD658\uBD88\uC728refund rates'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateTourProduct;
	}(_react2.default.Component);
	
	exports.default = UpdateTourProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateTourProduct.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 4302779376677864:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.resetIdCounter = exports.Tabs = exports.TabPanel = exports.TabList = exports.Tab = undefined;
	
	var _Tabs = __webpack_require__(2665048300771620);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabList = __webpack_require__(228970576441975);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _Tab = __webpack_require__(7925919092148657);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabPanel = __webpack_require__(7121215342470674);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	var _uuid = __webpack_require__(6985462053439918);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tab = _Tab2.default;
	exports.TabList = _TabList2.default;
	exports.TabPanel = _TabPanel2.default;
	exports.Tabs = _Tabs2.default;
	exports.resetIdCounter = _uuid.reset;

/***/ }),

/***/ 4387242569932491:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewTicketDetails = function (_React$Component) {
	    _inherits(ViewTicketDetails, _React$Component);
	
	    function ViewTicketDetails(props) {
	        _classCallCheck(this, ViewTicketDetails);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewTicketDetails.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uD2F0\uCF13 \uC0C1\uC138 \uC815\uBCF4 \uC870\uD68C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uD2F0\uCF13\uC5D0 \uB300\uD55C \uC0C1\uC138 \uC815\uBCF4\uB97C \uC870\uD68C \uD569\uB2C8\uB2E4. \uC774 API\uB97C \uC774\uC6A9\uD574 \uD558\uB098\uC758 \uD2F0\uCF13 \uC815\uBCF4\uB97C \uAC00\uC838\uC62C \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/',
	                                '{ticketNumber}',
	                                '?dealId=',
	                                '{dealId}',
	                                '&optionId=',
	                                '{optionId}',
	                                '&quantity=',
	                                '{quantity}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/7000000000151?dealId=300000001&optionId=3100000001&quantity=1'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Query String Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'quantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9 \uAC00\uB2A5 \uC218\uB7C9'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'redeemable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9 \uCC98\uB9AC \uAC00\uB2A5 \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'purchasedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'canceledAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'statusType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '"CANCEL_COMPLETE" : \uCDE8\uC18C\uC644\uB8CC\uC0C1\uD0DC',
	                                _react2.default.createElement('br', null),
	                                '"PURCHASE_COMPLETE" : \uAD6C\uB9E4\uC644\uB8CC\uC0C1\uD0DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'useAmount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9 \uAC00\uB2A5 \uC218\uB7C9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'totalAmount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD1D \uC0AC\uC6A9\uC218\uB7C9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uAC00\uACA9'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n\t{\n\t\t"code" : "0000",\n\t\t"message" : "success",\n\t\t"ticket" : {\n\t\t\t"useAmount" : 0,\n\t\t\t"totalAmount" : 1,\n\t\t\t"ticketNumber" : "8231E1-13000000000768",\n\t\t\t"statusType" : "PURCHASE_COMPLETE",\n\t\t\t"redeemable" : false,\n\t\t\t"price" : 0,\n\t\t\t"optionId" : 53000424937,\n\t\t\t"dealId" : 6500124650,\n\t\t\t"purchasedAt" : "2017-05-23 23:19:21",\n\t\t\t"canceledAt" : null\n\t\t}\n\t}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0000'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'success'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9 \uCC98\uB9AC \uC131\uACF5'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0001'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon that was used'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8 \uC0AC\uC6A9\uCC98\uB9AC\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0002'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon that has been canceled'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0003'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'system error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB0B4\uBD80 \uC11C\uBC84 \uC5D0\uB7EC'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '500'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0004'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'invalid parameter'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCFE0\uD3F0\uBC88\uD638\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC744\uB54C(\uCFE0\uD3F0\uC774 \uC874\uC7AC\uD558\uC9C0 \uC54A\uC744\uB54C)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0005'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon useAmount invalid'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCC98\uB9AC\uC218\uB7C9\uC73C\uB85C \uCC98\uB9AC\uAC00 \uBD88\uAC00\uB2A5\uD560\uB54C(ex. 1\uD68C \uB0A8\uC558\uB294\uB370 2\uD68C \uC0AC\uC6A9\uCC98\uB9AC\uD558\uB824\uACE0 \uD560\uB54C)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0006'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'has no parameter'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD544\uC218 \uC785\uB825\uAC12\uC744 \uC785\uB825\uD558\uC9C0 \uC54A\uC558\uC744\uB54C'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0007'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'un used coupon'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD55C\uBC88\uB3C4 \uC0AC\uC6A9\uCC98\uB9AC \uB418\uC9C0 \uC54A\uC740 \uCFE0\uD3F0\uC744 \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0008'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon canceling'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC811\uC218\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0009'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon is already in progress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3D9\uC77C \uBC88\uD638\uC758 \uCFE0\uD3F0\uC774 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC911\uC77C\uB54C \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0010'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'couponNumber is duplicated'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCFE0\uD3F0\uBC88\uD638\uC758 \uCFE0\uD3F0\uC774 2\uAC1C \uC774\uC0C1 \uC874\uC7AC\uD560\uB54C'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '500'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0011'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'unauthorized vendor id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBBF8\uC778\uC99D vendorId\uB85C \uCFE0\uD3F0 \uCC98\uB9AC\uC2DC\uB3C4, \uBBF8\uC778\uC99D\uC740 acl\uC5D0 \uB4F1\uB85D\uB418\uC9C0 \uC54A\uC740 vendorId\uC778 \uACBD\uC6B0,',
	                                _react2.default.createElement('br', null),
	                                ' \uCC98\uB9AC\uD558\uB824\uB294 \uCFE0\uD3F0\uC758 vendorId\uC640 \uB2E4\uB97C \uACBD\uC6B0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewTicketDetails;
	}(_react2.default.Component);
	
	exports.default = ViewTicketDetails;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewTicketDetails.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 4467244190152793:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2715183967877881);
	var invariant = __webpack_require__(7236580699222333);
	var ReactPropTypesSecret = __webpack_require__(1965880802553340);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),

/***/ 4526404861839573:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewConfirmReservation = function (_React$Component) {
		_inherits(ViewConfirmReservation, _React$Component);
	
		function ViewConfirmReservation(props) {
			_classCallCheck(this, ViewConfirmReservation);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		ViewConfirmReservation.prototype.render = function render() {
			var col_number_8 = 8;
			var total_levels = 6;
			var level1 = 5;
			var level2 = 4;
			var level2_prefix = level1 - level2;
			var level3 = 3;
			var level3_prefix = level1 - level3;
			var level4 = 2;
			var level4_prefix = level1 - level4;
			var level5 = 1;
			var level5_prefix = level1 - level5;
			return _react2.default.createElement(
				'div',
				{ id: "view-confirm-reject-reservation" },
				_react2.default.createElement(
					'h3',
					{ className: "mb0 mt40" },
					'\uC608\uC57D \uD655\uC815 \uCDE8\uC18C'
				),
				_react2.default.createElement(
					'div',
					{ className: 'blog-post-meta' },
					_react2.default.createElement(
						'span',
						{ className: 's-post' },
						'\uC608\uC57D \uB300\uAE30\uC911\uC778 \uD2F0\uCF13\uC758 \uC0C1\uD0DC\uB97C \uC608\uC57D\uBD88\uAC00\uB85C \uBCC0\uACBD \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC608\uC57D\uBD88\uAC00\uB85C \uD2F0\uCF13\uC758 \uC0C1\uD0DC\uB97C \uBCC0\uACBD \uD560 \uACBD\uC6B0 \uD574\uB2F9 \uD2F0\uCF13\uC740 \uC790\uB3D9\uC73C\uB85C \uCDE8\uC18C \uC644\uB8CC \uCC98\uB9AC\uB429\uB2C8\uB2E4.\x0B'
					),
					_react2.default.createElement(
						'h3',
						{ className: 'request-method' },
						_react2.default.createElement(
							'span',
							{ className: 'label label-success' },
							'POST'
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'Path'
								),
								_react2.default.createElement(
									'td',
									null,
									'Example Endpoint'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'/v1/marketplace/reservation/request/rejection'
								),
								_react2.default.createElement(
									'td',
									null,
									'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/reservation/request/rejection'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'h4',
						null,
						'Request Parameters'
					),
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: '4', className: 'bold' },
									'Request Header'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Required'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'Request-Vendor-Id'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: '4', className: 'bold' },
									'Query Parameter'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Required'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'ticketNumber'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uD2F0\uCF13 \uBC88\uD638'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'h4',
						null,
						'Response Specifications'
					),
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: level1 },
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'code'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uCF54\uB4DC'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'message'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uBA54\uC138\uC9C0'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'data'
								),
								_react2.default.createElement(
									'td',
									null,
									'responseDto'
								),
								_react2.default.createElement('td', null)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'isSuccessfulRequest'
								),
								_react2.default.createElement(
									'td',
									null,
									'boolean'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD \uC131\uACF5 \uC5EC\uBD80'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'requestedTicketNumber'
								),
								_react2.default.createElement(
									'td',
									null,
									'boolean'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD \uD2F0\uCF13 \uBC88\uD638'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'message'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uBA54\uC2DC\uC9C0'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'div',
						{ className: 'panel panel-default' },
						_react2.default.createElement(
							'div',
							{ className: 'panel-heading' },
							_react2.default.createElement(
								'h3',
								{ className: 'panel-title' },
								'\uC751\uB2F5\uAC12 \uC608\uC2DC'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'panel-body' },
							_react2.default.createElement(
								'pre',
								{ className: 'ty01' },
								'\n{\n  "code": 200,\n  "message": "SUCCESS",\n  "data": [\n    {\n      "isSuccessfulRequest" : "true",\n      "requestedTicketNumber" : "044670-5000000000620",\n      "message" : "Successfully Requested"\n    }\n  ]\n}\n                        '
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'HTTP CODE'
								),
								_react2.default.createElement(
									'th',
									null,
									'message'
								),
								_react2.default.createElement(
									'th',
									null,
									'\uC124\uBA85'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'400'
								),
								_react2.default.createElement(
									'td',
									null,
									'Bad request'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'401'
								),
								_react2.default.createElement(
									'td',
									null,
									'Unauthorized Error'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'403'
								),
								_react2.default.createElement(
									'td',
									null,
									'Forbidden Error'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'410'
								),
								_react2.default.createElement(
									'td',
									null,
									'The resource has been permanently deleted'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'412'
								),
								_react2.default.createElement(
									'td',
									null,
									'Precondition failed'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'429'
								),
								_react2.default.createElement(
									'td',
									null,
									'Too many requests'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'504'
								),
								_react2.default.createElement(
									'td',
									null,
									'API Gateway response timeout'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'521'
								),
								_react2.default.createElement(
									'td',
									null,
									'API provider server has error'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'524'
								),
								_react2.default.createElement(
									'td',
									null,
									'API provider to API gateway connection response timeout'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							)
						)
					)
				)
			);
		};
	
		return ViewConfirmReservation;
	}(_react2.default.Component);
	
	exports.default = ViewConfirmReservation;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewRejectReservation.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 4563773596670964:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketFreeProcessing = function (_React$Component) {
	    _inherits(TicketFreeProcessing, _React$Component);
	
	    function TicketFreeProcessing(props) {
	        _classCallCheck(this, TicketFreeProcessing);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    TicketFreeProcessing.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uD2F0\uCF13 \uBBF8\uC0AC\uC6A9 \uCC98\uB9AC API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: 's-post' },
	                    '\uC0AC\uC6A9\uB41C \uC0C1\uD0DC\uC758 \uD2F0\uCF13\uC744 \uBBF8\uC0AC\uC6A9 \uC0C1\uD0DC\uB85C \uCC98\uB9AC\uD569\uB2C8\uB2E4. \uC774 API\uB97C \uC774\uC6A9\uD574 \uD558\uB098\uC758 \uD2F0\uCF13\uC744 \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/',
	                                '{ticketNumber}',
	                                '/reclaim'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/7000000000151/reclaim'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638 (default = null)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638 (default = null)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'quantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBBF8\uC0AC\uC6A9\uD560 \uC218\uB7C9 (default = 1)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'reclaimReason'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC0AC\uC720 (default = "\uC5C5\uCCB4\uADC0\uCC45")'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n            {\n                "code": "0000",\n                "message" : "success"\n            }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0000'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'success'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9 \uCC98\uB9AC \uC131\uACF5'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0001'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon that was used'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8 \uC0AC\uC6A9\uCC98\uB9AC\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0002'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon that has been canceled'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0003'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'system error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB0B4\uBD80 \uC11C\uBC84 \uC5D0\uB7EC'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '500'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0004'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'invalid parameter'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCFE0\uD3F0\uBC88\uD638\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC744\uB54C(\uCFE0\uD3F0\uC774 \uC874\uC7AC\uD558\uC9C0 \uC54A\uC744\uB54C)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0005'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon useAmount invalid'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCC98\uB9AC\uC218\uB7C9\uC73C\uB85C \uCC98\uB9AC\uAC00 \uBD88\uAC00\uB2A5\uD560\uB54C(ex. 1\uD68C \uB0A8\uC558\uB294\uB370 2\uD68C \uC0AC\uC6A9\uCC98\uB9AC\uD558\uB824\uACE0 \uD560\uB54C)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0006'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'has no parameter'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD544\uC218 \uC785\uB825\uAC12\uC744 \uC785\uB825\uD558\uC9C0 \uC54A\uC558\uC744\uB54C'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0007'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'un used coupon'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD55C\uBC88\uB3C4 \uC0AC\uC6A9\uCC98\uB9AC \uB418\uC9C0 \uC54A\uC740 \uCFE0\uD3F0\uC744 \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0008'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon canceling'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC811\uC218\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0009'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon is already in progress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3D9\uC77C \uBC88\uD638\uC758 \uCFE0\uD3F0\uC774 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC911\uC77C\uB54C \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0010'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'couponNumber is duplicated'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCFE0\uD3F0\uBC88\uD638\uC758 \uCFE0\uD3F0\uC774 2\uAC1C \uC774\uC0C1 \uC874\uC7AC\uD560\uB54C'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '500'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0011'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'unauthorized vendor id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBBF8\uC778\uC99D vendorId\uB85C \uCFE0\uD3F0 \uCC98\uB9AC\uC2DC\uB3C4, \uBBF8\uC778\uC99D\uC740 acl\uC5D0 \uB4F1\uB85D\uB418\uC9C0 \uC54A\uC740 vendorId\uC778 \uACBD\uC6B0,',
	                                _react2.default.createElement('br', null),
	                                ' \uCC98\uB9AC\uD558\uB824\uB294 \uCFE0\uD3F0\uC758 vendorId\uC640 \uB2E4\uB97C \uACBD\uC6B0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return TicketFreeProcessing;
	}(_react2.default.Component);
	
	exports.default = TicketFreeProcessing;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "TicketFreeProcessing.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 4681680635909653:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateTicketProduct = function (_React$Component) {
	    _inherits(CreateTicketProduct, _React$Component);
	
	    function CreateTicketProduct(props) {
	        _classCallCheck(this, CreateTicketProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    CreateTicketProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC0C1\uD488 \uB4F1\uB85D'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uCFE0\uD321\uC5D0\uC11C \uD310\uB9E4\uD560 \uD2F0\uCF13 \uC0C1\uD488\uC744 \uB4F1\uB85D\uD558\uB294 API\uC785\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC0DD\uC131 \uD6C4 \uBCC0\uACBD\uBD88\uAC00 \uD56D\uBAA9 \uC785\uB2C8\uB2E4'
	                                            ),
	                                            _react2.default.createElement('td', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAD6D\uB0B4\uC5EC\uD589'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OVERSEAS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uC678\uC5EC\uD589'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'productDetailType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0DD\uC131 \uD6C4 \uBCC0\uACBD\uBD88\uAC00 \uD56D\uBAA9 \uC785\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'travelType'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'productDetailType'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WATER_PARK'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC6CC\uD130\uD30C\uD06C (\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'THEME_PARK'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD14C\uB9C8\uD30C\uD06C (\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SKI'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2A4\uD0A4(\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'LEISURE_AND_SPORTS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB808\uD3EC\uCE20 (\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PERFORMANCE_AND_EXHIBITION'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBB38\uD654 (\uACF5\uC5F0/\uC804\uC2DC) (\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FOOD_AND_BEVERAGE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD638\uD154\uBDD4\uD398 (\uC2DD\uC74C) (\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'GOLF'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACE8\uD504 (\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FESTIVAL_AND_THEME'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD95\uC81C/\uD14C\uB9C8/\uC5EC\uAC00 (\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'KID_AND_EXPERIENCE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD0A4\uC988(\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SIGHTSEEING_PASS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC81C\uC8FC\uAD00\uAD11\uC9C0 (\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OVERSEAS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'LOCAL_TOUR'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB370\uC774\uD22C\uC5B4 (\uD604\uC9C0\uD22C\uC5B4) (\uD574\uC678)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OVERSEAS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'READY_TO_TRIP'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uC678\uC5EC\uD589\uC900\uBE44\uBB3C (\uD574\uC678)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OVERSEAS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TRANSPORT_AND_ATTRACTION_PASS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD2F0\uCF13/\uAD50\uD1B5\uD328\uC2A4 (\uD574\uC678)'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'inventoryType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'Inventory Type'
	                                            ),
	                                            _react2.default.createElement('td', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            ),
	                                            _react2.default.createElement('th', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DAILY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB9E4\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PERIOD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uAC04'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'reservationRequired'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC804 \uC608\uC57D\uC608\uC57D \uC5EC\uBD80,\uC778\uBCA4\uD1A0\uB9AC \uD0C0\uC785\uC774 Daily \uC77C \uACBD\uC6B0 \uC774 \uD544\uB4DC\uC758 \uAC12\uC740 false \uC785\uB2C8\uB2E4. Default:FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488\uBA85. (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 50\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'adultOnly'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '19\uC138\uBBF8\uB9CC \uAD6C\uB9E4\uBD88\uAC00. Default:FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'subordinateIds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uAD00\uB9AC \uC11C\uBE0CID \uB9AC\uC2A4\uD2B8'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'searchTags'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC11C\uCE58\uD0DC\uADF8 \uB9AC\uC2A4\uD2B8 (\uAC01 \uC11C\uCE58\uD0DC\uADF8 \uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 10\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'displayKeyword'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uC5D0 \uD45C\uC2DC\uD560 \uC9C0\uC5ED \uD0A4\uC6CC\uB4DC (\uAC01 \uD0A4\uC6CC\uB4DC \uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 10\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'displayCategoryCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uC758 \uB178\uCD9C \uCE74\uD14C\uACE0\uB9AC. Example: 106774 (\uC0DD\uC131 \uD6C4 \uBCC0\uACBD\uBD88\uAC00 \uD56D\uBAA9 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'images'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\uAC00 \uC0C1\uD488 \uB300\uD45C\uD568, \uC0C1\uD488\uB2F9 \uB2E8\uC77C \uB300\uD45C\uC774\uBBF8\uC9C0 \uBCF4\uC720. Default: FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerImageCategory'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 \uCE74\uD14C\uACE0\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'imageGroup'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'VIEW'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FACILITY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD80\uB300\uC2DC\uC124'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESTAURANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DD\uB2F9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ROOM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        )
	                                    )
	                                ),
	                                '\uB514\uD3F4\uD2B8 \uAC12: BASIC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC21C\uC11C.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelItems'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerTravelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'onSale'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC911:true, \uD310\uB9E4\uC911\uC9C0:false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'usePeriod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '<UsePeriodDto>'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uBCA4\uD1A0\uB9AC \uD0C0\uC785\uC774 \u2018PERIOD\u2019 \uC774\uBA74 \uC0AC\uC6A9\uAE30\uAC04\uC740 \uD544\uC218\uC774\uACE0 \uC778\uBCA4\uD1A0\uB9AC \uD0C0\uC785\uC774 \u2018DAILY\u2019 \uC778 \uACBD\uC6B0 \uC0AC\uC6A9\uAE30\uAC04\uC740 \uC0AC\uC6A9\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.'
	                            ),
	                            '.'
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'usePeriodName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9 \uAE30\uAC04\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'useStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBD80\uD130 \uC0AC\uC6A9 \uAC00\uB2A5.Format: yyyy-MM-dd HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'useEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE4C\uC9C0 \uC0AC\uC6A9 \uC911\uC9C0. Format: yyyy-MM-dd HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'features'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'featureId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'featureValues'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'taxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 taxType\uC774 \uC790\uB3D9\uC73C\uB85C \uBA74\uC138(FREE)\uB85C \uC124\uC815\uB418\uBA70, \uC774\uC678\uC758 taxType\uB97C \uC124\uC815 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACFC\uC138 (\uAE30\uBCF8\uAC12)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBA74\uC138'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ZERO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC138'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Rate id from seller side'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN_AND_CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778/\uC18C\uC778\uB3D9\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNIVERSITY_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACE0\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_AND_MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEENS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCCAD\uC18C\uB144'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PRESCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uCDE8\uD559\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC18C\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'INFANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'priceType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'COUPANG_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCFE0\uD321 \uAC00\uACA9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TOTAL_PRODUCT_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD1D \uC0C1\uD488 \uAC00\uACA9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC \uD648\uD398\uC774\uC9C0\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_MALL_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC\uBAB0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ONLINE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC628\uB77C\uC778 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TRAVEL_AGENCY_SPECIAL_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5EC\uD589\uC0AC \uD2B9\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESERVATION_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uB9E4\uCC98 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HOMEPAGE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD648\uD398\uC774\uC9C0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SITE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD604\uC7A5 \uD310\uB9E4\uAC00'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC6D0\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB300\uD45C\uAC00 \uC124\uC815 \uC5EC\uBD80 / False\uB85C \uC124\uC815\uD560 \uACBD\uC6B0 \uB300\uD45C\uAC00 \uB178\uCD9C\uC5D0\uC11C \uC81C\uC678\uB429\uB2C8\uB2E4. (Default: TRUE)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'saleStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC2DC\uC791\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'saleEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC885\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss). Default: 2099-12-31 23:59:59'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'maxPurchaseQtyPerPerson'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uB2F9 \uCD5C\uB300 \uAD6C\uB9E4 \uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'maxPurchaseQtyPeriod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4 \uC81C\uD55C \uAE30\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08 \uB4F1\uB85D \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'trafficInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCC3E\uC544\uAC00\uB294 \uAE38 \uC124\uBA85\uD558\uB294 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825. (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 20\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'publicTransportInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uB300\uC911\uAD50\uD1B5 \uC815\uBCF4 \uC124\uBA85\uD558\uB294 \uC790\uC720 \uD14D\uC2A4\uD2B8 \uC785\uB825. (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 20\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'nearbyLandmarks'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uAD00\uAD11\uC9C0 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C \uC704\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C \uACBD\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C\uAE4C\uC9C0\uC758 \uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'distanceUnit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Default:METER',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'KILOMETER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD0AC\uB85C\uBBF8\uD130'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'METER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uD130'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'direction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC11C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTH'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTH'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTHEAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTHWEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81\uC11C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTHEAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTHWEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8\uC11C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'transportations'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SUBWAY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC9C0\uD558\uCCA0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BUS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC84\uC2A4'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'operationPeriods'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B4\uD589\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'startTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B4\uD589 \uC2DC\uC791\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'endTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B4\uD589 \uC885\uB8CC\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'locations'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 locations\uAC00 \uD544\uC218 \uAC12\uC774 \uC544\uB2D8. Locations \uAC12\uC774 \uC785\uB825\uB41C \uACBD\uC6B0 \uAF2D \uC815\uD655\uD55C \uAC12\uC73C\uB85C \uC785\uB825\uD574\uC57C\uD568.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0 \uC704\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0 \uACBD\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'roadNameAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uB85C\uBA85\uC8FC\uC18C.\uB3C4\uB85C\uBA85 \uB610\uB294 \uC9C0\uBC88\uC8FC\uC18C \uC911 \uCD5C\uC18C\uD55C \uD55C\uAC00\uC9C0\uB294 \uC785\uB825\uD574\uC57C \uD568'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'landNumberAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uBC88\uC8FC\uC18C. \uB3C4\uB85C\uBA85 \uB610\uB294 \uC9C0\uBC88\uC8FC\uC18C \uC911 \uCD5C\uC18C\uD55C \uD55C\uAC00\uC9C0\uB294 \uC785\uB825\uD574\uC57C \uD568'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6D\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'province'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD589\uC815\uB2E8\uC704 \uC8FC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'city'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'district'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C, \uAD6C\uC5ED'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'town'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC74D \uBA74 \uB3D9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'zipCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B0\uD3B8\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'contents'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uCEE8\uD150\uCE20 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785\uC5D0 \uB300\uD55C \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825. \uC608:\uD328\uD0A4\uC9C0 \uD22C\uC5B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\' \uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \'\uC774\uBBF8\uC9C0\'\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\'\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url \uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'features'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureValues'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC18D\uC131 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'reservationGuide'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D\uAC00\uC774\uB4DC \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'reservationNotifications'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBA54\uC77C \uC8FC\uC18C, \uC804\uD654\uBC88\uD638 \uD639\uC740 \uD329\uC2A4 \uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactDescription'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'contacts'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WEBSITE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC6F9\uC0AC\uC774\uD2B8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactUseType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'REPRESENTATIVE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD45C\uC5F0\uB77D\uCC98*\uD544\uC218'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BOOKING_INQUIRY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D\uBB38\uC758 \uC5F0\uB77D\uCC98'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CANCEL_INQUIRY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uBB38\uC758 \uC5F0\uB77D\uCC98'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMERGENCY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE34\uAE09\uC5F0\uB77D\uB9DD'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contact'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608: \uC5F0\uB77D\uCC98 \uD0C0\uC785\uC774 \uD3F0\uC774\uBA74: 010-0000-0000'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'cancelPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uACF5\uC9C0 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AUTO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uB3D9\uCDE8\uC18C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778\uCDE8\uC18C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelMarkType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uB2F9 \uC5C6\uC74C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_CANCELED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNUSE_REFUND_ALL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uC0AC\uC6A9 100%\uD658\uBD88'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_REFUND_AFTER_RECEIPT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD2F0\uCF13 \uBC1C\uC1A1 \uD6C4 \uD658\uBD88 \uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_REFUND_AFTER_RESERVATION_CONFIRM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D \uD655\uC815 \uD6C4 \uD658\uBD88 \uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNUSE_REFUND_ALL_BEFORE_ONE_DAY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uC6A9\uC77C 1\uC77C\uC804\uAE4C\uC9C0 100%\uD658\uBD88'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DEPENDING_ON_VENDOR'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5C5\uCCB4 \uADDC\uC815\uC5D0 \uB530\uB984'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundOnBusinessDay'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC601\uC5C5\uC77C \uAE30\uC900 \uCDE8\uC18C \uC811\uC218 \uC5EC\uBD80 (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundUnusedTicket'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBBF8\uC0AC\uC6A9 \uD2F0\uCF13 100% \uD658\uBD88 \uC5EC\uBD80 (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundRates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9CC\uC57D cancelMarkType\uC774 \u2018\uC5C5\uCCB4\uADDC\uC815\uC5D0 \uB530\uB984\u2019\uC778 \uACBD\uC6B0, \uD658\uBD88\uC728 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'conditionDays'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uC77C x \uC77C \uC804 \uAE4C\uC9C0 \uD658\uBD88 \uAC00\uB2A5'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'conditionTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uC77C x \uC77C y \uC2DC \uC804 \uAE4C\uC9C0 \uD658\uBD88 \uAC00\uB2A5 format: HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'refundRate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC728 ex: rate 70% is 70'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'cancellable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC544\uC774\uD15C \uD310\uB9E4 \uC0C1\uD0DC (Default: TRUE)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'introduction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC0C1\uD488 \uC18C\uAC1C\uB9D0 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uC6A9\uC548\uB0B4 \uBC0F \uC720\uC758\uC0AC\uD56D (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'benefits'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uBCC4\uD788 \uC81C\uACF5\uB418\uB294 \uD61C\uD0DD \uBC0F \uBCF4\uB108\uC2A4\u2018\uB780 \uAD6C\uB9E4 \uACE0\uAC1D\uC5D0\uAC8C \uD2B9\uBCC4\uD558\uAC8C \uC81C\uACF5\uB418\uB294 \uD61C\uD0DD\uC73C\uB85C \uC2E4\uC81C \uBCF8 \uC0C1\uD488\uC678\uC5D0 \uBB34\uB8CC \uD639\uC740 \uD560\uC778\uB418\uC5B4 \uC81C\uACF5\uB418\uB294 \uC120\uBB3C\uC774\uB098 \uC11C\uBE44\uC2A4\uB97C \uB9D0\uD569\uB2C8\uB2E4.(\uAC01 \uBCF4\uB108\uC2A4 \uC124\uBA85 \uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 30\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'insuranceInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCF4\uD5D8\uC815\uBCF4 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DDl'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'inclusionNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD3EC\uD568\uC0AC\uD56D \uAE30\uC7AC (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'exclusionNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBD88\uD3EC\uD568 \uC0AC\uD56D \uAE30\uC7AC (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'publication'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'useBarcode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCFE0\uD321 \uD2F0\uCF13\uBC88\uD638 \uBC14\uCF54\uB4DC \uBCC0\uD658 \uC5EC\uBD80 ((Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'isUseDirect'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC989\uC2DC\uC0AC\uC6A9 \uC5EC\uBD80, \uC219\uBC15\uC758 \uACBD\uC6B0 : true, \uAE30\uD0C0 \uD0C0\uC785\uC758 \uACBD\uC6B0 : false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'externalCouponUseType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC678\uBD80\uD2F0\uCF13\uBC88\uD638 \uC0AC\uC6A9\uC720\uD615'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'useExternalTicketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC678\uBD80\uD2F0\uCF13\uBC88\uD638 \uC0AC\uC6A9\uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketUsage'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uC81C\uACF5\uBC25\uBC95',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            ),
	                                            _react2.default.createElement('th', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PURCHASE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAD6C\uB9E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BARCODE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC14\uCF54\uB4DC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BARCODE_REAL_TIME'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC14\uCF54\uB4DC \uC2E4\uC2DC\uAC04'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'E_TICKET'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'E-\uD2F0\uCF13'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DELIVERY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC30\uC1A1'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ON_SITE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD604\uC7A5'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketSendCriteriaType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13 \uBC1C\uC1A1 \uAE30\uC900',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DAY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TIME'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DC\uAC04'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5C6\uC74C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketSendSpentTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13 \uBC1C\uC1A1 \uC18C\uC694 \uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketSendLimitTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13 \uB2F9\uC77C \uBC1C\uC1A1 \uAE30\uC900 \uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'usageNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC758\uC0AC\uD56D \uAE30\uC7AC (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'additionalInfoPrompt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488 \uC8FC\uBB38/\uC608\uC57D\uC5D0 \uD544\uC694\uD55C \uACE0\uAC1D\uC815\uBCF4\uB97C \uC218\uC9D1\uD560\uC218 \uC788\uC2B5\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'maxPurchaseQuantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC778\uB2F9 \uAD6C\uB9E4 \uCD5C\uB300 \uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'csContactInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D\uC548\uB0B4 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'taxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 taxType\uC774 \uC790\uB3D9\uC73C\uB85C \uBA74\uC138(FREE)\uB85C \uC124\uC815\uB418\uBA70, \uC774\uC678\uC758 taxType\uB97C \uC124\uC815 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACFC\uC138 (\uAE30\uBCF8\uAC12)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBA74\uC138'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ZERO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC138'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'instantBooking'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC989\uC2DC \uC608\uC57D (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'estimatedBookingDuration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D\uD655\uC815 \uC18C\uC694\uC2DC\uAC04, \uC989\uC2DC\uC608\uC57D\uC774 FALSE \uB77C\uBA74 \uD544\uC694.\uB370\uC774\uD130\uB294 0 \uBD80\uD130 72\uAE4C\uC9C0\uC774\uBA70'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'extension'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                "Map<String,String>"
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE30\uD0C0 \uC815\uBCF4\uC0AC\uD56D \uC790\uC720 \uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#createTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'createTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n  "additionalInfoPrompt": "string",\n  "adultOnly": true,\n  "benefits": [\n    "string"\n  ],\n  "cancelPolicy": {\n    "cancelMarkType": "NOT_CANCELED",\n    "cancelType": "AUTO",\n    "notice": "string",\n    "refundOnBusinessDay": true,\n    "refundUnusedTicket": true\n  },\n  "contacts": [\n    {\n      "contact": "010-0000-0000",\n      "contactType": "PHONE",\n      "contactUseType": "REPRESENTATIVE"\n    }\n  ],\n  "contents": [\n    {\n                "title": "product content title 2",\n                "type": "Product-Content",\n                "content": null,\n                "format": "IMAGE",\n                "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_345855cf-a8a4-4dae-88aa-0797d665385d.jpg",\n                "sellerUrlMethod": "GET",\n                "seq": 0\n            }\n  ],\n  "productDetailType":"READY_TO_TRIP",\n  "csContactInfo": "string",\n  "displayCategoryCode": 108804,\n  "displayKeyword": "test1",\n  "estimatedBookingDuration": 0,\n  "exclusionNotice": "string",\n  "extension": {},\n  "features": [\n  \t{\n  \t\t"description":"",\n  \t\t"featureId":"TYPE",\n  \t\t"featureValues":[\n  \t\t\t"WIFI","CAMERA"\n  \t\t\t]\n  \t}\n  ],\n  "images": [\n            {\n                "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_345855cf-a8a4-4dae-88aa-0797d665385d.jpg",\n                "sellerUrlMethod": "GET",\n                "representative": true,\n                "sellerImageCategory": "1234",\n                "imageGroup": "BASIC",\n                "description": "image 1 description",\n                 "seq": 0\n            }\n  ],\n  "inclusionNotice": "string",\n  "instantBooking": true,\n  "introduction": "introduction test",\n  "inventoryType": "PERIOD",\n  "maxPurchaseQuantity": 0,\n  "name": "Test_5",\n  "notice": "string",\n  "publicTransportInfo": "string",\n  "publication": {\n    "externalCouponUseType": "string",\n    "isUseDirect": true,\n    "ticketSendCriteriaType": "string",\n    "ticketSendLimitTime": 0,\n    "ticketSendSpentTime": 0,\n    "ticketUsage": "string",\n    "useBarcode": false,\n    "useExternalTicketNumber": true\n  },\n  "searchTags": [\n    "test1"\n  ],\n  "sellerProductId": "string",\n  "subordinateIds": [\n    "string"\n  ],\n  "taxType": "FREE",\n  "trafficInfo": "string",\n  "travelItems": [\n    {\n      "description": "string",\n        "features": [\n        \t{\n        \t\t"description":"",\n        \t\t"featureId":"OFFERING_SERVICE",\n        \t\t"featureValues":[\n        \t\t\t"NO_CHARGE_CALL","UNLIMITED_USE"\n        \t\t\t]\n        \t}\n      ],\n      "name": "test item 2",\n      "onSale": true,\n      "rates": [\n        {\n          "maxPurchaseQtyPerPerson": 0,\n          "maxPurchaseQtyPeriod": 0,\n          "price": 0,\n          "priceType": "COUPANG_PRICE",\n          "rateType": "BASIC",\n          "representative": true,\n          "saleEndedAt": "2019-12-31 23:59:59",\n          "saleStartedAt": "2019-10-01 23:59:59",\n          "sellerRateId": "",\n          "seq": 0\n        }\n      ],\n      "sellerTravelItemId": "string",\n      "seq": 0,\n      "usePeriod": {\n        "useEndedAt": "2020-12-31 23:59:59",\n        "usePeriodName": "string",\n        "useStartedAt": "2019-12-01 23:59:59"\n      }\n    }\n  ],\n  "travelType": "OVERSEAS",\n  "usageNotice": "test"\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'productCreateResponseDto'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'itemCreateResponse'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<itemCreateResponse>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerTravelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Success",\n    "data": {\n        "travelProductId": 12345678910,\n        "sellerProductId": "sellerProductId_1",\n        "itemCreateResponse": [\n            {\n                "sellerTravelItemId": "sellerTravelItemId_test001",\n                "name": "After4 \uC544\uCFE0\uC544\uB9AC\uC6C0\uAD8C",\n                "travelItemId": 11111111\n            }\n        ]\n    }\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforCreateProduct' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforCreateProduct', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel-body' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC774\uB118 \uD0C0\uC785 ',
	                                            '${enumClazz.getSimpleName()}',
	                                            '\uC5D0 \uB300\uD55C \uBB34\uD6A8 \uBB38\uC790\uC5F4 \uAC12'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 display category code  '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'images\uAC00 \uBE44\uC5B4\uC788\uC744 \uC218 \uC5C6\uC74C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uB300\uD45C \uC774\uBBF8\uC9C0 \uB2E8 \uD55C\uC7A5\uB9CC \uD5C8\uC6A9 \uAC00\uB2A5'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uAD6D\uB0B4 \uC5EC\uD589\uC5D0 \uB300\uD55C locations\uAC00 \uBE44\uC5B4\uC788\uC73C\uBA74 \uC548\uB428 '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'landNumberAddress\uC911 \uD558\uB098\uC640 roadNameAddress\uB97C \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 seqs  '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uAC00 \uC544\uB2CC \uACBD\uC6B0 content\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uC778 \uACBD\uC6B0 sellerUrl\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'travelType \uBC0F productDetailType\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC74C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'instantBooking\uC774 false\uC778 \uACBD\uC6B0 estimatedBookingDuration\uC774 0\uBCF4\uB2E4 \uD06C\uACE0 72\uBCF4\uB2E4 \uC791\uAC70\uB098 \uAC19\uC544\uC57C\uB428'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC5F0\uB77D\uCC98\uC5D0 \uB300\uD45C \uC804\uD654 \uBC88\uD638\uAC00 \uD558\uB098 \uC788\uC5B4\uC57C\uD568 '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 travel ticket feature id '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 travel ticket item feature id '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 travel ticket feature value '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 travel ticket item feature value '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 \uC77C\uC790/\uC2DC\uAC04 \uD3EC\uB9F7, \uD3EC\uB9F7\uC774 ',
	                                            '{pattern}',
	                                            '\uC774\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uD310\uB9E4 \uC2DC\uC791\uC77C\uC740 \uD310\uB9E4 \uC885\uB8CC\uC77C\uBCF4\uB2E4 \uB2A6\uC9C0 \uC54A\uC544\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC0C1\uD488 inventoryType\uC774 PERIOD\uC778 \uACBD\uC6B0 usePeriod\uAC00 NULL\uC774\uBA74 \uC548\uB428'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'inventoryType\uC774 DAILY\uC778 \uACBD\uC6B0 usePeriod\uAC00 \uBD88\uD544\uC694\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'publication\uC740 null\uC774 \uC544\uB2C8\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'inventoryType\uC744 \uC81C\uACF5\uD574\uC57C\uD568'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return CreateTicketProduct;
	}(_react2.default.Component);
	
	exports.default = CreateTicketProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "CreateTicketProduct.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 4764256660237640:
2692642590089237,

/***/ 4787353091300423:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewCanceledTicketInfoV2 = function (_React$Component) {
	    _inherits(ViewCanceledTicketInfoV2, _React$Component);
	
	    function ViewCanceledTicketInfoV2(props) {
	        _classCallCheck(this, ViewCanceledTicketInfoV2);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewCanceledTicketInfoV2.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uCDE8\uC18C\uC644\uB8CC\uB41C \uD2F0\uCF13 \uC815\uBCF4 \uC870\uD68C V2 API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: 's-post' },
	                    '\uCDE8\uC18C\uC644\uB8CC\uB41C \uD2F0\uCF13 \uC815\uBCF4\uB97C \uC870\uD68C\uD569\uB2C8\uB2E4. \uC774 API\uB97C \uC774\uC6A9\uD574 \uC77C\uC8FC\uC77C \uC774\uB0B4\uC758 \uD2F0\uCF13 \uC815\uBCF4\uB97C \uAC00\uC838\uC62C \uC218 \uC788\uC2B5\uB2C8\uB2E4.\xA0'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v2/purchasers/cancel-completed?searchStartDateTime=',
	                                '{searchStartDateTime}',
	                                '&searchEndDateTime=',
	                                '{searchEndDateTime}',
	                                '&dealId=',
	                                '{dealId}',
	                                '&offset=',
	                                '{offset}',
	                                '&limit=',
	                                '{limit}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v2/purchasers/cancel-completed?searchStartDateTime=2017-08-04 00:00:00&searchEndDateTime=2017-08-04 23:59:59&dealId=3000000001&offset=0&limit=1000'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Query String Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'offset'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0 \uBC88\uD638 (\uCCAB\uBC88\uC9F8 \uD398\uC774\uC9C0 = 0)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'limit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD5C\uB300 \uC694\uCCAD \uAC2F\uC218 (\uCD5C\uB313\uAC12 = 1000)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'searchStartDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC \uAC80\uC0C9\uC2DC\uC791\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'searchEndDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC \uAC80\uC0C9\uC885\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'userName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 \uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'phoneNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 \uD578\uB4DC\uD3F0 \uBC88\uD638 (010-xxxx-xxxx)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'email'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 email'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C \uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C \uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'purchaseDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'canceledDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uAC00\uACA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'status'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'CANCEL_COMPLETE(\uCDE8\uC18C\uC644\uB8CC)'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "totalCount": 2,\n            "totalPageCount": 1,\n            "countPerPage": 1000,\n            "currentPage": 0,\n            "ticketPurchasers": [\n                {\n                    "ticketNumber": "9C320B-9000000000234",\n                    "userName": "\uAE40\uCFE0\uD321",\n                    "phoneNumber": null,\n                    "email": "coupang@coupang.com",\n                    "dealId": 6500124641,\n                    "dealName": "\uCFE0\uD321\uACFC \uD568\uAED8 \uBC14\uB85C\uC140\uB85C\uB098",\n                    "optionId": 53000424227,\n                    "optionName": "\uC989\uC2DC \uAC00\uAE30  ",\n                    "price": 1000,\n                    "purchaseDateTime": "2017-07-05 05:17:13",\n                    "canceledDateTime": "2017-07-06 07:27:21",\n                    "status": "CANCEL_COMPLETE",\n                    "orderId" : "2ma*aBZy*ho+zQO+dRZlCQJ8pEKWuZspZg8kCVCyx9Q="\n                },\n                {\n                    "ticketNumber": "DCAA6C-9000000000235",\n                    "userName": "\uAE40\uCFE0\uD321",\n                    "phoneNumber": null,\n                    "email": "coupang@coupang.com",\n                    "dealId": 6500124641,\n                    "dealName": "\uCFE0\uD321\uACFC \uD568\uAED8 \uBC14\uB85C\uC140\uB85C\uB098",\n                    "optionId": 53000424227,\n                    "optionName": "\uC989\uC2DC \uAC00\uAE30  ",\n                    "price": 1000,\n                    "purchaseDateTime": "2017-07-05 05:17:13",\n                    "canceledDateTime": "2017-07-06 07:27:21",\n                    "status": "CANCEL_COMPLETE",\n                    "orderId" : "2ma*aBZy*ho+zQO+dRZlCQJ8pEKWuZspZg8kCVCyx9Q="\n                }\n            ]\n        }\n                        '
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewCanceledTicketInfoV2;
	}(_react2.default.Component);
	
	exports.default = ViewCanceledTicketInfoV2;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewCanceledTicketInfoV2.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 4813844983747096:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(4467244190152793)();
	}


/***/ }),

/***/ 4970350560183710:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MutipleTicketUnusedProcessing = function (_React$Component) {
	    _inherits(MutipleTicketUnusedProcessing, _React$Component);
	
	    function MutipleTicketUnusedProcessing(props) {
	        _classCallCheck(this, MutipleTicketUnusedProcessing);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    MutipleTicketUnusedProcessing.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uB2E4\uC218 \uD2F0\uCF13 \uBBF8\uC0AC\uC6A9 \uCC98\uB9AC API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC0AC\uC6A9\uB41C \uC0C1\uD0DC\uC758 \uD2F0\uCF13\uC744 \uBBF8\uC0AC\uC6A9 \uC0C1\uD0DC\uB85C \uCC98\uB9AC\uD569\uB2C8\uB2E4. \uC774 API\uB97C \uC774\uC6A9\uD574 \uCD5C\uB300 5\uAC1C\uC758 \uD2F0\uCF13\uC744 \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/multiple/reclaim'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/multiple/reclaim'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638 (default = null)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638 (default = null)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'quantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBBF8\uC0AC\uC6A9\uD560 \uC218\uB7C9 (default = 1)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'reclaimReason'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC0AC\uC720 (default = "\uC5C5\uCCB4\uADC0\uCC45")'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumbers'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638 \uB9AC\uC2A4\uD2B8'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "message" : "success",\n            "data" : {\n                        "8231E1-13000000000768" : {\n                            "code": "0000",\n                            "message" : "success"\n                        },\n                        "823ABC-13000000000769" : {\n                            "code": "0000",\n                            "message" : "success"\n                        }\n                    }\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0000'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'success'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9 \uCC98\uB9AC \uC131\uACF5'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0001'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon that was used'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8 \uC0AC\uC6A9\uCC98\uB9AC\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0002'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon that has been canceled'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0003'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'system error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB0B4\uBD80 \uC11C\uBC84 \uC5D0\uB7EC'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '500'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0004'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'invalid parameter'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCFE0\uD3F0\uBC88\uD638\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC744\uB54C(\uCFE0\uD3F0\uC774 \uC874\uC7AC\uD558\uC9C0 \uC54A\uC744\uB54C)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0005'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon useAmount invalid'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCC98\uB9AC\uC218\uB7C9\uC73C\uB85C \uCC98\uB9AC\uAC00 \uBD88\uAC00\uB2A5\uD560\uB54C(ex. 1\uD68C \uB0A8\uC558\uB294\uB370 2\uD68C \uC0AC\uC6A9\uCC98\uB9AC\uD558\uB824\uACE0 \uD560\uB54C)'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0006'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'has no parameter'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD544\uC218 \uC785\uB825\uAC12\uC744 \uC785\uB825\uD558\uC9C0 \uC54A\uC558\uC744\uB54C'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0007'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'un used coupon'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD55C\uBC88\uB3C4 \uC0AC\uC6A9\uCC98\uB9AC \uB418\uC9C0 \uC54A\uC740 \uCFE0\uD3F0\uC744 \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0008'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon canceling'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC811\uC218\uB41C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0009'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'coupon is already in progress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3D9\uC77C \uBC88\uD638\uC758 \uCFE0\uD3F0\uC774 \uC0AC\uC6A9, \uBBF8\uC0AC\uC6A9\uCC98\uB9AC \uC911\uC77C\uB54C \uC2DC\uB3C4'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '200'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0010'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'couponNumber is duplicated'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD30C\uB77C\uBBF8\uD130\uB85C \uBC1B\uC740 \uCFE0\uD3F0\uBC88\uD638\uC758 \uCFE0\uD3F0\uC774 2\uAC1C \uC774\uC0C1 \uC874\uC7AC\uD560\uB54C'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '500'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '0011'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'unauthorized vendor id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBBF8\uC778\uC99D vendorId\uB85C \uCFE0\uD3F0 \uCC98\uB9AC\uC2DC\uB3C4, \uBBF8\uC778\uC99D\uC740 acl\uC5D0 \uB4F1\uB85D\uB418\uC9C0 \uC54A\uC740 vendorId\uC778 \uACBD\uC6B0,',
	                                _react2.default.createElement('br', null),
	                                ' \uCC98\uB9AC\uD558\uB824\uB294 \uCFE0\uD3F0\uC758 vendorId\uC640 \uB2E4\uB97C \uACBD\uC6B0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return MutipleTicketUnusedProcessing;
	}(_react2.default.Component);
	
	exports.default = MutipleTicketUnusedProcessing;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "MutipleTicketUnusedProcessing.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 5256309363921096:
2692642590089237,

/***/ 5289629256324197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.deepMap = deepMap;
	exports.deepForEach = deepForEach;
	
	var _react = __webpack_require__(1);
	
	var _Tab = __webpack_require__(7925919092148657);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabList = __webpack_require__(228970576441975);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _TabPanel = __webpack_require__(7121215342470674);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isTabChild(child) {
	  return child.type === _Tab2.default || child.type === _TabList2.default || child.type === _TabPanel2.default;
	}
	
	function deepMap(children, callback) {
	  return _react.Children.map(children, function (child) {
	    // null happens when conditionally rendering TabPanel/Tab
	    // see https://github.com/reactjs/react-tabs/issues/37
	    if (child === null) return null;
	
	    if (isTabChild(child)) {
	      return callback(child);
	    }
	
	    if (child.props && child.props.children && _typeof(child.props.children) === 'object') {
	      // Clone the child that has children and map them too
	      return (0, _react.cloneElement)(child, _extends({}, child.props, {
	        children: deepMap(child.props.children, callback)
	      }));
	    }
	
	    return child;
	  });
	}
	
	function deepForEach(children, callback) {
	  return _react.Children.forEach(children, function (child) {
	    // null happens when conditionally rendering TabPanel/Tab
	    // see https://github.com/reactjs/react-tabs/issues/37
	    if (child === null) return;
	
	    if (child.type === _Tab2.default || child.type === _TabPanel2.default) {
	      callback(child);
	    } else if (child.props && child.props.children && _typeof(child.props.children) === 'object') {
	      if (child.type === _TabList2.default) callback(child);
	      deepForEach(child.props.children, callback);
	    }
	  });
	}

/***/ }),

/***/ 5368640261582402:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewTourProductList = function (_React$Component) {
	    _inherits(ViewTourProductList, _React$Component);
	
	    function ViewTourProductList(props) {
	        _classCallCheck(this, ViewTourProductList);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewTourProductList.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC7AC\uACE0 \uC870\uD68C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC758 \uC635\uC158 \uC815\uBCF4\uB97C \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tours/',
	                                '{travelProductId}',
	                                '/items/',
	                                '{travelItemId}',
	                                '/inventories'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/1234567890/items/11111111/inventories'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '8', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '8', className: 'bold' },
	                                ' Query Parameters'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN_AND_CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778/\uC18C\uC778\uB3D9\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNIVERSITY_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACE0\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_AND_MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEENS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCCAD\uC18C\uB144'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PRESCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uCDE8\uD559\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC18C\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'INFANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'calendarDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uC815\uC77C\uC790(Format: yyyy-MM-dd)'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<InventoryDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                '\xA0calendarDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uC815\uC77C\uC790(Format: yyyy-MM-dd)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                '\xA0deadlineDay'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uD558\uB294 \uB0A0\uC9DC\uC804\uC5D0 \uBA87 \uC77C\uC5D0 \uD504\uB85C\uB355\uD2B8 \uD310\uB9E4\uB97C \uC911\uC9C0\uC2DC\uD0A4\uACA0\uC2B5\uB2C8\uAE4C? \uB514\uD3F4\uD2B8\uAC12:0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'deadlineHour'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uD558\uB294 \uB0A0\uC9DC \uB9C8\uC774\uB108\uC2A4 deadlineDay \uC804\uC5D0 \uBA87 \uC2DC\uAC04\uC5D0 \uD504\uB85C\uB355\uD2B8 \uD310\uB9E4\uB97C \uC911\uC9C0\uC2DC\uD0A4\uACA0\uC2B5\uB2C8\uAE4C? \uB370\uC774\uD130\uB294 1\uBD80\uD130 24\uAE4C\uC9C0\uC774\uBA70 \uB514\uD3F4\uD2B8\uAC12:24'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'onSale'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC911:true, \uD310\uB9E4\uC911\uC9C0:false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'salePrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'totalSoldCount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD1D\uD310\uB9E4\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'totalStockCount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD1D \uC7AC\uACE0 \uC218\uB7C9'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#toursResponseDto' },
	                            'Response Body Sample'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'toursResponseDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n    "code": 200,\n    "message": "OK",\n    "nextPageToken": "1573106534426",\n    "size": 20,\n    "data": [\n        {\n            "travelProductId": 515006525668851712,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-22T11:32:13.55",\n            "modifiedAt": "2019-11-22T11:32:15.449"\n        },\n        {\n            "travelProductId": 511520339147096064,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T21:13:46.422",\n            "modifiedAt": "2019-11-13T07:52:14.463"\n        },\n        {\n            "travelProductId": 511496123001602048,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T19:03:08.745",\n            "modifiedAt": "2019-11-12T19:09:53.528"\n        },\n        {\n            "travelProductId": 511493199361998848,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T18:51:31.416",\n            "modifiedAt": "2019-11-12T18:51:33.011"\n        },\n        {\n            "travelProductId": 511485095396245504,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T18:49:53.339",\n            "modifiedAt": "2019-11-12T18:58:21.498"\n        },\n        {\n            "travelProductId": 511485064899461120,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T18:49:46.063",\n            "modifiedAt": "2019-11-12T18:58:20.659"\n        },\n        {\n            "travelProductId": 511485478193594368,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T18:20:50.113",\n            "modifiedAt": "2019-11-12T18:50:00.398"\n        },\n        {\n            "travelProductId": 511468899942793216,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T18:19:49.08",\n            "modifiedAt": "2019-11-12T18:49:59.633"\n        },\n        {\n            "travelProductId": 511104860452552704,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T11:45:07.147",\n            "modifiedAt": "2019-11-12T11:45:09.107"\n        },\n        {\n            "travelProductId": 511373882012205056,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T11:44:59.29",\n            "modifiedAt": "2019-11-12T11:45:01.547"\n        },\n        {\n            "travelProductId": 511014995421560832,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-11T11:17:28.458",\n            "modifiedAt": "2019-11-11T11:17:40.001"\n        },\n        {\n            "travelProductId": 511013362465767424,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-11T11:12:50.049",\n            "modifiedAt": "2019-11-11T11:13:05.581"\n        },\n        {\n            "travelProductId": 510008242529632256,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-08T16:40:47.522",\n            "modifiedAt": "2019-11-08T16:41:42.496"\n        },\n        {\n            "travelProductId": 510006709880619008,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-08T16:24:45.278",\n            "modifiedAt": "2019-11-12T11:43:45.453"\n        },\n        {\n            "travelProductId": 509936318738857984,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-08T16:16:39.401",\n            "modifiedAt": "2019-11-08T16:17:10.729"\n        },\n        {\n            "travelProductId": 509728881356308480,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-07T22:00:49.816",\n            "modifiedAt": "2019-11-07T22:00:51.318"\n        },\n        {\n            "travelProductId": 509720793962250240,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-07T21:50:04.258",\n            "modifiedAt": "2019-11-07T21:50:05.569"\n        },\n        {\n            "travelProductId": 509707256686706688,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-07T20:36:41.435",\n            "modifiedAt": "2019-11-07T20:36:43.597"\n        },\n        {\n            "travelProductId": 90594745723791,\n            "sellerProductId": "seller-product-id --- 11111",\n            "vendorItemPackageId": 10000000003173,\n            "productId": 98723984761,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": "COMPLETE_APPROVAL",\n            "saleStatus": "SUSPENDED",\n            "name": "[\uB9CC\uB9AC\uC7A5\uC131]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-07T17:24:25.061",\n            "modifiedAt": "2019-11-14T18:03:41.71"\n        },\n        {\n            "travelProductId": 90594745723761,\n            "sellerProductId": "seller-product-id --- 11111",\n            "vendorItemPackageId": 10000000003167,\n            "productId": 98723984761,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": "COMPLETE_APPROVAL",\n            "saleStatus": "ON_SALE",\n            "name": "[\uB9CC\uB9AC\uC7A5\uC131]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-07T15:02:14.426",\n            "modifiedAt": "2019-11-07T17:22:39.741"\n        }\n    ]\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewTourProductList;
	}(_react2.default.Component);
	
	exports.default = ViewTourProductList;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewTourItemInventories.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 5514153148102359:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewReservationList = function (_React$Component) {
	    _inherits(ViewReservationList, _React$Component);
	
	    function ViewReservationList(props) {
	        _classCallCheck(this, ViewReservationList);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewReservationList.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { id: "view-reservation-list" },
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC608\uC57D \uBAA9\uB85D \uC870\uD68C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uD310\uB9E4\uB41C \uC0C1\uD488\uC758 \uC608\uC57D\uC744 \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. (\uAE30\uAC04 \uC81C\uD55C : 1\uB2EC , \uC81C\uACF5 \uB370\uC774\uD130 \uC218 \uC81C\uD55C : \uCD5C\uB300 10,000\uAC1C)'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/reservations'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/reservations'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                ' Query Parameters'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'pageSize'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0\uB124\uC774\uC158: \uD55C \uD398\uC774\uC9C0 \uD06C\uAE30. Default: 50'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'startDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB514\uD3F4\uD2B8 \uC624\uB298\uC758 00:00:00, \uB0A0\uC9DC \uD615\uC2DD yyyy-MM-dd HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'endDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB514\uD3F4\uD2B8 \uB0B4\uC77C\uC758 00:00:00, \uB0A0\uC9DC \uD615\uC2DD yyyy-MM-dd HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'responseDto'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Travel Item Id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Travel Rate Id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productDetailType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488 \uC0C1\uC138 \uD0C0\uC785'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'checkInDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'CheckIn Date'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'checkOutDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'CheckOut Date'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'penaltyPrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Penalty Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'arrivalTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uCC29\uC608\uC815\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'roomRequest'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4\uC694\uCCAD\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'additionalInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5C5\uCCB4 \uCEE4\uC2A4\uD140 \uD544\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorItemPackageName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC0C1\uD488\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorItemPackageId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uD15C \uD328\uD0A4\uC9C0 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorItemName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC0C1\uD488 \uC544\uC774\uD15C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uD15C \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Vendor Id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'userPhoneNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC800 \uC804\uD654 \uBC88\uD638r'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'userName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC800 \uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'userEmail'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC800 \uC774\uBA54\uC77C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'totalQuantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketStatusType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Enum'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD2F0\uCF13 \uC0C1\uD0DC'
	                                            ),
	                                            _react2.default.createElement('td', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CONFIRM_PENDING'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D\uB300\uAE30'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CONFIRMED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D\uD655\uC815'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CANCEL_RECEIPT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uC811\uC218'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CANCEL_PROCEEDING'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uC911'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CANCEL_COMPLETE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uC644\uB8CC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'USED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC1C\uD589\uC644\uB8CC'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13 \uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'salePrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uAC00\uACA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'reservedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D \uC77C\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'reservationModifiedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Reservation Update Time'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'reservationId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Reservation Id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88 \uC77C\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateCategoryId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'RateCategory Id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'purcahsedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4 \uC77C\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Product Type'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD504\uB85C\uB355\uD2B8 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'orderId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBB38 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'dailyInventoryPrices'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraPrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Extra Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraDepositPrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Extra Deposit Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'discountedSalePrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Discounted Sale Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'depositPrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Deposit Price'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'couponSrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Coupon Serial Number'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#responseReservationDto' },
	                            'Response Body Sample'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'responseReservationDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": {\n        "success": true,\n        "results": {\n            "totalPages": 3,\n            "totalElements": 121,\n            "sort": null,\n            "size": 50,\n            "numberOfElements": 50,\n            "number": 0,\n            "last": false,\n            "first": true,\n            "content": [\n                {\n                    "travelProductId": "a5901dc1-9080-4d50-a2cb-7e7b8d9aa061",\n                    "travelItemId": "15c366c9-1249-48bd-8abd-44e5ba2b2adf",\n                    "travelRateId": null,\n                    "productDetailType": "HOTEL",\n                    "penaltyPrice": null,\n                    "arrivalTime": "",\n                    "roomRequest": "\uB354\uBE14\uBC30\uB4DC\uD574\uC8FC\uC138\uC694^^",\n                    "additionalInfo": null,\n                    "vendorItemPackageName": "\uC528\uD074\uB77C\uC6B0\uB4DC\uD638\uD154\uB808\uC9C0\uB358\uC2A4",\n                    "vendorItemPackageId": 100000068296,\n                    "vendorItemName": "\uC288\uD398\uB9AC\uC5B4 \uD558\uD504\uC624\uC158 \uB79C\uB364\uBC30\uC815 \uAE30\uBCF8\uC694\uAE08(\uC870\uC2DD\uBD88\uD3EC\uD568)",\n                    "vendorItemId": 5631440404,\n                    "vendorId": "A12345678",\n                    "userPhoneNumber": "010-1234-5678",\n                    "userName": "abc",\n                    "userEmail": "test@naver.com",\n                    "totalQuantity": 1,\n                    "ticketStatusType": "USED",\n                    "ticketNumber": "BD8543-24000123456789",\n                    "salePrice": 66000,\n                    "reservedAt": "2021-02-12 00:00:00",\n                    "reservationModifiedAt": "2021-01-20 23:24:29",\n                    "reservationId": 12345678,\n                    "refundedAt": null,\n                    "rateCategoryId": 123451,\n                    "purchasedAt": "2021-01-20 23:24:04",\n                    "productType": "ACCOMMODATION",\n                    "productId": 347244742,\n                    "orderId": 24000123456789,\n                    "dailyInventoryPrices": [\n                        {\n                            "price": 66000,\n                            "extraPrice": 0,\n                            "extraDepositPrice": 0,\n                            "discountedSalePrice": 66000,\n                            "depositPrice": 58740,\n                            "date": "2021-02-12"\n                        }\n                    ],\n                    "couponSrl": 2400112344567,\n                    "checkOutDate": "2021-02-13",\n                    "checkInDate": "2021-02-12"\n                },\n                {\n                    "travelProductId": "a5901dc1-9080-4d50-a2cb-7e7b8d9aa061",\n                    "travelItemId": "8b78ce04-4df0-4016-971e-114e29ef0c7f",\n                    "travelRateId": null,\n                    "productDetailType": "HOTEL",\n                    "penaltyPrice": "0",\n                    "arrivalTime": "",\n                    "roomRequest": "",\n                    "additionalInfo": null,\n                    "vendorItemPackageName": "\uC528\uD074\uB77C\uC6B0\uB4DC\uD638\uD154\uB808\uC9C0\uB358\uC2A4",\n                    "vendorItemPackageId": 100000068296,\n                    "vendorItemName": "\uC288\uD398\uB9AC\uC5B4 \uD2B8\uC708 \uBE44\uC804\uB9DD -> \uD558\uD504\uC624\uC158\uBDF0 \uAE30\uBCF8\uC694\uAE08(\uC870\uC2DD\uBD88\uD3EC\uD568)",\n                    "vendorItemId": 5631440410,\n                    "vendorId": "A11223344",\n                    "userPhoneNumber": "010-1234-5678",\n                    "userName": "xyz",\n                    "userEmail": "test222@coupang.com",\n                    "totalQuantity": 1,\n                    "ticketStatusType": "CANCEL_COMPLETE",\n                    "ticketNumber": "E583E7-5000123456789",\n                    "salePrice": 121000,\n                    "reservedAt": "2021-02-11 00:00:00",\n                    "reservationModifiedAt": "2021-01-20 21:13:13",\n                    "reservationId": 11223344,\n                    "refundedAt": "2021-01-22 13:51:44",\n                    "rateCategoryId": 11111,\n                    "purchasedAt": "2021-01-20 21:13:04",\n                    "productType": "ACCOMMODATION",\n                    "productId": 347244742,\n                    "orderId": 5001122334455,\n                    "dailyInventoryPrices": [\n                        {\n                            "price": 55000,\n                            "extraPrice": 0,\n                            "extraDepositPrice": 0,\n                            "discountedSalePrice": 55000,\n                            "depositPrice": 48950,\n                            "date": "2021-02-11"\n                        },\n                        {\n                            "price": 66000,\n                            "extraPrice": 0,\n                            "extraDepositPrice": 0,\n                            "discountedSalePrice": 66000,\n                            "depositPrice": 58740,\n                            "date": "2021-02-12"\n                        }\n                    ],\n                    "couponSrl": 5112233445566,\n                    "checkOutDate": "2021-02-13",\n                    "checkInDate": "2021-02-11"\n                },\n                {\n                    "travelProductId": "a5901dc1-9080-4d50-a2cb-7e7b8d9aa061",\n                    "travelItemId": "8b78ce04-4df0-4016-971e-114e29ef0c7f",\n                    "travelRateId": null,\n                    "productDetailType": "HOTEL",\n                    "penaltyPrice": "0",\n                    "arrivalTime": "",\n                    "roomRequest": "",\n                    "additionalInfo": null,\n                    "vendorItemPackageName": "\uC528\uD074\uB77C\uC6B0\uB4DC\uD638\uD154\uB808\uC9C0\uB358\uC2A4",\n                    "vendorItemPackageId": 100000068296,\n                    "vendorItemName": "\uC288\uD398\uB9AC\uC5B4 \uD2B8\uC708 \uBE44\uC804\uB9DD -> \uD558\uD504\uC624\uC158\uBDF0 \uAE30\uBCF8\uC694\uAE08(\uC870\uC2DD\uBD88\uD3EC\uD568)",\n                    "vendorItemId": 5631440410,\n                    "vendorId": "A00112233",\n                    "userPhoneNumber": "010-1111-2222",\n                    "userName": "abc",\n                    "userEmail": "test1234@coupang.com",\n                    "totalQuantity": 1,\n                    "ticketStatusType": "CANCEL_COMPLETE",\n                    "ticketNumber": "28849C-5001122334455",\n                    "salePrice": 121000,\n                    "reservedAt": "2021-02-11 00:00:00",\n                    "reservationModifiedAt": "2021-01-20 21:11:32",\n                    "reservationId": 11223344,\n                    "refundedAt": "2021-01-22 13:51:43",\n                    "rateCategoryId": 112345,\n                    "purchasedAt": "2021-01-20 21:11:24",\n                    "productType": "ACCOMMODATION",\n                    "productId": 347244742,\n                    "orderId": 5123412341234,\n                    "dailyInventoryPrices": [\n                        {\n                            "price": 55000,\n                            "extraPrice": 0,\n                            "extraDepositPrice": 0,\n                            "discountedSalePrice": 55000,\n                            "depositPrice": 48950,\n                            "date": "2021-02-11"\n                        },\n                        {\n                            "price": 66000,\n                            "extraPrice": 0,\n                            "extraDepositPrice": 0,\n                            "discountedSalePrice": 66000,\n                            "depositPrice": 58740,\n                            "date": "2021-02-12"\n                        }\n                    ],\n                    "couponSrl": 5567856785678,\n                    "checkOutDate": "2021-02-13",\n                    "checkInDate": "2021-02-11"\n                }\n            ]\n        },\n        "failMessage": null\n    }\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforReservation' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforReservation', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel-body' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC2DC\uAC04\uB300\uB294 ',
	                                            '<= {maxDays}',
	                                            '\uC77C\uC774\uC5B4\uC57C\uB428'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'VendorItemPackageIds\uC758 \uC218\uCE58\uB294 ',
	                                            '<= {maxVips}',
	                                            '\uC774\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC2DC\uC791\uC77C\uC740 \uC885\uB8CC\uC77C\uBCF4\uB2E4 \uB2A6\uC9C0 \uC54A\uC544\uC57C\uD568'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewReservationList;
	}(_react2.default.Component);
	
	exports.default = ViewReservationList;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewReservationList.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 5744599009178468:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeleteTourProduct = function (_React$Component) {
	    _inherits(DeleteTourProduct, _React$Component);
	
	    function DeleteTourProduct(props) {
	        _classCallCheck(this, DeleteTourProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    DeleteTourProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { id: "delete-tour-product" },
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC0C1\uD488 \uC0AD\uC81C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC744 \uC0AD\uC81C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'DELETE'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tours/',
	                                '{travelProductId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/1234567890'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "code": 200\n            "message" : "success"\n            "data" : 504283629589889024\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return DeleteTourProduct;
	}(_react2.default.Component);
	
	exports.default = DeleteTourProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "DeleteTourProduct.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 5903247864544070:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateTourProduct = function (_React$Component) {
	    _inherits(CreateTourProduct, _React$Component);
	
	    function CreateTourProduct(props) {
	        _classCallCheck(this, CreateTourProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    CreateTourProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { className: 'mb0 mt40', id: 'create-tour-product' },
	            _react2.default.createElement(
	                'h3',
	                null,
	                ' \uC0C1\uD488 \uB4F1\uB85D'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uCFE0\uD321\uC5D0\uC11C \uD310\uB9E4\uD560 \uD328\uD0A4\uC9C0/\uD56D\uACF5 \uC0C1\uD488\uC744 \uB4F1\uB85D\uD558\uB294 API\uC785\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tours'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC0DD\uC131 \uD6C4 \uBCC0\uACBD\uBD88\uAC00 \uD56D\uBAA9 \uC785\uB2C8\uB2E4'
	                                            ),
	                                            _react2.default.createElement('td', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            ),
	                                            _react2.default.createElement('th', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAD6D\uB0B4\uC5EC\uD589'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OVERSEAS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uC678\uC5EC\uD589'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'productDetailType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC0DD\uC131 \uD6C4 \uBCC0\uACBD\uBD88\uAC00 \uD56D\uBAA9 \uC785\uB2C8\uB2E4'
	                                            ),
	                                            _react2.default.createElement('td', null),
	                                            _react2.default.createElement('td', null)
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'travelType'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'productDetailType'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DAY_TRIP_TOUR'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB2F9\uC77C\uC5EC\uD589 (\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ACCOMMODATION_TOUR'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC219\uBC15\uC5EC\uD589 (\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC_AIR_TEL_TOUR'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAD6D\uB0B4 \uC5D0\uC5B4\uD154 \uD22C\uC5B4 (\uAD6D\uB0B4)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC_AIR_TICKET'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAD6D\uB0B4\uD56D\uACF5\uAD8C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OVERSEAS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AIR_TEL_TOUR'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC720\uC5EC\uD589 (\uD574\uC678)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OVERSEAS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PACKAGE_TOUR'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD328\uD0A4\uC9C0\uC5EC\uD589 (\uD574\uC678)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OVERSEAS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OVERSEAS_AIR_TICKET'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uC678\uD56D\uACF5\uAD8C/\uC2B9\uC120\uAD8C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488\uBA85. (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 50\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'adultOnly'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '19\uC138\uBBF8\uB9CC \uAD6C\uB9E4\uBD88\uAC00. Default:FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'subordinateIds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uAD00\uB9AC \uC11C\uBE0CID \uB9AC\uC2A4\uD2B8'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'searchTags'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC11C\uCE58\uD0DC\uADF8 \uB9AC\uC2A4\uD2B8 (\uAC01 \uC11C\uCE58\uD0DC\uADF8 \uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 10\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'displayKeyword'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uC5D0 \uD45C\uC2DC\uD560 \uC9C0\uC5ED \uD0A4\uC6CC\uB4DC (\uAC01 \uD0A4\uC6CC\uB4DC \uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 10\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'displayCategoryCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uC758 \uB178\uCD9C \uCE74\uD14C\uACE0\uB9AC. Example: 106774 (\uC0DD\uC131 \uD6C4 \uBCC0\uACBD\uBD88\uAC00 \uD56D\uBAA9 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'images'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\uAC00 \uC0C1\uD488 \uB300\uD45C\uD568, \uC0C1\uD488\uB2F9 \uB2E8\uC77C \uB300\uD45C\uC774\uBBF8\uC9C0 \uBCF4\uC720. Default: FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerImageCategory'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 \uCE74\uD14C\uACE0\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'imageGroup'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'VIEW'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FACILITY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD80\uB300\uC2DC\uC124'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESTAURANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DD\uB2F9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ROOM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        )
	                                    )
	                                ),
	                                '\uB514\uD3F4\uD2B8 \uAC12: BASIC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC21C\uC11C.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelItems'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerTravelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'onSale'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC911:true, \uD310\uB9E4\uC911\uC9C0:false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'period'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C\uC758 \uC5EC\uD589\uAE30\uAC04 (\uC608: 4\uBC155\uC77C)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'itineraries'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC77C\uC815 \uC81C\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815\uC5D0 \uAD00\uD55C \uACF5\uC9C0\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'courses'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC81C\uBAA9 \uC608) 1\uC77C\uCC28'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'summary'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC694\uC57D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'from'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD9C\uBC1C\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'to'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'details'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'HOTEL, FLIGHT, MEAL, SIGHTSEEING, SHOPPING, NOTICE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'mealName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2DD\uC0AC \uC81C\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'location'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC7A5\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'flightFrom'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uCD9C\uBC1C\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'flightTo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uBAA9\uC801\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'flightDepartureTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uCD9C\uBC1C\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'flightArrivalTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uB3C4\uCC29\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'duration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC18C\uC694\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'descriptions'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                '\u2003\u2003title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uB0B4\uC6A9 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                '\u2003\u2003type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                '\u2003\u2003content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uB0B4\uC6A9(\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                '\u2003\u2003format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT \uB514\uD3F4\uD2B8 \uAC12'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                '\u2003\u2003sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url \uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                '\u2003\u2003sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                '\u2003\u2003seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC11C\uBD80\uC77C\uC815 \uB0B4\uC6A9 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'feeIncluded'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08 \uD3EC\uD568\uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'optional'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815 \uC790\uC720\uC120\uD0DD \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contents'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uCEE8\uD150\uCE20 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785\uC5D0 \uB300\uD55C \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825. \uC608:\uD328\uD0A4\uC9C0 \uD22C\uC5B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\' \uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \'\uC774\uBBF8\uC9C0\'\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\'\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url \uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'features'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'featureId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'featureValues'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'taxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 taxType\uC774 \uC790\uB3D9\uC73C\uB85C \uBA74\uC138(FREE)\uB85C \uC124\uC815\uB418\uBA70, \uC774\uC678\uC758 taxType\uB97C \uC124\uC815 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACFC\uC138 (\uAE30\uBCF8\uAC12)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBA74\uC138'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ZERO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC138'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Rate id from seller side'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN_AND_CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778/\uC18C\uC778\uB3D9\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNIVERSITY_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACE0\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_AND_MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEENS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCCAD\uC18C\uB144'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PRESCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uCDE8\uD559\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC18C\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'INFANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'priceType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TOTAL_PRODUCT_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD1D \uC0C1\uD488 \uAC00\uACA9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC \uD648\uD398\uC774\uC9C0\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_MALL_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC\uBAB0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ONLINE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC628\uB77C\uC778 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TRAVEL_AGENCY_SPECIAL_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5EC\uD589\uC0AC \uD2B9\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESERVATION_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uB9E4\uCC98 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HOMEPAGE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD648\uD398\uC774\uC9C0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SITE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD604\uC7A5 \uD310\uB9E4\uAC00'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC6D0\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Default: TRUE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'saleStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC2DC\uC791\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'saleEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC885\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss). Default: 2099-12-31 23:59:59'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'maxPurchaseQtyPerPerson'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uB2F9 \uCD5C\uB300 \uAD6C\uB9E4 \uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'maxPurchaseQtyPeriod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4 \uC81C\uD55C \uAE30\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'trafficInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCC3E\uC544\uAC00\uB294 \uAE38 \uC124\uBA85\uD558\uB294 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825. (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAC08\uC774\uB294 20\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'publicTransportInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uB300\uC911\uAD50\uD1B5 \uC815\uBCF4 \uC124\uBA85\uD558\uB294 \uC790\uC720 \uD14D\uC2A4\uD2B8 \uC785\uB825. (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 20\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'nearbyLandmarks'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uAD00\uAD11\uC9C0 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C \uC704\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C \uACBD\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C\uAE4C\uC9C0\uC758 \uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'distanceUnit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'KILOMETER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD0AC\uB85C\uBBF8\uD130'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'METER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uD130'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'direction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC11C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTH'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTH'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTHEAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NORTHWEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD81\uC11C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTHEAST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SOUTHWEST'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0A8\uC11C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'transportations'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SUBWAY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC9C0\uD558\uCCA0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BUS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBC84\uC2A4'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'operationPeriods'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B4\uD589\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'startTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B4\uD589 \uC2DC\uC791\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'endTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B4\uD589 \uC885\uB8CC\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'locations'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 locations\uAC00 \uD544\uC218 \uAC12\uC774 \uC544\uB2D8. Locations \uAC12\uC774 \uC785\uB825\uB41C \uACBD\uC6B0 \uAF2D \uC815\uD655\uD55C \uAC12\uC73C\uB85C \uC785\uB825\uD574\uC57C\uD568.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0 \uC704\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0 \uACBD\uB3C4 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'roadNameAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uB85C\uBA85\uC8FC\uC18C.\uB3C4\uB85C\uBA85 \uB610\uB294 \uC9C0\uBC88\uC8FC\uC18C \uC911 \uCD5C\uC18C\uD55C \uD55C\uAC00\uC9C0\uB294 \uC785\uB825\uD574\uC57C \uD568'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'landNumberAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uBC88\uC8FC\uC18C. \uB3C4\uB85C\uBA85 \uB610\uB294 \uC9C0\uBC88\uC8FC\uC18C \uC911 \uCD5C\uC18C\uD55C \uD55C\uAC00\uC9C0\uB294 \uC785\uB825\uD574\uC57C \uD568'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6D\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'province'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD589\uC815\uB2E8\uC704 \uC8FC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'city'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'district'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C, \uAD6C\uC5ED'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'town'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC74D \uBA74 \uB3D9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'zipCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B0\uD3B8\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'contents'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uCEE8\uD150\uCE20 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785\uC5D0 \uB300\uD55C \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825. \uC608:\uD328\uD0A4\uC9C0 \uD22C\uC5B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\' \uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \'\uC774\uBBF8\uC9C0\'\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\'\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url \uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'features'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureValues'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC18D\uC131 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'themes'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'reservationNotifications'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBA54\uC77C \uC8FC\uC18C, \uC804\uD654\uBC88\uD638 \uD639\uC740 \uD329\uC2A4 \uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactDescription'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'contacts'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WEBSITE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC6F9\uC0AC\uC774\uD2B8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contactUseType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'REPRESENTATIVE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD45C\uC5F0\uB77D\uCC98*\uD544\uC218'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BOOKING_INQUIRY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D\uBB38\uC758 \uC5F0\uB77D\uCC98'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CANCEL_INQUIRY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uBB38\uC758 \uC5F0\uB77D\uCC98'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMERGENCY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE34\uAE09\uC5F0\uB77D\uB9DD'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'contact'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608: \uC5F0\uB77D\uCC98 \uD0C0\uC785\uC774 \uD3F0\uC774\uBA74: 010-0000-0000'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'itineraries'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC77C\uC815 \uC81C\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815\uC5D0 \uAD00\uD55C \uACF5\uC9C0\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'courses'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC81C\uBAA9 \uC608) 1\uC77C\uCC28'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'summary'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC694\uC57D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'from'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD9C\uBC1C\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'to'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'details'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'HOTEL, FLIGHT, MEAL, SIGHTSEEING, SHOPPING, NOTICE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'mealName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2DD\uC0AC \uC81C\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'location'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC7A5\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightFrom'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uCD9C\uBC1C\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightTo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uBAA9\uC801\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightDepartureTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uCD9C\uBC1C\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightArrivalTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uB3C4\uCC29\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'duration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC18C\uC694\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'descriptions'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uB0B4\uC6A9 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uB0B4\uC6A9(\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT \uB514\uD3F4\uD2B8 \uAC12'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url \uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC11C\uBD80\uC77C\uC815 \uB0B4\uC6A9 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'feeIncluded'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08 \uD3EC\uD568\uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'optional'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815 \uC790\uC720\uC120\uD0DD \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'cancelPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uACF5\uC9C0 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AUTO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uB3D9\uCDE8\uC18C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778\uCDE8\uC18C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelPeriodType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BEFORE_USE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC0AC\uC6A9 \uCC98\uB9AC\uC804 \uAC00\uB2A5(\uC720\uD6A8\uAE30\uAC04 \uC885\uB8CC\uC2DC\uAE4C\uC9C0)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AFTER_7DAYS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAD6C\uB9E4\uC77C + 7\uC77C \uC774\uB0B4 \uAC00\uB2A5'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelMarkType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uB2F9 \uC5C6\uC74C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_CANCELED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCDE8\uC18C\uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNUSE_REFUND_ALL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uC0AC\uC6A9 100%\uD658\uBD88'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_REFUND_AFTER_RECEIPT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD2F0\uCF13 \uBC1C\uC1A1 \uD6C4 \uD658\uBD88 \uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'NOT_REFUND_AFTER_RESERVATION_CONFIRM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uC57D \uD655\uC815 \uD6C4 \uD658\uBD88 \uBD88\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNUSE_REFUND_ALL_BEFORE_ONE_DAY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uC6A9\uC77C 1\uC77C\uC804\uAE4C\uC9C0 100%\uD658\uBD88'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DEPENDING_ON_VENDOR'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5C5\uCCB4 \uADDC\uC815\uC5D0 \uB530\uB984'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundOnBusinessDay'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC601\uC5C5\uC77C \uAE30\uC900 \uCDE8\uC18C \uC811\uC218 \uC5EC\uBD80 (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundUnusedTicket'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBBF8\uC0AC\uC6A9 \uD2F0\uCF13 100% \uD658\uBD88 \uC5EC\uBD80 (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'refundRates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9CC\uC57D cancelMarkType\uC774 \u2018\uC5C5\uCCB4\uADDC\uC815\uC5D0 \uB530\uB984\u2019\uC778 \uACBD\uC6B0, \uD658\uBD88\uC728 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'conditionDays'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uC77C x \uC77C \uC804 \uAE4C\uC9C0 \uD658\uBD88 \uAC00\uB2A5'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'conditionTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uC77C x \uC77C y \uC2DC \uC804 \uAE4C\uC9C0 \uD658\uBD88 \uAC00\uB2A5 format: HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'refundRate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC728 ex: rate 70% is 70'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'cancellable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uAC00\uB2A5 \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'introduction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC0C1\uD488 \uC18C\uAC1C\uB9D0 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uC6A9\uC548\uB0B4 \uBC0F \uC720\uC758\uC0AC\uD56D (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'benefits'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uBCC4\uD788 \uC81C\uACF5\uB418\uB294 \uD61C\uD0DD \uBC0F \uBCF4\uB108\uC2A4\u2018\uB780 \uAD6C\uB9E4 \uACE0\uAC1D\uC5D0\uAC8C \uD2B9\uBCC4\uD558\uAC8C \uC81C\uACF5\uB418\uB294 \uD61C\uD0DD\uC73C\uB85C \uC2E4\uC81C \uBCF8 \uC0C1\uD488\uC678\uC5D0 \uBB34\uB8CC \uD639\uC740 \uD560\uC778\uB418\uC5B4 \uC81C\uACF5\uB418\uB294 \uC120\uBB3C\uC774\uB098 \uC11C\uBE44\uC2A4\uB97C \uB9D0\uD569\uB2C8\uB2E4. (\uAC01 \uBCF4\uB108\uC2A4 \uC124\uBA85 \uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 30\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'flightInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uC0AC \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825,\uC608: \uD56D\uACF5\uD3B8 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'visaInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBE44\uC790 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'meetingNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9D1\uD569 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825,\uC608: \uD56D\uACF5\uD3B8 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DDl'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC8FC\uBB38'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'guideInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC00\uC774\uB4DC \uC815\uBCF4 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'shoppingInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'details'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'shoppingCategory'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC1FC\uD305 \uCE74\uD14C\uACE0\uB9AC \uC790\uC720 \uD14D\uC2A4\uD2B8 \uC785\uB825 example : "\uB77C\uD14D\uC2A4"'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'shoppingPlace'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC1FC\uD551 \uC7A5\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'duration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC1FC\uD551 \uC18C\uC694\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'refundable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88 \uAC00\uB2A5 \uC5EC\uBD80 Default: true'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'exchangeRefundNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement('td', null),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD50\uD658 \uD658\uBD88 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825,\uC608: \uD56D\uACF5\uD3B8 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'tourGuides'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC5B4 \uAC00\uC774\uB4DC \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'safetyInstructions'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC548\uC804\uC218\uCE59 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'hotelInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD638\uD154\uC815\uBCF4 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'insuranceInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCF4\uD5D8\uC815\uBCF4 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DDl'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'inclusionNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD3EC\uD568\uC0AC\uD56D \uAE30\uC7AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'exclusionNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBD88\uD3EC\uD568 \uC0AC\uD56D \uAE30\uC7AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'usageNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC720\uC758\uC0AC\uD56D \uAE30\uC7AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'reservationGuide'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D\uAC00\uC774\uB4DC \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url\uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'additionalInfoPrompt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488 \uC8FC\uBB38/\uC608\uC57D\uC5D0 \uD544\uC694\uD55C \uACE0\uAC1D\uC815\uBCF4\uB97C \uC218\uC9D1\uD560\uC218 \uC788\uC2B5\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'maxPurchaseQuantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC778\uB2F9 \uAD6C\uB9E4 \uCD5C\uB300 \uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'csContactInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uACE0\uAC1D\uC13C\uD130 \uBB38\uC758 \uC815\uBCF4 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'taxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 taxType\uC774 \uC790\uB3D9\uC73C\uB85C \uBA74\uC138(FREE)\uB85C \uC124\uC815\uB418\uBA70, \uC774\uC678\uC758 taxType\uB97C \uC124\uC815 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACFC\uC138 (\uAE30\uBCF8\uAC12)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBA74\uC138'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ZERO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC138'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'instantBooking'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC989\uC2DC \uC608\uC57D (Default: false)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'estimatedBookingDuration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D\uD655\uC815 \uC18C\uC694\uC2DC\uAC04, \uC989\uC2DC\uC608\uC57D\uC774 FALSE \uB77C\uBA74 \uD544\uC694.\uB370\uC774\uD130\uB294 0 \uBD80\uD130 72\uAE4C\uC9C0\uC774\uBA70'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'extension'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE30\uD0C0 \uC815\uBCF4\uC0AC\uD56D \uC790\uC720 \uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#createTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'createTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n  "sellerProductId": "seller-product-id",\n  "productDetailType": "PACKAGE_TOUR",\n  "travelType": "OVERSEAS",\n  "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 5/6\uC77C \uD328\uD0A4\uC9C0",\n  "adultOnly": false,\n  "searchTags": [\n    "\uC911\uAD6D\uC7A5\uAC00\uACC4",\n    "\uC7A5\uAC00\uACC4\uC5EC\uD589"\n  ],\n  "displayKeyword": "\uC778\uCC9C\u51FA",\n  "displayCategoryCode": 108682,\n  "images": [\n    {\n      "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n      "sellerUrlMethod": "GET",\n      "representative": true,\n      "sellerImageCategory": "1234",\n      "imageGroup": "BASIC",\n      "description": "image 1 description",\n      "seq": 0\n    },\n    {\n      "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n      "sellerUrlMethod": "GET",\n      "representative": false,\n      "sellerImageCategory": "1234",\n      "imageGroup": "BASIC",\n      "description": "image 2 description",\n      "seq": 1\n    },\n    {\n      "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",\n      "sellerUrlMethod": "GET",\n      "representative": false,\n      "sellerImageCategory": "1234",\n      "imageGroup": "BASIC",\n      "description": "image 3 description",\n      "seq": 2\n    },\n    {\n      "sellerUrl": "http://image15.coupangcdn.com/image/bannerunit/bannerunit_c5b412fb-44cd-4cfb-b632-bafd1270fef8.jpg",\n      "sellerUrlMethod": "GET",\n      "representative": false,\n      "sellerImageCategory": "1234",\n      "imageGroup": "BASIC",\n      "description": "image 4 description",\n      "seq": 3\n    }\n  ],\n  "trafficInfo": "\uC81C\uC8FC\uACF5\uD56D \uCC28\uB7C9 \uC57D 3km",\n  "publicTransportInfo": "\uC6A9\uB450\uC554 \uCC28\uB7C9 \uC57D 1km",\n  "nearbyLandmarks": [\n    {\n      "name": "nearby 1",\n      "latitude": 10.1,\n      "longitude": 20.2,\n      "distance": 300,\n      "distanceUnit": "METER",\n      "direction": null,\n      "transportations": [\n        \n      ]\n    },\n    {\n      "name": "nearby 2",\n      "latitude": 30.3,\n      "longitude": 40.4,\n      "distance": 2,\n      "distanceUnit": "KILOMETER",\n      "direction": null,\n      "transportations": [\n        \n      ]\n    }\n  ],\n  "locations": [\n    {\n      "latitude": 80.11,\n      "longitude": 20.12,\n      "roadNameAddress": "\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4 \uC81C\uC8FC\uC2DC \uC6A9\uD574\uB85C 21-6",\n      "landNumberAddress": "\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4 \uC81C\uC8FC\uC2DC \uC6A9\uB2F4\uC0BC\uB3D9 1016",\n      "nation": "\uB300\uD55C\uBBFC\uAD6D",\n      "province": null,\n      "city": "\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4",\n      "district": "\uC81C\uC8FC\uC2DC",\n      "town": "\uC6A9\uB2F4\uC0BC\uB3D9",\n      "zipCode": "63150"\n    }\n  ],\n  "contents": [\n    {\n      "title": "product content title 1",\n      "type": "Product-Content",\n      "content": "product content 1: text",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 0\n    },\n    {\n      "title": "product content title 2",\n      "type": "Product-Content",\n      "content": null,\n      "format": "IMAGE",\n      "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n      "sellerUrlMethod": "GET",\n      "seq": 1\n    },\n    {\n      "title": "product content title 3",\n      "type": "Product-Content",\n      "content": null,\n      "format": "IMAGE",\n      "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpgg",\n      "sellerUrlMethod": "GET",\n      "seq": 2\n    },\n    {\n      "title": "product content title 2",\n      "type": "Product-Content",\n      "content": null,\n      "format": "IMAGE",\n      "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",\n      "sellerUrlMethod": "GET",\n      "seq": 3\n    }\n  ],\n  "features": [\n    {\n      "featureId": "ADDITIONAL_EXPENSE",\n      "featureValues": [\n        "ADDITIONAL_EXPENSE_EXCLUDE"\n      ],\n      "description": null\n    },\n    {\n      "featureId": "SHOPPING",\n      "featureValues": [\n        "SHOPPING_INCLUDE"\n      ],\n      "description": null\n    },\n    {\n      "featureId": "FREE_SCHEDULE",\n      "featureValues": [\n        "FREE_SCHEDULE_EXCLUDE"\n      ],\n      "description": null\n    }\n  ],\n  "themes": [\n    "SIGHT_SEEING",\n    "WATER_SPORTS"\n  ],\n  "reservationNotifications": [\n    {\n      "type": "PHONE",\n      "contactInfo": "010-1234-5678",\n      "contactDescription": "order notification phone number"\n    },\n    {\n      "type": "EMAIL",\n      "contactInfo": "coupang@coupang.com",\n      "contactDescription": "order notification email"\n    }\n  ],\n  "contacts": [\n    {\n      "contactType": "PHONE",\n      "contactUseType": "REPRESENTATIVE",\n      "contact": "02-1544-3663"\n    },\n    {\n      "contactType": "PHONE",\n      "contactUseType": "BOOKING_INQUIRY",\n      "contact": "02-1544-3663"\n    },\n    {\n      "contactType": "PHONE",\n      "contactUseType": "EMERGENCY",\n      "contact": "02-1544-3663"\n    },\n    {\n      "contactType": "PHONE",\n      "contactUseType": "CANCEL_INQUIRY",\n      "contact": "02-1544-3663"\n    }\n  ],\n  "itineraries": [\n    {\n      "name": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4 3\uBC155\uC77C]",\n      "notice": "\u203B\uBCF8 \uC0C1\uD488\uC740 \uBAA8\uB450\uD22C\uC5B4\uC758 \uB3D9\uC77C\uD56D\uACF5\uC758 \uB2E4\uB978\uC0C1\uD488\uACFC \uD604\uC9C0\uC5D0\uC11C \uC870\uC778(\uD569\uB958) \uB418\uC5B4 \uC9C4\uD589\uB420 \uC218 \uC788\uC73C\uBA70, \uCD9C\uBC1C 1\uC77C\uC804\uAE4C\uC9C0 \uC77C\uC815 \uD655\uC815\uC2DC \uD648\uD398\uC774\uC9C0 \uB4F1\uC744 \uD1B5\uD574 \uD655\uC778 \uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n\u203B\uBCF8 \uC0C1\uD488\uC740 \uC608\uC57D\uC2DC\uC810\uC5D0 \uB530\uB77C \uC0C1\uD488\uAC00\uAC00 \uC0C1\uC774\uD560 \uC218 \uC788\uC73C\uBA70 \uAE08\uC561 \uCC28\uC774\uC5D0 \uB300\uD574\uC11C\uB294 \uCD94\uD6C4 \uD658\uBD88 \uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\\n\u203B\uC77C\uC815\uC0C1\uC758 \uD45C\uAE30\uB41C \uD638\uD154\uC740 \uD604\uC9C0 \uC0AC\uC815\uC0C1 \uAC00\uB2A5\uD55C \uD638\uD154\uC774\uB098 \uB3D9\uAE09 \uD638\uD154\uB85C \uBCC0\uACBD\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\u203B\uC7A5\uAC00\uACC4 \uC77C\uC815 \uC911 \uC1FC\uD551\uC13C\uD130 \uC678 \uCC28\uB7C9\uB0B4 \uAE30\uB150\uD488 \uD310\uB9E4 \uBC0F \uB18D\uC218\uC0B0\uD488 \uD310\uB9E4\uB97C \uD558\uBA70, \uD544\uC694\uD55C \uACE0\uAC1D\uC5D0 \uD55C\uD558\uBA70 \uAD6C\uB9E4\uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n\u203B\uD604\uC9C0\uC0AC\uC815(\uAE30\uD6C4, \uB3C4\uB85C\uB4F1)\uC5D0 \uB530\uB77C \uC18C\uBE44\uC790\uC758 \uB3D9\uC758\uB97C \uC5BB\uC5B4 \uC5EC\uD589\uC77C\uC815 \uBCC0\uACBD\uC774 \uAC00\uB2A5\uD558\uBA70, \uAE30\uC0C1\uC545\uD654\uC5D0 \uB530\uB77C \uC77C\uBD80 \uAD00\uAD11\uC9C0\uAC00 \uC81C\uD55C\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n---111111",\n      "courses": [\n        {\n          "name": "1 \uC77C\uCC28 - 1",\n          "summary": "2019\uB144 10\uC6D4 14\uC77C \uC6D4\uC694\uC77C - 1",\n          "from": "\uC778\uCC9C (ICN)\uCD9C\uBC1C - 1",\n          "to": "\uC911\uACBD (CKG)\uB3C4\uCC29 - 1",\n          "details": [\n            {\n              "type": "NOTICE",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": "19:00:00",\n              "flightArrivalTime": "19:00:00",\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "\uC911\uACBD \uB2E8\uCCB4\uBE44\uC790 \uC785\uAD6D\uC2DC \uC720\uC758 \uC0AC\uD56D - 1",\n                  "type": null,\n                  "content": "\uAC1C\uC694 : \u25CE \uC911\uAD6D \uBE44\uC790 \uC785\uAD6D \uC21C\uC11C \u25CE\\n1. \uC5EC\uAD8C\uACFC \uBE44\uC790 \uC6D0\uBCF8\uC744 \uD655\uC778 \uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n-\uC911\uAD6D \uBE44\uC790 \uC6D0\uBCF8\uC740 \uBD89\uC740\uC0C9 \uB3C4\uC7A5\uC774 \uCC0D\uD600 \uC788\uC2B5\uB2C8\uB2E4.\\n2. \uBE44\uC790 1\uBC88\uC5D0 \uC788\uB294 \uC190\uB2D8\uAED8\uC11C \uC5EC\uAD8C\uACFC \uBE44\uC790 \uC6D0\uBCF8, \uBCF5\uC0AC\uBCF8 1\uBD80\uB97C \uC785\uAD6D\uC2EC\uC0AC\uB300\uC5D0 \uC81C\uCD9C \uD569\uB2C8\uB2E4.\\n3. \uBE44\uC790\uC5D0 \uB098\uC640 \uC788\uB294 \uC21C\uC11C\uB300\uB85C \uC785\uAD6D\uC2EC\uC0AC\uB300\uB97C \uD1B5\uACFC\uD569\uB2C8\uB2E4.\\n4. \uBE44\uC790 \uB9C8\uC9C0\uB9C9\uC5D0 \uC788\uB294 \uC190\uB2D8\uAED8\uC11C\uB294 \uBE44\uC790 \uC6D0\uBCF8\uC744 \uBC1B\uC544 \uC624\uC154\uC57C \uD569\uB2C8\uB2E4.\\n(\uBE44\uC790 \uC6D0\uBCF8\uC740 \uCD9C\uAD6D \uC2DC \uC81C\uCD9C\uD569\uB2C8\uB2E4.)\\n---111111",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                }\n              ],\n              "seq": 0,\n              "feeIncluded": true,\n              "optional": false\n            },\n            {\n              "type": "FLIGHT",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": "\uC778\uCC9C (ICN)\uCD9C\uBC1C - 1",\n              "flightTo": "\uC911\uACBD (CKG)\uB3C4\uCC29 - 1",\n              "flightDepartureTime": "10-14 (\uC6D4) 15:10",\n              "flightArrivalTime": "10-14 (\uC6D4) 17:40",\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "Fight Title Required",\n                  "type": null,\n                  "content": "CA440\uD3B8-03\uC2DC\uAC04 30\uBD84 \uC18C\uC694",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                }\n              ],\n              "seq": 1,\n              "feeIncluded": true,\n              "optional": false\n            },\n            {\n              "type": "MEAL",\n              "mealName": "\uC11D\uC2DD",\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "Meal Title Required",\n                  "type": null,\n                  "content": "\uD604\uC9C0\uC2DD",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                }\n              ],\n              "seq": 2,\n              "feeIncluded": true,\n              "optional": false\n            },\n            {\n              "type": "HOTEL",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "Hotel Title Required",\n                  "type": null,\n                  "content": "\uCD1D 2\uAC1C\uC758 \uC608\uC815 \uD638\uD154\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uD655\uC815 \uB418\uB294\uB300\uB85C(\uCD9C\uBC1C 1\uC77C\uC804\uAE4C\uC9C0) \uD648\uD398\uC774\uC9C0, \uC774\uBA54\uC77C \uB610\uB294 \uC54C\uB9BC\uD1A1 \uB4F1\uC744 \uD1B5\uD574 \uC548\uB0B4 \uB4DC\uB9AC\uACA0\uC2B5\uB2C8\uB2E4.",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                }\n              ],\n              "seq": 3,\n              "feeIncluded": true,\n              "optional": false\n            }\n          ]\n        },\n        {\n          "name": "2 \uC77C\uCC28",\n          "summary": "2019\uB144 10\uC6D4 15\uC77C \uD654\uC694\uC77C",\n          "from": null,\n          "to": null,\n          "details": [\n            {\n              "type": "SIGHTSEEING",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "\uBCF4\uBD09\uD638",\n                  "type": null,\n                  "content": "\uBCF4\uBD09\uD638\uC218\uB294 \uB310\uC744 \uC313\uC544 \uBB3C\uC744 \uB9C9\uC544\uC11C \uB9CC\uB4E0 \uC778\uACF5\uD638\uC218\uB85C \uC8FC\uB85C \uC218\uB825\uBC1C\uC804\uACFC \uC591\uC2DD\uC7A5\uC73C\uB85C \uC0AC\uC6A9 \uB418\uB358 \uC911 \uBCF4\uBD09\uD638\uC758 \uC544\uB984\uB2E4\uC6C0\uC5D0 \uAD00\uAD11\uC9C0\uB85C \uAC1C\uBC1C\uB418\uC5C8\uC2B5\uB2C8\uB2E4 \uD574\uBC1C 430m \uC704\uC5D0 \uC788\uB294 \uC0B0\uC815\uD638\uC218\uB85C \uD3C9\uADE0\uC218\uC2EC\uC740 72m\uC774\uBA70 \uAC00\uC7A5 \uB113\uC740 \uACF3\uC758 \uD3ED\uC740 150m\uC5D0 \uC774\uB978\uB2E4. \uC120\uB140\uBC14\uC704, \uB450\uAEBC\uBE44\uBC14\uC704, \uACF5\uC791\uC0C8\uBC14\uC704 \uB4F1\uACFC \uAC19\uC774 \uC0AC\uB78C \uD639\uC740 \uC9D0\uC2B9\uBAA8\uC591\uC73C\uB85C \uB418\uC5B4\uC788\uB294 \uBC14\uC704\uB4E4\uC774 \uBCF4\uBD09\uD638\uC758 \uC544\uB984\uB2E4\uC6C0\uC744 \uB354\uC6B1 \uC2E0\uBE44\uC2A4\uB7FD\uAC8C \uB9CC\uB4E4...",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 1\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 2\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 3\n                }\n              ],\n              "seq": 0,\n              "feeIncluded": true,\n              "optional": false\n            },\n            {\n              "type": "SIGHTSEEING",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "\uC120\uD0DD\uAD00\uAD11-\uD669\uB8E1\uB3D9\uAD74($30)",\n                  "type": null,\n                  "content": "\uAC1C\uC694 : \uAD70\uC9C0\uD3C9 \uB3D9\uCABD\uC73C\uB85C 8km \uB5A8\uC5B4\uC9C4 \uACF3\uC5D0 \uC704\uCE58\uD574 \uC788\uB2E4. \uC9C0\uAC01\uC6B4\uB3D9\uC73C\uB85C \uC778\uD574 \uC0DD\uC131\uB41C \uC11D\uD68C\uC554 \uC6A9\uC554\uB3D9\uAD74\uB85C \uC0C1\uD558 4\uCE35\uC73C\uB85C \uB418\uC5B4 \uC788\uACE0, \uC544\uB798 2\uCE35\uC5D0\uB294 4\uAC1C\uC758 \uC2DC\uB0B4\uAC00 \uD758\uB7EC\uB0B4\uB9AC\uB294 \uB3D9\uAD74\uC774\uB2E4. \uC218\uC9C1\uACE0\uB3C4\uB294 160m, \uB3D9\uAD74 \uAE38\uC774\uB294 15km\uC774\uBA70, \uC774\uBBF8 \uAC1C\uBC1C\uB418\uC5B4 \uC788\uB294 \uBA74\uC801\uC774 6\uB9CC\uD3C9\uC5D0 \uB2EC\uD55C\uB2E4. \uB610\uD55C \uB3D9\uAD74 \uC548\uC5D0\uB294 \uC218\uB9CE\uC740 \uAE30\uC774\uD55C \uC885\uC720\uC11D\uC774 \uCC9C\uD0DC\uB9CC\uC0C1\uC744 \uBCF4\uC5EC\uC8FC\uACE0 \uC788\uB2E4.",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 1\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 2\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 3\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image15.coupangcdn.com/image/bannerunit/bannerunit_c5b412fb-44cd-4cfb-b632-bafd1270fef8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 4\n                }\n              ],\n              "seq": 1,\n              "feeIncluded": false,\n              "optional": true\n            },\n            {\n              "type": "SIGHTSEEING",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "\uC120\uD0DD\uAD00\uAD11-\uC720\uB9AC\uB2E4\uB9AC+\uB300\uD611\uACE1($95)",\n                  "type": null,\n                  "content": "\uAC1C\uC694 : \uC720\uB9AC\uB2E4\uB9AC\uC640 \uB300\uD611\uACE1\uC744 \uD568\uAC8C \uBCFC \uC218 \uC788\uB294 \uC120\uD0DD\uAD00\uAD11",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 1\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 2\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_190acf41-9f35-4085-9e46-f3ff2f407c05.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 3\n                },\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": null,\n                  "format": "IMAGE",\n                  "sellerUrl": "http://image15.coupangcdn.com/image/bannerunit/bannerunit_c5b412fb-44cd-4cfb-b632-bafd1270fef8.jpg",\n                  "sellerUrlMethod": "GET",\n                  "seq": 4\n                }\n              ],\n              "seq": 2,\n              "feeIncluded": false,\n              "optional": true\n            },\n            {\n              "type": "HOTEL",\n              "mealName": null,\n              "location": null,\n              "hotelName": null,\n              "flightFrom": null,\n              "flightTo": null,\n              "flightDepartureTime": null,\n              "flightArrivalTime": null,\n              "duration": null,\n              "distance": null,\n              "descriptions": [\n                {\n                  "title": "Test Title",\n                  "type": null,\n                  "content": "\uCD1D 2\uAC1C\uC758 \uC608\uC815 \uD638\uD154\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uD655\uC815 \uB418\uB294\uB300\uB85C(\uCD9C\uBC1C 1\uC77C\uC804\uAE4C\uC9C0) \uD648\uD398\uC774\uC9C0, \uC774\uBA54\uC77C \uB610\uB294 \uC54C\uB9BC\uD1A1 \uB4F1\uC744 \uD1B5\uD574 \uC548\uB0B4 \uB4DC\uB9AC\uACA0\uC2B5\uB2C8\uB2E4.",\n                  "format": "TEXT",\n                  "sellerUrl": null,\n                  "sellerUrlMethod": "GET",\n                  "seq": 0\n                }\n              ],\n              "seq": 3,\n              "feeIncluded": true,\n              "optional": false\n            }\n          ]\n        }\n      ]\n    }\n  ],\n  "cancelPolicy": {\n    "notice": "\u2022 \uCDE8\uC18C\uB8CC\uB294 \uCFE0\uD321\uAC00(\uC989\uC2DC\uD560\uC778 \uC801\uC6A9 \uC804 \uC0C1\uD488\uAC00) \uAE30\uC900\uC73C\uB85C \uBD80\uACFC\uB429\uB2C8\uB2E4.(\uC5EC\uD589\uC0AC\uC758 \uADC0\uCC45 \uC0AC\uC720\uB85C \uC778\uD55C \uCDE8\uC18C\uC758 \uACBD\uC6B0\uC5D0\uB3C4 \uB3D9\uC77C\uD558\uAC8C \uC801\uC6A9\uB429\uB2C8\uB2E4.) \u2022 \uC989\uC2DC\uD560\uC778\uC740 \uC0C1\uD669\uC5D0 \uB530\uB77C \uC608\uACE0\uC5C6\uC774 \uD560\uC778\uAE08\uC561\uC758 \uC870\uC815 \uBC0F \uC870\uAE30\uC885\uB8CC \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \u2022 \uC989\uC2DC\uD560\uC778 \uC774\uBCA4\uD2B8\uAC00 \uC885\uB8CC\uB41C \uD6C4\uC5D0\uB294 \uAE30\uC801\uC6A9\uB41C \uC989\uC2DC\uD560\uC778 \uC0C1\uD488\uC744 \uCDE8\uC18C \uD6C4\uC5D0 \uC7AC\uAD6C\uB9E4\uD558\uB354\uB77C\uB3C4 \uD560\uC778 \uC801\uC6A9\uC774 \uC720\uC9C0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \u2022 \uBCF8 \uC0C1\uD488\uC740 \uC608\uC57D \uD6C4 \uCDE8\uC18C\uD560 \uACBD\uC6B0 \uC5EC\uD589\uC57D\uAD00 \uC81C5\uC870 (\uD2B9\uC57D)\uC5D0 \uB530\uB77C \uD45C\uC900\uC57D\uAD00\uACFC\uB294 \uBCC4\uB3C4\uC758 \uCDE8\uC18C\uC218\uC218\uB8CC\uAC00 \uC801\uC6A9\uB429\uB2C8\uB2E4. (\uC774 \uC0C1\uD488\uC740 \uD56D\uACF5(\uB610\uB294 \uC120\uBC15)\uC88C\uC11D \uB610\uB294 \uD638\uD154 \uAC1D\uC2E4\uC5D0 \uB300\uD55C \uBE44\uC6A9\uC744 \uC120\uB0A9\uD574 \uB193\uC740 \uC0C1\uD488\uC73C\uB85C\uC11C, \uCDE8\uC18C\uC2DC \uBCC4\uB3C4\uC758 \uCDE8\uC18C\uC218\uC218\uB8CC\uAC00 \uC801\uC6A9\uB428\uC744 \uC591\uD574 \uBC14\uB78D\uB2C8\uB2E4.) \u2022 \uD574\uD53C\uCF5C\uC744 \uD1B5\uD574 \uC608\uC57D \uD655\uC815 \uD6C4 \uC5EC\uD589\uC790\uC758 \uCDE8\uC18C\uC694\uCCAD \uC2DC \uC5C5\uCCB4\uAC00 \uC815\uD55C \uD2B9\uBCC4\uC57D\uAD00\uC5D0 \uC758\uAC70 \uCDE8\uC18C\uB8CC\uAC00 \uBD80\uACFC\uB429\uB2C8\uB2E4. (\uAD6D\uC678\uC5EC\uD589\uC57D\uAD00 \uC81C5\uC870 \uD2B9\uC57D) \u261E \uCDE8\uC18C\uC218\uC218\uB8CC \uD2B9\uBCC4 \uADDC\uC815 (\u203B \uC804\uC138\uAE30 \uC0C1\uD488 \uBC0F \uC911\uAD6D \uBBFC\uD56D\uAE30 \uC0C1\uD488 \uADDC\uC815\u203B) - \uD574\uD53C\uCF5C \uD655\uC815 \uD6C4 ~30\uC77C \uC774\uC804 \uCDE8\uC18C \uC704\uC57D\uAE08 20\uB9CC\uC6D0 - \uC5EC\uD589\uAC1C\uC2DC 20\uC77C \uC804\uAE4C\uC9C0(29 ~ 20) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 30% \uBC30\uC0C1 - \uC5EC\uD589\uAC1C\uC2DC 10\uC77C \uC804\uAE4C\uC9C0(19 ~ 10) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 55% \uBC30\uC0C1 - \uC5EC\uD589\uAC1C\uC2DC   8\uC77C \uC804\uAE4C\uC9C0( 9 ~   8) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 85% \uBC30\uC0C1 - \uC5EC\uD589\uAC1C\uC2DC   1\uC77C \uC804\uAE4C\uC9C0( 7 ~   1) \uD1B5\uBCF4 : \uC5EC\uD589\uC694\uAE08\uC758 90% \uBC30\uC0C1 - \uC5EC\uD589 \uB2F9\uC77C \uD1B5\uBCF4 \uC2DC : \uC5EC\uD589\uC694\uAE08\uC758 100% \uBC30\uC0C1",\n    "cancelType": "APPROVAL",\n    "cancelPeriodType": "BEFORE_USE",\n    "cancelMarkType": "DEPENDING_ON_VENDOR",\n    "refundOnBusinessDay": true,\n    "refundUnusedTicket": true,\n    "refundRates": [\n      {\n        "conditionDays": 5,\n        "conditionTime": "17:00:00",\n        "refundRate": 100,\n        "cancellable": false\n      },\n      {\n        "conditionDays": 3,\n        "conditionTime": "17:00:00",\n        "refundRate": 70,\n        "cancellable": false\n      },\n      {\n        "conditionDays": 1,\n        "conditionTime": "17:00:00",\n        "refundRate": 50,\n        "cancellable": false\n      }\n    ]\n  },\n  "introduction": "\uC7A5\uAC00\uACC4 \uD56D\uACF5\uC774\uB3D9&\uBC84\uC2A4\uC774\uB3D9 \uC120\uD0DD\uAC00\uB2A5",\n  "notice": "\uB0A0\uC9DC\uB2F9 \uC131\uC778\uAE30\uC900 10\uBA85 \uC774\uC0C1 \uBAA8\uAC1D \uC2DC \uCD9C\uBC1C\uD655\uC815 \uAC00\uB2A5",\n  "benefits": [\n    "Special Offer 1",\n    "Special Offer 2"\n  ],\n  "flightInfo": {\n    "title": "Flight Information",\n    "type": "Flight Info",\n    "content": "\uD56D\uACF5\uD3B8:\uC911\uAD6D\uAD6D\uC81C\uD56D\uACF5\\n\uBB34\uB8CC\uC704\uD0C1\uC218\uD558\uBB3C:1pc 23kg [\uB2E8, \uC0B0\uB3D9\uB178\uC120(\uCCAD\uB3C4, \uC81C\uB0A8, \uC704\uD574, \uC5F0\uD0DC)\uC740 2pc 23kg]\\n\uD5C8\uC6A9\uAE30\uB0B4\uC218\uD558\uBB3C:1pc 5kg\\n",\n    "format": "TEXT",\n    "sellerUrl": null,\n    "sellerUrlMethod": "GET",\n    "seq": 0\n  },\n  "visaInfo": {\n    "title": "\uBE44 \uC790",\n    "type": "VISA Info",\n    "content": null,\n    "format": "IMAGE",\n    "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b01b1226-d2c9-490d-9110-0b18b179717d.jpg",\n    "sellerUrlMethod": "GET",\n    "seq": 0\n  },\n  "meetingPlace": "\uC778\uCC9C\uAD6D\uC81C\uACF5\uD56D 1\uD130\uBBF8\uB110 3\uCE35 \uCD9C\uAD6D\uC7A5 14\uBC88 \uCD9C\uAD6C \uC55E(N\uCE74\uC6B4\uD130 \uC606 \uCC3D\uCE21) \uC5EC\uD589\uC0AC\uCE74\uC6B4\uD130 38~42\uBC88 \uD14C\uC774\uBE14",\n  "meetingTime": "2019-11-01 12:30:00",\n  "meetingNotice": {\n    "title": "Map - Meeting Point",\n    "type": "Meeting Notice",\n    "content": null,\n    "format": "IMAGE",\n    "sellerUrl": "http://image11.coupangcdn.com/image/bannerunit/bannerunit_b81798da-9771-4edc-b1fc-ef2bb12a64d9.jpg",\n    "sellerUrlMethod": "GET",\n    "seq": 0\n  },\n  "guideInfo": "\uC778\uC194\uC790\uB294 \uB3D9\uBC18\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",\n  "shoppingInfo": {\n    "details": [\n      {\n        "shoppingCategory": "\uB77C\uD14D\uC2A4",\n        "shoppingPlace": "\uBB34\uB989\uC6D0 \uCC9C\uC790\uAC70\uB9AC \uB300\uC9C0\uB77C\uD14D\uC2A4",\n        "duration": "\uC57D 7-80\uBD84",\n        "refundable": false\n      },\n      {\n        "shoppingCategory": "\uC9C4\uC8FC",\n        "shoppingPlace": "\uCC9C\uBB381\uD638 \uC591\uC0C1 \uBC15\uB78C\uC911\uC2EC",\n        "duration": "\uC57D 60\uBD84",\n        "refundable": false\n      },\n      {\n        "shoppingCategory": "\uD788\uB178\uB07C",\n        "shoppingPlace": "\uBB34\uB989\uC6D0 \uBCF4\uBD09\uC0B0\uC7A5 \uB0B4 \uD788\uB178\uB07C \uB9E4\uC7A5",\n        "duration": "\uC57D 60\uBD84",\n        "refundable": false\n      },\n      {\n        "shoppingCategory": "\uAC8C\uB974\uB9C8\uB284",\n        "shoppingPlace": "\uBB34\uB989\uC6D0\uAD6C \uBC31\uB85C\uB85C \uAC74\uC124\uC740\uD589 \uD6C4\uC6D0",\n        "duration": "\uC57D 60\uBD84",\n        "refundable": true\n      }\n    ],\n    "exchangeRefundNotice": {\n      "title": null,\n      "type": "Exchange Refund Notice",\n      "content": "? \uD658\uBD88\uC811\uC218\uAE30\uAC04 : \uC5EC\uD589\uC885\uB8CC \uD6C4 30\uC77C \uC774\uB0B4\\n? \uD658\uBD88\uAC00\uB2A5\uBB3C\uD488 : \uC9C0\uC815\uB41C \uC1FC\uD551\uC7A5\uC18C\uC5D0\uC11C \uAD6C\uB9E4\uD55C \uBB3C\uD488,\uAC1C\uC778 \uAD6C\uB9E4 \uBB3C\uD488 \uD639\uC740 \uB2E8\uC21C \uACE0\uAC1D \uBCC0\uC2EC\uC758 \uAD50\uD658/\uD658\uBD88 \uB300\uD589 \uBD88\uAC00\\n? \uD658\uBD88\uC694\uCCAD\uBC29\uBC95 : \uC5EC\uD589\uC0C1\uD488\uBA85,\uCD9C\uBC1C\uC77C,\uC778\uC194\uC790\uBA85,\uAC04\uB2E8\uD55C \uC0AC\uC720\uB97C \uB300\uB9AC\uC810 \uD639\uC740 \uC608\uC57D\uB2F4\uB2F9\uC790\uC5D0\uAC8C \uC720\uC120 \uBB38\uC758 \uD6C4 \uC870\uCE58\\n? \uD658\uBD88\uD544\uC694\uC11C\uB958 : \uBCF8\uC778 \uC5F0\uB77D\uCC98/\uD1B5\uC7A5\uBC88\uD638(\uC218\uCDE8\uC778 \uBCF8\uC778\uB9CC \uAC00\uB2A5),\uC6D0\uBCF8 \uC601\uC218\uC99D(\uC0AC\uBCF8 \uBCF4\uAD00 \uD544\uC218),\uD658\uBD88 \uD639\uC740 \uAD50\uD658 \uC694\uCCAD \uBB3C\uD488\\n? \uD658\uBD88\uBC30\uC1A1\uBE44\uBD80\uB2F4 : \uACE0\uAC1D\uBCF8\uC778\\n? \uD658\uBD88\uC18C\uC694\uAE30\uAC04 : \uC811\uC218\uC77C\uB85C\uBD80\uD130 \uCD5C\uC18C 15\uC77C ~ \uCD5C\uB300 60\uC77C\\n\u25CE\uD658\uBD88\uC2DC \uC8FC\uC758\uC0AC\uD56D\u25CE\\n-\uD658\uBD88\uC218\uC218\uB8CC: \uCE74\uB4DC\uACB0\uC81C\uC778 \uACBD\uC6B0 \uD658\uBD88\uC2DC \uCE74\uB4DC\uC218\uC218\uB8CC 5% \uBD80\uACFC (\uD658\uBD88\uC218\uC218\uB8CC\uB294 \uC0C1\uD488 \uBC0F \uC1FC\uD551\uC810 \uAE30\uC900\uC5D0 \uB530\uB77C \uC0C1\uC774\uD558\uBA70, \uC601\uC218\uC99D \uBBF8\uC9C0\uCC38\uC2DC \uD658\uBD88 \uBD88\uAC00)\\n-\uC720\uC758\uC0AC\uD56D\\n1)\uBCF4\uC11D\uB958\\n\uC131\uBD84\uD568\uB7C9\uC774 \uBBF8\uB2EC\uB418\uB294 \uC81C\uD488\uC774 \uB9CE\uC73C\uB2C8, \uACE0\uAC00\uC758 \uC0C1\uD488\uC740 \uAD6C\uC785\uC744 \uC790\uC81C\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n2)\uB77C\uD14D\uC2A4\\n\uD3EC\uC7A5\uC774 \uC81C\uAC70\uB418\uC9C0 \uC54A\uC740 \uC81C\uD488\uC77C\uACBD\uC6B0 100% \uD658\uBD88 \uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n30\uC77C \uC774\uB0B4\uC5D0 \uB2E8\uC21C\uBCC0\uC2EC\uC73C\uB85C \uC778\uD55C \uD658\uBD88\uC2DC \uAD6C\uB9E4\uAE08\uC561\uC758 30% \uD658\uBD88\uC218\uC218\uB8CC \uBC1C\uC0DD\\n90\uC77C \uC774\uB0B4\uC5D0 \uB2E8\uC21C\uBCC0\uC2EC\uC73C\uB85C \uC778\uD55C \uD658\uBD88\uC2DC \uAD6C\uB9E4\uAE08\uC561\uC758 50% \uD658\uBD88\uC218\uC218\uB8CC \uBC1C\uC0DD\\n\uD604\uC9C0\uC5D0\uC11C \uBC30\uC1A1\uBC1B\uB294 \uACBD\uC6B0 \uBCC4\uB3C4\uC758 \uBC30\uC1A1\uBE44\uAC00 \uBD80\uACFC\\n3)\uAC8C\uB974\uB9C8\uB284\\n\uD658\uBD88\uC2DC \uC54C\uB808\uB974\uAE30 \uBC1C\uC0DD\uC740 \uAD6C\uB9E4\uC77C\uB85C\uBD80\uD130 7\uC77C \uB0B4\uC5D0 \uD658\uBD88\uC2E0\uCCAD, \uADF8 \uC678\uC758 \uD658\uBD88\uC740 \uAD6C\uB9E4\uC77C\uB85C\uBD80\uD130 15\uC77C \uB0B4\uC5D0 \uD658\uBD88 \uC2E0\uCCAD\\n\uD658\uBD88\uC2DC 5% \uCE74\uB4DC\uC218\uC218\uB8CC + 10% \uC704\uC57D\uAE08 \uBC1C\uC0DD\\n\uB3C4\uAE08\uBCC0\uC0C9\uC740 A/S \uBD88\uAC00\\n4)\uB18D\uC218\uC0B0\uBB3C(\uAE68,\uC7A3 \uB4F1)\\n\uAD50\uD658 \uBC0F \uD658\uBD88 \uC808\uB300 \uBD88\uAC00\\n",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 0\n    }\n  },\n  "tourGuides": [\n    {\n      "title": "\uC120\uD0DD\uAD00\uAD11 \uC548\uB0B4",\n      "type": "Tour Guide",\n      "content": "1. \uC120\uD0DD\uAD00\uAD11 \uBC0F \uC790\uC720\uC2DC\uAC04 \uC911 \uACE0\uAC1D\uB2D8\uC758 \uC548\uC804\uC744 \uC704\uD558\uC5EC \uAC00\uC774\uB4DC\uC758 \uC548\uB0B4\uC0AC\uD56D \uBC0F \uC548\uC804\uC218\uCE59\uC744 \uC900\uC218\uD558\uC5EC \uBAA8\uB4E0 \uC548\uC804\uC0AC\uACE0\uC5D0 \uC720\uC758\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n2. \uD604\uC9C0 \uC120\uD0DD\uAD00\uAD11\uC740 \uAC00\uC774\uB4DC\uC758 \uC8FC\uC758\uC0AC\uD56D\uC744 \uC219\uC9C0 \uD6C4 \uCC38\uC5EC \uC5EC\uBD80\uB97C \uACB0\uC815\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB77C\uBA70, \uCC38\uC5EC \uC804 \uBC18\uB4DC\uC2DC \uBC30\uD3EC\uB418\uB294 \uC548\uC804\uC218\uCE59 \uB3D9\uC758\uC11C\uB97C \uC219\uC9C0 \uBC0F \uB3D9\uC758 \uD6C4 \uCC38\uC5EC\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\\n3. \uC774\uC6A9\uC790 \uBCF8\uC778\uC758 \uACFC\uC2E4 \uBC0F \uAC74\uAC15\uC0C1\uD0DC\uB85C \uC778\uD558\uC5EC \uBC1C\uC0DD\uD55C \uC548\uC804\uC0AC\uACE0\uC5D0 \uB300\uD558\uC5EC \uB2F9\uC0AC\uB294 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\\n4. \uC120\uD0DD\uAD00\uAD11\uC740 \uACE0\uAC1D\uB2D8\uC774 \uC790\uC720\uB86D\uAC8C \uC9C0\uBD88\uC5EC\uBD80\uB97C \uACB0\uC815\uD560 \uC218 \uC788\uC73C\uBA70 \uC120\uD0DD\uAD00\uAD11\uC5D0 \uCC38\uC5EC\uD558\uC9C0 \uC54A\uC74C\uC73C\uB85C \uC778\uD55C \uCD94\uAC00\uC801\uC778 \uBE44\uC6A9 \uB610\uB294 \uC77C\uC815\uC0C1\uC758 \uBD88\uC774\uC775\uC740 \uC5C6\uC2B5\uB2C8\uB2E4.\\n",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 0\n    },\n    {\n      "title": "Tour Guide",\n      "type": "Tour Guide",\n      "content": "\u25C7 \uBBF8\uD305\uC7A5\uC18C : \uC778\uCC9C\uAD6D\uC81C\uACF5\uD56D \uC81C1\uD130\uBBF8\uB110 3\uCE35 N\uCE74\uC6B4\uD130(14\uBC88 \uCD9C\uC785\uBB38) \uC55E <\uD22C\uC5B42000> \uD14C\uC774\uBE14 \uBBF8\uD305\\n\u25C7 \uC778\uCC9C\uACF5\uD56D : \uC778\uCC9C\uACF5\uD56D \uC5F0\uB77D\uCC98 010-2742-6200\\n\u25C7 \uCD5C\uC18C \uCD9C\uBC1C \uC778\uC6D0 : \uC131\uC77810\uBA85 \uC774\uC0C1 \uCD9C\uBC1C \uAC00\uB2A5\uD569\uB2C8\uB2E4.\\n\u25C7 \uCD9C\uBC1C\uC778\uC6D0\uC774 \uBD80\uC871\uD560 \uACBD\uC6B0 \uD0C0\uC0AC\uC640 \uACF5\uB3D9 \uC9C4\uD589 \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\u25C7 \uC778\uC194\uC790\uB294 \uB3D9\uD589\uD558\uC9C0 \uC54A\uC73C\uBA70, \uD604\uC9C0 \uB3C4\uCC29 \uD6C4 \uAC00\uC774\uB4DC\uC640 \uBBF8\uD305 \uD569\uB2C8\uB2E4.\\n\u25C7 \uB3C5\uC2E4\uC0AC\uC6A9\uB8CC : 1\uBC15 40,000\uC6D0(\uC804 \uC77C\uC815 3\uBC15 120,000\uC6D0) \uC785\uB2C8\uB2E4.\\n- \uD638\uD154: 2\uC7781\uC2E4 \uAE30\uC900\uC774\uBA70, 3\uC778\uC2E4 \uC774\uC6A9\uC2DC \uAC04\uC774\uCE68\uB300\uAC00 \uC81C\uACF5 \uB429\uB2C8\uB2E4.\\n- \uC5EC\uD589 \uD558\uC2DC\uB294 \uC778\uC6D0\uC774 \uD640\uC218\uC778 \uACBD\uC6B0 \uBCC4\uB3C4\uC758 \uC694\uCCAD\uC774 \uC5C6\uC73C\uC2E4 \uACBD\uC6B0 3\uC7781\uC2E4\uB85C \uBC30\uC815 \uB429\uB2C8\uB2E4.\\n\u25C7 \uC790\uC720\uC77C\uC815 : \uD328\uD0A4\uC9C0\uC77C\uC815\uC758 \uD2B9\uC131\uC0C1 \uAC1C\uBCC4\uC77C\uC815 \uBD88\uAC00\uD569\uB2C8\uB2E4.\\n\u25C7 \uC77C\uC815 \uC9C4\uD589 \uC911 \uC1FC\uD551\uC810 \uBC29\uBB38\uC774 \uC788\uC2B5\uB2C8\uB2E4.(*\uC1FC\uD551\uC815\uBCF4 \uCC38\uC870)\\n\u25C7 \uC5EC\uD589\uC790 \uBCF4\uD5D8\uC740 \'DB \uC190\uD574\uBCF4\uD5D8\'\uC73C\uB85C \uC790\uB3D9 \uAC00\uC785 \uB429\uB2C8\uB2E4. (*\uC5EC\uD589\uC790\uBCF4\uD5D8 \uCC38\uC870)\\n\u25C7 \uBCF8 \uC5EC\uD589\uC0C1\uD488\uC740 \uACC4\uC57D\uAE08 \uC9C0\uBD88 \uC2DC\uC810\uBD80\uD130 \uACC4\uC57D\uC774 \uCCB4\uACB0\uB418\uBA70, \uACC4\uC57D \uD574\uC81C \uC694\uCCAD \uC2DC \uADC0\uCC45\uC0AC\uC720\uC5D0 \uB530\uB77C \uCDE8\uC18C\uC218\uC218\uB8CC\uAC00 \uBD80\uACFC\uB429\uB2C8\uB2E4. \uCDE8\uC18C\uC218\uC218\uB8CC \uBD80\uACFC\uAE30\uC900\uC740 [\uAD6D\uC678\uC5EC\uD589\uD45C\uC900\uC57D\uAD00/\uD2B9\uBCC4\uC57D\uAD00]\uC5D0 \uB530\uB985\uB2C8\uB2E4.\\n\u25C7 \uC0C1\uAE30 \uC77C\uC815\uC740 \uD56D\uACF5 \uBC0F \uD604\uC9C0\uC0AC\uC815\uC5D0 \uC758\uD558\uC5EC \uBCC0\uACBD\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\u25C7 \uC720\uB958\uD560\uC99D\uB8CC\uB294 \uC608\uC57D\uC2DC\uC810\uC774 \uC544\uB2CC \uBC1C\uAD8C\uC77C \uAE30\uC900\uC73C\uB85C \uC801\uC6A9\uB418\uBA70, \uAD6D\uC81C\uC720\uAC00\uC640 \uD56D\uACF5\uC0AC \uC601\uC5C5\uD658\uACBD\uC744 \uACE0\uB824\uD55C \uAC74\uC124\uAD50\uD1B5\uBD80\uC758 \uAD6D\uC81C\uC120 \uD56D\uACF5\uC694\uAE08\uACFC \uC720\uB958\uD560\uC99D\uB8CC \uD655\uB300\uBC29\uC548\uC5D0 \uB530\uB77C \uC608\uACE0\uC5C6\uC774 \uC778\uC0C1\uB418\uAC70\uB098 \uC778\uD558\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 1\n    }\n  ],\n  "safetyInstructions": [\n    {\n      "title": "\uC5EC\uD589\uAE08\uC9C0\uAD6D\uAC00 \uD604\uD669 \uBC0F \uBC95\uC801\uADFC\uAC70",\n      "type": "Safety Instruction",\n      "content": "\u25CF \uC5EC\uD589\uAE08\uC9C0\uAD6D\uAC00 \uC9C0\uC815 \uD604\uD669\\n\uC678\uAD50\uBD80\uB294 \uC6B0\uB9AC \uAD6D\uBBFC\uC758 \uC0DD\uBA85\xB7\uC548\uC804\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD558\uC5EC \uC5EC\uAD8C\uBC95 \uC81C 17\uC870\uC5D0 \uB530\uB77C \uC544\uB798\uC758 \uAD6D\uAC00\uB4E4\uC740 \uC9C0\uC815\uB41C \uAE30\uAC04 \uB3D9\uC548 \uC5EC\uD589\uAE08\uC9C0\uAD6D\uC73C\uB85C \uC9C0\uC815\uD558\uC5EC \uC6B0\uB9AC \uAD6D\uBBFC\uB4E4\uC758 \uBC29\uBB38 \uBC0F \uCCB4\uB958\uB97C \uAE08\uC9C0\uD569\uB2C8\uB2E4.\\n- \uC774\uB77C\uD06C(2007\uB144 8\uC6D4 7\uC77C ~ 2017\uB144 1\uC6D431\uC77C\uAE4C\uC9C0)\\n- \uC18C\uB9D0\uB9AC\uC544\xB7\uC544\uD504\uAC00\uB2C8\uC2A4\uD0C4(2007\uB144 8\uC6D4 7\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uC608\uBA58(2011\uB144 6\uC6D4 28\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uC2DC\uB9AC\uC544(2011\uB144 8\uC6D4 20\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uB9AC\uBE44\uC544(2014\uB144 8\uC6D4 4\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n- \uD544\uB9AC\uD540 \uC77C\uBD80\uC9C0\uC5ED(\uC7A0\uBCF4\uC559\uAC00, \uC220\uB8E8 \uAD70\uB3C4, \uBC14\uC2E4\uB780, \uD0C0\uC704\uD0C0\uC704 \uAD70\uB3C4) (2015\uB144 12\uC6D4 1\uC77C ~ 2017\uB144 1\uC6D4 31\uC77C\uAE4C\uC9C0)\\n\u25CF \uBC95\uC801\uADFC\uAC70\\n- \uC5EC\uAD8C\uBC95 17\uC870(\uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uC81C\uD55C \uB4F1)\\n\uC678\uAD50\uBD80\uC7A5\uAD00\uC740 \uCC9C\uC7AC\uC9C0\uBCC0\xB7\uC804\uC7C1\xB7\uB0B4\uB780\xB7\uD3ED\uB3D9\xB7\uD14C\uB7EC \uB4F1 \uB300\uD1B5\uB839\uB839\uC73C\uB85C \uC815\uD558\uB294 \uAD6D\uC678 \uC704\uB09C\uC0C1\uD669(\u5371\u96E3\u72C0\u6CC1)\uC73C\uB85C \uC778\uD558\uC5EC \uAD6D\uBBFC\uC758 \uC0DD\uBA85\xB7\uC2E0\uCCB4\uB098 \uC7AC\uC0B0\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD558\uC5EC \uAD6D\uBBFC\uC774 \uD2B9\uC815 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC744 \uBC29\uBB38\uD558\uAC70\uB098 \uCCB4\uB958\uD558\uB294 \uAC83\uC744 \uC911\uC9C0\uC2DC\uD0A4\uB294 \uAC83\uC774 \uD544\uC694\uD558\uB2E4\uACE0 \uC778\uC815\uD558\uB294 \uB54C\uC5D0\uB294 \uAE30\uAC04\uC744 \uC815\uD558\uC5EC \uD574\uB2F9 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC5D0\uC11C\uC758 \uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uC744 \uC81C\uD55C\uD558\uAC70\uB098 \uBC29\uBB38\xB7\uCCB4\uB958\uB97C \uAE08\uC9C0 (\uC774\uD558 \\"\uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uC81C\uD55C \uB4F1\\"\uC774\uB77C \uD55C\uB2E4)\uD560\uC218 \uC788\uB2E4. \uB2E4\uB9CC, \uC601\uC8FC(\u6C38\u4F4F), \uCDE8\uC7AC\xB7\uBCF4\uB3C4, \uAE34\uAE09\uD55C \uC778\uB3C4\uC801 \uC0AC\uC720, \uACF5\uBB34 \uB4F1 \uB300\uD1B5\uB839\uB839\uC73C\uB85C \uC815\uD558\uB294 \uBAA9\uC801\uC758 \uC5EC\uD589\uC73C\uB85C\uC11C \uC678\uAD50\uBD80\uC7A5\uAD00\uC774 \uD544\uC694\uD558\uB2E4\uACE0 \uC778\uC815\uD558\uBA74 \uC5EC\uAD8C\uC758 \uC0AC\uC6A9\uACFC \uBC29\uBB38\xB7\uCCB4\uB958\uB97C \uD5C8\uAC00\uD560 \uC218 \uC788\uB2E4.\\n- \uC5EC\uAD8C\uBC95 \uC81C26\uC870 \uC81C17\uC870\uC81C1\uD56D \uBCF8\uBB38 \uBC0F \uC81C2\uD56D\uC5D0 \uB530\uB77C \uBC29\uBB38 \uBC0F \uCCB4\uB958\uAC00 \uAE08\uC9C0\uB41C \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC73C\uB85C \uACE0\uC2DC\uB41C \uC0AC\uC815\uC744 \uC54C\uBA74\uC11C\uB3C4 \uAC19\uC740 \uC870 \uC81C1\uD56D \uB2E8\uC11C\uC5D0 \uB530\uB978 \uD5C8\uAC00(\uC81C14\uC870\uC81C3\uD56D\uC5D0 \uB530\uB77C \uC900\uC6A9\uB418\uB294 \uACBD\uC6B0\uB97C \uD3EC\uD568\uD55C\uB2E4)\uB97C \uBC1B\uC9C0 \uC544\uB2C8\uD558\uACE0 \uD574\uB2F9 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC5D0\uC11C \uC5EC\uAD8C \uB4F1\uC744 \uC0AC\uC6A9\uD558\uAC70\uB098 \uD574\uB2F9 \uAD6D\uAC00\uB098 \uC9C0\uC5ED\uC744 \uBC29\uBB38\uD558\uAC70\uB098 \uCCB4\uB958\uD55C \uC0AC\uB78C\uC740 1\uB144 \uC774\uD558\uC758 \uC9D5\uC5ED \uB610\uB294 1000\uB9CC\uC6D0 \uC774\uD558\uC758 \uBC8C\uAE08\uC5D0 \uCC98\uD55C\uB2E4.\\n",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 0\n    },\n    {\n      "title": "\uC5EC\uD589\uC9C0(\uAD6D\uAC00/\uC9C0\uC5ED) \uC5EC\uD589\uACBD\uBCF4 \uBC1C\uB839\uD604\uD669",\n      "type": "Safety Instruction",\n      "content": "\u25CF \uC911\uAD6D\\n- \uC5EC\uD589\uC720\uC758(\uC77C\uBD80) : \uC911\uAD6D\u318D\uBD81\uD55C \uAD6D\uACBD\uC9C0\uC5ED : \uB2E8\uB465\uC2DC, \uAD00\uC804\uB9CC\uC871\uC790\uCE58\uD604, \uC9D1\uC548\uC2DC, \uBC31\uC0B0\uC2DC, \uC784\uAC15\uC2DC, \uC7A5\uBC31\uC870\uC120\uC871\uC790\uCE58\uD604, \uC548\uB3C4\uD604, \uD654\uB8E1\uC2DC, \uC6A9\uC815\uC2DC, \uB3C4\uBB38\uC2DC, \uD6C8\uCD98\uC2DC\\n- \uC5EC\uD589\uC790\uC81C(\uC77C\uBD80) : \uD2F0\uBCB3, \uC2E0\uC7A5\uC704\uAD6C\uB974\uC790\uCE58\uAD6C\\n\uC678\uAD50\uBD80\uB294 \uC6B0\uB9AC \uAD6D\uBBFC\uC758 \uC0DD\uBA85\xB7\uC548\uC804\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD558\uC5EC \uC5EC\uAD8C\uBC95 \uC81C 17\uC870\uC5D0 \uB530\uB77C \uC544\uB798\uC758 \uAD6D\uAC00\uB4E4\uC740 \uC9C0\uC815\uB41C \uAE30\uAC04 \uB3D9\uC548 \uC5EC\uD589\uAE08\uC9C0\uAD6D\uC73C\uB85C \uC9C0\uC815\uD558\uC5EC \uC6B0\uB9AC \uAD6D\uBBFC\uB4E4\uC758 \uBC29\uBB38 \uBC0F \uCCB4\uB958\uB97C \uAE08\uC9C0\uD569\uB2C8\uB2E4.\\n\u203B \uC5EC\uD589\uACBD\uBCF4\uB2E8\uACC4\uB294 \uC5EC\uD589\uC720\uC758/\uC790\uC81C/\uC81C\uD55C/\uAE08\uC9C0 4\uB2E8\uACC4\uB85C \uAD6C\uBD84\uB418\uBA70, \uC678\uAD50\uBD80 \'\uD574\uC678\uC548\uC804\uC5EC\uD589\' \uC0AC\uC774\uD2B8(www.0404.go.kr)\uC5D0\uC11C \uC0C1\uC138\uC815\uBCF4\uB97C \uD655\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n\uB610\uD55C \uCD9C\uAD6D \uC804 \uB3D9\uC0AC\uC774\uD2B8\uC758 \uD574\uC678\uC5EC\uD589 \uB4F1\uB85D\uC81C \\"\uB3D9\uD589\\"\uC5D0 \uAC00\uC785\uD558\uC2DC\uBA74 \uC548\uC804\uC815\uBCF4\uB97C \uC218\uC2DC\uB85C \uC81C\uACF5 \uBC1B\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n",\n      "format": "TEXT",\n      "sellerUrl": null,\n      "sellerUrlMethod": "GET",\n      "seq": 1\n    }\n  ],\n  "hotelInfo": {\n    "title": "Hotel Information",\n    "type": "Hotel Information",\n    "content": "\u2022 \uD638\uD154\uBA85 :\\n\u2022 \uB4F1\uAE09 : \\n\u2022 \uB8F8\uD0C0\uC785 : \\n\u2022 1\uC778 \uC2F1\uAE00 \uB8F8 \uC0AC\uC6A9\uC2DC :\\n- \uD638\uD154\uC740 \uBD80\uB4DD\uC774\uD55C \uACBD\uC6B0 \uB3D9\uAE09\uC758 \uB2E4\uB978 \uD638\uD154\uB85C \uBCC0\uB3D9 \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\\n",\n    "format": "TEXT",\n    "sellerUrl": null,\n    "sellerUrlMethod": "GET",\n    "seq": 0\n  },\n  "insuranceInfo": null,\n  "inclusionNotice": "\uC655\uBCF5 \uD56D\uACF5\uAD8C \uD3EC\uD568 -\\n\uC720\uB958\uD560\uC99D\uB8CC \uBC0F \uAC01\uC885 TAX(\uC655\uBCF5\uACF5\uD56D\uC138, \uC804\uC7C1\uBCF4\uD5D8\uB8CC, \uAD00\uAD11\uC9C4\uD765\uAC1C\uBC1C\uAE30\uAE08 \uB4F1) \uD3EC\uD568:   XXX\uD56D\uACF5 00,\\n000 \uC6D0(\uC131\uC778 / \uC18C\uC544 \uB3D9\uC77C) -\\n\uC720\uB958\uD560\uC99D\uB8CC\uB294 \uAD6D\uC81C \uC720\uAC00 \uBC0F IATA\uAD6D\uC81C\uD56D\uACF5\uC218\uC1A1\uD611\uD68C\uC758 \uACF5\uC2DC \uD658\uC728\uC5D0 \uB530\uB77C \uBCC0\uB3D9 \uB420 \uC218 \uC788\uC74C. \uBCC0\uB3D9\uC5D0 \uB530\uB77C \uCD94\uAC00\uC694\uAE08\uC774 \uBC1C\uC0DD\uB420 \uC218 \uC788\uC73C\uBA70,\\n\uCD94\uAC00\uC694\uAE08 \uBC1C\uC0DD\uC758 \uACBD\uC6B0 \uD574\uD53C\uCF5C\uC2DC \uC548\uB0B4\uB4DC\uB9BD\uB2C8\uB2E4.\u2022\uC804 \uC77C\uC815 \uC219\uBC15 \uBE44\uC6A9(\uC131\uC778 2 \uC778 1 \uC2E4 \uAE30\uC900)\u2022 \uC77C\uC815\uD45C\uC0C1 \uAE30\uC81C\uB41C \uAD00\uAD11\uC9C0 \uC785\uC7A5\uB8CC \uBC0F \uC2DD\uC0AC\u2022 \uC77C\uC815 \uC911 \uC804\uC6A9\uCC28\uB7C9 \uBC0F \uAE30\uC0AC\u2022 \uC5EC\uD589\uC790 \uBCF4\uD5D8\u2022 \uAC01\uC885 \uD2B9\uC804 \uC81C\uACF5(\uCEE8\uD150\uCE20 \uC0C1\uC138\uD398\uC774\uC9C0 \uCC38\uC870)\\n---111111",\n  "exclusionNotice": "1 \uC778\uB2F9 \uC804\uC77C\uC815 $00 (0 \uBC150\uC77C) \uC758 \uAC00\uC774\uB4DC / \uAE30\uC0AC \uACBD\uBE44 \uD604\uC9C0 \uC9C0\uBD88(\uC131\uC778 / \uC544\uB3D9 \uB3D9\uC77C)\u2022 \uC120\uD0DD \uAD00\uAD11 \uACBD\uBE44 \uBC0F \uAE30\uD0C0 \uAC1C\uC778\uACBD\uBE44 -\\n\uC120\uD0DD \uAD00\uAD11\uC740 \uC790\uC720\uC758\uC0AC\uB85C \uBBF8 \uC120\uD0DD\uC5D0 \uB530\uB978 \uBD88\uC774\uC775 \uBC0F \uCD94\uAC00\uAE08\uC740 \uC5C6\uC2B5\uB2C8\uB2E4.\\n---111111",\n  "usageNotice": "\uC544\uB3D9(24 \uAC1C\uC6D4\uC774\uC0C1~\uB9CC12\uC138\uBBF8\uB9CC) \uC694\uAE08: \uC131\uC778\uACFC \uB3D9\uC77C -\\n\uD56D\uACF5 \uC88C\uC11D \uC788\uC74C,\\n\uC131\uC778\uACFC \uD55C\uBC29 \uC0AC\uC6A9\u2022 \uC720\uC544(24 \uAC1C\uC6D4\uBBF8\uB9CC) \uC694\uAE08: 000,\\n000 \uC6D0 / \uC778 -\\n\uBCC4\uB3C4\uC758 \uD56D\uACF5\uC88C\uC11D \uC5C6\uC74C,\\n\uB178\uBCA0\uB4DC \uC870\uAC74(\uC5EC\uD589\uC0AC\uC5D0 \uC9C1\uC811 \uACB0\uC81C) \u2022 \uC5EC\uAD8C \uC720\uD6A8\uAE30\uAC04\uC740 6 \uAC1C\uC6D4 \uC774\uC0C1 \uB0A8\uC544 \uC788\uC5B4\uC57C \uD569\uB2C8\uB2E4.\u2022\uB2E8\uC218\uC5EC\uAD8C\uC758 \uACBD\uC6B0 \uBCC4\uB3C4 \uBB38\uC758 \uBD80\uD0C1 \uB4DC\uB9BD\uB2C8\uB2E4.\u2022\uD574\uD53C\uCF5C\uC2DC \uC5EC\uD589\uC0AC\uC5D0 \uC815\uD655\uD55C \uC5EC\uAD8C\uC0C1\uC758 \uC601\uBB38\uC774\uB984\uC744 \uC54C\uB824\uC8FC\uC154\uC57C \uD569\uB2C8\uB2E4.\u2022\uBCF8 \uC0C1\uD488\uC740 \uC1FC\uD551\uC13C\uD130 0 \uD68C(XX, XX, XX \uC911 0 \uD68C) \uBC29\uBB38 \uC608\uC815\\n---111111",\n  "reservationGuide": {\n    "title": null,\n    "type": "Reservation Guide",\n    "content": "\u2022 \uCD9C\uBC1C\uC870\uAC74\\n-  \uB0A0\uC9DC\uB2F9 \uC131\uC778\uAE30\uC900 0\uBA85 \uC774\uC0C1 \uBAA8\uAC1D \uC2DC \uCD9C\uBC1C\uD655\uC815 \uAC00\uB2A5\\n- \uCFE0\uD321\uACFC \uC5C5\uCCB4\uC758 \uBAA8\uAC1D\uC778\uC6D0\uC744 \uD569\uC0B0\uD55C \uCD5C\uC18C\uC778\uC6D0\\n- \uCD5C\uC18C\uC778\uC6D0 \uBBF8\uB2EC \uC2DC \uCD9C\uBC1C 7\uC77C\uC804\uAE4C\uC9C0 \uC5EC\uD589 \uCDE8\uC18C \uD1B5\uC9C0\\n\u2022 \uC5EC\uD589\uC9C0 \uC548\uC804\uC815\uBCF4: \uAD6D\uAC00\uBCC4 \uC5EC\uD589\uACBD\uBCF4 \uB2E8\uACC4 \uBCF4\uAE30 (http://www.0404.go.kr/dev/main.mofa)",\n    "format": "TEXT",\n    "sellerUrl": null,\n    "sellerUrlMethod": "GET",\n    "seq": 0\n  },\n  "additionalInfoPrompt": "please leave your phone number,dob,name and gender",\n  "maxPurchaseQuantity": 1000,\n  "csContactInfo": "\uD3C9\uC77C 09: 00~18: 00(\uB2E8, \uD1A0 / \uC77C, \uACF5\uD734\uC77C\uC740 \uD734\uBB34)",\n  "taxType": "FREE",\n  "instantBooking": false,\n  "estimatedBookingDuration": 1,\n  "extension": null,\n  "travelItems": [\n    {\n      "sellerTravelItemId": "seller-item-id-1",\n      "name": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 3\uBC155\uC77C",\n      "description": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 3\uBC155\uC77C description",\n      "onSale": true,\n      "period": "3\uBC155\uC77C",\n      "seq": 0,\n      "features": [\n        {\n          "featureId": "AIRLINE_SHIP_TYPE",\n          "featureValues": [\n            "FOREIGN_AIRLINE"\n          ],\n          "description": null\n        },\n        {\n          "featureId": "TRAVEL_PERIOD",\n          "featureValues": [\n            "FIVE_DAYS"\n          ],\n          "description": null\n        },\n        {\n          "featureId": "DOMESTIC_DEPARTING_CITY",\n          "featureValues": [\n            "SEOUL_INCLUDE_INCHOEN_AND_KIMPO"\n          ],\n          "description": null\n        },\n        {\n          "featureId": "CONFIRMED_DEPART",\n          "featureValues": [\n            "DEPARTURE_UNDECIDED"\n          ],\n          "description": null\n        },\n        {\n          "featureId": "HOTEL_GRADE",\n          "featureValues": [\n            "FIVE_STAR"\n          ],\n          "description": null\n        },\n        {\n          "featureId": "FUEL_SURCHARGE_TAX",\n          "featureValues": [\n            "FUEL_SURCHARGE_INCLUDED"\n          ],\n          "description": null\n        },\n        {\n          "featureId": "DEPARTURE_OVERSEA_TIME",\n          "featureValues": [\n            "EVENING"\n          ],\n          "description": null\n        }\n      ],\n      "taxType": "FREE",\n      "rates": [\n        {\n          "sellerRateId": "seller-rate-id-1",\n          "rateType": "BASIC",\n          "priceType": "COUPANG_PRICE",\n          "price": 500000,\n          "representative": true,\n          "saleStartedAt": "2019-11-01 01:00:00",\n          "saleEndedAt": "2019-11-21 01:00:00",\n          "maxPurchaseQtyPerPerson": 10,\n          "maxPurchaseQtyPeriod": 1,\n          "seq": 0\n        }\n      ]\n    },\n    {\n      "sellerTravelItemId": "seller-item-id-2",\n      "name": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 4\uBC156\uC77C",\n      "onSale": true,\n      "description": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 4\uBC156\uC77C description",\n      "period": "4\uBC156\uC77C",\n      "seq": 1,\n      "features": [\n        \n      ],\n      "taxType": "FREE",\n      "rates": [\n        {\n          "sellerRateId": "seller-rate-id-1",\n          "rateType": "ADULT",\n          "priceType": "COUPANG_PRICE",\n          "price": 500000,\n          "representative": true,\n          "saleStartedAt": "2019-11-01 01:00:00",\n          "saleEndedAt": "2019-11-21 01:00:00",\n          "maxPurchaseQtyPerPerson": 10,\n          "maxPurchaseQtyPeriod": 1,\n          "seq": 0\n        },\n        {\n          "sellerRateId": "seller-rate-id-1",\n          "rateType": "CHILD",\n          "priceType": "COUPANG_PRICE",\n          "price": 400000,\n          "representative": true,\n          "saleStartedAt": "2019-11-01 01:00:00",\n          "saleEndedAt": "2019-11-21 01:00:00",\n          "maxPurchaseQtyPerPerson": 10,\n          "maxPurchaseQtyPeriod": 1,\n          "seq": 1\n        }\n      ]\n    }\n  ]\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'productCreateResponseDto'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'itemCreateResponse'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<itemCreateResponse>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerTravelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Success",\n    "data": {\n        "travelProductId": 12345678910,\n        "sellerProductId": "sellerProductId_1",\n        "itemCreateResponse": [\n            {\n                "sellerTravelItemId": "sellerTravelItemId_test001",\n                "name": "After4 \uC544\uCFE0\uC544\uB9AC\uC6C0\uAD8C",\n                "travelItemId": 11111111\n            }\n        ]\n    }\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforCreateProduct' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforCreateProduct', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel-body' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC774\uB118 \uD0C0\uC785 ',
	                                            '${enumClazz.getSimpleName()}',
	                                            '\uC5D0 \uB300\uD55C \uBB34\uD6A8 \uBB38\uC790\uC5F4 \uAC12'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 display category code   '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'images\uAC00 \uBE44\uC5B4\uC788\uC744 \uC218 \uC5C6\uC74C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBCF5\uC81C \uB41C \uC774\uBBF8\uC9C0 \uACBD\uB85C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uB300\uD45C \uC774\uBBF8\uC9C0 \uB2E8 \uD55C\uC7A5\uB9CC \uD5C8\uC6A9 \uAC00\uB2A5'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uAD6D\uB0B4 \uC5EC\uD589\uC5D0 \uB300\uD55C locations\uAC00 \uBE44\uC5B4\uC788\uC73C\uBA74 \uC548\uB428 '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'landNumberAddress\uC911 \uD558\uB098\uC640 roadNameAddress\uB97C \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 seqs  '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uAC00 \uC544\uB2CC \uACBD\uC6B0 content\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uC778 \uACBD\uC6B0 sellerUrl\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'title\uC744 \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'travelType \uBC0F productDetailType\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC74C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 theme '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'instantBooking\uC774 false\uC778 \uACBD\uC6B0 estimatedBookingDuration\uC7740\uBCF4\uB2E4 \uD06C\uACE0 72\uBCF4\uB2E4 \uC791\uAC70\uB098 \uAC19\uC544\uC57C\uB428'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC5F0\uB77D\uCC98\uC5D0 \uB300\uD45C \uC804\uD654 \uBC88\uD638\uAC00 \uD558\uB098 \uC788\uC5B4\uC57C\uD568 '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour feature id '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour feature value'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour item feature id'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour item feature value  '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 \uC77C\uC790/\uC2DC\uAC04 \uD3EC\uB9F7, \uD3EC\uB9F7\uC774 ',
	                                            '{pattern}',
	                                            '\uC774\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uD310\uB9E4 \uC2DC\uC791\uC77C\uC740 \uD310\uB9E4 \uC885\uB8CC\uC77C\uBCF4\uB2E4 \uB2A6\uC9C0 \uC54A\uC544\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC911\uBCF5 \uCDE8\uC18C \uD658\uBD88\uC728refund rates'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    { className: 'mt40' },
	                    '*\xA0'
	                ),
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Notice\xA0\xA0'
	                ),
	                '\uBA54\uC2DC\uC9C0\uB97C \uBC1B\uC740 \uD6C4\uC5D0 \uD504\uB85C\uB355\uC158 \uC0DD\uC131\uC774 \uC131\uACF5\uC801\uC774\uC5C8\uC2B5\uB2C8\uB2E4. GET \uD504\uB85C\uB355\uC158 \uC815\uBCF4 \uBA54\uC18C\uB4DC\uB85C \uD504\uB85C\uB355\uC158\uC758 qcStatus\uB97C \uD655\uC778\uD558\uC2DC\uAE30\uB97C \uAD8C\uC7A5\uD569\uB2C8\uB2E4.'
	            )
	        );
	    };
	
	    return CreateTourProduct;
	}(_react2.default.Component);
	
	exports.default = CreateTourProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "CreateTourProduct.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 6013708201064431:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewConfirmReservation = function (_React$Component) {
		_inherits(ViewConfirmReservation, _React$Component);
	
		function ViewConfirmReservation(props) {
			_classCallCheck(this, ViewConfirmReservation);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		ViewConfirmReservation.prototype.render = function render() {
			var col_number_8 = 8;
			var total_levels = 6;
			var level1 = 5;
			var level2 = 4;
			var level2_prefix = level1 - level2;
			var level3 = 3;
			var level3_prefix = level1 - level3;
			var level4 = 2;
			var level4_prefix = level1 - level4;
			var level5 = 1;
			var level5_prefix = level1 - level5;
			return _react2.default.createElement(
				'div',
				{ id: "view-confirm-reject-reservation" },
				_react2.default.createElement(
					'h3',
					{ className: "mb0 mt40" },
					'\uC608\uC57D \uD655\uC815'
				),
				_react2.default.createElement(
					'div',
					{ className: 'blog-post-meta' },
					_react2.default.createElement(
						'span',
						{ className: 's-post' },
						'\uC608\uC57D \uB300\uAE30\uC911\uC778 \uD2F0\uCF13\uC758 \uC0C1\uD0DC\uB97C \uC608\uC57D\uD655\uC815\uC73C\uB85C \uBCC0\uACBD \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
					),
					_react2.default.createElement(
						'h3',
						{ className: 'request-method' },
						_react2.default.createElement(
							'span',
							{ className: 'label label-success' },
							'POST'
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'Path'
								),
								_react2.default.createElement(
									'td',
									null,
									'Example Endpoint'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'/v1/marketplace/reservation/request/confirmation'
								),
								_react2.default.createElement(
									'td',
									null,
									'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/reservation/request/confirmation'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'h4',
						null,
						'Request Parameters'
					),
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: '4', className: 'bold' },
									'Request Header'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Required'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'Request-Vendor-Id'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: '4', className: 'bold' },
									'Query Parameter'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Required'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'ticketNumber'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uD2F0\uCF13 \uBC88\uD638'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'h4',
						null,
						'Response Specifications'
					),
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: level1 },
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'code'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uCF54\uB4DC'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'message'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uBA54\uC138\uC9C0'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'data'
								),
								_react2.default.createElement(
									'td',
									null,
									'responseDto'
								),
								_react2.default.createElement('td', null)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'isSuccessfulRequest'
								),
								_react2.default.createElement(
									'td',
									null,
									'boolean'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD \uC131\uACF5 \uC5EC\uBD80'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'requestedTicketNumber'
								),
								_react2.default.createElement(
									'td',
									null,
									'boolean'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD \uD2F0\uCF13 \uBC88\uD638'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'message'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uBA54\uC2DC\uC9C0'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'div',
						{ className: 'panel panel-default' },
						_react2.default.createElement(
							'div',
							{ className: 'panel-heading' },
							_react2.default.createElement(
								'h3',
								{ className: 'panel-title' },
								'\uC751\uB2F5\uAC12 \uC608\uC2DC'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'panel-body' },
							_react2.default.createElement(
								'pre',
								{ className: 'ty01' },
								'\n{\n  "code": 200,\n  "message": "SUCCESS",\n  "data": [\n    {\n      "isSuccessfulRequest" : "true",\n      "requestedTicketNumber" : "044670-5000000000620",\n      "message" : "Successfully Requested"\n    }\n  ]\n}\n                        '
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'HTTP CODE'
								),
								_react2.default.createElement(
									'th',
									null,
									'message'
								),
								_react2.default.createElement(
									'th',
									null,
									'\uC124\uBA85'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'400'
								),
								_react2.default.createElement(
									'td',
									null,
									'Bad request'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'401'
								),
								_react2.default.createElement(
									'td',
									null,
									'Unauthorized Error'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'403'
								),
								_react2.default.createElement(
									'td',
									null,
									'Forbidden Error'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'410'
								),
								_react2.default.createElement(
									'td',
									null,
									'The resource has been permanently deleted'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'412'
								),
								_react2.default.createElement(
									'td',
									null,
									'Precondition failed'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'429'
								),
								_react2.default.createElement(
									'td',
									null,
									'Too many requests'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'504'
								),
								_react2.default.createElement(
									'td',
									null,
									'API Gateway response timeout'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'521'
								),
								_react2.default.createElement(
									'td',
									null,
									'API provider server has error'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'524'
								),
								_react2.default.createElement(
									'td',
									null,
									'API provider to API gateway connection response timeout'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							)
						)
					)
				)
			);
		};
	
		return ViewConfirmReservation;
	}(_react2.default.Component);
	
	exports.default = ViewConfirmReservation;
	;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewConfirmReservation.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 6195576110025848:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeleteTourProductItem = function (_React$Component) {
	    _inherits(DeleteTourProductItem, _React$Component);
	
	    function DeleteTourProductItem(props) {
	        _classCallCheck(this, DeleteTourProductItem);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    DeleteTourProductItem.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { id: "delete-tour-product-item" },
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC0C1\uD488 \uC635\uC158 \uC0AD\uC81C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC758 \uC635\uC158\uC744 \uC0AD\uC81C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'DELETE'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tours/',
	                                '{travelProductId}',
	                                '/items/',
	                                '{travelItemId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/1234567890/items/12345678'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "code": 200\n            "message" : "success"\n            "data" : 3629379889\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return DeleteTourProductItem;
	}(_react2.default.Component);
	
	exports.default = DeleteTourProductItem;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "DeleteTourProductItem.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 6329104695656332:
2692642590089237,

/***/ 6445149586794477:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewTicketBuyerInfoByV2API = function (_React$Component) {
	    _inherits(ViewTicketBuyerInfoByV2API, _React$Component);
	
	    function ViewTicketBuyerInfoByV2API(props) {
	        _classCallCheck(this, ViewTicketBuyerInfoByV2API);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewTicketBuyerInfoByV2API.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uD2F0\uCF13 \uAD6C\uB9E4\uC790 \uC815\uBCF4 \uC870\uD68C V2 API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uD2F0\uCF13 \uAD6C\uB9E4\uC790 \uC815\uBCF4\uB97C \uC870\uD68C\uD569\uB2C8\uB2E4. \uCD5C\uB300 1\uB144 \uC774\uB0B4\uC758 \uAD6C\uB9E4\uC790 \uC815\uBCF4\uB97C \uC77C\uC8FC\uC77C \uB2E8\uC704\uB85C \uC870\uD68C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v2/purchasers?searchStartDateTime=',
	                                '{searchStartDateTime}',
	                                '&searchEndDateTime=',
	                                '{searchEndDateTime}',
	                                '&dealId=',
	                                '{dealId}',
	                                '&offset=',
	                                '{offset}',
	                                '&limit=',
	                                '{limit}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v2/purchasers?searchStartDateTime=2017-08-04 00:00:00&searchEndDateTime=2017-08-04 23:59:59&dealId=3000000001&offset=0&limit=1000'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Query String Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'offset'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0 \uBC88\uD638 (\uCCAB\uBC88\uC9F8 \uD398\uC774\uC9C0 = 0)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'limit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD5C\uB300 \uC694\uCCAD \uAC2F\uC218 (\uCD5C\uB313\uAC12 = 1000)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'searchStartDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC \uAC80\uC0C9\uC2DC\uC791\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'searchEndDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC \uAC80\uC0C9\uC885\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss) - \uC2DC\uC791\uC77C\uB85C\uBD80\uD130 1\uC8FC\uC77C\uC774\uB0B4'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'userName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 \uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'phoneNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 \uD578\uB4DC\uD3F0 \uBC88\uD638 (010-xxxx-xxxx)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'email'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 email'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C \uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C \uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'purchaseDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'canceledDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uAC00\uACA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'status'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'CANCEL_COMPLETE(\uCDE8\uC18C\uC644\uB8CC), PURCHASE_COMPLETE(\uAD6C\uB9E4\uC644\uB8CC)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'orderId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC790 \uC8FC\uBB38\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'totalQuantity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4 \uC218\uB7C9'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n                        {\n                            "totalCount": 2,\n                            "totalPageCount": 1,\n                            "countPerPage": 1000,\n                            "currentPage": 0,\n                            "ticketPurchasers": [\n                                {\n                                    "ticketNumber": "9C320B-9000000000234",\n                                    "userName": "\uAE40\uCFE0\uD321",\n                                    "phoneNumber": null,\n                                    "email": "coupang@coupang.com",\n                                    "dealId": 6500124641,\n                                    "dealName": "\uCFE0\uD321\uACFC \uD568\uAED8 \uBC14\uB85C\uC140\uB85C\uB098",\n                                    "optionId": 53000424227,\n                                    "optionName": "\uC989\uC2DC \uAC00\uAE30  ",\n                                    "price": 1000,\n                                    "purchaseDateTime": "2017-07-05 05:17:13",\n                                    "canceledDateTime": null,\n                                    "status": "PURCHASE_COMPLETE",\n                                    "orderId" : "2ma*aBZy*ho+zQO+dRZlCQJ8pEKWuZspZg8kCVCyx9Q=",\n                                    "totalQuantity":1\n                                },\n                                {\n                                    "ticketNumber": "DCAA6C-9000000000235",\n                                    "userName": "\uAE40\uCFE0\uD321",\n                                    "phoneNumber": null,\n                                    "email": "coupang@coupang.com",\n                                    "dealId": 6500124641,\n                                    "dealName": "\uCFE0\uD321\uACFC \uD568\uAED8 \uBC14\uB85C\uC140\uB85C\uB098",\n                                    "optionId": 53000424227,\n                                    "optionName": "\uC989\uC2DC \uAC00\uAE30  ",\n                                    "price": 1000,\n                                    "purchaseDateTime": "2017-07-05 05:17:13",\n                                    "canceledDateTime": "2017-07-06 07:27:21",\n                                    "status": "CANCEL_COMPLETE",\n                                    "orderId" : "2ma*aBZy*ho+zQO+dRZlCQJ8pEKWuZspZg8kCVCyx9Q=",\n                                    "totalQuantity":1\n                                }\n                            ]\n                        }\n                                        '
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewTicketBuyerInfoByV2API;
	}(_react2.default.Component);
	
	exports.default = ViewTicketBuyerInfoByV2API;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewTicketBuyerInfoByV2API.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 6481278976589768:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(4813844983747096);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(642862956009192);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _uuid = __webpack_require__(6985462053439918);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _propTypes3 = __webpack_require__(762558919458398);
	
	var _Tab = __webpack_require__(7925919092148657);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabList = __webpack_require__(228970576441975);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _TabPanel = __webpack_require__(7121215342470674);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	var _count = __webpack_require__(8476312172317632);
	
	var _childrenDeepMap = __webpack_require__(5289629256324197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Determine if a node from event.target is a Tab element
	function isTabNode(node) {
	  return node.nodeName === 'LI' && node.getAttribute('role') === 'tab';
	}
	
	// Determine if a tab node is disabled
	function isTabDisabled(node) {
	  return node.getAttribute('aria-disabled') === 'true';
	}
	
	var canUseActiveElement = !!(typeof window !== 'undefined' && window.document && window.document.activeElement);
	
	var UncontrolledTabs = function (_Component) {
	  _inherits(UncontrolledTabs, _Component);
	
	  function UncontrolledTabs() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UncontrolledTabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.tabNodes = [], _this.handleKeyDown = function (e) {
	      if (_this.isTabFromContainer(e.target)) {
	        var index = _this.props.selectedIndex;
	        var preventDefault = false;
	
	        if (e.keyCode === 37 || e.keyCode === 38) {
	          // Select next tab to the left
	          index = _this.getPrevTab(index);
	          preventDefault = true;
	        } else if (e.keyCode === 39 || e.keyCode === 40) {
	          // Select next tab to the right
	          index = _this.getNextTab(index);
	          preventDefault = true;
	        }
	
	        // This prevents scrollbars from moving around
	        if (preventDefault) {
	          e.preventDefault();
	        }
	
	        _this.setSelected(index, e);
	      }
	    }, _this.handleClick = function (e) {
	      var node = e.target;
	      // eslint-disable-next-line no-cond-assign
	      do {
	        if (_this.isTabFromContainer(node)) {
	          if (isTabDisabled(node)) {
	            return;
	          }
	
	          var index = [].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);
	          _this.setSelected(index, e);
	          return;
	        }
	      } while ((node = node.parentNode) !== null);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  UncontrolledTabs.prototype.setSelected = function setSelected(index, event) {
	    // Don't do anything if nothing has changed
	    if (index === this.props.selectedIndex) return;
	    // Check index boundary
	    if (index < 0 || index >= this.getTabsCount()) return;
	
	    // Call change event handler
	    this.props.onSelect(index, this.props.selectedIndex, event);
	  };
	
	  UncontrolledTabs.prototype.getNextTab = function getNextTab(index) {
	    var count = this.getTabsCount();
	
	    // Look for non-disabled tab from index to the last tab on the right
	    for (var i = index + 1; i < count; i++) {
	      if (!isTabDisabled(this.getTab(i))) {
	        return i;
	      }
	    }
	
	    // If no tab found, continue searching from first on left to index
	    for (var _i = 0; _i < index; _i++) {
	      if (!isTabDisabled(this.getTab(_i))) {
	        return _i;
	      }
	    }
	
	    // No tabs are disabled, return index
	    return index;
	  };
	
	  UncontrolledTabs.prototype.getPrevTab = function getPrevTab(index) {
	    var i = index;
	
	    // Look for non-disabled tab from index to first tab on the left
	    while (i--) {
	      if (!isTabDisabled(this.getTab(i))) {
	        return i;
	      }
	    }
	
	    // If no tab found, continue searching from last tab on right to index
	    i = this.getTabsCount();
	    while (i-- > index) {
	      if (!isTabDisabled(this.getTab(i))) {
	        return i;
	      }
	    }
	
	    // No tabs are disabled, return index
	    return index;
	  };
	
	  UncontrolledTabs.prototype.getTabsCount = function getTabsCount() {
	    return (0, _count.getTabsCount)(this.props.children);
	  };
	
	  UncontrolledTabs.prototype.getPanelsCount = function getPanelsCount() {
	    return (0, _count.getPanelsCount)(this.props.children);
	  };
	
	  UncontrolledTabs.prototype.getTab = function getTab(index) {
	    return this.tabNodes['tabs-' + index];
	  };
	
	  UncontrolledTabs.prototype.getChildren = function getChildren() {
	    var _this2 = this;
	
	    var index = 0;
	    var _props = this.props,
	        children = _props.children,
	        disabledTabClassName = _props.disabledTabClassName,
	        focus = _props.focus,
	        forceRenderTabPanel = _props.forceRenderTabPanel,
	        selectedIndex = _props.selectedIndex,
	        selectedTabClassName = _props.selectedTabClassName,
	        selectedTabPanelClassName = _props.selectedTabPanelClassName;
	
	
	    this.tabIds = this.tabIds || [];
	    this.panelIds = this.panelIds || [];
	    var diff = this.tabIds.length - this.getTabsCount();
	
	    // Add ids if new tabs have been added
	    // Don't bother removing ids, just keep them in case they are added again
	    // This is more efficient, and keeps the uuid counter under control
	    while (diff++ < 0) {
	      this.tabIds.push((0, _uuid2.default)());
	      this.panelIds.push((0, _uuid2.default)());
	    }
	
	    // Map children to dynamically setup refs
	    return (0, _childrenDeepMap.deepMap)(children, function (child) {
	      var result = child;
	
	      // Clone TabList and Tab components to have refs
	      if (child.type === _TabList2.default) {
	        var listIndex = 0;
	
	        // Figure out if the current focus in the DOM is set on a Tab
	        // If it is we should keep the focus on the next selected tab
	        var wasTabFocused = false;
	
	        if (canUseActiveElement) {
	          wasTabFocused = _react2.default.Children.toArray(child.props.children).filter(function (tab) {
	            return tab.type === _Tab2.default;
	          }).some(function (tab, i) {
	            return document.activeElement === _this2.getTab(i);
	          });
	        }
	
	        result = (0, _react.cloneElement)(child, {
	          children: (0, _childrenDeepMap.deepMap)(child.props.children, function (tab) {
	            var key = 'tabs-' + listIndex;
	            var selected = selectedIndex === listIndex;
	
	            var props = {
	              tabRef: function tabRef(node) {
	                _this2.tabNodes[key] = node;
	              },
	              id: _this2.tabIds[listIndex],
	              panelId: _this2.panelIds[listIndex],
	              selected: selected,
	              focus: selected && (focus || wasTabFocused)
	            };
	
	            if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
	            if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
	
	            listIndex++;
	
	            return (0, _react.cloneElement)(tab, props);
	          })
	        });
	      } else if (child.type === _TabPanel2.default) {
	        var props = {
	          id: _this2.panelIds[index],
	          tabId: _this2.tabIds[index],
	          selected: selectedIndex === index
	        };
	
	        if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
	        if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
	
	        index++;
	
	        result = (0, _react.cloneElement)(child, props);
	      }
	
	      return result;
	    });
	  };
	
	  /**
	   * Determine if a node from event.target is a Tab element for the current Tabs container.
	   * If the clicked element is not a Tab, it returns false.
	   * If it finds another Tabs container between the Tab and `this`, it returns false.
	   */
	  UncontrolledTabs.prototype.isTabFromContainer = function isTabFromContainer(node) {
	    // return immediately if the clicked element is not a Tab.
	    if (!isTabNode(node)) {
	      return false;
	    }
	
	    // Check if the first occurrence of a Tabs container is `this` one.
	    var nodeAncestor = node.parentElement;
	    do {
	      if (nodeAncestor === this.node) return true;else if (nodeAncestor.getAttribute('data-tabs')) break;
	
	      nodeAncestor = nodeAncestor.parentElement;
	    } while (nodeAncestor);
	
	    return false;
	  };
	
	  UncontrolledTabs.prototype.render = function render() {
	    var _this3 = this;
	
	    // Delete all known props, so they don't get added to DOM
	    var _props2 = this.props,
	        children = _props2.children,
	        className = _props2.className,
	        disabledTabClassName = _props2.disabledTabClassName,
	        focus = _props2.focus,
	        forceRenderTabPanel = _props2.forceRenderTabPanel,
	        onSelect = _props2.onSelect,
	        selectedIndex = _props2.selectedIndex,
	        selectedTabClassName = _props2.selectedTabClassName,
	        selectedTabPanelClassName = _props2.selectedTabPanelClassName,
	        attributes = _objectWithoutProperties(_props2, ['children', 'className', 'disabledTabClassName', 'focus', 'forceRenderTabPanel', 'onSelect', 'selectedIndex', 'selectedTabClassName', 'selectedTabPanelClassName']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)(className),
	        onClick: this.handleClick,
	        onKeyDown: this.handleKeyDown,
	        ref: function ref(node) {
	          _this3.node = node;
	        },
	        'data-tabs': true
	      }),
	      this.getChildren()
	    );
	  };
	
	  return UncontrolledTabs;
	}(_react.Component);
	
	UncontrolledTabs.defaultProps = {
	  className: 'react-tabs',
	  focus: false
	};
	exports.default = UncontrolledTabs;
	UncontrolledTabs.propTypes =  false ? {
	  children: _propTypes3.childrenPropType,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
	  disabledTabClassName: _propTypes2.default.string,
	  focus: _propTypes2.default.bool,
	  forceRenderTabPanel: _propTypes2.default.bool,
	  onSelect: _propTypes2.default.func.isRequired,
	  selectedIndex: _propTypes2.default.number.isRequired,
	  selectedTabClassName: _propTypes2.default.string,
	  selectedTabPanelClassName: _propTypes2.default.string
	} : {};

/***/ }),

/***/ 6526674205931212:
/***/ (function(module, exports) {

	module.exports = "<pre class=\"python hljs\">\n    <code class=python>\n\n    <span class=hljs-keyword>import</span> os\n    <span class=hljs-keyword>import</span> time\n    <span class=hljs-keyword>import</span> hmac, hashlib\n    <span class=hljs-keyword>import</span> urllib.request\n    <span class=hljs-keyword>import</span> ssl\n\n    os.environ[<span class=hljs-string>'TZ'</span>] = <span class=hljs-string>'GMT+0'</span>\n\n    datetime=time.strftime(<span class=hljs-string>'%y%m%d'</span>)+<span class=hljs-string>'T'</span>+time.strftime(<span class=hljs-string>'%H%M%S'</span>)+<span class=hljs-string>'Z'</span>\n    method = <span class=hljs-string>\"GET\"</span>\n    path = <span class=hljs-string>\"/v2/providers/travel_backbone_api/apis/ticket-api/v1/mock-up/purchasers\"</span>\n    query = urllib.parse.urlencode({<span class=hljs-string>\"searchStartDateTime\"</span>: <span class=hljs-string>\"20130501000000\"</span>, <span class=hljs-string>\"searchEndDateTime\"</span>: <span class=hljs-string>\"20130530000000\"</span>, <span class=hljs-string>\"offset\"</span>: <span class=hljs-string>\"0\"</span>, <span class=hljs-string>\"limit\"</span>: <span class=hljs-string>\"100\"</span>})\n\n    message = datetime+method+path+query\n\n    accesskey = <span class=hljs-string>\"****\"</span>\n    secretkey = <span class=hljs-string>\"****\"</span>\n\n    signature=hmac.new(secretkey.encode(<span class=hljs-string>'utf-8'</span>),message.encode(<span class=hljs-string>'utf-8'</span>),hashlib.sha256).hexdigest()\n\n    authorization  = <span class=hljs-string>\"CEA algorithm=HmacSHA256, access-key=\"</span>+accesskey+<span class=hljs-string>\", signed-date=\"</span>+datetime+<span class=hljs-string>\", signature=\"</span>+signature\n    <span class=hljs-comment>#print(authorization)</span>\n\n    <span class=hljs-comment># ************* SEND THE REQUEST *************</span>\n    url = <span class=hljs-string>\"https://api-gateway.coupang.com\"</span>+path+<span class=hljs-string>\"?%s\"</span> % query\n\n    print(<span class=hljs-string>'\n    BEGIN REQUEST++++++++++++++++++++++++++++++++++++'</span>)\n    req = urllib.request.Request(url)\n    <span class=hljs-comment>#print(req)</span>\n\n    req.add_header(<span class=hljs-string>\"Content-type\"</span>,<span class=hljs-string>\"application/json;charset=UTF-8\"</span>)\n    req.add_header(<span class=hljs-string>\"Authorization\"</span>,authorization)\n\n    req.get_method = <span class=hljs-keyword>lambda</span>: method\n\n    ctx = ssl.create_default_context()\n    ctx.check_hostname = <span class=hljs-keyword>False</span>\n    ctx.verify_mode = ssl.CERT_NONE\n\n    print(req.get_full_url())\n    print(req.get_header(<span class=hljs-string>\"Content-type\"</span>))\n    print(req.get_header(<span class=hljs-string>\"Authorization\"</span>))\n    print(req.get_method())\n\n    print(<span class=hljs-string>'\n    RESPONSE++++++++++++++++++++++++++++++++++++'</span>)\n    <span class=hljs-comment>#resp = urllib.request.urlopen(req)</span>\n\n    <span class=hljs-keyword>try</span>:\n        resp = urllib.request.urlopen(req,context=ctx)\n    <span class=hljs-keyword>except</span> urllib.request.HTTPError <span class=hljs-keyword>as</span> e:\n        <span class=hljs-keyword>if</span> e.code == <span class=hljs-number>404</span>:\n            print(<span class=hljs-string>\"404\"</span>)\n        <span class=hljs-keyword>else</span>:\n            print(<span class=hljs-string>\"NOT 404\"</span>)\n    <span class=hljs-keyword>except</span> urllib.request.URLError <span class=hljs-keyword>as</span> e:\n        print(e.errno)\n    <span class=hljs-keyword>else</span>:\n        <span class=hljs-comment># 200</span>\n        body = resp.read().decode(resp.headers.get_content_charset())\n        print(body)\n\n    </code>\n</pre>";

/***/ }),

/***/ 6542839653521249:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewTourItemInventoriesV2 = function (_React$Component) {
	    _inherits(ViewTourItemInventoriesV2, _React$Component);
	
	    function ViewTourItemInventoriesV2(props) {
	        _classCallCheck(this, ViewTourItemInventoriesV2);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewTourItemInventoriesV2.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC7AC\uACE0 \uC870\uD68C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC758 \uC7AC\uACE0 \uC815\uBCF4\uB97C \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/marketplace/search/',
	                                '{travelProductId}',
	                                '/items/',
	                                '{travelItemId}',
	                                '/inventories'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v2/marketplace/search/1234567890/items/11111111/inventories'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '8', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCFE0\uD321 \uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCFE0\uD321 \uC0C1\uD488 \uC544\uC774\uD15C \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '8', className: 'bold' },
	                                ' Query Parameters'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'calendarDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uC815\uC77C\uC790. Format: yyyy-MM-dd'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'calendarDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uC815\uC77C\uC790. Format: yyyy-MM-dd'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'deadlineDay'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uD558\uB294 \uB0A0\uC9DC\uC804\uC5D0 \uBA87 \uC77C\uC5D0 \uD504\uB85C\uB355\uD2B8 \uD310\uB9E4\uB97C \uC911\uC9C0\uC2DC\uD0A4\uACA0\uC2B5\uB2C8\uAE4C? \uAE30\uBCF8\uAC12: 0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'deadlineHour'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uD558\uB294 \uB0A0\uC9DC \uB9C8\uC774\uB108\uC2A4 deadlineDay \uC804\uC5D0 \uBA87 \uC2DC\uAC04\uC5D0 \uD504\uB85C\uB355\uD2B8 \uD310\uB9E4\uB97C \uC911\uC9C0\uC2DC\uD0A4\uACA0\uC2B5\uB2C8\uAE4C? \uB370\uC774\uD130\uB294 1\uBD80\uD130 24\uAE4C\uC9C0\uC774\uBA70 \uB514\uD3F4\uD2B8\uAC12:24'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'onSale'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC911:true, \uD310\uB9E4\uC911\uC9C0:false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08\uD0C0\uC785'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'salePrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'totalSoldCount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD1D\uD310\uB9E4\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'totalStockCount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD1D \uC7AC\uACE0 \uC218\uB7C9'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#toursResponseDto' },
	                            'Response Body Sample'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'toursResponseDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n    "code": 200,\n    "message": "OK",\n    "nextPageToken": "1573106534426",\n    "size": 20,\n    "data": [\n        {\n            "travelProductId": 515006525668851712,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-22T11:32:13.55",\n            "modifiedAt": "2019-11-22T11:32:15.449"\n        },\n        {\n            "travelProductId": 511520339147096064,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T21:13:46.422",\n            "modifiedAt": "2019-11-13T07:52:14.463"\n        },\n        {\n            "travelProductId": 511496123001602048,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T19:03:08.745",\n            "modifiedAt": "2019-11-12T19:09:53.528"\n        }\n    ]\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewTourItemInventoriesV2;
	}(_react2.default.Component);
	
	exports.default = ViewTourItemInventoriesV2;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewTourItemInventoriesV2.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 6985462053439918:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = uuid;
	exports.reset = reset;
	// Get a universally unique identifier
	var count = 0;
	function uuid() {
	  return "react-tabs-" + count++;
	}
	
	function reset() {
	  count = 0;
	}

/***/ }),

/***/ 6995356643797629:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewConfirmReservation = function (_React$Component) {
		_inherits(ViewConfirmReservation, _React$Component);
	
		function ViewConfirmReservation(props) {
			_classCallCheck(this, ViewConfirmReservation);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		ViewConfirmReservation.prototype.render = function render() {
			var col_number_8 = 8;
			var total_levels = 6;
			var level1 = 5;
			var level2 = 4;
			var level2_prefix = level1 - level2;
			var level3 = 3;
			var level3_prefix = level1 - level3;
			var level4 = 2;
			var level4_prefix = level1 - level4;
			var level5 = 1;
			var level5_prefix = level1 - level5;
			return _react2.default.createElement(
				'div',
				{ id: "view-confirm-reject-reservation" },
				_react2.default.createElement(
					'h3',
					{ className: "mb0 mt40" },
					'\uCDE8\uC18C \uC2B9\uC778'
				),
				_react2.default.createElement(
					'div',
					{ className: 'blog-post-meta' },
					_react2.default.createElement(
						'span',
						{ className: 's-post' },
						'\uCDE8\uC18C \uB300\uAE30\uC911\uC778 \uD2F0\uCF13\uC758 \uC0C1\uD0DC\uB97C \uCDE8\uC18C\uC2B9\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uCDE8\uC18C\uC2B9\uC778 \uC2DC \uD574\uB2F9 \uD2F0\uCF13\uC740 \uC790\uB3D9\uC73C\uB85C \uCDE8\uC18C \uC644\uB8CC \uCC98\uB9AC\uB429\uB2C8\uB2E4. '
					),
					_react2.default.createElement(
						'h3',
						{ className: 'request-method' },
						_react2.default.createElement(
							'span',
							{ className: 'label label-success' },
							'POST'
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'Path'
								),
								_react2.default.createElement(
									'td',
									null,
									'Example Endpoint'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'/v1/marketplace/reservation/request/cancellation'
								),
								_react2.default.createElement(
									'td',
									null,
									'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/reservation/request/cancellation'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'h4',
						null,
						'Request Parameters'
					),
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: '4', className: 'bold' },
									'Request Header'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Required'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'Request-Vendor-Id'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: '4', className: 'bold' },
									'Query Parameter'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Required'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'ticketNumber'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uD2F0\uCF13 \uBC88\uD638'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'h4',
						null,
						'Response Specifications'
					),
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: level1 },
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'code'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uCF54\uB4DC'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'message'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uBA54\uC138\uC9C0'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'data'
								),
								_react2.default.createElement(
									'td',
									null,
									'responseDto'
								),
								_react2.default.createElement('td', null)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'isSuccessfulRequest'
								),
								_react2.default.createElement(
									'td',
									null,
									'boolean'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD \uC131\uACF5 \uC5EC\uBD80'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'requestedTicketNumber'
								),
								_react2.default.createElement(
									'td',
									null,
									'boolean'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD \uD2F0\uCF13 \uBC88\uD638'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'message'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uBA54\uC2DC\uC9C0'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'div',
						{ className: 'panel panel-default' },
						_react2.default.createElement(
							'div',
							{ className: 'panel-heading' },
							_react2.default.createElement(
								'h3',
								{ className: 'panel-title' },
								'\uC751\uB2F5\uAC12 \uC608\uC2DC'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'panel-body' },
							_react2.default.createElement(
								'pre',
								{ className: 'ty01' },
								'\n{\n  "code": 200,\n  "message": "SUCCESS",\n  "data": [\n    {\n      "isSuccessfulRequest" : "true",\n      "requestedTicketNumber" : "044670-5000000000620",\n      "message" : "Successfully Requested"\n    }\n  ]\n}\n                        '
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'HTTP CODE'
								),
								_react2.default.createElement(
									'th',
									null,
									'message'
								),
								_react2.default.createElement(
									'th',
									null,
									'\uC124\uBA85'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'400'
								),
								_react2.default.createElement(
									'td',
									null,
									'Bad request'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'401'
								),
								_react2.default.createElement(
									'td',
									null,
									'Unauthorized Error'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'403'
								),
								_react2.default.createElement(
									'td',
									null,
									'Forbidden Error'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'410'
								),
								_react2.default.createElement(
									'td',
									null,
									'The resource has been permanently deleted'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'412'
								),
								_react2.default.createElement(
									'td',
									null,
									'Precondition failed'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'429'
								),
								_react2.default.createElement(
									'td',
									null,
									'Too many requests'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'504'
								),
								_react2.default.createElement(
									'td',
									null,
									'API Gateway response timeout'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'521'
								),
								_react2.default.createElement(
									'td',
									null,
									'API provider server has error'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'524'
								),
								_react2.default.createElement(
									'td',
									null,
									'API provider to API gateway connection response timeout'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							)
						)
					)
				)
			);
		};
	
		return ViewConfirmReservation;
	}(_react2.default.Component);
	
	exports.default = ViewConfirmReservation;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewApprovalCancellation.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 7014169121198188:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewTourProductList = function (_React$Component) {
	    _inherits(ViewTourProductList, _React$Component);
	
	    function ViewTourProductList(props) {
	        _classCallCheck(this, ViewTourProductList);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewTourProductList.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { id: "view-tour-product-list" },
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uBAA9\uB85D \uC870\uD68C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uD328\uD0A4\uC9C0/\uD56D\uACF5 \uC0C1\uD488\uC758 \uBAA9\uB85D\uC744 \uD655\uC778/\uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tours'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                ' Query Parameters'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'pageSize'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0\uB124\uC774\uC158: \uD55C \uD398\uC774\uC9C0 \uD06C\uAE30. Default: 50'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'nextPageToken'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0\uB124\uC774\uC158: \uB2E4\uC74C \uD398\uC774\uC9C0 \uD1A0\uD070'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'qcStatus'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'qcStatus Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SAVED_TEMPORARY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC784\uC2DC \uC800\uC7A5'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WAITING_APPROVAL_MD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MD \uC2B9\uC778 \uB300\uAE30'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WAITING_APPROVAL_QC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'QC \uC2B9\uC778 \uB300\uAE30'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'COMPLETE_APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778 \uC644\uB8CC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'REJECTED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778 \uBC18\uB824'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BLOCKED'
	                                            ),
	                                            _react2.default.createElement('td', null)
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'sellerProductName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC758 \uC0C1\uD488\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'createdDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0DD\uC131\uC77C \uBA85\uC2DC ex)2019-01-01 \uB514\uD3F4\uD2B8: \uD604\uC7AC \uB0A0\uC9DC'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'nextPageToken'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0\uB124\uC774\uC158 \uD1A0\uD070'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'pageSize'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0\uB124\uC774\uC158 \uD398\uC774\uC9D5 \uD06C\uAE30, \uCD5C\uC18C10&\uCD5C\uB300100'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<TravelIndexDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                '\xA0travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                '\xA0sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorItemPackageId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uD15C \uD328\uD0A4\uC9C0 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD504\uB85C\uB355\uD2B8 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uBD84\uB958'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productDetailType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC138\uBD80 \uBD84\uB958'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'qcStatus'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC218\uB7C9 \uCEE8\uD2B8\uB864 \uC0C1\uD0DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleStatus'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC0C1\uD0DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC0C1\uD488 \uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'createdAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0DD\uC131\uC77C\uC790'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'modifiedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC218\uC815\uC77C\uC790'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#toursResponseDto' },
	                            'Response Body Sample'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'toursResponseDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n    "code": 200,\n    "message": "OK",\n    "nextPageToken": "1573106534426",\n    "size": 20,\n    "data": [\n        {\n            "travelProductId": 515006525668851712,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-22T11:32:13.55",\n            "modifiedAt": "2019-11-22T11:32:15.449"\n        },\n        {\n            "travelProductId": 511520339147096064,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T21:13:46.422",\n            "modifiedAt": "2019-11-13T07:52:14.463"\n        },\n        {\n            "travelProductId": 511496123001602048,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T19:03:08.745",\n            "modifiedAt": "2019-11-12T19:09:53.528"\n        },\n        {\n            "travelProductId": 511493199361998848,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T18:51:31.416",\n            "modifiedAt": "2019-11-12T18:51:33.011"\n        },\n        {\n            "travelProductId": 511485095396245504,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T18:49:53.339",\n            "modifiedAt": "2019-11-12T18:58:21.498"\n        },\n        {\n            "travelProductId": 511485064899461120,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T18:49:46.063",\n            "modifiedAt": "2019-11-12T18:58:20.659"\n        },\n        {\n            "travelProductId": 511485478193594368,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T18:20:50.113",\n            "modifiedAt": "2019-11-12T18:50:00.398"\n        },\n        {\n            "travelProductId": 511468899942793216,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T18:19:49.08",\n            "modifiedAt": "2019-11-12T18:49:59.633"\n        },\n        {\n            "travelProductId": 511104860452552704,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T11:45:07.147",\n            "modifiedAt": "2019-11-12T11:45:09.107"\n        },\n        {\n            "travelProductId": 511373882012205056,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-12T11:44:59.29",\n            "modifiedAt": "2019-11-12T11:45:01.547"\n        },\n        {\n            "travelProductId": 511014995421560832,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-11T11:17:28.458",\n            "modifiedAt": "2019-11-11T11:17:40.001"\n        },\n        {\n            "travelProductId": 511013362465767424,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-11T11:12:50.049",\n            "modifiedAt": "2019-11-11T11:13:05.581"\n        },\n        {\n            "travelProductId": 510008242529632256,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-08T16:40:47.522",\n            "modifiedAt": "2019-11-08T16:41:42.496"\n        },\n        {\n            "travelProductId": 510006709880619008,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-08T16:24:45.278",\n            "modifiedAt": "2019-11-12T11:43:45.453"\n        },\n        {\n            "travelProductId": 509936318738857984,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-08T16:16:39.401",\n            "modifiedAt": "2019-11-08T16:17:10.729"\n        },\n        {\n            "travelProductId": 509728881356308480,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-07T22:00:49.816",\n            "modifiedAt": "2019-11-07T22:00:51.318"\n        },\n        {\n            "travelProductId": 509720793962250240,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-07T21:50:04.258",\n            "modifiedAt": "2019-11-07T21:50:05.569"\n        },\n        {\n            "travelProductId": 509707256686706688,\n            "sellerProductId": "seller-product-id",\n            "vendorItemPackageId": 0,\n            "productId": 0,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": null,\n            "saleStatus": null,\n            "name": "[\uC7A5\uAC00\uACC4]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-07T20:36:41.435",\n            "modifiedAt": "2019-11-07T20:36:43.597"\n        },\n        {\n            "travelProductId": 90594745723791,\n            "sellerProductId": "seller-product-id --- 11111",\n            "vendorItemPackageId": 10000000003173,\n            "productId": 98723984761,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": "COMPLETE_APPROVAL",\n            "saleStatus": "SUSPENDED",\n            "name": "[\uB9CC\uB9AC\uC7A5\uC131]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-07T17:24:25.061",\n            "modifiedAt": "2019-11-14T18:03:41.71"\n        },\n        {\n            "travelProductId": 90594745723761,\n            "sellerProductId": "seller-product-id --- 11111",\n            "vendorItemPackageId": 10000000003167,\n            "productId": 98723984761,\n            "travelType": "OVERSEAS",\n            "productDetailType": "PACKAGE_TOUR",\n            "vendorId": "A0000TEST",\n            "qcStatus": "COMPLETE_APPROVAL",\n            "saleStatus": "ON_SALE",\n            "name": "[\uB9CC\uB9AC\uC7A5\uC131]\u2605BSET\u2605\uD6A8\uB3C4\uC5EC\uD589 \uCD94\uCC9C 4/5\uC77C \uD328\uD0A4\uC9C0",\n            "createdAt": "2019-11-07T15:02:14.426",\n            "modifiedAt": "2019-11-07T17:22:39.741"\n        }\n    ]\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewTourProductList;
	}(_react2.default.Component);
	
	exports.default = ViewTourProductList;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewTourProductList.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 7076417321288329:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewTicketDetails = function (_React$Component) {
	    _inherits(ViewTicketDetails, _React$Component);
	
	    function ViewTicketDetails(props) {
	        _classCallCheck(this, ViewTicketDetails);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewTicketDetails.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uB2E4\uC218 \uD2F0\uCF13 \uC0C1\uC138 \uC815\uBCF4 \uC870\uD68C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: 's-post' },
	                    '\uD2F0\uCF13\uC5D0 \uB300\uD55C \uC0C1\uC138 \uC815\uBCF4\uB97C \uC870\uD68C \uD569\uB2C8\uB2E4. \uC774 API\uB97C \uC774\uC6A9\uD574 \uCD5C\uB300 10\uAC1C\uC758 \uD2F0\uCF13 \uC815\uBCF4\uB97C \uAC00\uC838\uC62C \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v1/deal/',
	                                '{dealId}',
	                                '/tickets'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/deal/1234567/tickets'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumbers'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638 \uB9AC\uC2A4\uD2B8'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'redeemable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9 \uCC98\uB9AC \uAC00\uB2A5 \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'purchasedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'canceledAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'statusType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '"CANCEL_COMPLETE" : \uCDE8\uC18C\uC644\uB8CC\uC0C1\uD0DC',
	                                _react2.default.createElement('br', null),
	                                '"PURCHASE_COMPLETE" : \uAD6C\uB9E4\uC644\uB8CC\uC0C1\uD0DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'optionId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC635\uC158\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'useAmount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9 \uAC00\uB2A5 \uC218\uB7C9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'totalAmount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD1D \uC0AC\uC6A9\uC218\uB7C9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4\uAC00\uACA9'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n           {\n                "message": "success",\n                "data" : {\n                    "8231E1-13000000000768" : {\n                        "useAmount" : 0,\n                        "totalAmount" : 1,\n                        "ticketNumber" : "8231E1-13000000000768",\n                        "statusType" : "PURCHASE_COMPLETE",\n                        "redeemable" : false,\n                        "price" : 0,\n                        "optionId" : 53000424937,\n                        "dealId" : 6500124650,\n                        "purchasedAt" : "2017-05-23 23:19:21",\n                        "canceledAt" : null\n                    },\n                     "8231E1-13000000000769" : {\n                        "useAmount" : 0,\n                        "totalAmount" : 1,\n                        "ticketNumber" : "8231E1-13000000000769",\n                        "statusType" : "PURCHASE_COMPLETE",\n                        "redeemable" : false,\n                        "price" : 0,\n                        "optionId" : 53000424937,\n                        "dealId" : 6500124650,\n                        "purchasedAt" : "2017-05-23 23:19:21",\n                        "canceledAt" : null\n                    }\n                }\n            }\n\n                        '
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewTicketDetails;
	}(_react2.default.Component);
	
	exports.default = ViewTicketDetails;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewMutipleTicketDetails.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 7121215342470674:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(4813844983747096);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(642862956009192);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_CLASS = 'react-tabs__tab-panel';
	
	var TabPanel = function (_Component) {
	  _inherits(TabPanel, _Component);
	
	  function TabPanel() {
	    _classCallCheck(this, TabPanel);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TabPanel.prototype.render = function render() {
	    var _cx;
	
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        forceRender = _props.forceRender,
	        id = _props.id,
	        selected = _props.selected,
	        selectedClassName = _props.selectedClassName,
	        tabId = _props.tabId,
	        attributes = _objectWithoutProperties(_props, ['children', 'className', 'forceRender', 'id', 'selected', 'selectedClassName', 'tabId']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)(className, (_cx = {}, _cx[selectedClassName] = selected, _cx)),
	        role: 'tabpanel',
	        id: id,
	        'aria-labelledby': tabId
	      }),
	      forceRender || selected ? children : null
	    );
	  };
	
	  return TabPanel;
	}(_react.Component);
	
	TabPanel.defaultProps = {
	  className: DEFAULT_CLASS,
	  forceRender: false,
	  selectedClassName: DEFAULT_CLASS + '--selected',
	  style: {}
	};
	exports.default = TabPanel;
	TabPanel.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
	  forceRender: _propTypes2.default.bool,
	  id: _propTypes2.default.string, // private
	  selected: _propTypes2.default.bool, // private
	  selectedClassName: _propTypes2.default.string,
	  tabId: _propTypes2.default.string // private
	} : {};

/***/ }),

/***/ 7217189229661154:
/***/ (function(module, exports) {

	module.exports = "<div class=container> <div class=\"jumbotron mt100\"> <h1 class=text-center>404 Not Found<p> </p><p><small class=text-center> Oh noes everything broke</small></p></h1> <p class=text-center>Try pressing the back button or clicking on this button.</p> <p class=text-center><a class=\"btn btn-primary\" href=/ ><i class=\"fa fa-home\"></i> Take Me Home</a></p> </div> </div>";

/***/ }),

/***/ 7220459442453782:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(7932631929871328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GetAPIKeyContent = function (_React$Component) {
	    _inherits(GetAPIKeyContent, _React$Component);
	
	    function GetAPIKeyContent(props) {
	        _classCallCheck(this, GetAPIKeyContent);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    GetAPIKeyContent.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'section-03 page-header', id: 'guides-section-03' },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'blog-title' },
	                    'Ticket Open API Key \uBC1C\uAE09\uBC1B\uAE30'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'mt40' },
	                    '\uC774 \uB2E8\uACC4\uB97C \uC2DC\uC791\uD558\uC2DC\uAE30\uC804\uC5D0 Join \uCE74\uD14C\uACE0\uB9AC\uC5D0\uC11C \uD310\uB9E4\uC790 \uB4F1\uB85D\uC744 \uD558\uC154\uC57C \uD569\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '\uC774 \uC7A5\uC5D0\uC11C\uB294 Production \uD658\uACBD\uC5D0 \uC0AC\uC6A9\uB420 API\uD0A4\uB97C \uBC1C\uAE09\uD558\uB294 \uACFC\uC815\uC5D0 \uB300\uD558\uC5EC \uC124\uBA85\uD569\uB2C8\uB2E4. Production Open API Key \uC2E0\uCCAD\uD6C4 key\uBC1C\uAE09\uC740 \uC989\uAC01\uC801\uC73C\uB85C \uC774\uB8E8\uC5B4\uC9C0\uB098 \uC2E4\uC81C access \uAD8C\uD55C\uC740 \uB0B4\uBD80 \uC2EC\uC0AC\uC808\uCC28\uC5D0 \uC758\uD574 \uADFC\uBB34\uC77C \uAE30\uC900 24 ~ 72\uC2DC\uAC04\uC758 \uC778\uC99D \uC2DC\uAC04\uC744 \uD544\uC694\uB85C \uD558\uBA70 \uAC04\uD639 \uC2EC\uC0AC\uC808\uCC28\uAC00 \uAE38\uC5B4\uC9C0\uB294 \uACBD\uC6B0\uB3C4 \uC788\uC73C\uB2C8 \uC774 Getting Started \uBB38\uC11C\uC5D0 \uB530\uB77C\uC11C \uC9C4\uD589\uD558\uC2DC\uB294\uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4.'
	                )
	            )
	        );
	    };
	
	    return GetAPIKeyContent;
	}(_react2.default.Component);
	
	exports.default = GetAPIKeyContent;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "GetAPIKeyContent.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 7236580699222333:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),

/***/ 7340906541339508:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketRefundRequest = function (_React$Component) {
	    _inherits(TicketRefundRequest, _React$Component);
	
	    function TicketRefundRequest(props) {
	        _classCallCheck(this, TicketRefundRequest);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    TicketRefundRequest.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uD2F0\uCF13 \uD658\uBD88 \uC694\uCCAD API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uD2F0\uCF13\uC744 \uD658\uBD88\uC694\uCCAD\uD569\uB2C8\uB2E4. \uC774 API\uB97C \uC774\uC6A9\uD574 \uCD5C\uB300 5\uAC1C\uC758 \uD2F0\uCF13\uC744 \uD658\uBD88\uC694\uCCAD \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/cancel-request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/cancel-request'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '5', className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumbers'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638 \uB9AC\uC2A4\uD2B8'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'cancelRequestStatusType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '"CANCEL_PROGRESS" : \uD658\uBD88\uC9C4\uD589\uC911',
	                                _react2.default.createElement('br', null),
	                                '"CANCEL_FAIL" : \uD658\uBD88\uC2E4\uD328',
	                                _react2.default.createElement('br', null),
	                                '"CANCEL_COMPLETE" : \uD658\uBD88\uC644\uB8CC',
	                                _react2.default.createElement('br', null),
	                                '"CANCEL_INVALID_REQUEST" : \uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uD2F0\uCF13'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'requestedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC694\uCCAD\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'cancelCompletedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "message": "SUCCESS",\n            "data": {\n                "2C9A62-15000000000587": {\n                    "ticketNumber": "2C9A62-15000000000587",\n                    "dealId": 6500124650,\n                    "cancelRequestStatusType": "CANCEL_PROGRESS",\n                    "requestedAt": "2017-11-07 13:34:22",\n                    "cancelCompletedAt": null\n                    "message": "\uD658\uBD88\uC9C4\uD589\uC911"\n                }\n            }\n        }\n                        '
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return TicketRefundRequest;
	}(_react2.default.Component);
	
	exports.default = TicketRefundRequest;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "TicketRefundRequest.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 7519069036365474:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeleteTicketProduct = function (_React$Component) {
	    _inherits(DeleteTicketProduct, _React$Component);
	
	    function DeleteTicketProduct(props) {
	        _classCallCheck(this, DeleteTicketProduct);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    DeleteTicketProduct.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uC0C1\uD488 \uC0AD\uC81C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC744 \uC0AD\uC81C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'DELETE'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets/',
	                                '{travelProductId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "SUCCESS",\n    "data": 1234567890\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return DeleteTicketProduct;
	}(_react2.default.Component);
	
	exports.default = DeleteTicketProduct;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "DeleteTicketProduct.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 7549376536968869:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateLodgingProductRatePlans = function (_React$Component) {
	    _inherits(CreateLodgingProductRatePlans, _React$Component);
	
	    function CreateLodgingProductRatePlans(props) {
	        _classCallCheck(this, CreateLodgingProductRatePlans);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    CreateLodgingProductRatePlans.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC219\uBC15 \uC694\uAE08\uC81C API \uC0DD\uC131'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC219\uBC15 \uC0C1\uD488\uC5D0 \uB300\uD55C \uD558\uB098 \uC774\uC0C1\uC758 \uC694\uAE08\uC81C \uC0DD\uC131'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/lodgings/',
	                                '{travelProductId}',
	                                '/rates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings/1234567890/rates'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'lodgingRateCreateDtos'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08 \uCE74\uD14C\uACE0\uB9AC \uC0DD\uC131'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC790\uC0AC\uC0AC\uC774\uD2B8\uC758 \uC694\uAE08ID'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRoomIds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC790\uC0AC \uC0AC\uC774\uD2B8\uC758 \uAC1D\uC2E4 ID'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08\uCE74\uD14C\uACE0\uB9AC\uBA85 (\uAD00\uB9AC\uB97C \uC704\uD55C \uBA85\uCE6D\uC73C\uB85C \uCFE0\uD321 \uD310\uB9E4\uD398\uC774\uC9C0\uC5D0 \uB178\uCD9C\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219 \uAE30\uAC04 - \uC2DC\uC791 (format : yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219 \uAE30\uAC04 - \uC885\uB8CC (\uBBF8\uC124\uC815\uC2DC2099-12-31 23:59:59\uB85C \uC124\uC815\uB428. format : yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'mealPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC815\uCC45'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'breakfastIncluded'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uD3EC\uD568 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'numberOfGuests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC720\uD615'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'mealStyle'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC720\uD615 (\uC870\uC2DD\uD3EC\uD568 \uC5EC\uBD80\uAC00 True\uC77C \uACBD\uC6B0 \uD544\uC218 \uC785\uB825). Eg:\uC9C1\uC811\uC785\uB825,\uC77C\uC2DD,\uC591\uC2DD,\uBDD4\uD398\uC2DD,\uCC44\uC2DD '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'surchargeAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uCD94\uAC00 \uC694\uAE08 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uC870\uC2DD \uCD94\uAC00 \uC694\uAE08\uC774 True\uC77C \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 12\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC694\uAE08 \uC785\uB825 (\'\uD604\uC7A5\uACB0\uC81C\' \uAE30\uC900\uC73C\uB85C \uC694\uAE08\uC744 \uC124\uC815\uD574\uC8FC\uC138\uC694.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uADDC\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uADDC\uC815 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'refundable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88 \uBD88\uAC00 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : True)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'refundRates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC790\uBCC4 \uCDE8\uC18C \uD658\uBD88 \uADDC\uC815 (\uCDE8\uC18C \uBD88\uAC00 \uC5EC\uBD80\uAC00 True \uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825 / False \uC778 \uACBD\uC6B0 \uC785\uB825 \uBD88\uD544\uC694)',
	                                _react2.default.createElement('br', null),
	                                '\uC804\uC561 \uD658\uBD88\uC758 \uACBD\uC6B0 \uADDC\uC815\uC5D0 \uB9DE\uB294 \uC219\uBC15\uC77C\uC744 \uC120\uD0DD\uD558\uACE0, \uD658\uBD88\uC728\uC740 100%\uB85C \uC124\uC815\uD574\uC8FC\uC138\uC694.\u200B',
	                                _react2.default.createElement('br', null),
	                                '\uC608: \uC219\uBC15\uC77C= 7days, \uD658\uBD88\uC728=100%\uB85C \uC124\uC815\uD558\uB294 \uACBD\uC6B0 \uACE0\uAC1D\uC774 \uBCF4\uB294 \uD658\uBD88 \uADDC\uC815\uC740 \uCDE8\uC18C \uC885\uB958\uC5D0 \uB530\uB77C \uC790\uB3D9 \uCDE8\uC18C\uC778 \uACBD\uC6B0 "7\uC77C 23:59 \uC804 \uCDE8\uC18C \uC2DC \uC804\uC561 \uD658\uBD88", \uC2B9\uC778 \uCDE8\uC18C\uC778 \uACBD\uC6B0 "7\uC77C 17:00 \uC804 \uCDE8\uC18C \uC2DC \uC804\uC561 \uD658\uBD88"\uC73C\uB85C \uBCF4\uC785\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'days'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC77C (\uC608: \uC219\uBC15\uC77C 5 ',
	                                '{days}',
	                                '\uC77C\uC804\uBD80\uD130 70% ',
	                                '{refundRate}',
	                                ' \uD658\uBD88)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'refundRate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC728 (\uC608: \uC219\uBC15\uC77C 5 ',
	                                '{days}',
	                                '\uC77C\uC804\uBD80\uD130 70% ',
	                                '{refundRate}',
	                                ' \uD658\uBD88)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'extraGuestPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uBE44\uC6A9 (\uC785\uB825\uD55C \uC778\uC6D0\uCD94\uAC00\uC694\uAE08\uC740 \uAC01 \uAC1D\uC2E4\uC758 \uAE30\uC900\uC778\uC6D0 \uCD08\uACFC\uC2DC \uC790\uB3D9\uC73C\uB85C \uC801\uC6A9\uB418\uC5B4 \uC628\uB77C\uC778\uC73C\uB85C \uACB0\uC81C\uB429\uB2C8\uB2E4.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'surchargeAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 17\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5 / (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825))'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uC694\uAE08 \uC785\uB825 (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'extraBedPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uC124\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraBedAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uAC00\uB2A5 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False) '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'surchargeNeeded'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraBeds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uC885\uB958'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'bedType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BABY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BABY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 17\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5 / (\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825))'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'checkInOutPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778/\uCCB4\uD06C\uC544\uC6C3 \uC2DC\uAC04 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'checkInStartTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778 \uC2DC\uAC04 (HH:mm)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'checkOutEndTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC544\uC6C3 \uC2DC\uAC04 (HH:mm)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'instruction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778/\uCCB4\uD06C\uC544\uC6C3 \uC548\uB0B4 \uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'freeServicePolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778/\uCCB4\uD06C\uC544\uC6C3 \uC548\uB0B4 \uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBB34\uB8CC \uC11C\uBE44\uC2A4 \uC81C\uACF5 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'freeServices'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBB34\uB8CC \uC11C\uBE44\uC2A4 \uC81C\uACF5 \uC720\uD615 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'freeServiceType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_DRINK'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBB34\uB8CC \uC74C\uB8CC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_GIFT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBB34\uB8CC \uC120\uBB3C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_ROOM_UPGRADE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4 \uBB34\uB8CC \uC5C5\uADF8\uB808\uC774\uB4DC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_VIEW_UPGRADE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4 \uBDF0 \uBB34\uB8CC \uC5C5\uADF8\uB808\uC774\uB4DC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBB34\uB8CC \uC11C\uBE44\uC2A4\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'extraPackagePolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC124\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraPackages'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC720\uD615 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC11C\uBE44\uC2A4\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'extraPackageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ENTRANCE_TICKET'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC785\uC7A5\uAD8C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#createTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'createTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n  "lodgingRateCreateDtos": [\n    {\n      "cancelPolicy": {\n        "notice": "cancel policy notice - 2",\n        "refundRates": [\n          {\n            "days": 5,\n            "refundRate": 90\n          },\n          {\n            "days": 4,\n            "refundRate": 80\n          },\n          {\n            "days": 3,\n            "refundRate": 50\n          }\n        ],\n        "refundable": true\n      },\n      "checkInOutPolicy": {\n        "checkInStartTime": "15:00",\n        "checkOutEndTime": "11:00",\n        "instruction": "check in/out instruction - 2"\n      },\n      "extraBedPolicy": {\n        "extraBedAvailable": true,\n        "surchargeNeeded": true,\n        "extraBeds": [\n          {\n            "bedType": "ADULT",\n            "name": "extra bed 1",\n            "surcharges": [\n              {\n                "ageType": "ADULT",\n                "minAge": 18,\n                "surcharge": 80000\n              }\n            ]\n          }\n        ]\n      },\n      "extraGuestPolicy": {\n        "surchargeAvailable": true,\n        "surcharges": [\n          {\n            "ageType": "ADULT",\n            "minAge": 18,\n            "surcharge": 50000\n          }\n        ]\n      },\n      "extraPackagePolicy": {\n        "extraPackages": [\n          {\n            "extraPackageType": "ENTRANCE_TICKET",\n            "name": "Disney land"\n          }\n        ],\n        "notice": "extra package notice"\n      },\n      "freeServicePolicy": {\n        "freeServices": [\n          {\n            "freeServiceType": "FREE_DRINK",\n            "name": "Welcome drink"\n          }\n        ],\n        "notice": "free service policy notice"\n      },\n      "mealPolicy": {\n        "breakfastIncluded": false,\n        "mealStyle": "Chinese",\n        "notice": "meal policy notice",\n        "numberOfGuests": 2,\n        "surchargeAvailable": true,\n        "surcharges": [\n          {\n            "ageType": "CHILD",\n            "minAge": 9,\n            "surcharge": 10000\n          }\n        ]\n      },\n      "name": "room_rate_4",\n      "saleEndedAt": "2099-12-31 23:59:59",\n      "saleStartedAt": "2020-01-01 00:00:01",\n      "sellerRateId": "seller rate 2",\n      "sellerRoomIds": [\n        "room_1",\n        "room_2","room_3","room_4"\n      ]\n    }\n  ]\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<LodgingRateResponseDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'rate id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uC694\uAE08 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08\uCE74\uD14C\uACE0\uB9AC\uBA85'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Rate plan create request successfully received",\n    "data": [\n        {\n            "rateId": 577900851415220224,\n            "sellerRateId": "seller rate 2",\n            "name": "room_rate_4"\n        }\n    ]\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforCreateProduct' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforCreateProduct', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement('div', { className: 'panel-body' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return CreateLodgingProductRatePlans;
	}(_react2.default.Component);
	
	exports.default = CreateLodgingProductRatePlans;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "CreateLodgingProductRatePlans.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 7855088649851362:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateLodgingProducts = function (_React$Component) {
	    _inherits(CreateLodgingProducts, _React$Component);
	
	    function CreateLodgingProducts(props) {
	        _classCallCheck(this, CreateLodgingProducts);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    CreateLodgingProducts.prototype.render = function render() {
	        var col_number_9 = 9;
	        var total_levels = 6;
	        var level1 = 6;
	        var level2 = 5;
	        var level2_prefix = level1 - level2;
	        var level3 = 4;
	        var level3_prefix = level1 - level3;
	        var level4 = 3;
	        var level4_prefix = level1 - level4;
	        var level5 = 2;
	        var level6 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC219\uBC15 \uC0C1\uD488 \uC0DD\uC131 API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uCFE0\uD321\uC5D0\uC11C \uD310\uB9E4\uD560 \uC219\uBC15 \uC0C1\uD488\uC744 \uB4F1\uB85D\uD558\uB294 API\uC785\uB2C8\uB2E4. '
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/lodgings'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_9, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_9, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'lodgingCreateDtos'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<LodgingCreateDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productDetailType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uC18C \uC720\uD615 (\uC0C1\uD488 \uC0DD\uC131 \uC774\uD6C4 \uBCC0\uACBD \uBD88\uAC00\uD569\uB2C8\uB2E4.)',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HOTEL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD638\uD154'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESORT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB9AC\uC870\uD2B8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PENSION'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD39C\uC158'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'GUEST_HOUSE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC8C\uC2A4\uD2B8\uD558\uC6B0\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CAMPING'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCEA0\uD551'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MOTEL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBAA8\uD154'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'DOMESTIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAD6D\uB0B4\uC5EC\uD589'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OVERSEAS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD574\uC678\uC5EC\uD589'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC790\uC0AC\uC0AC\uC774\uD2B8\uC758 \uC0C1\uD488ID'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15 \uC2DC\uC124 \uAD6D\uAC00 (\uAE30\uBCF8\uAC12 : \uD55C\uAD6D)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uC774\uB984 (\uCD5C\uB300 50\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'localName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB85C\uCEEC\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'introduction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uC18C\uAC1C (\uCD5C\uB300 2000\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uACF5\uC9C0\uC0AC\uD56D (\uCD5C\uB300 2000\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5) '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'benefits'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uD2B9\uBCC4\uD61C\uD0DD (\uCD5C\uB300 3\uAC1C / \uCD5C\uB300 30\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5) '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'regionKeyword'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uC5ED\uD0A4\uC6CC\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'searchTags'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC80\uC0C9\uD0DC\uADF8 (\uCD5C\uB300 100\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'images'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Method. Default: GET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'representative '
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\uAC00 \uC0C1\uD488 \uB300\uD45C\uD568, \uC0C1\uD488\uB2F9 \uB2E8\uC77C \uB300\uD45C\uC774\uBBF8\uC9C0 \uBCF4\uC720. Default: FALSE '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'imageGroup'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85. Default:BASIC',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'VIEW'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FACILITY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD80\uB300\uC2DC\uC124'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESTAURANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DD\uB2F9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ROOM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uC815\uCC45',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AUTO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uB3D9\uCDE8\uC18C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778\uCDE8\uC18C'
	                                            )
	                                        )
	                                    )
	                                ),
	                                'CancelType(\uCDE8\uC18C\uC885\uB958) \uBCC4 \uCDE8\uC18C\uB9C8\uAC10\uC2DC\uAC04 (\uC219\uBC15\uC0C1\uD488)',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'AUTO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uB3D9\uCDE8\uC18C: \uBE44\uC601\uC5C5\uC77C(\uACE0\uAC1D\uCDE8\uC18C\uC811\uC218)\uAE30\uC900 23:59\u200B'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778\uCDE8\uC18C: \uC601\uC5C5\uC77C \uAE30\uC900 17:00'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelPolicyNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'instantBooking'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2E4\uC2DC\uAC04 \uC608\uC57D \uAC00\uB2A5 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : True)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'additionalInfoPrompt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBB38 \uCD94\uAC00\uC815\uBCF4  (\uCFE0\uD321\uC5D0\uC11C \uC8FC\uBB38\uC2DC \uACE0\uAC1D\uC5D0\uAC8C \uCD94\uAC00\uC694\uCCAD\uC0AC\uD56D\uC744 \uB0A8\uAE30\uB3C4\uB85D \uC694\uCCAD\uD574\uC57C\uD558\uB294\uACBD\uC6B0, \uC8FC\uBB38 \uCD94\uAC00 \uC815\uBCF4\uB97C \uB0A8\uACA8\uC8FC\uC138\uC694. (\uC608 : \uBC29\uBB38\uBC29\uBC95\uACFC \uC2DC\uAC04\uC744 \uB0A8\uACA8\uC8FC\uC138\uC694 \uB4F1))'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'usageGuide'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uC6A9 \uC548\uB0B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'usageNotice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uC6A9\uC548\uB0B4 \uBC0F \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'address'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15 \uC2DC\uC124 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uB3C4, \uB370\uC774\uD130 \uBC94\uC704(-90, 90)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uACBD\uB3C4, \uB370\uC774\uD130 \uBC94\uC704(-180,180)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'roadNameAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uB85C\uBA85 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'landNumberAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uBC88 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6D\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'province'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'city'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'district'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'town'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'zipCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B0\uD3B8\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'localAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD604\uC9C0 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uB3C4 , \uB370\uC774\uD130 \uBC94\uC704(-90, 90)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uACBD\uB3C4, \uB370\uC774\uD130 \uBC94\uC704(-180,180)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'roadNameAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4\uB85C\uBA85 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'landNumberAddress'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uBC88 \uC8FC\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'nation'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6D\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'province'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'city'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'district'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'town'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'zipCode'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6B0\uD3B8\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'reservationNotifications'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D/\uCDE8\uC18C \uC54C\uB9BC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PHONE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC804\uD654'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD329\uC2A4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'EMAIL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC774\uBA54\uC77C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'contactInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'contactDescription'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5F0\uB77D\uCC98 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'homepage'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD648\uD398\uC774\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'representativePhone'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uB300\uD45C \uC804\uD654'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'bookingInquiryPhone'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC608\uC57D \uBB38\uC758 \uC804\uD654. \uC81C\uACF5\uB418\uC9C0 \uC54A\uC73C\uBA74 \uD574\uB2F9 \uB370\uC774\uD130\uAC00 representativePhone\uACFC \uB3D9\uC77C\uD568.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'cancelInquiryPhone'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uBB38\uC758 \uC804\uD654.\uC81C\uACF5\uB418\uC9C0 \uC54A\uC73C\uBA74 \uD574\uB2F9 \uB370\uC774\uD130\uAC00 representativePhone\uACFC \uB3D9\uC77C\uD568.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'emergencyPhone'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD734\uB300\uD3F0 \uAE34\uAE09 \uC5F0\uB77D\uCC98'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'trafficInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE38\uC548\uB0B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'publicTransportInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB79C\uB4DC\uB9C8\uD06C \uC548\uB0B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'nearbyLandmarks'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC8FC\uBCC0 \uAD00\uAD11\uC9C0 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'latitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'longitude'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC704\uB3C4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'distanceUnit'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'KILOMETER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD0AC\uB85C\uBBF8\uD130'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'METER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uD130'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'amenities'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uACF5\uD1B5 \uAD6C\uBE44 \uD488\uBAA9. \uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'themes'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD14C\uB9C8\uC815\uBCF4. \uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rooms'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uC0DD\uC131'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerRoomId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC790\uC0AC\uC0AC\uC774\uD2B8\uC758 \uAC1D\uC2E4ID.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'bedType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA0\uB4DC\uD0C0\uC785,\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'viewType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4\uC804\uB9DD,\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'additionalInfo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uCD94\uAC00 \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'area'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC9C0\uC5ED'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'components'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'componentType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'count'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'beds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'bedType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC790\uC138\uD55C \uB0B4\uC6A9\uC744 \uC5D1\uC140 \uD30C\uC77C\uC744 \uCC38\uACE0\uD574 \uC8FC\uC2ED\uC2DC\uC624.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'count'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'images'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC774\uBBF8\uC9C0 URL'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0\uAC00 \uC0C1\uD488 \uB300\uD45C\uD568, \uC0C1\uD488\uB2F9 \uB2E8\uC77C \uB300\uD45C\uC774\uBBF8\uC9C0 \uBCF4\uC720. Default: FALSE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'imageGroup'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85. Default Value:BASIC',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'VIEW'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB0B4\uC678\uAD00/\uC804\uACBD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FACILITY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBD80\uB300\uC2DC\uC124'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESTAURANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2DD\uB2F9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ROOM'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC774\uBBF8\uC9C0 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'amenities'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC1D\uC2E4 \uAD6C\uBE44 \uD488\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'occupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'standardOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE30\uC900\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'maximumOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD5C\uB300\uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'maximumChildrenOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uBB34\uB8CC \uB3D9\uBC18 \uC785\uC2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'freeChildrenAllowed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uBB34\uB8CC \uB3D9\uBC18 \uC785\uC2E4 \uAC00\uB2A5 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'freeChildrenAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC785\uC2E4 \uAC00\uB2A5\uD55C \uC5B4\uB9B0\uC774 \uB098\uC774'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'freeChildrenOccupancy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC785\uC2E4 \uAC00\uB2A5\uD55C \uC5B4\uB9B0\uC774 \uC778\uC6D0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08 \uCE74\uD14C\uACE0\uB9AC \uC0DD\uC131'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC790\uC0AC\uC0AC\uC774\uD2B8\uC758 \uC694\uAE08ID'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerRoomIds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uC790 \uC790\uC0AC \uC0AC\uC774\uD2B8\uC758 \uAC1D\uC2E4 ID'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08\uCE74\uD14C\uACE0\uB9AC\uBA85 (\uAD00\uB9AC\uB97C \uC704\uD55C \uBA85\uCE6D\uC73C\uB85C \uCFE0\uD321 \uD310\uB9E4\uD398\uC774\uC9C0\uC5D0 \uB178\uCD9C\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'saleStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219 \uAE30\uAC04 - \uC2DC\uC791 (format : yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'saleEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD22C\uC219 \uAE30\uAC04 - \uC885\uB8CC (\uBBF8\uC124\uC815\uC2DC2099-12-31 23:59:59\uB85C \uC124\uC815\uB428. format : yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'mealPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC815\uCC45'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'breakfastIncluded'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uD3EC\uD568 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'numberOfGuests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC720\uD615'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'mealStyle'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC720\uD615 (\uC870\uC2DD\uD3EC\uD568 \uC5EC\uBD80\uAC00 True\uC77C \uACBD\uC6B0 \uD544\uC218 \uC785\uB825). Eg:\uC9C1\uC811\uC785\uB825,\uC77C\uC2DD,\uC591\uC2DD,\uBDD4\uD398\uC2DD,\uCC44\uC2DD '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surchargeAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uCD94\uAC00 \uC694\uAE08 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uC870\uC2DD \uCD94\uAC00 \uC694\uAE08\uC774 True\uC77C \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 12\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC870\uC2DD \uC694\uAE08 \uC785\uB825 (\'\uD604\uC7A5\uACB0\uC81C\' \uAE30\uC900\uC73C\uB85C \uC694\uAE08\uC744 \uC124\uC815\uD574\uC8FC\uC138\uC694.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'cancelPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uADDC\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCDE8\uC18C \uD658\uBD88 \uADDC\uC815 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'refundable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88 \uBD88\uAC00 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : True)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'refundRates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC790\uBCC4 \uCDE8\uC18C \uD658\uBD88 \uADDC\uC815 (\uCDE8\uC18C \uBD88\uAC00 \uC5EC\uBD80\uAC00 True \uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825 / False \uC778 \uACBD\uC6B0 \uC785\uB825 \uBD88\uD544\uC694)',
	                                _react2.default.createElement('br', null),
	                                '\uC804\uC561 \uD658\uBD88\uC758 \uACBD\uC6B0 \uADDC\uC815\uC5D0 \uB9DE\uB294 \uC219\uBC15\uC77C\uC744 \uC120\uD0DD\uD558\uACE0, \uD658\uBD88\uC728\uC740 100%\uB85C \uC124\uC815\uD574\uC8FC\uC138\uC694.\u200B',
	                                _react2.default.createElement('br', null),
	                                '\uC608: \uC219\uBC15\uC77C= 7days, \uD658\uBD88\uC728=100%\uB85C \uC124\uC815\uD558\uB294 \uACBD\uC6B0 \uACE0\uAC1D\uC774 \uBCF4\uB294 \uD658\uBD88 \uADDC\uC815\uC740 \uCDE8\uC18C \uC885\uB958\uC5D0 \uB530\uB77C \uC790\uB3D9 \uCDE8\uC18C\uC778 \uACBD\uC6B0 "7\uC77C 23:59 \uC804 \uCDE8\uC18C \uC2DC \uC804\uC561 \uD658\uBD88", \uC2B9\uC778 \uCDE8\uC18C\uC778 \uACBD\uC6B0 "7\uC77C 17:00 \uC804 \uCDE8\uC18C \uC2DC \uC804\uC561 \uD658\uBD88"\uC73C\uB85C \uBCF4\uC785\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'days'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC77C (\uC608: \uC219\uBC15\uC77C 5 ',
	                                '{days}',
	                                '\uC77C\uC804\uBD80\uD130 70% ',
	                                '{refundRate}',
	                                ' \uD658\uBD88)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'refundRate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC728 (\uC608: \uC219\uBC15\uC77C 5 ',
	                                '{days}',
	                                '\uC77C\uC804\uBD80\uD130 70% ',
	                                '{refundRate}',
	                                ' \uD658\uBD88)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraGuestPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uBE44\uC6A9 (\uC785\uB825\uD55C \uC778\uC6D0\uCD94\uAC00\uC694\uAE08\uC740 \uAC01 \uAC1D\uC2E4\uC758 \uAE30\uC900\uC778\uC6D0 \uCD08\uACFC\uC2DC \uC790\uB3D9\uC73C\uB85C \uC801\uC6A9\uB418\uC5B4 \uC628\uB77C\uC778\uC73C\uB85C \uACB0\uC81C\uB429\uB2C8\uB2E4.)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surchargeAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5B4\uB9B0\uC774 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 17\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5 / (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825))'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uC694\uAE08 \uC785\uB825 (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraBedPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uC124\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'extraBedAvailable'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uAC00\uB2A5 \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False) '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'surchargeNeeded'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80 (\uAE30\uBCF8\uAC12 : False)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'extraBeds'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uC885\uB958'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'bedType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BABY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'surcharges'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'ageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BABY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'minAge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uAE30\uC900 \uB098\uC774 (\uCD5C\uB300 \uB9CC 17\uC138 \uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5 / (\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825))'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level6 },
	                                'surcharge'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCE68\uAD6C \uCD94\uAC00 \uC694\uAE08 \uC124\uC815 (\uC778\uC6D0 \uCD94\uAC00 \uC694\uAE08 \uBC1C\uC0DD \uC5EC\uBD80\uAC00 True\uC778 \uACBD\uC6B0 \uD544\uC218 \uC785\uB825)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'checkInOutPolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778/\uCCB4\uD06C\uC544\uC6C3 \uC2DC\uAC04 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'checkInStartTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778 \uC2DC\uAC04 (HH:mm)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'checkOutEndTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC544\uC6C3 \uC2DC\uAC04 (HH:mm)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'instruction'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778/\uCCB4\uD06C\uC544\uC6C3 \uC548\uB0B4 \uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'freeServicePolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCCB4\uD06C\uC778/\uCCB4\uD06C\uC544\uC6C3 \uC548\uB0B4 \uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBB34\uB8CC \uC11C\uBE44\uC2A4 \uC81C\uACF5 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'freeServices'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBB34\uB8CC \uC11C\uBE44\uC2A4 \uC81C\uACF5 \uC720\uD615 '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'freeServiceType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_DRINK'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBB34\uB8CC \uC74C\uB8CC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_GIFT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBB34\uB8CC \uC120\uBB3C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_ROOM_UPGRADE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4 \uBB34\uB8CC \uC5C5\uADF8\uB808\uC774\uB4DC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE_VIEW_UPGRADE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAC1D\uC2E4 \uBDF0 \uBB34\uB8CC \uC5C5\uADF8\uB808\uC774\uB4DC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uD0C0'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBB34\uB8CC \uC11C\uBE44\uC2A4\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'extraPackagePolicy'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC124\uC815'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC720\uC758\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'extraPackages'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC720\uD615 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD328\uD0A4\uC9C0 \uC11C\uBE44\uC2A4\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'extraPackageType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ENTRANCE_TICKET'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC785\uC7A5\uAD8C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ETC'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#createTourDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'createTourDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n{\n  "lodgingCreateDtos": [\n    {\n    \t"address":{\n    \t\t"nation":"CN",\n    \t\t"city":"Shanghai",\n    \t\t"district":"Pudong Avenue",\n    \t\t"landNumberAddress":"Shanghai \uC0C1\uD558\uC774 shanghaihutail617"\n    \t},\n\t\t"reservationNotifications":[{\n\t\t\t"type":"PHONE",\n\t\t\t"contactInfo":"010-0000-1111",\n\t\t\t"contactDescription":""\n\t\t},\n\t\t{\n\t\t\t"type":"EMAIL",\n\t\t\t"contactInfo":"test@coupang.com",\n\t\t\t"contactDescription":""\n\t\t}\n\t\t],\n\t\t"homepage":"homepage",\n      "usageGuide":"usageGuide",\n      "additionalInfoPrompt":"additionalInfoPrompt",\n      "cancelType": "APPROVAL",\n      "cancelPolicyNotice":"cancelPolicyNotice",\n      "images": [\n        {\n          "description": "image description 1",\n          "imageGroup": "BASIC",\n          "representative": true,    \n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq":0\n        },\n        {\n          "description": "image description 2",\n          "imageGroup": "ROOM",\n          "representative": false,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/db272720_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq":1\n        },\n        {\n          "description": "image description 3",\n          "imageGroup": "VIEW",\n          "representative": false,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq":2\n        },\n        {\n          "description": "image description 4",\n          "imageGroup": "VIEW",\n          "representative": false,\n          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq":3\n        }\n      ],\n      \n      "introduction": "product introduction",\n       "benefits": [\n        "benefit 1",\n        "benefit 2"\n      ],\n      "searchTags": [\n        "shanghai",\n        "disney"\n      ],\n      "regionKeyword":"regionKeyword",\n      "localName": "\u5047\u65E5\u9152\u5E97",\n      "name": "\uD558\uC774 \uC778_Test_nation_resort",  \n      "notice": "product notice",\n      "productDetailType": "HOTEL",     \n      "rates": [\n        {\n        \t"sellerRateId":"sellerRateId",\n         "saleStartedAt":"2020-05-04 11:00:00",\n         "name":"rate_name_1",\n\t\t "sellerRoomIds":["room_1"],\n          "cancelPolicy": {  \n            "refundRates": [\n              {\n                "days": 5,\n                "refundRate": 90\n              }\n            ]\n          },\n          "checkInOutPolicy": {\n            "checkInStartTime": "15:00",\n            "checkOutEndTime": "11:00",\n            "instruction":"checkInOutPolicy.instruction"\n          },    \n          "mealPolicy":{\n          \t"numberOfGuests":2\n          }\n        },\n        {\n        \t"saleStartedAt":"2020-05-04 11:00:00",\n         "sellerRoomIds":["room_2"],\n          "cancelPolicy": {\n            \n            "refundRates": [\n              {\n                "days": 6,\n                "refundRate": 90\n              }\n            ]\n          },\n          "checkInOutPolicy": {\n            "checkInStartTime": "11:00",\n            "checkOutEndTime": "11:00"\n          },\n          "mealPolicy": {\n            "numberOfGuests": 2\n          }\n        }\n      ],\n      "nearbyLandmarks": [\n        {\n          "distance": 1,\n          "distanceUnit": "KILOMETER",\n          "latitude": 31,\n          "longitude": 121,\n          "name": "nearbyLandmark 1"\n        },\n        {\n          "distance": 500,\n          "distanceUnit": "METER",\n          "latitude": 31.1,\n          "longitude": 121.1,\n          "name": "nearbyLandmark 1"\n        }\n      ],\n      "amenities":[\n      \t"ROOM_AMENITY_GENERAL_3",\n      \t"ROOM_AMENITY_GENERAL_6",\n      \t"ROOM_AMENITY_GENERAL_9"\n      \t],\n      \t"themes":[\n      \t\t"ACCOMMODATION_THEME_63","ACCOMMODATION_THEME_65"\n      \t\t],\n      "representativePhone": "010-1234-5678",\n      "bookingInquiryPhone":"010-1111-1111",\n      "cancelInquiryPhone":"010-2222-2222",\n      "emergencyPhone":"emergencyPhone",\n      "trafficInfo":"trafficInfo",\n      "publicTransportInfo":"publicTransportInfo",\n      "rooms": [ \n        {\n        \t"viewType":"ROOM_VIEW_110",\n        \t"bedType":"ROOM_BED_TYPE_95",\n        "sellerRoomId":"room_1",\n          "name": "\uD328\uBC00\uB9AC \uD0C0\uC6B4\uD648_3",\n          "additionalInfo":"additionalInfo",\n          "area":20.01,\n           "beds": [\n            {\n              "count": 1,\n              "bedType": "BED_TYPE_89"\n            }\n            ],\n          "components": [\n          {\n             "count": 1,\n             "componentType": "ROOM_COMPONENT_COUNT_109"\n          }\n          ],\n          "occupancy": {\n            "freeChildrenAge": 9,\n            "freeChildrenAllowed": true,\n            "freeChildrenOccupancy": 1,\n            "maximumChildrenOccupancy": 1,\n            "maximumOccupancy": 4,\n            "standardOccupancy": 2\n          },\n           "images": [\n        {\n          "description": null,\n          "imageGroup": "ROOM",\n          "representative": true, \n          "sellerUrl": "https://i.travelapi.com/hotels/46000000/45590000/45583000/45582932/c86f2711_z.jpg",\n          "sellerUrlMethod": "GET"\n        }],\n        "amenities":["ROOM_AMENITY_GENERAL_12","ROOM_AMENITY_GENERAL_13","ROOM_AMENITY_GENERAL_5","ROOM_AMENITY_GENERAL_1","ROOM_AMENITY_GENERAL_2"] \n        },\n        \t{\n        "sellerRoomId":"room_2",\n        "viewType":"ROOM_VIEW_110",\n        "bedType":"ROOM_BED_TYPE_95",\n          "name": "\uD328\uBC00\uB9AC \uD0C0\uC6B4\uD648_3",\n          "occupancy": {\n            "freeChildrenAge": 9,\n            "freeChildrenAllowed": true,\n            "freeChildrenOccupancy": 1,\n            "maximumChildrenOccupancy": 1,\n            "maximumOccupancy": 4,\n            "standardOccupancy": 2\n          },\n          "images": [\n        {\n          "description": null,\n          "imageGroup": "ROOM",\n          "representative": true,\n          "sellerImageCategory": null,\n          "sellerUrl": "https://i.travelapi.com/hotels/46000000/45590000/45583000/45582932/c86f2711_z.jpg",\n          "sellerUrlMethod": "GET",\n          "seq": 0\n        }]\n        }\n      ],\n     \n      "nation":"CN",\n     "sellerProductId":"sellerProductId",\n     "travelType": "OVERSEAS", \n      "usageNotice": "usage notice"\n    }\n  ]\n}\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'LodgingResultResponseDto'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<SuccessOrFail>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'success'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC219\uBC15\uC2DC\uC124 \uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'rooms'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<LodgingRoomResponseDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'sellerRoomId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uB8F8 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uB8F8\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'rates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<LodgingRateResponseDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'rateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'rate id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC6F9\uC0AC\uC774\uD2B8\uC758 \uC694\uAE08 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uC694\uAE08\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'fail'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uD504\uB85C\uB355\uD2B8 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC6F9\uC0AC\uC774\uD2B8\uC758 \uD504\uB85C\uB355\uD2B8\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'reason'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC624\uB958 \uC0AC\uC720'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "Lodging product create request successfully received",\n    "data": {\n        "success": [\n            {\n                "travelProductId": 577844653924024324,\n                "sellerProductId": "sellerProductId",\n                "name": "\uD558\uC774 \uC778_Test_nation_resort",\n                "rooms": [\n                    {\n                        "travelItemId": 577844653924024323,\n                        "sellerRoomId": "room_1",\n                        "name": "\uD328\uBC00\uB9AC \uD0C0\uC6B4\uD648_3"\n                    },\n                    {\n                        "travelItemId": 577844653924024322,\n                        "sellerRoomId": "room_2",\n                        "name": "\uD328\uBC00\uB9AC \uD0C0\uC6B4\uD648_3"\n                    }\n                ],\n                "rates": [\n                    {\n                        "rateId": 577844653924024321,\n                        "sellerRateId": "sellerRateId",\n                        "name": "rate_name_1"\n                    },\n                    {\n                        "rateId": 577844653924024320,\n                        "sellerRateId": null,\n                        "name": null\n                    }\n                ]\n            }\n        ],\n        "fail": []\n    }\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforCreateProduct' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforCreateProduct', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement('div', { className: 'panel-body' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return CreateLodgingProducts;
	}(_react2.default.Component);
	
	exports.default = CreateLodgingProducts;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "CreateLodgingProducts.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 7925919092148657:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(4813844983747096);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(642862956009192);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_CLASS = 'react-tabs__tab';
	
	var Tab = function (_Component) {
	  _inherits(Tab, _Component);
	
	  function Tab() {
	    _classCallCheck(this, Tab);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Tab.prototype.componentDidMount = function componentDidMount() {
	    this.checkFocus();
	  };
	
	  Tab.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.checkFocus();
	  };
	
	  Tab.prototype.checkFocus = function checkFocus() {
	    if (this.props.selected && this.props.focus) {
	      this.node.focus();
	    }
	  };
	
	  Tab.prototype.render = function render() {
	    var _cx,
	        _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        disabled = _props.disabled,
	        disabledClassName = _props.disabledClassName,
	        focus = _props.focus,
	        id = _props.id,
	        panelId = _props.panelId,
	        selected = _props.selected,
	        selectedClassName = _props.selectedClassName,
	        tabRef = _props.tabRef,
	        attributes = _objectWithoutProperties(_props, ['children', 'className', 'disabled', 'disabledClassName', 'focus', 'id', 'panelId', 'selected', 'selectedClassName', 'tabRef']);
	
	    return _react2.default.createElement(
	      'li',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)(className, (_cx = {}, _cx[selectedClassName] = selected, _cx[disabledClassName] = disabled, _cx)),
	        ref: function ref(node) {
	          _this2.node = node;
	          if (tabRef) tabRef(node);
	        },
	        role: 'tab',
	        id: id,
	        'aria-selected': selected ? 'true' : 'false',
	        'aria-disabled': disabled ? 'true' : 'false',
	        'aria-controls': panelId,
	        tabIndex: selected ? '0' : null
	      }),
	      children
	    );
	  };
	
	  return Tab;
	}(_react.Component);
	
	Tab.defaultProps = {
	  className: DEFAULT_CLASS,
	  disabledClassName: DEFAULT_CLASS + '--disabled',
	  focus: false,
	  id: null,
	  panelId: null,
	  selected: false,
	  selectedClassName: DEFAULT_CLASS + '--selected'
	};
	exports.default = Tab;
	Tab.propTypes =  false ? {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string]),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
	  disabled: _propTypes2.default.bool,
	  disabledClassName: _propTypes2.default.string,
	  focus: _propTypes2.default.bool, // private
	  id: _propTypes2.default.string, // private
	  panelId: _propTypes2.default.string, // private
	  selected: _propTypes2.default.bool, // private
	  selectedClassName: _propTypes2.default.string,
	  tabRef: _propTypes2.default.func // private
	} : {};

/***/ }),

/***/ 7932631929871328:
/***/ (function(module, exports) {

	/*!
	 * Bootstrap v3.3.7 (http://getbootstrap.com)
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
	this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);

/***/ }),

/***/ 7950831717660649:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewTicketProductByPage = function (_React$Component) {
	    _inherits(ViewTicketProductByPage, _React$Component);
	
	    function ViewTicketProductByPage(props) {
	        _classCallCheck(this, ViewTicketProductByPage);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ViewTicketProductByPage.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uBAA9\uB85D \uC870\uD68C'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uD2F0\uCF13 \uC0C1\uD488\uC758 \uBAA9\uB85D\uC744 \uD655\uC778/\uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'GET'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '4', className: 'bold' },
	                                'Query Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'pageSize'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0 \uC0AC\uC774\uC988. \uB514\uD3F4\uD2B8 \uAC12: 50. \uCD5C\uB300\uCE58: 100'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'nextPageToken'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Next Page Token'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC758 \uC0C1\uD488'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'sellerProductName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travel product name'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'createdDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0DD\uC131 \uB0A0\uC9DC \uC9C0\uC815\uD558\uAE30.Format: yyyy-MM-dd ex)2019-10-15'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'qcStatus'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'qcStatus Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SAVED_TEMPORARY'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC784\uC2DC \uC800\uC7A5'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WAITING_APPROVAL_MD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MD \uC2B9\uC778 \uB300\uAE30'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'WAITING_APPROVAL_QC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'QC \uC2B9\uC778 \uB300\uAE30'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'COMPLETE_APPROVAL'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778 \uC644\uB8CC'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'REJECTED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC2B9\uC778 \uBC18\uB824'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BLOCKED'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB9C9\uD78C'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'nextPageToken'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0\uB124\uC774\uC158 \uD1A0\uD070'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'size'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'int'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD398\uC774\uC9C0\uB124\uC774\uC158 \uD398\uC774\uC9D5 \uD06C\uAE30, \uCD5C\uC18C10&\uCD5C\uB300100'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<TravelIndexDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                '\xA0travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                '\xA0sellerProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorItemPackageId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uD15C \uD328\uD0A4\uC9C0 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD504\uB85C\uB355\uD2B8 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uBD84\uB958'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productDetailType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC138\uBD80 \uBD84\uB958'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'vendorId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'qcStatus'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC218\uB7C9 \uCEE8\uD2B8\uB864 \uC0C1\uD0DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleStatus'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC0C1\uD0DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC0C1\uD488 \uC774\uB984'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'createdAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0DD\uC131\uC77C\uC790'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'modifiedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC218\uC815\uC77C\uC790'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n{\n    "code": 200,\n    "message": "OK",\n    "nextPageToken": "1577432448330",\n    "size": 38,\n    "data": [\n        {\n            "travelProductId": 527852958679826432,\n            "sellerProductId": "string",\n            "vendorItemPackageId": 30000000000460,\n            "productId": 10000000000680,\n            "travelType": "OVERSEAS",\n            "productDetailType": "READY_TO_TRIP",\n            "vendorId": "A00100622",\n            "qcStatus": "COMPLETE_APPROVAL",\n            "saleStatus": "ON_SALE",\n            "name": "Jenny_Test_5",\n            "createdAt": "2019-12-27T23:19:15.03",\n            "modifiedAt": "2019-12-27T23:19:21.815"\n        },\n        {\n            "travelProductId": 527849475654287360,\n            "sellerProductId": "string",\n            "vendorItemPackageId": 30000000000459,\n            "productId": 10000000000679,\n            "travelType": "OVERSEAS",\n            "productDetailType": "READY_TO_TRIP",\n            "vendorId": "A00100622",\n            "qcStatus": "COMPLETE_APPROVAL",\n            "saleStatus": "ON_SALE",\n            "name": "Jenny_Test_5",\n            "createdAt": "2019-12-27T23:05:46.554",\n            "modifiedAt": "2019-12-27T23:06:00.638"\n        },\n        {\n            "travelProductId": 527846208840925184,\n            "sellerProductId": "string",\n            "vendorItemPackageId": 30000000000458,\n            "productId": 10000000000678,\n            "travelType": "OVERSEAS",\n            "productDetailType": "READY_TO_TRIP",\n            "vendorId": "A00100622",\n            "qcStatus": "COMPLETE_APPROVAL",\n            "saleStatus": "ON_SALE",\n            "name": "Jenny_Test_5",\n            "createdAt": "2019-12-27T22:52:25.293",\n            "modifiedAt": "2019-12-27T22:55:01.64"\n        }\n    ]\n}\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ViewTicketProductByPage;
	}(_react2.default.Component);
	
	exports.default = ViewTicketProductByPage;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "ViewTicketProductByPage.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 8373411682089081:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateTourProductV2 = function (_React$Component) {
		_inherits(CreateTourProductV2, _React$Component);
	
		function CreateTourProductV2(props) {
			_classCallCheck(this, CreateTourProductV2);
	
			return _possibleConstructorReturn(this, _React$Component.call(this, props));
		}
	
		CreateTourProductV2.prototype.render = function render() {
			var col_number_8 = 8;
			var level1 = 5;
			var level2 = 4;
			var level3 = 3;
			var level4 = 2;
			var level5 = 1;
	
			return _react2.default.createElement(
				'div',
				{ className: 'mb0 mt40', id: 'create-tour-product' },
				_react2.default.createElement(
					'h3',
					null,
					'\uC0C1\uD488 \uB4F1\uB85D'
				),
				_react2.default.createElement(
					'div',
					{ className: 'blog-post-meta' },
					_react2.default.createElement(
						'span',
						{ className: 's-post' },
						'\uCFE0\uD321\uC5D0\uC11C \uD310\uB9E4\uD560 \uD328\uD0A4\uC9C0/\uD56D\uACF5 \uC0C1\uD488\uC744 \uB4F1\uB85D\uD558\uB294 API\uC785\uB2C8\uB2E4. ',
						_react2.default.createElement('br', null),
						' \uB4F1\uB85D \uCD5C\uB300 \uC81C\uD55C (Product 10\uAC1C, Item 50\uAC1C), \uB4F1\uB85D \uC694\uCCAD \uD6C4 \uBC18\uB4DC\uC2DC \uC870\uD68C API\uB85C \uB4F1\uB85D \uC5EC\uBD80\uB97C \uD655\uC778 \uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.'
					),
					_react2.default.createElement(
						'h3',
						{ className: 'request-method' },
						_react2.default.createElement(
							'span',
							{ className: 'label label-success' },
							'POST'
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'Path'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: 3 },
									'Example Endpoint'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'/v2/marketplace/create/',
									'{type}',
									'/tour/product'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: 3 },
									'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v2/marketplace/create/overseas/tour/product'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: '4', className: 'bold' },
									'Path Segment Parameter'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Required'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'type'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									_react2.default.createElement(
										'table',
										{ className: 'table table-striped' },
										_react2.default.createElement(
											'tbody',
											null,
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'\uC9C0\uC5ED \uCE74\uD14C\uACE0\uB9AC'
												),
												_react2.default.createElement('td', null),
												_react2.default.createElement('td', null)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'th',
													null,
													'Value'
												),
												_react2.default.createElement(
													'th',
													null,
													'Type'
												),
												_react2.default.createElement(
													'th',
													null,
													'Description'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'overseas'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uD574\uC678'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'domestic'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uAD6D\uB0B4'
												)
											)
										)
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt10' },
					_react2.default.createElement(
						'h4',
						null,
						'Request Parameters'
					),
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: col_number_8, className: 'bold' },
									'Request Header'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: level1 },
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Required'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'Request-Vendor-Id'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uBCA4\uB354 \uC544\uC774\uB514'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: col_number_8, className: 'bold' },
									'Body Parameter'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: level1 },
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Required'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'propertyId'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC544\uC774\uB514'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'title'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC5EC\uD589\uC0C1\uD488\uBA85 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 50\uC790 \uC785\uB2C8\uB2E4)'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'introduction'
								),
								_react2.default.createElement(
									'td',
									null,
									'X'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC5EC\uD589\uC0C1\uD488\uC18C\uAC1C'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'searchTags'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Array'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC11C\uCE58\uD0DC\uADF8 \uB9AC\uC2A4\uD2B8 (\uAC01 \uC11C\uCE58\uD0DC\uADF8 \uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 10\uC790 \uC785\uB2C8\uB2E4)'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'destination'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC0C1\uD488\uC5D0 \uD45C\uC2DC\uD560 \uB3C4\uCC29 \uC9C0\uC5ED \uD0A4\uC6CC\uB4DC (\uAC01 \uD0A4\uC6CC\uB4DC \uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 10\uC790 \uC785\uB2C8\uB2E4)'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'displayCategoryCode'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Integer'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC0C1\uD488\uC758 \uB178\uCD9C \uCE74\uD14C\uACE0\uB9AC. Example: 106774 (\uC0DD\uC131 \uD6C4 \uBCC0\uACBD\uBD88\uAC00 \uD56D\uBAA9 \uC785\uB2C8\uB2E4)'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'airportCode'
								),
								_react2.default.createElement(
									'td',
									null,
									'X'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'IATA \uACF5\uD56D \uCF54\uB4DC. Example: SHA'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'representativeImages'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Array'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uBCF5\uC218 \uB300\uD45C \uC774\uBBF8\uC9C0 URL'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'composition'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									_react2.default.createElement(
										'table',
										{ className: 'table table-striped' },
										_react2.default.createElement(
											'tbody',
											null,
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'\uC0C1\uD488 \uAD6C\uC131 \uC694\uC18C'
												),
												_react2.default.createElement('td', null)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'th',
													null,
													'Optional Value'
												),
												_react2.default.createElement(
													'th',
													null,
													'Description'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'FUEL_SURCHARGE_INCLUDED'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC720\uB958\uD560\uC99D\uB8CC \uD3EC\uD568'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'FUEL_SURCHARGE_TAX_EXCLUDED'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC720\uB958\uD560\uC99D\uB8CC+\uC138\uAE08\uBD88\uD3EC\uD568'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'FUEL_SURCHARGE_NOT_APPLICABLE'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uD574\uB2F9\uC5C6\uC74C(\uC720\uB958\uD560\uC99D\uB8CC)'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'SHOPPING_INCLUDE'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC1FC\uD551 \uD3EC\uD568'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'SHOPPING_EXCLUDE'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC1FC\uD551 \uBD88\uD3EC\uD568'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'ADDITIONAL_EXPENSE_INCLUDE'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uCD94\uAC00\uACBD\uBE44 \uD3EC\uD568'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'ADDITIONAL_EXPENSE_EXCLUDE'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uCD94\uAC00\uACBD\uBE44 \uBD88\uD3EC\uD568'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'FREE_SCHEDULE_INCLUDE'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC790\uC720\uC77C\uC815 \uD3EC\uD568'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'FREE_SCHEDULE_EXCLUDE'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC790\uC720\uC77C\uC815 \uBD88\uD3EC\uD568'
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'saleStatus'
								),
								_react2.default.createElement(
									'td',
									null,
									'X'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									_react2.default.createElement(
										'table',
										{ className: 'table table-striped' },
										_react2.default.createElement(
											'tbody',
											null,
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'\uC0C1\uD488 \uD310\uB9E4 \uC0C1\uD0DC. \uAE30\uBCF8\uAC12: ON_SALE'
												),
												_react2.default.createElement('td', null)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'th',
													null,
													'Optional Value'
												),
												_react2.default.createElement(
													'th',
													null,
													'Description'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'ON_SALE'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uD310\uB9E4\uC911'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'SUSPENDED'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uD310\uB9E4\uC77C\uC2DC\uC911\uC9C0'
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'items'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Array'
								),
								_react2.default.createElement('td', null)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'propertyItemId'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC544\uC774\uD15C \uB2E8\uC704 \uC544\uC774\uB514'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'title'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC5EC\uD589\uC544\uC774\uD15C\uBA85 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 50\uC790 \uC785\uB2C8\uB2E4)'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'departure'
								),
								_react2.default.createElement(
									'td',
									null,
									'X'
								),
								_react2.default.createElement(
									'td',
									null,
									'Object'
								),
								_react2.default.createElement(
									'td',
									null,
									_react2.default.createElement(
										'table',
										{ className: 'table table-striped' },
										_react2.default.createElement(
											'tbody',
											null,
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'\uCD9C\uBC1C \uD56D\uACF5\uD3B8 \uC815\uBCF4'
												),
												_react2.default.createElement('td', null),
												_react2.default.createElement('td', null)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'th',
													null,
													'Name'
												),
												_react2.default.createElement(
													'th',
													null,
													'Type'
												),
												_react2.default.createElement(
													'th',
													null,
													'Description'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'takeOffDate'
												),
												_react2.default.createElement(
													'td',
													null,
													'String (format : yyyy-MM-dd HH:mm:ss)'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC774\uB959\uC2DC\uAC04'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'landingDate'
												),
												_react2.default.createElement(
													'td',
													null,
													'String (format : yyyy-MM-dd HH:mm:ss)'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uCC29\uB959\uC2DC\uAC04'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'flight'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uD56D\uACF5\uD3B8 (\uC608 : OZ757)'
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'arrival'
								),
								_react2.default.createElement(
									'td',
									null,
									'X'
								),
								_react2.default.createElement(
									'td',
									null,
									'Object'
								),
								_react2.default.createElement(
									'td',
									null,
									_react2.default.createElement(
										'table',
										{ className: 'table table-striped' },
										_react2.default.createElement(
											'tbody',
											null,
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'\uB3C4\uCC29 \uD56D\uACF5\uD3B8 \uC815\uBCF4'
												),
												_react2.default.createElement('td', null),
												_react2.default.createElement('td', null)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'th',
													null,
													'Name'
												),
												_react2.default.createElement(
													'th',
													null,
													'Type'
												),
												_react2.default.createElement(
													'th',
													null,
													'Description'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'takeOffDate'
												),
												_react2.default.createElement(
													'td',
													null,
													'String (format : yyyy-MM-dd HH:mm:ss)'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uC774\uB959\uC2DC\uAC04'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'landingDate'
												),
												_react2.default.createElement(
													'td',
													null,
													'String (format : yyyy-MM-dd HH:mm:ss)'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uCC29\uB959\uC2DC\uAC04'
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'flight'
												),
												_react2.default.createElement(
													'td',
													null,
													'String'
												),
												_react2.default.createElement(
													'td',
													null,
													'\uD56D\uACF5\uD3B8 (\uC608 : OZ757)'
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'hasChildRate'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Boolean'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uD310\uB9E4\uC0C1\uD0DC \uC124\uC815 / \uD310\uB9E4\uC911 : TRUE, \uD310\uB9E4\uC911\uC9C0 : FALSE (Default: TRUE)'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'notices'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Object'
								),
								_react2.default.createElement('td', null)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'usage'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC720\uC758\uC0AC\uD56D'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'inclusion'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uD3EC\uD568\uC0AC\uD56D'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'exclusion'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uBD88\uD3EC\uD568\uC0AC\uD56D'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'reservation'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC608\uC57D\uC548\uB0B4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'customerCenter'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uACE0\uAC1D\uC13C\uD130 \uC6B4\uC601\uC2DC\uAC04. Example: \uACE0\uAC1D\uC13C\uD130 \uBB38\uC758\uC2DC\uAC04: 1644-2888, \uD3C9\uC77C 09:30~17:30 (\uB2E8, \uD1A0/\uC77C, \uACF5\uD734\uC77C\uC740 \uD734\uBB34)'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'duration'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Object'
								),
								_react2.default.createElement('td', null)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'days'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Integer'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC5EC\uC815 \uC77C \uC218'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'nights'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Integer'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC5EC\uC815 \uC219\uBC15 \uC218'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'itinerary'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Array'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC77C\uC815'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'days'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Integer'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC77C\uC815 \uCC28\uC218. Exmaple: 1, 2'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'order'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'Integer'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC815\uB82C \uC21C\uC11C'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'courseName'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC77C\uC815 \uC81C\uBAA9'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'location'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC704\uCE58\uC548\uB0B4\uC815\uBCF4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'mealName'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC2DD\uC0AC\uBA85'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'hotelName'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC219\uC18C\uBA85'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'description'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC77C\uC815\uC124\uBA85'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'representativeImage'
								),
								_react2.default.createElement(
									'td',
									null,
									'O'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC77C\uC815 \uC774\uBBF8\uC9C0 URL'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'div',
						{ className: 'panel panel-default' },
						_react2.default.createElement(
							'div',
							{ className: 'panel-heading' },
							_react2.default.createElement('h3', { className: 'panel-title' }),
							_react2.default.createElement(
								'a',
								{ 'data-toggle': 'collapse', href: '#createTourDto' },
								'Request Body'
							)
						),
						_react2.default.createElement(
							'div',
							{ id: 'createTourDto', className: 'panel-collapse collapse' },
							_react2.default.createElement(
								'div',
								{ id: 'createTourDto', className: 'panel-body' },
								_react2.default.createElement(
									'pre',
									{ className: 'ty01' },
									'\n{\n   "tourProductDtoList":[\n      {\n         "displayCategoryCode":108804,\n         "propertyId":"seller-product-id",\n         "title":"[\uC778\uCC9C/\uAE40\uD3EC\uCD9C\uBC1C] \uC0C1\uD574+\uD56D\uC8FC+\uC218\uD5A5\uB9C8\uC744 \uD328\uD0A4\uC9C0",\n         "items":[\n            {\n               "propertyItemId":"seller-item-id-1",\n               "title":"\uC0C1\uD574/\uD56D\uC8FC/\uC8FC\uAC00\uAC01 1\uC77C",\n               "departure":{\n                  "takeOffDate":"2020-03-16 09:30:00",\n                  "landingDate":"2020-03-16 13:30:00",\n                  "flight":"KE982"\n               },\n               "arrival":{\n                  "takeOffDate":"2020-03-25 18:30:00",\n                  "landingDate":"2020-03-25 22:30:00",\n                  "flight":"KE982"\n               },\n               "duration":{\n                  "days":3,\n                  "nights":4\n               },\n               "itinerary":[\n                  {\n                     "courseName":"\uD56D\uACF5\uC2A4\uCF00\uC974",\n                     "days":1,\n                     "order":1,\n                     "descriptions":"[KE893] 08:35 \uC778\uCC9C \uC0C1\uD574 \uD5A5\uBC1C (\uC57D 02\uC2DC\uAC04 10\uBD84 \uC18C\uC694) 09:45 \uC0C1\uD574 \uB3C4\uCC29",\n                     "location":""\n                  },\n                  {\n                     "courseName":"[\uAD00\uAD11] \uC0C1\uD574",\n                     "days":1,\n                     "order":2,\n                     "descriptions":"\uB3C4\uC2DC\uAC1C\uC694 - \uC18C\uAC1C : \uC0C1\uD558\uC774\uB294 \uC911\uAD6D \uC591\uCBD4\uAC15 \uC5B4\uADC0\uC5D0 \uC788\uB294 \uC0C1\uACF5\uC5C5 \uB3C4\uC2DC\uB85C \uC815\uBD80 \uC9C1\uD560\uC2DC\uC774\uB2E4",\n                     "location":"",\n                     "representativeImage":"http://img.test-tour.com/test.jpg"\n                  },\n                  {\n                     "courseName":"\uC0C1\uD574-\uD56D\uC8FC \uC774\uB3D9 (\uC57D3\uC2DC\uAC04 \uC18C\uC694)",\n                     "days":1,\n                     "order":3,\n                     "descriptions":"",\n                     "location":"",\n                     "representativeImage":"http://img.test-tour.com/test.jpg"\n                  },\n                  {\n                     "courseName":"[\uAD00\uAD11] \uD56D\uC8FC",\n                     "days":1,\n                     "order":4,\n                     "descriptions":"\uC624\uB798\uB41C \uC61B \uCC3B\uC9D1\uB4E4\uB85C \uC720\uBA85\uD55C \uACF3"\n                  }\n               ],\n               "notices":{\n                  "usage":"\uBCF8 \uC0C1\uD488\uC740 \uB2E8\uCCB4\uAD00\uAD11\uC744 \uBAA9\uC801\uC73C\uB85C \uD558\uB294 \uD328\uD0A4\uC9C0\uC5EC\uD589\uC73C\uB85C, \uAD00\uAD11\uC5D0 \uCC38\uC5EC\uD558\uC9C0 \uC54A\uACE0 \uAC1C\uBCC4\uC801\uC778 \uD65C\uB3D9\uC744 \uC6D0\uD558\uC2DC\uB294 \uBD84\uB4E4\uC740 \uC790\uC720\uC5EC\uD589 \uC0C1\uD488\uC73C\uB85C \uC608\uC57D\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.",\n                  "inclusion":"\uC655\uBCF5 \uD56D\uACF5\uAD8C \uD3EC\uD568",\n                  "exclusion":"1\uC778\uB2F9 \uC804\uC77C\uC815 \uAC00\uC774\uB4DC",\n                  "reservation":"\uB2F4\uB2F9\uC790\uAC00 \uC608\uC57D\uD655\uC815\uC5EC\uBD80\uB97C \uBB38\uC790\uB85C \uC54C\uB824\uB4DC\uB9BD\uB2C8\uB2E4.",\n                  "customerCenter":"\uACE0\uAC1D\uC13C\uD130 \uBB38\uC758\uC2DC\uAC04: 1644-2888, \uD3C9\uC77C 09:30~17:30 (\uB2E8, \uD1A0/\uC77C, \uACF5\uD734\uC77C\uC740 \uD734\uBB34)"\n               }\n            },\n            {\n               "propertyItemId":"seller-item-id-2",\n               "title":"\uC0C1\uD574/\uD56D\uC8FC/\uC8FC\uAC00\uAC01 2\uC77C",\n               "departure":{\n                  "takeOffDate":"2020-03-16 09:30:00",\n                  "landingDate":"2020-03-16 13:30:00",\n                  "flight":"KE982"\n               },\n               "arrival":{\n                  "takeOffDate":"2020-03-25 18:30:00",\n                  "landingDate":"2020-03-25 22:30:00",\n                  "flight":"KE982"\n               },\n               "duration":{\n                  "days":3,\n                  "nights":4\n               },\n               "itinerary":[\n                  {\n                     "courseName":"\uD56D\uACF5\uC2A4\uCF00\uC974",\n                     "days":1,\n                     "order":1,\n                     "descriptions":"[KE893] 08:35 \uC778\uCC9C \uC0C1\uD574 \uD5A5\uBC1C (\uC57D 02\uC2DC\uAC04 10\uBD84 \uC18C\uC694) 09:45 \uC0C1\uD574 \uB3C4\uCC29",\n                     "location":""\n                  },\n                  {\n                     "courseName":"[\uAD00\uAD11] \uC0C1\uD574",\n                     "days":1,\n                     "order":2,\n                     "descriptions":"\uB3C4\uC2DC\uAC1C\uC694 - \uC18C\uAC1C : \uC0C1\uD558\uC774\uB294 \uC911\uAD6D \uC591\uCBD4\uAC15 \uC5B4\uADC0\uC5D0 \uC788\uB294 \uC0C1\uACF5\uC5C5 \uB3C4\uC2DC\uB85C \uC815\uBD80 \uC9C1\uD560\uC2DC\uC774\uB2E4",\n                     "location":"",\n                     "representativeImage":"http://img.test-tour.com/test.jpg"\n                  },\n                  {\n                     "courseName":"\uC0C1\uD574-\uD56D\uC8FC \uC774\uB3D9 (\uC57D3\uC2DC\uAC04 \uC18C\uC694)",\n                     "days":1,\n                     "order":3,\n                     "descriptions":"",\n                     "location":"",\n                     "representativeImage":"http://img.test-tour.com/test.jpg"\n                  },\n                  {\n                     "courseName":"[\uAD00\uAD11] \uD56D\uC8FC",\n                     "days":1,\n                     "order":4,\n                     "descriptions":"\uC624\uB798\uB41C \uC61B \uCC3B\uC9D1\uB4E4\uB85C \uC720\uBA85\uD55C \uACF3"\n                  }\n               ],\n               "notices":{\n                  "usage":"\uBCF8 \uC0C1\uD488\uC740 \uB2E8\uCCB4\uAD00\uAD11\uC744 \uBAA9\uC801\uC73C\uB85C \uD558\uB294 \uD328\uD0A4\uC9C0\uC5EC\uD589\uC73C\uB85C, \uAD00\uAD11\uC5D0 \uCC38\uC5EC\uD558\uC9C0 \uC54A\uACE0 \uAC1C\uBCC4\uC801\uC778 \uD65C\uB3D9\uC744 \uC6D0\uD558\uC2DC\uB294 \uBD84\uB4E4\uC740 \uC790\uC720\uC5EC\uD589 \uC0C1\uD488\uC73C\uB85C \uC608\uC57D\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.",\n                  "inclusion":"\uC655\uBCF5 \uD56D\uACF5\uAD8C \uD3EC\uD568",\n                  "exclusion":"1\uC778\uB2F9 \uC804\uC77C\uC815 \uAC00\uC774\uB4DC",\n                  "reservation":"\uB2F4\uB2F9\uC790\uAC00 \uC608\uC57D\uD655\uC815\uC5EC\uBD80\uB97C \uBB38\uC790\uB85C \uC54C\uB824\uB4DC\uB9BD\uB2C8\uB2E4.",\n                  "customerCenter":"\uACE0\uAC1D\uC13C\uD130 \uBB38\uC758\uC2DC\uAC04: 1644-2888, \uD3C9\uC77C 09:30~17:30 (\uB2E8, \uD1A0/\uC77C, \uACF5\uD734\uC77C\uC740 \uD734\uBB34)"\n               }\n            }\n         ],\n         "searchTags":[\n            "\uC0C1\uD574",\n            "\uD56D\uC8FC",\n            "\uC218\uD5A5\uB9C8\uC744"\n         ],\n         "destination":"\uC0C1\uD558\uC774",\n         "representativeImages":[\n            "http://img.test-tour.com/test.jpg"\n         ],\n         "composition":[\n            "FUEL_SURCHARGE_INCLUDED",\n            "SHOPPING_INCLUDE",\n            "ADDITIONAL_EXPENSE_INCLUDE",\n            "FREE_SCHEDULE_INCLUDE"\n         ],\n         "airportCode":"SHA",\n         "saleStatus":"ON_SALE",\n         "introduction":"\uACE0\uD488\uC73C\uB85C \uC54C\uCC2C \uC0C1\uD574\uC5EC\uD589\uD2B9\uC8041. NO\uD301 NO\uC635\uC158\uD2B9\uC8042. \uC804 \uC77C\uC815VIP\uB9AC\uBB34\uC9C4 \uD0D1\uC2B9\uD2B9\uC8043. \uC1A1\uC131\uAC00\uBB34\uC1FCVIP /\uD669\uD3EC\uAC15\uC720\uB78C\uC120/ \uC804\uC2E0\uB9C8\uC0AC\uC9C0 \uD3EC\uD568\uD2B9\uC8044. \uCC28\uBCC4\uD654\uB41C \uD2B9\uC2DD \uB3D9\uD30C\uC721,\uC0AC\uCC9C\uC694\uB9AC,\uC0BC\uACB9\uC0B4\uBB34\uC81C\uD55C \uC81C\uACF5"\n      }\n   ]\n}\n                        '
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'h4',
						null,
						'Response Specifications'
					),
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									{ colSpan: level1 },
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Type'
								),
								_react2.default.createElement(
									'th',
									null,
									'Description'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'code'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uCF54\uB4DC'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'message'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC751\uB2F5 \uBA54\uC138\uC9C0'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									{ colSpan: level1 },
									'productCreateResponseDto'
								),
								_react2.default.createElement(
									'td',
									null,
									'Object'
								),
								_react2.default.createElement('td', null)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'travelProductId'
								),
								_react2.default.createElement(
									'td',
									null,
									'Long'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC5EC\uD589\uC0C1\uD488 \uC544\uC774\uB514'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'sellerProductId'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC720\uB2C9 \uC544\uC774\uB514'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level2 },
									'itemCreateResponse'
								),
								_react2.default.createElement(
									'td',
									null,
									'Array'
								),
								_react2.default.createElement('td', null)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'sellerTravelItemId'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC140\uB7EC\uC5D0\uC11C \uC0C1\uD488\uC744 \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD55C \uC544\uC774\uD15C \uB2E8\uC704 \uC544\uC774\uB514'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'name'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC5EC\uD589 \uC544\uC774\uD15C\uBA85'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'td',
									{ colSpan: level3 },
									'travelItemId'
								),
								_react2.default.createElement(
									'td',
									null,
									'String'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uCFE0\uD321 \uC0C1\uD488 \uC544\uC774\uD15C \uC544\uC774\uB514'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive mt40' },
					_react2.default.createElement(
						'div',
						{ className: 'panel panel-default' },
						_react2.default.createElement(
							'div',
							{ className: 'panel-heading' },
							_react2.default.createElement(
								'h3',
								{ className: 'panel-title' },
								'\uC751\uB2F5\uAC12 \uC608\uC2DC'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'panel-body' },
							_react2.default.createElement(
								'pre',
								{ className: 'ty01' },
								'\n{\n  "code": 200,\n  "message": "SUCCESS",\n  "data": [\n    {\n      "travelProductId": 542240730693763100,\n      "sellerProductId": "seller-product-id",\n      "itemCreateResponse": [\n        {\n          "name": "\uC0C1\uD574/\uD56D\uC8FC/\uC8FC\uAC00\uAC01 1\uC77C",\n          "travelItemId": 542240730999947260,\n          "sellerTravelItemId": "seller-item-id-1"\n        },\n        {\n          "name": "\uC0C1\uD574/\uD56D\uC8FC/\uC8FC\uAC00\uAC01 2\uC77C",\n          "travelItemId": 542240731289354240,\n          "sellerTravelItemId": "seller-item-id-2"\n        }\n      ]\n    }\n  ]\n}\n                        '
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'table table-striped' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'th',
									null,
									'HTTP CODE'
								),
								_react2.default.createElement(
									'th',
									null,
									'message'
								),
								_react2.default.createElement(
									'th',
									null,
									'\uC124\uBA85'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'400'
								),
								_react2.default.createElement(
									'td',
									null,
									'Bad request'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
									_react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'a',
											{ 'data-toggle': 'collapse', href: '#errorMessagesforCreateProduct' },
											'400 Error Messages'
										)
									),
									_react2.default.createElement(
										'div',
										{ id: 'errorMessagesforCreateProduct', className: 'panel-collapse collapse' },
										_react2.default.createElement(
											'div',
											{ className: 'panel-body' },
											_react2.default.createElement(
												'li',
												null,
												'\uC774\uB118 \uD0C0\uC785 ',
												'${enumClazz.getSimpleName()}',
												'\uC5D0 \uB300\uD55C \uBB34\uD6A8 \uBB38\uC790\uC5F4 \uAC12'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uBB34\uD6A8 display category code'
											),
											_react2.default.createElement(
												'li',
												null,
												'images\uAC00 \uBE44\uC5B4\uC788\uC744 \uC218 \uC5C6\uC74C'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uBCF5\uC81C \uB41C \uC774\uBBF8\uC9C0 \uACBD\uB85C'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uB300\uD45C \uC774\uBBF8\uC9C0 \uB2E8 \uD55C\uC7A5\uB9CC \uD5C8\uC6A9 \uAC00\uB2A5'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uAD6D\uB0B4 \uC5EC\uD589\uC5D0 \uB300\uD55C locations\uAC00 \uBE44\uC5B4\uC788\uC73C\uBA74 \uC548\uB428'
											),
											_react2.default.createElement(
												'li',
												null,
												'landNumberAddress\uC911 \uD558\uB098\uC640 roadNameAddress\uB97C \uC81C\uACF5\uD574\uC57C\uD568'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uBB34\uD6A8 seqs'
											),
											_react2.default.createElement(
												'li',
												null,
												'format\uC774 IMAGE\uAC00 \uC544\uB2CC \uACBD\uC6B0 content\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
											),
											_react2.default.createElement(
												'li',
												null,
												'format\uC774 IMAGE\uC778 \uACBD\uC6B0 sellerUrl\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
											),
											_react2.default.createElement(
												'li',
												null,
												'title\uC744 \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
											),
											_react2.default.createElement(
												'li',
												null,
												'travelType \uBC0F productDetailType\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC74C'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uBB34\uD6A8 theme'
											),
											_react2.default.createElement(
												'li',
												null,
												'instantBooking\uC774 false\uC778 \uACBD\uC6B0 estimatedBookingDuration\uC7740\uBCF4\uB2E4 \uD06C\uACE0 72\uBCF4\uB2E4 \uC791\uAC70\uB098 \uAC19\uC544\uC57C\uB428'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uC5F0\uB77D\uCC98\uC5D0 \uB300\uD45C \uC804\uD654 \uBC88\uD638\uAC00 \uD558\uB098 \uC788\uC5B4\uC57C\uD568'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uBB34\uD6A8 tour feature id'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uBB34\uD6A8 tour feature value'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uBB34\uD6A8 tour item feature id'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uBB34\uD6A8 tour item feature value'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uBB34\uD6A8 \uC77C\uC790/\uC2DC\uAC04 \uD3EC\uB9F7, \uD3EC\uB9F7\uC774 ',
												'{pattern}',
												'\uC774\uC5B4\uC57C\uD568'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uD310\uB9E4 \uC2DC\uC791\uC77C\uC740 \uD310\uB9E4 \uC885\uB8CC\uC77C\uBCF4\uB2E4 \uB2A6\uC9C0 \uC54A\uC544\uC57C\uD568'
											),
											_react2.default.createElement(
												'li',
												null,
												'\uC911\uBCF5 \uCDE8\uC18C \uD658\uBD88\uC728refund rates'
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'401'
								),
								_react2.default.createElement(
									'td',
									null,
									'Unauthorized Error'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'403'
								),
								_react2.default.createElement(
									'td',
									null,
									'Forbidden Error'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'410'
								),
								_react2.default.createElement(
									'td',
									null,
									'The resource has been permanently deleted'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'412'
								),
								_react2.default.createElement(
									'td',
									null,
									'Precondition failed'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'429'
								),
								_react2.default.createElement(
									'td',
									null,
									'Too many requests'
								),
								_react2.default.createElement(
									'td',
									null,
									'\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'504'
								),
								_react2.default.createElement(
									'td',
									null,
									'API Gateway response timeout'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'521'
								),
								_react2.default.createElement(
									'td',
									null,
									'API provider server has error'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							),
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement(
									'td',
									null,
									'524'
								),
								_react2.default.createElement(
									'td',
									null,
									'API provider to API gateway connection response timeout'
								),
								_react2.default.createElement(
									'td',
									null,
									'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
								)
							)
						)
					)
				)
			);
		};
	
		return CreateTourProductV2;
	}(_react2.default.Component);
	
	exports.default = CreateTourProductV2;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "CreateTourProductV2.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 8386636578645942:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(7932631929871328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IntroContent = function (_React$Component) {
	    _inherits(IntroContent, _React$Component);
	
	    function IntroContent(props) {
	        _classCallCheck(this, IntroContent);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    IntroContent.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'page-header', id: 'guides-section-01' },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'blog-title mt20' },
	                    'Coupang Open API Intro'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'mt40' },
	                    'Coupang Open API\uB97C \uC774\uC6A9\uD568\uC73C\uB85C\uC368 \uBB34\uC5C7\uC774 \uAC1C\uC120\uB418\uB098\uC694?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '\uCFE0\uD321\uC758 Open API\uB97C \uC774\uC6A9\uD558\uC5EC \uC5EC\uB7EC\uBD84\uC758 \uC2DC\uC2A4\uD15C\uC5D0 \uC5F0\uB3D9\uD560 \uACBD\uC6B0 \uC2E4\uC2DC\uAC04\uC73C\uB85C \uC5EC\uB7EC\uBD84\uC758 \uC2DC\uC2A4\uD15C\uC774 \uCFE0\uD321\uC5D0 \uBC18\uC601\uB418\uAC8C \uD568\uC73C\uB85C\uC368 \uCFE0\uD321 \uC0AC\uC774\uD2B8\uC5D0 \uC5EC\uB7EC\uBD84\uC758 \uC0C1\uD488\uC744 \uAD00\uB9AC\uD568\uC5D0 \uB530\uB77C \uB9E4\uCD9C \uD5A5\uC0C1 \uBC0F \uAD6C\uB9E4\uC790 \uAD00\uB9AC\uB97C \uC190\uC27D\uAC8C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'mt40' },
	                    '\uBCC4\uB3C4\uC758 \uC81C\uD734\uAC00 \uD544\uC694\uD569\uB2C8\uAE4C?'
	                ),
	                _react2.default.createElement(
	                    'blockquote',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'font14' },
	                        '\uBB38\uC758\uB97C \uC6D0\uD558\uC2DC\uB294 \uACBD\uC6B0 \uC544\uB798 \uBA54\uC77C \uC8FC\uC18C\uB85C \uC804\uC1A1 \uBD80\uD0C1\uB4DC\uB9BD\uB2C8\uB2E4.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        '\uC218\uC2E0\uC790 : travel-api@coupang.com',
	                        _react2.default.createElement('br', null),
	                        '\uC81C\uBAA9 : [Open API \uC81C\uD734\uBB38\uC758][\uC5C5\uCCB4\uBA85]',
	                        _react2.default.createElement('br', null),
	                        'ex) [Open API \uC81C\uD734\uBB38\uC758][\uCFE0\uD321]',
	                        _react2.default.createElement('br', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'mt40' },
	                    'Open API \uC5F0\uB3D9 \uACBD\uD5D8\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '\uAC71\uC815\uD558\uC9C0 \uB9C8\uC138\uC694. Open API\uB97C \uC5F0\uB3D9\uD558\uB294 \uC77C\uB828\uC758 \uACFC\uC815\uB4E4 \uC989 workflow Best Practice\uB97C \uC81C\uACF5\uD569\uB2C8\uB2E4.'
	                )
	            )
	        );
	    };
	
	    return IntroContent;
	}(_react2.default.Component);
	
	exports.default = IntroContent;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "IntroContent.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 8476312172317632:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTabsCount = getTabsCount;
	exports.getPanelsCount = getPanelsCount;
	
	var _childrenDeepMap = __webpack_require__(5289629256324197);
	
	var _Tab = __webpack_require__(7925919092148657);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabPanel = __webpack_require__(7121215342470674);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTabsCount(children) {
	  var tabCount = 0;
	  (0, _childrenDeepMap.deepForEach)(children, function (child) {
	    if (child.type === _Tab2.default) tabCount++;
	  });
	
	  return tabCount;
	}
	
	function getPanelsCount(children) {
	  var panelCount = 0;
	  (0, _childrenDeepMap.deepForEach)(children, function (child) {
	    if (child.type === _TabPanel2.default) panelCount++;
	  });
	
	  return panelCount;
	}

/***/ }),

/***/ 8482719018238175:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateTicketProductItem = function (_React$Component) {
	    _inherits(UpdateTicketProductItem, _React$Component);
	
	    function UpdateTicketProductItem(props) {
	        _classCallCheck(this, UpdateTicketProductItem);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateTicketProductItem.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC0C1\uD488 \uC635\uC158 \uC218\uC815'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uB4F1\uB85D\uD55C \uC0C1\uD488\uC758 \uC635\uC158 \uC815\uBCF4\uB97C \uC218\uC815/\uC5C5\uB370\uC774\uD2B8 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'PUT'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tickets/',
	                                '{travelProductId}',
	                                '/items/',
	                                '{travelItemId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890/items/11111111'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'sellerTravelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'onSale'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC911:true, \uD310\uB9E4\uC911\uC9C0:false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'features'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Feature \uAD00\uB828 \uC138\uBD80 \uC0AC\uD56D\uC740 \uC5D1\uC140 \uD30C\uC77C \uCC38\uC870 \uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureValues'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<String>'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Feature \uAD00\uB828 \uC138\uBD80 \uC0AC\uD56D\uC740 \uC5D1\uC140 \uD30C\uC77C \uCC38\uC870 \uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'taxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'TaxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 taxType\uC774 \uC790\uB3D9\uC73C\uB85C \uBA74\uC138(FREE)\uB85C \uC124\uC815\uB418\uBA70, \uC774\uC678\uC758 taxType\uB97C \uC124\uC815 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACFC\uC138 (\uAE30\uBCF8\uAC12)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBA74\uC138'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ZERO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC138'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'usePeriod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '<UsePeriodDto>'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uBCA4\uD1A0\uB9AC \uD0C0\uC785\uC774 \u2018PERIOD\u2019 \uC774\uBA74 \uC0AC\uC6A9\uAE30\uAC04\uC740 \uD544\uC218\uC774\uACE0 \uC778\uBCA4\uD1A0\uB9AC \uD0C0\uC785\uC774 \u2018DAILY\u2019 \uC778 \uACBD\uC6B0 \uC0AC\uC6A9\uAE30\uAC04\uC740 \uC0AC\uC6A9\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'usePeriodName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9 \uAE30\uAC04\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'useStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBD80\uD130 \uC0AC\uC6A9 \uAC00\uB2A5. Format: yyyy-MM-dd HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'useEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAE4C\uC9C0 \uC0AC\uC6A9 \uC911\uC9C0 Format:yyyy-MM-dd HH:mm:ss'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'rates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<TravelRateDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC rate id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'TourRateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN_AND_CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778/\uC18C\uC778\uB3D9\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNIVERSITY_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACE0\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_AND_MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEENS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCCAD\uC18C\uB144'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PRESCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uCDE8\uD559\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC18C\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'INFANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'priceType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'COUPANG_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCFE0\uD321 \uAC00\uACA9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TOTAL_PRODUCT_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD1D \uC0C1\uD488 \uAC00\uACA9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC \uD648\uD398\uC774\uC9C0\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_MALL_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC\uBAB0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ONLINE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC628\uB77C\uC778 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TRAVEL_AGENCY_SPECIAL_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5EC\uD589\uC0AC \uD2B9\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESERVATION_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uB9E4\uCC98 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HOMEPAGE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD648\uD398\uC774\uC9C0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SITE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD604\uC7A5 \uD310\uB9E4\uAC00'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC6D0\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB300\uD45C\uAC00 \uC124\uC815 \uC5EC\uBD80 / False\uB85C \uC124\uC815\uD560 \uACBD\uC6B0 \uB300\uD45C\uAC00 \uB178\uCD9C\uC5D0\uC11C \uC81C\uC678\uB429\uB2C8\uB2E4. (Default: TRUE)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC2DC\uC791\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC885\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss). Default: 2099-12-31 23:59:59'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'maxPurchaseQtyPerPerson'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uB2F9 \uCD5C\uB300 \uAD6C\uB9E4 \uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'maxPurchaseQtyPeriod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4 \uC81C\uD55C \uAE30\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08 \uB4F1\uB85D \uC21C\uC11C'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#putItemDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'putItemDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n    {\n      "description": "string",\n        "features": [\n        \t{\n        \t\t"description":"",\n        \t\t"featureId":"OFFERING_SERVICE",\n        \t\t"featureValues":[\n        \t\t\t"NO_CHARGE_CALL","UNLIMITED_USE"\n        \t\t\t]\n        \t}\n      ],\n      "name": "test item 9999",\n      "onSale": false,\n      "rates": [\n        {\n          "maxPurchaseQtyPerPerson": 0,\n          "maxPurchaseQtyPeriod": 0,\n          "price": 0,\n          "priceType": "COUPANG_PRICE",\n          "rateType": "BASIC",\n          "representative": true,\n          "saleEndedAt": "2019-12-31 23:59:59",\n          "saleStartedAt": "2019-10-01 00:00:00",\n          "sellerRateId": "",\n          "seq": 0\n        }\n      ],\n      "sellerTravelItemId": "string",\n      "seq": 0,\n      "taxType": "TAX",\n      "usePeriod": {\n        "useEndedAt": "2019-12-31 23:59:59",\n        "usePeriodName": "string",\n        "useStartedAt": "2019-12-01 23:59:59"\n      }\n    }\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "code": 200\n            "message" : "success"\n            "data" : 191043228223418368\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforUpdateItem' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforUpdateItem', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel-body' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC774\uB118 \uD0C0\uC785 ',
	                                            '${enumClazz.getSimpleName()}',
	                                            '\uC5D0 \uB300\uD55C \uBB34\uD6A8 \uBB38\uC790\uC5F4 \uAC12'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 seqs  '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'format\uC774 IMAGE\uC778 \uACBD\uC6B0 sellerUrl\uB97C \uBC18\uB4DC\uC2DC \uC81C\uACF5\uD574\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 travel item feature id '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 travel item feature value '
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 \uC77C\uC790/\uC2DC\uAC04 \uD3EC\uB9F7, \uD3EC\uB9F7\uC774 ',
	                                            '{pattern}',
	                                            '\uC774\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uD310\uB9E4 \uC2DC\uC791\uC77C\uC740 \uD310\uB9E4 \uC885\uB8CC\uC77C\uBCF4\uB2E4 \uB2A6\uC9C0 \uC54A\uC544\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC0C1\uD488 inventoryType\uC774 PERIOD\uC778 \uACBD\uC6B0 usePeriod\uAC00 NULL\uC774\uBA74 \uC548\uB428'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'inventoryType\uC774 DAILY\uC778 \uACBD\uC6B0 usePeriod\uAC00 \uBD88\uD544\uC694\uD568'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateTicketProductItem;
	}(_react2.default.Component);
	
	exports.default = UpdateTicketProductItem;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateTicketProductItem.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 8501594307383073:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(7932631929871328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuLayout = function (_React$Component) {
	  _inherits(MenuLayout, _React$Component);
	
	  function MenuLayout(props) {
	    _classCallCheck(this, MenuLayout);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  MenuLayout.prototype.handleMenuClick = function handleMenuClick(activeName, type) {
	    this.props.onMenuClick(activeName, type || "html");
	    // this.props.rootController.handleMenuClick(activeName);
	  };
	
	  MenuLayout.prototype.render = function render() {
	    var _this2 = this;
	
	    var actives = [];
	    actives.push(this.props.activeName == "guides" ? "active" : "");
	    actives.push(this.props.activeName == "member" ? "active" : "");
	    actives.push(this.props.activeName == "login" ? "active" : "");
	    /*actives.push( this.props.activeName == "wing" ? "active" : "");*/
	
	    return _react2.default.createElement(
	      'nav',
	      { className: 'navbar navbar-inverse navbar-fixed-top' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'navbar-header' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'navbar-toggle collapsed', 'data-toggle': 'collapse', 'data-target': '#navbar', 'aria-expanded': 'false', 'aria-controls': 'navbar' },
	            _react2.default.createElement(
	              'span',
	              { className: 'sr-only' },
	              'Toggle navigation'
	            ),
	            _react2.default.createElement('span', { className: 'icon-bar' }),
	            _react2.default.createElement('span', { className: 'icon-bar' }),
	            _react2.default.createElement('span', { className: 'icon-bar' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'navbar-brand bi-coupang', href: '/' },
	            'Home'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'navbar', className: 'navbar-collapse collapse' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav navbar-nav navbar-right' },
	            _react2.default.createElement(
	              'li',
	              { className: actives[0] },
	              _react2.default.createElement(
	                'a',
	                { href: '/guide', onClick: function onClick(e) {
	                    return _this2.handleMenuClick('guides');
	                  } },
	                'Guides'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: actives[1] },
	              _react2.default.createElement(
	                'a',
	                { href: '/member' },
	                'Member'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return MenuLayout;
	}(_react2.default.Component);
	
	MenuLayout.propTypes = {
	  activeName: _react2.default.PropTypes.string.isRequired,
	  onMenuClick: _react2.default.PropTypes.func.isRequired,
	  activeName2: _react2.default.PropTypes.string.isRequired
	};
	MenuLayout.defaultProps = {
	  activeName2: "111"
	};
	MenuLayout.ACTIVES = {
	  "notice": {
	    name: "notice",
	    contentPage: "noticet.componen"
	  },
	  "guides": {
	    name: "guides",
	    contentPage: "guides.html"
	  },
	  "member": {
	    name: "",
	    contentPage: ""
	  },
	  "login": {
	    name: "",
	    contentPage: ""
	  }
	};
	MenuLayout.ACTIVE_DEFAULT = {
	  name: "notice",
	  contentPage: "notice.component"
	};
	exports.default = MenuLayout;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "MenuLayout.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 8585802677143340:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketRefundRequestList = function (_React$Component) {
	    _inherits(TicketRefundRequestList, _React$Component);
	
	    function TicketRefundRequestList(props) {
	        _classCallCheck(this, TicketRefundRequestList);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    TicketRefundRequestList.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'mb0 mt40' },
	                '\uD2F0\uCF13 \uD658\uBD88 \uC694\uCCAD \uB9AC\uC2A4\uD2B8 \uC870\uD68C API'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uD658\uBD88 \uC694\uCCAD\uD55C \uD2F0\uCF13 \uB9AC\uC2A4\uD2B8\uB97C \uC870\uD68C\uD569\uB2C8\uB2E4. \uC774 API\uB97C \uC774\uC6A9\uD574 \uCD5C\uB300 5\uAC1C\uC758 \uD2F0\uCF13\uC744 \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-primary' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/cancel-status'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/cancel-status'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: '5', className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumbers'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638 \uB9AC\uC2A4\uD2B8'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'ticketNumber'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2F0\uCF13\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'dealId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB51C\uBC88\uD638'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'cancelRequestStatusType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '"CANCEL_PROGRESS" : \uD658\uBD88\uC9C4\uD589\uC911',
	                                _react2.default.createElement('br', null),
	                                '"CANCEL_FAIL" : \uD658\uBD88\uC2E4\uD328',
	                                _react2.default.createElement('br', null),
	                                '"CANCEL_COMPLETE" : \uD658\uBD88\uC644\uB8CC',
	                                _react2.default.createElement('br', null),
	                                '"CANCEL_INVALID_REQUEST" : \uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uD2F0\uCF13'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'requestedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC694\uCCAD\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'cancelCompletedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD658\uBD88\uC644\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "message": "SUCCESS",\n            "data": {\n                "2C9A62-15000000000587": {\n                    "ticketNumber": "2C9A62-15000000000587",\n                    "dealId": 6500124650,\n                    "cancelRequestStatusType": "CANCEL_PROGRESS",\n                    "requestedAt": "2017-11-07 13:34:22",\n                    "cancelCompletedAt": null\n                    "message": "\uD658\uBD88\uC9C4\uD589\uC911"\n                }\n            }\n        }\n                        '
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return TicketRefundRequestList;
	}(_react2.default.Component);
	
	exports.default = TicketRefundRequestList;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "TicketRefundRequestList.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 8600493323831505:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateTourInventoryByDate = function (_React$Component) {
	    _inherits(UpdateTourInventoryByDate, _React$Component);
	
	    function UpdateTourInventoryByDate(props) {
	        _classCallCheck(this, UpdateTourInventoryByDate);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateTourInventoryByDate.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { id: "update-inventory-by-date" },
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC694\uAE08/\uC218\uB7C9'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC0C1\uD488 \uC635\uC158\uC758 \uC694\uAE08 \uBC0F \uC218\uB7C9\uC744 \uB4F1\uB85D/\uC5C5\uB370\uC774\uD2B8 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'PATCH'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tours/',
	                                '{travelProductId}',
	                                '/items/',
	                                '{travelItemId}'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/1234567890/items/11111111'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'inventoryDtos'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<TravelItemInventoryDto>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN_AND_CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778/\uC18C\uC778\uB3D9\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNIVERSITY_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACE0\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_AND_MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEENS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCCAD\uC18C\uB144'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PRESCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uCDE8\uD559\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC18C\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'INFANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'calendarDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD2B9\uC815\uC77C\uC790(Format: yyyy-MM-dd)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'totalStockCount'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD1D \uC7AC\uACE0 \uC218\uB7C9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'salePrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'onSale'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC911:true, \uD310\uB9E4\uC911\uC9C0:false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'deadlineDay'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0AC\uC6A9\uD558\uB294 \uB0A0\uC9DC\uC804\uC5D0 \uBA87 \uC77C\uC5D0 \uD504\uB85C\uB355\uD2B8 \uD310\uB9E4\uB97C \uC911\uC9C0\uC2DC\uD0A4\uACA0\uC2B5\uB2C8\uAE4C? \uB514\uD3F4\uD2B8\uAC12:0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'deadlineHour'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                ' \uC0AC\uC6A9\uD558\uB294 \uB0A0\uC9DC \uB9C8\uC774\uB108\uC2A4 deadlineDay \uC804\uC5D0 \uBA87 \uC2DC\uAC04\uC5D0 \uD504\uB85C\uB355\uD2B8 \uD310\uB9E4\uB97C \uC911\uC9C0\uC2DC\uD0A4\uACA0\uC2B5\uB2C8\uAE4C? \uB370\uC774\uD130\uB294 1\uBD80\uD130 24\uAE4C\uC9C0\uC774\uBA70 \uB514\uD3F4\uD2B8\uAC12:24'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#patchInventoryDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'patchInventoryDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n[\n {\n   "calendarDate": "2019-10-29",\n   "rateType": "ADULT",\n   "salePrice": 10000,\n   "onSale": false,\n   "totalStockCount": 1000,\n   "deadlineDay":1,\n   "deadlineHour":0\n }\n]\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'null'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "code": 200\n            "message" : "success"\n            "data" : null\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateTourInventoryByDate;
	}(_react2.default.Component);
	
	exports.default = UpdateTourInventoryByDate;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateTourInventoryByDate.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 8737297522905820:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateTourProductItems = function (_React$Component) {
	    _inherits(CreateTourProductItems, _React$Component);
	
	    function CreateTourProductItems(props) {
	        _classCallCheck(this, CreateTourProductItems);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    CreateTourProductItems.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { className: 'mb0 mt40', id: "create-tour-product-items" },
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC0C1\uD488 \uC635\uC158 \uB4F1\uB85D'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uCFE0\uD321\uC5D0\uC11C \uD310\uB9E4\uD560 \uC0C1\uD488\uC758 \uC635\uC158\uC744 \uB4F1\uB85D\uD558\uB294 API\uC785\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v1/marketplace/travel/tours/',
	                                '{travelProductId}',
	                                '/items'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/1234567890/items'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514 \uC694\uCCAD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Path Segment Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'sellerTravelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC \uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uBA85. (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 50\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'onSale'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC911:true, \uD310\uB9E4\uC911\uC9C0:false'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC124\uBA85 (\uCD5C\uB300 \uBB38\uC790\uC5F4 \uAE38\uC774\uB294 2000\uC790 \uC785\uB2C8\uB2E4)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'period'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C\uC758 \uC5EC\uD589\uAE30\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'contents'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC0C1\uD488 \uCEE8\uD150\uCE20 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785\uC5D0 \uB300\uD55C \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825. \uC608:\uD328\uD0A4\uC9C0 \uD22C\uC5B4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\' \uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \'\uC774\uBBF8\uC9C0\'\uC774\uBA74 \uD544\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'IMAGE'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\'\uC774\uBBF8\uC9C0\'\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url \uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'itineraries'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589\uC77C\uC815 \uC81C\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'notice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815\uC5D0 \uAD00\uD55C \uACF5\uC9C0\uC0AC\uD56D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'courses'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'name'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC81C\uBAA9 \uC608) 1\uC77C\uCC28'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'summary'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC694\uC57D'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'from'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCD9C\uBC1C\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'to'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBAA9\uC801\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'details'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'HOTEL, FLIGHT, MEAL, SIGHTSEEING, SHOPPING, NOTICE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'mealName'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC2DD\uC0AC \uC81C\uBAA9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'location'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC7A5\uC18C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightFrom'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uCD9C\uBC1C\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightTo'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uBAA9\uC801\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightDepartureTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uCD9C\uBC1C\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'flightArrivalTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD56D\uACF5\uAE30 \uB3C4\uCC29\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'duration'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC18C\uC694\uC2DC\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'distance'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAC70\uB9AC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'descriptions'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003title'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uB0B4\uC6A9 \uD0C0\uC774\uD2C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003type'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCEE8\uD150\uCE20 \uD0C0\uC785 \uC790\uC720\uD14D\uC2A4\uD2B8 \uC785\uB825'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003content'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uB0B4\uC6A9(\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC774 \uC544\uB2CC \uACBD\uC6B0 \uC120\uD0DD, \uC774\uBBF8\uC9C0\uC774\uBA74 \uD544\uC218)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003format'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEXT \uB514\uD3F4\uD2B8 \uAC12'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003sellerUrl'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\u2018\uC774\uBBF8\uC9C0\u2019\uD3EC\uB9F7\uC778 \uACBD\uC6B0 sellerUrl \uC774 image url \uC774\uBA70 \uD544\uC218\uC784, \uADF8 \uC678 \uC120\uD0DD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003sellerUrlMethod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Http method(GET/POST), default GET.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                '\u2003\u2003seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC11C\uBD80\uC77C\uC815 \uB0B4\uC6A9 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC138\uBD80\uC77C\uC815 \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'feeIncluded'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08 \uD3EC\uD568\uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'optional'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC77C\uC815 \uC790\uC720\uC120\uD0DD \uC5EC\uBD80'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC21C\uC11C'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'features'
	                            ),
	                            _react2.default.createElement('td', null),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Feature \uAD00\uB828 \uC138\uBD80 \uC0AC\uD56D\uC740 \uC5D1\uC140 \uD30C\uC77C \uCC38\uC870 \uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'featureValues'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<String>'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Feature \uAD00\uB828 \uC138\uBD80 \uC0AC\uD56D\uC740 \uC5D1\uC140 \uD30C\uC77C \uCC38\uC870 \uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'description'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'taxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'TaxType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '*travelType\uC774 OVERSEAS\uC778 \uACBD\uC6B0 taxType\uC774 \uC790\uB3D9\uC73C\uB85C \uBA74\uC138(FREE)\uB85C \uC124\uC815\uB418\uBA70, \uC774\uC678\uC758 taxType\uB97C \uC124\uC815 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.',
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TAX'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACFC\uC138 (\uAE30\uBCF8\uAC12)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'FREE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBA74\uC138'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ZERO'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC138'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'rates'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'List',
	                                '<TourRate>'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'sellerRateId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC140\uB7EC rate id'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'rateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'TourRateType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'BASIC'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uAE30\uBCF8'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN_AND_CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778/\uC18C\uC778\uB3D9\uC77C'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT_DAEIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'UNIVERSITY_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uB300\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uACE0\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uB4F1\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HIGH_AND_MIDDLE_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD08\uC911\uACE0\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TEENS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCCAD\uC18C\uB144'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'STUDENT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD559\uC0DD'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'PRESCHOOL_CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uBBF8\uCDE8\uD559\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD_SOIN'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC18C\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'INFANT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC601\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'priceType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TOTAL_PRODUCT_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uCD1D \uC0C1\uD488 \uAC00\uACA9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC \uD648\uD398\uC774\uC9C0\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'OWN_COMPANY_MALL_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC790\uC0AC\uBAB0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ONLINE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC628\uB77C\uC778 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TRAVEL_AGENCY_SPECIAL_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC5EC\uD589\uC0AC \uD2B9\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'RESERVATION_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC608\uB9E4\uCC98 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'HOMEPAGE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD648\uD398\uC774\uC9C0 \uD310\uB9E4\uAC00'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'SITE_SALE_PRICE'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uD604\uC7A5 \uD310\uB9E4\uAC00'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'BigDecimal'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4 \uC6D0\uAC00'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'representative'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Boolean'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Default: TRUE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleStartedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC2DC\uC791\uC77C (yyyy-MM-dd HH:mm:ss)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'saleEndedAt'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDateTime'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uB178\uCD9C \uC885\uB8CC\uC77C (yyyy-MM-dd HH:mm:ss). Default: 2099-12-31 23:59:59'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'maxPurchaseQtyPerPerson'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC778\uB2F9 \uCD5C\uB300 \uAD6C\uB9E4 \uAC1C\uC218'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'maxPurchaseQtyPeriod'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uAD6C\uB9E4 \uC81C\uD55C \uAE30\uAC04'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'seq'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'X'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C \uC21C\uC11C'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#postItemDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'postItemDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n            {\n                "sellerTravelItemId": "seller-item-id-2",\n                "name": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 4\uBC156\uC77C",\n                "description": "[\uC7A5\uC0AC/\uC7A5\uAC00\uACC4] 4\uBC156\uC77C description",\n                "period": "4\uBC156\uC77C",\n                "seq": 1,\n                "features": [],\n                "taxType": "FREE",\n                "onSale": true,\n                "rates": [\n                    {\n                        "sellerRateId": "seller-rate-id-1",\n                        "rateType": "ADULT",\n                        "priceType": "COUPANG_PRICE",\n                        "price": 50000000,\n                        "representative": true,\n                        "saleStartedAt": "2019-11-01 01:00:00",\n                        "saleEndedAt": "2019-12-21 01:00:00",\n                        "maxPurchaseQtyPerPerson": 10,\n                        "maxPurchaseQtyPeriod": 1,\n                        "seq": 0\n                    },\n                    {\n                        "sellerRateId": "seller-rate-id-1",\n                        "rateType": "CHILD",\n                        "priceType": "COUPANG_PRICE",\n                        "price": 40000000,\n                        "representative": true,\n                        "saleStartedAt": "2019-11-01 01:00:00",\n                        "saleEndedAt": "2019-12-21 01:00:00",\n                        "maxPurchaseQtyPerPerson": 10,\n                        "maxPurchaseQtyPeriod": 1,\n                        "seq": 1\n                    }\n                ]\n            }\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC5EC\uD589 \uC544\uC774\uD15C id'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "code": 200\n            "message" : "success"\n            "data" : 191043228223418368\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4',
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-toggle': 'collapse', href: '#errorMessagesforCreateItem' },
	                                        '400 Error Messages'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'errorMessagesforCreateItem', className: 'panel-collapse collapse' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'panel-body' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uC774\uB118 \uD0C0\uC785 ',
	                                            '${enumClazz.getSimpleName()}',
	                                            '\uC5D0 \uB300\uD55C \uBB34\uD6A8 \uBB38\uC790\uC5F4 \uAC12'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 seqs'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour item feature id'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 tour item feature value'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uBB34\uD6A8 \uC77C\uC790/\uC2DC\uAC04 \uD3EC\uB9F7, \uD3EC\uB9F7\uC774 ',
	                                            '{pattern}',
	                                            '\uC774\uC5B4\uC57C\uD568'
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            '\uD310\uB9E4 \uC2DC\uC791\uC77C\uC740 \uD310\uB9E4 \uC885\uB8CC\uC77C\uBCF4\uB2E4 \uB2A6\uC9C0 \uC54A\uC544\uC57C\uD568'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return CreateTourProductItems;
	}(_react2.default.Component);
	
	exports.default = CreateTourProductItems;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "CreateTourProductItems.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ }),

/***/ 8914084046446817:
/***/ (function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/root/project/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/root/project/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTabs = __webpack_require__(4302779376677864);
	
	__webpack_require__(5256309363921096);
	
	__webpack_require__(4764256660237640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateTourInventoryByDateV2 = function (_React$Component) {
	    _inherits(UpdateTourInventoryByDateV2, _React$Component);
	
	    function UpdateTourInventoryByDateV2(props) {
	        _classCallCheck(this, UpdateTourInventoryByDateV2);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    UpdateTourInventoryByDateV2.prototype.render = function render() {
	        var col_number_8 = 8;
	        var total_levels = 6;
	        var level1 = 5;
	        var level2 = 4;
	        var level2_prefix = level1 - level2;
	        var level3 = 3;
	        var level3_prefix = level1 - level3;
	        var level4 = 2;
	        var level4_prefix = level1 - level4;
	        var level5 = 1;
	        var level5_prefix = level1 - level5;
	        return _react2.default.createElement(
	            'div',
	            { id: "update-inventory-by-date" },
	            _react2.default.createElement(
	                'h3',
	                { className: "mb0 mt40" },
	                '\uC694\uAE08/\uC218\uB7C9'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'blog-post-meta' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 's-post' },
	                    '\uC0C1\uD488 \uC635\uC158\uC758 \uC694\uAE08 \uBC0F \uC218\uB7C9\uC744 \uB4F1\uB85D/\uC5C5\uB370\uC774\uD2B8 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'request-method' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label label-success' },
	                        'POST'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Path'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Example Endpoint'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '/v2/marketplace/fill/inventories'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v2/marketplace/fill/inventories'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt10' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Request Parameters'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Request Header'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'Request-Vendor-Id'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uBCA4\uB354 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: col_number_8, className: 'bold' },
	                                'Body Parameter'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { colSpan: level1 },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Required'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level1 },
	                                'inventoryDtos'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'travelProductId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uCFE0\uD321 \uC0C1\uD488 \uC544\uC774\uB514'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'productType'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC0C1\uD488\uD0C0\uC785. Example: TOUR'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level2 },
	                                'itemWithStockAndPriceList'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Array'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'travelItemId'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Long'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'targetDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'LocalDate'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uAE08/\uC218\uB7C9 \uB4F1\uB85D\uC77C\uC790. Format: yyyy-MM-dd'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level3 },
	                                'rateWithStockAndPrice'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Map'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'key'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Optional Value'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Description'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'ADULT'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC131\uC778'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'CHILD'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC544\uB3D9'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                'TODDLER'
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                '\uC720\uC544'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level4 },
	                                'value'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Object'
	                            ),
	                            _react2.default.createElement('td', null)
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'stock'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Integer'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC7AC\uACE0\uC218\uB7C9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: level5 },
	                                'price'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'O'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Double'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD310\uB9E4\uAC00'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement('h3', { className: 'panel-title' }),
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', href: '#patchInventoryDto' },
	                            'Request Body'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'patchInventoryDto', className: 'panel-collapse collapse' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'createTourDto', className: 'panel-body' },
	                            _react2.default.createElement(
	                                'pre',
	                                { className: 'ty01' },
	                                '\n[\n    {\n        "travelProductId": 542694088235810800,\n        "productType": "TOUR",\n        "itemWithStockAndPriceList": [\n            {\n                "travelItemId": 542694088655241200,\n                "targetDate": "2020-02-25",\n                "rateWithStockAndPrice": {\n                    "ADULT": {\n                        "stock": 10,\n                        "price": 2500000\n                    }\n                }\n            },\n            {\n                "travelItemId": 542694088818819100,\n                "targetDate": "2020-02-25",\n                "rateWithStockAndPrice": {\n                    "ADULT": {\n                        "stock": 20,\n                        "price": 3500000\n                    }\n                }\n            }\n        ]\n    }\n]\n                        '
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Response Specifications'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Type'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'code'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uCF54\uB4DC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC751\uB2F5 \uBA54\uC138\uC9C0'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'data'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'String'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'null'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive mt40' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel panel-default' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-heading' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'panel-title' },
	                            '\uC751\uB2F5\uAC12 \uC608\uC2DC'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'pre',
	                            { className: 'ty01' },
	                            '\n        {\n            "code": 200\n            "message" : "Partial Update Ticket Inventory Request accepted"\n            "data" : null\n        }\n                        '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'HTTP CODE'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'message'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\uC124\uBA85'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '400'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Bad request'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD \uD30C\uB77C\uBBF8\uD130 \uAC12\uC774 \uC815\uD655\uD558\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '401'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Unauthorized Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '403'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Forbidden Error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uD074\uB77C\uC774\uC5B8\uD2B8 \uC5D0\uC11C \uC778\uC99D\uC744 \uC81C\uACF5\uD558\uC600\uC73C\uB098 \uC811\uC18D \uD5C8\uAC00\uB97C \uBC1B\uC9C0 \uBABB\uD588\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '410'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'The resource has been permanently deleted'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uB9AC\uC18C\uC2A4\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '412'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Precondition failed'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC804\uC81C\uC870\uAC74\uC774 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC544 \uC694\uCCAD\uC774 \uCC98\uB9AC\uB418\uC9C0 \uC54A\uC744 \uACBD\uC6B0\uC5D0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '429'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Too many requests'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '\uC694\uCCAD\uC774 \uB9CE\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '504'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API Gateway response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC751\uB2F5\uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '521'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider server has error'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354 \uC11C\uBC84\uC5D0 \uC5D0\uB7EC\uAC00 \uC788\uC744 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                '524'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API provider to API gateway connection response timeout'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'API \uD504\uB85C\uBC14\uC774\uB354\uC5D0\uC11C API \uAC8C\uC774\uD2B8\uC6E8\uC774 \uC5F0\uACB0 \uC751\uB2F5 \uC2DC\uAC04 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uBC1C\uC0DD\uD569\uB2C8\uB2E4'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return UpdateTourInventoryByDateV2;
	}(_react2.default.Component);
	
	exports.default = UpdateTourInventoryByDateV2;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/root/project/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "UpdateTourInventoryByDateV2.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ })

/******/ })));


// WEBPACK FOOTER //
// GuideEntryContainer.bundle.js